import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { GlobalService } from '../services/global.service';
import { SidebarService } from '../services/sidebar.service';
import { ModalService } from '../shared/modal/modal.service';
import { Router } from "@angular/router";

import { SnackBarService } from '../shared/snackbar/snackbar.service';
import { LoadingService } from '../shared/loading/loading.service';

import Utils from '../shared/utility';
import * as shape from 'd3-shape';

//import { CostProjectionDetailsComponent } from '../shared/modal/cost-projection-details/cost-projection-details.component'
//import { CostOfWaitingComponent } from '../shared/modal/cost-of-waiting/cost-of-waiting.component'
//import { FundingSourceComponent } from '../shared/modal/funding-source/funding-source.component';
import { COLAComponent } from '../shared/modal/cola/cola.component';
import { BasicQuestionComponent } from '../shared/modal/basic-question/basic-question.component';
import { AdjustRatesComponent } from '../shared/modal/adjust-rates-of-return/adjust-rates.component';
import { MatDialog } from '@angular/material/dialog';
import * as cloneDeep from 'lodash/cloneDeep';
import { CodegenComponentFactoryResolver } from '@angular/core/src/linker/component_factory_resolver';

@Component({
  selector: 'app-social-security',
  templateUrl: './social-security.component.html',
  styleUrls: ['./social-security.component.css']
})
export class SocialSecurityComponent implements OnInit {
  @ViewChild('illustrationDD') illustrationDD: ElementRef;
  @ViewChild('annualEl') annualEl: ElementRef;

  userForm = new FormGroup({
    UserID: new FormControl(''),
    CompanyCode: new FormControl(''),
    ClientID: new FormControl('')
  });

  socialSecurityForm = new FormGroup({
    futureValue: new FormControl('true'),
    inflationRate: new FormControl('3.4%'),
    colaFirst: new FormControl('1.6%'),
    colaSecond: new FormControl('2.6%'),
    colaThird: new FormControl('2.6%'),
    colaFourth: new FormControl('2.6%'),
    selfRetirementYears: new FormControl(''),
    selfRetirementMonths: new FormControl('0'),
    selfAlreadyClaiming: new FormControl('false'),
    spouseRetirementYears: new FormControl(''),
    spouseRetirementMonths: new FormControl('0'),
    spouseAlreadyClaiming: new FormControl('false'),
    selfLifeExpectancy: new FormControl('90'),
    spouseLifeExpectancy: new FormControl('90'),
    illustrationCashFlow: new FormControl({}),
    nonLegalMarriedInd: new FormControl('Client')
  });

  public error: string;
  public client: any = {};
  public backUpClient: any = {};
  public ssInputs: any = {};
  public ssData: any;
  public ssDataAlt: any;
  public origSSData: any;
  public earliestVsAlternate: any;
  public comparisonGraph: any;
  public illustrationComparisons: any[];
  public selectedIllustration: any;
  public selectedIllustrationIdx: number = 0;
  public comparisonIllustration: any;
  public discountRate: number = 3;
  public clientMonthlyBenefitAmount: number = 0;
  public spouseMonthlyBenefitAmount: number = 0;
  public startPIA;
  public endPIA;
  public spouseStartPIA;
  public spouseEndPIA;
  public clientSurvivorSwitchYears: number = 0; //70
  public clientSurvivorSwitchMonths: number = 0;

  public totalSocialSecurity: number = 0;  
  public totalInvestment: number = 0;
  public totalRemainingGap: number = 0;
  public ssRemaining: number = 0;
  public currentRemainingTotal: number = 0;
  public additionalFunds: number = 0;
  public futureTotalCost: number = 0;
  public medicareDeductions: number = 0;
  public swappedClaim: boolean = false;
  public swappedClaimFRA: boolean = false;

  public isAltCardRemoved: boolean = false;

  public displayEarningsTestMessage: boolean = false;
  public displayRetroTestMessage: boolean = false;
  public isPageReloadOtherThanFRACall: boolean = false;
  public isFirstCall: boolean = true;

  public previousSSObject: any = null;
  public previousSSObjectAlt: any = null;

  annuallyWeeklyTtlYear;
  orgOptAnnuallyWeeklyTtlYear
  orgFRAAnnuallyWeeklyTtlYear;
  orgEarlyAnnuallyWeeklyTtlYear;
  orgAltAnnuallyWeeklyTtlYear;;

  //lumpsumCost = 0;
  //yearlyCost = 0;
  //weeklyCost = 0;

  imgSrc: string;
  isSrcReport: string;

  curves = {
    Basis: shape.curveBasis,
    'Basis Closed': shape.curveBasisClosed,
    Bundle: shape.curveBundle.beta(1),
    Cardinal: shape.curveCardinal,
    'Cardinal Closed': shape.curveCardinalClosed,
    'Catmull Rom': shape.curveCatmullRom,
    'Catmull Rom Closed': shape.curveCatmullRomClosed,
    Linear: shape.curveLinear,
    'Linear Closed': shape.curveLinearClosed,
    'Monotone X': shape.curveMonotoneX,
    'Monotone Y': shape.curveMonotoneY,
    Natural: shape.curveNatural,
    Step: shape.curveStep,
    'Step After': shape.curveStepAfter,
    'Step Before': shape.curveStepBefore,
    default: shape.curveLinear
  };

  curveType: string = 'Step';
  curve: any = this.curves[this.curveType];
  interpolationTypes = [
    'Basis', 'Bundle', 'Cardinal', 'Catmull Rom', 'Linear', 'Monotone X',
    'Monotone Y', 'Natural', 'Step', 'Step After', 'Step Before'
  ];

  closedCurveType: string = 'Linear Closed';
  closedCurve: any = this.curves[this.closedCurveType];
  closedInterpolationTypes = [
    'Basis Closed', 'Cardinal Closed', 'Catmull Rom Closed', 'Linear Closed'
  ];

  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = false;
  showXAxisLabel = true;
  showYAxisLabel = true;
  /* yAxisLabel = 'Annual Income'; */
  yAxisLabel = 'Monthly Income';


  colorScheme = {
    domain: ['#8d68dd', '#73bcb8', '#5d80c0']
    // blue | teal | purple
  };

  autoScale = true;

  public illustrationsTypes = ["Optimal", "FRA", "Earliest"];//["Earliest", "FRA", "Optimal"];
  public includeSpouse = false;

  public colas: any[] = [
    { Cola: 1.3, Year: 0 },
    { Cola: 2.6, Year: 0 },
    { Cola: 2.6, Year: 0 },
    { Cola: 2.6, Year: 0 },
  ];

  public clientPIA: Number = 1250;
  public clientClaimStatus: string = "False";
  public clientRetirementYears: number = 67;
  public clientRetirementMonths: number = 0;
  public spousePIA: Number = 1250;
  public spouseClaimStatus: string = "False";
  public spouseRetirementYears: number = 0;
  public spouseRetirementMonths: number = 0;
  //public presentValue: string = "False";
  public presentValue: boolean = false;

  public dependentChildCount: number = 0;
  public previousSpouse: any;

  public clientClaimStatusDisabled: boolean = false;
  public spouseClaimStatusDisabled: boolean = false;

  public modalSubscription;
  
  public startingLumpsum: any = 0;
  public beginningBalance: any = 0;  
  public weeklyCost: any = 0;
  public yearlyCost: any = 0;
  public yearlyCostAlt: number = 0;
  public weeklyCostAlt: number = 0;
  public weeklyCostFRA: Number = 0;
  public yearlyCostFRA: Number = 0;
  public weeklyCostEarliest: Number = 0;
  public yearlyCostEarliest: Number = 0;
  public weeklyCostOptimal: Number = 0;
  public yearlyCostOptimal: Number = 0;

  public futureYearlyCost: Number = 0;
  public futureWeeklyCost: Number = 0;
  public futureYearlyCostFRA: Number = 0;
  public futureWeeklyCostFRA: Number = 0;
  public futureYearlyCostEarliest: Number = 0;
  public futureWeeklyCostEarliest: Number = 0;
  public futureYearlyCostOptimal: Number = 0;
  public futureWeeklyCostOptimal: Number = 0;

  public lumpsum: Number = 0;
  public lumpsumAlt: Number = 0;
  public lumpsumFRA: Number = 0;
  public lumpsumEarliest: Number = 0;
  public lumpsumOptimal: Number = 0;

  public fundingItems: any[] = [];

  public adjSurvivorBenefitAge: Number;
  public adjSurvivorBenefitMonths: Number;
  public adjRetirementBenefitAge: Number;
  public adjRetirementBenefitMonths: Number;
  public adjSurvivorModal: boolean = false;

  public adjSurvivorBenefitAgeFRA: Number;
  public adjSurvivorBenefitMonthsFRA: Number;
  public adjRetirementBenefitAgeFRA: Number;
  public adjRetirementBenefitMonthsFRA: Number;
  public adjSurvivorModalFRA: boolean = false;

  public isSurvAndFirstLoadSwapped: boolean = false;

  public minClientTBCLifeExp: any = 0;
  public minSpouseTBCLifeExp: any = 0;
  public maxClientTBCLifeExp: any = 101;
  public maxSpouseTBCLifeExp: any = 101;

  public scenarioDropDown: any = {
    scenarios: [],
    //TODO: need to adjust for First/Second Alt titles? Retro titles? Maybe?
    scenariosDisplay: ['Earliest', 'FRA', 'Optimal', 'Alternate'],
    selected: 1 // 0 = earliest, 1 = FRA, 2 = optimal, 3 = alternate
  }

  chosenLifetimeBenefitMessage: string = 'Test test';
  inflationRateMessage: string = 'Test test';
  breakEvenMessage: string = 'Test test';
  annualCashFlowMessage: string = "This illustration shows expected household Social Security benefits earned year-by-year in either Table or Chart View, which can be adjusted the toggle to the right. Each strategy is shown in its corresponding color.";
  unmarriedClientsMessage: string = "Social Security benefit calculations are based on marital status. Because the selected clients are not married, each partner must run a separate Social Security illustration as a single (unmarried) person.";
  displayYearByYearBreakdown: boolean = false;
  defaultIRR: 0;

  socialSecurityIllustrationCards = [
    //{ scenario: 'Earliest', color: '#5d80c0', clientName: 'John', clientAge: 62, clientTotal: 505109, partnerName: 'Jane', partnerAge: 62, partnerTotal: 591590, medicareDeductions: '19.16%', netOfMedicare: 880006 },
    //{ scenario: 'Desired', color: '#73bcb8', clientName: 'John', clientAge: 62, clientTotal: 576651, partnerName: 'Jane', partnerAge: 62, partnerTotal: 701830, medicareDeductions: '15.93%', netOfMedicare: 1074848 },
    //{ scenario: 'Optimal', color: '#8d68dd', clientName: 'John', clientAge: 62, clientTotal: 608882, partnerName: 'Jane', partnerAge: 62, partnerTotal: 756302, medicareDeductions: '13.3%', netOfMedicare: 1190906 }
  ]

  socialSecurityBenefitCards = [
    //{ scenario: 'Earliest', color: '#5d80c0', amount: 1, includeCheck: false },
    //{ scenario: 'Desired', color: '#73bcb8', amount: 100, includeCheck: false },
    //{ scenario: 'Optimal', color: '#8d68dd', amount: 1000, includeCheck: true }
  ]

  private clientFullName: string;
  private spouseFullName: string;
  private isNonLegalMarried: boolean = false;
  isClient: boolean = false;
  currentAgeOffset: number = 0;
  spouseAgeOffSet: number = 0;
  clientAgeMonth: number = 0;
  spouseAgeMonth: number = 0;
  isAlreadyInitializeComponent: boolean = false;
  isSpouseSurvivor: boolean = false;
  isShowAlternate: boolean = false;
  isFRABeingAdjusted: boolean = false;
  isShowSurvivorSection: boolean = false;
  dropDownSelectedIndexAnnually: number = 0;
  dropDownSelectedIndexWeekly: number = 0;
  bodyCardSelectedIndexAnnually: number;
  bodyCardSelectedIndexWeekly: number;
  investmentDescription: string;

  constructor(public sidebarService: SidebarService, public dialog: MatDialog, private globalService: GlobalService, private modalService: ModalService, private snackBarService: SnackBarService, private router: Router, private loadingService: LoadingService) {
    this.globalService.featFunding = JSON.parse(localStorage.getItem('featFunding'));
    //console.log('funding stuff on SS', JSON.stringify(this.globalService.featFunding || false));
    //console.log('has funding', this.globalService.featFunding);
    
    this.socialSecurityForm.controls['illustrationCashFlow'].valueChanges.subscribe((value) => {
      this.selectedIllustrationIdx = value;
      this.selectedIllustration = this.illustrationComparisons[value];
    });

    var isEmpower = (Number(localStorage.getItem('orgID')) === 782 || Number(localStorage.getItem('parentID')) === 782) ? true : false;
    const yearlyColas = JSON.parse(localStorage.getItem('yearlyValues')) || { BaseYear: 2020, Year1: 1.3, Year2: 2.6, Year3: 2.6, Year4: 2.6 };
    this.colas[0] = { Year: yearlyColas.BaseYear, Cola : (isEmpower) ? 0 : yearlyColas.Year1 };
    this.colas[1] = { Year: yearlyColas.BaseYear + 1, Cola : (isEmpower) ? 0 : yearlyColas.Year2 };
    this.colas[2] = { Year: yearlyColas.BaseYear + 2, Cola : (isEmpower) ? 0 : yearlyColas.Year3 };
    this.colas[3] = { Year: yearlyColas.BaseYear + 3, Cola : (isEmpower) ? 0 : yearlyColas.Year4 };

    this.socialSecurityForm.controls['colaFirst'].setValue(this.colas[0].Cola + "%");
    this.socialSecurityForm.controls['colaSecond'].setValue(this.colas[1].Cola + "%");
    this.socialSecurityForm.controls['colaThird'].setValue(this.colas[2].Cola + "%");
    this.socialSecurityForm.controls['colaFourth'].setValue(this.colas[3].Cola + "%");

    // Sidebar update occured - get new client values for page reload

      sidebarService.clientUpdated.subscribe(()=>{
        if (this.isAlreadyInitializeComponent) {
          //this.objAdjustedFRAScenario = null;
          this.objAdjustRates = null;
          //console.log('in sidebar service');
          // this.isPageReloadOtherThanFRACall = true;
          // this.callOnLoad();
          console.log('sidenav adj');
          //this.hasClientSidebarBeenUpdated = true;
          this.router.navigate(['/clients/edit/social-security/options/ss']);
        }

      })


    //required for page refresh when updating client profile
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };

    this.imgSrc = '../../../assets/icons/ss_illustration.svg';
    this.isSrcReport = "socialSecurityReport";
  }

  public selected: any = {
    isoneTimeInvestmentSelect: true,
    isannuallyRecurringInvestmentSelect: false,
    isweeklyRecurringInvestmentSelect: false,
  }

  bodyCardSelection(scenario) {
    console.log('bodyCardSelection');
    console.log(scenario);
    this.selected.isoneTimeInvestmentSelect = false;
    this.selected.isannuallyRecurringInvestmentSelect = false;
    this.selected.isweeklyRecurringInvestmentSelect = false;
    if (scenario == 'isoneTimeInvestmentSelect') {
      this.selected.isoneTimeInvestmentSelect = true;
      // this.investmentDescription = "test"
    }
    if (scenario == 'isannuallyRecurringInvestmentSelect') {
      // let bodyCardSelectedIndex = (this.bodyCardSelectedIndex ? this.bodyCardSelectedIndex : this.dropDownSelectedIndex).toString();
      let dropDownSelectedIndex = this.dropDownSelectedIndexAnnually ? this.dropDownSelectedIndexAnnually : Number(this.annuallyWeeklyTtlYear);//(Number(this.annuallyWeeklyTtlYear) < 10 ? 1: 10);
      console.log('this.dropDownSelectedIndexAnnually', this.dropDownSelectedIndexAnnually);
      console.log('this.annuallyWeeklyTtlYear', this.annuallyWeeklyTtlYear);
      console.log('this.bodyCardSelectedIndexAnnually', this.bodyCardSelectedIndexAnnually);
      let bodyCardSelectedIndex = (this.bodyCardSelectedIndexAnnually? this.bodyCardSelectedIndexAnnually : dropDownSelectedIndex).toString();
      this.investmentDescription = "Annually for " + bodyCardSelectedIndex + " years"
      this.selected.isannuallyRecurringInvestmentSelect = true;
    }
    if (scenario == 'isweeklyRecurringInvestmentSelect') {
      let dropDownSelectedIndex = this.dropDownSelectedIndexWeekly ? this.dropDownSelectedIndexWeekly : Number(this.annuallyWeeklyTtlYear);//(Number(this.annuallyWeeklyTtlYear) < 10 ? 1: 10);
      let bodyCardSelectedIndex = (this.bodyCardSelectedIndexWeekly? this.bodyCardSelectedIndexWeekly : dropDownSelectedIndex).toString();
      this.investmentDescription = "Weekly for " + bodyCardSelectedIndex + " years"
      this.selected.isweeklyRecurringInvestmentSelect = true;
    }
    console.log('this.investmentDescription', this.investmentDescription)

  }

  ngOnInit() {
    this.callOnLoad();
    this.isAlreadyInitializeComponent = true;
    //this.getSocialSecurityObject();
  }

  hasClientSidebarBeenUpdated: boolean = false;
  dateOfBirthModifiedOnPage: boolean = false;
  callOnLoad() {
    this.loadingService.isLoading(true);
    this.userForm.controls.UserID.setValue(Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorID') : localStorage.getItem('userId'));
    this.userForm.controls.CompanyCode.setValue(Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorOrgID') : localStorage.getItem('orgID'));
    this.userForm.controls.ClientID.setValue(localStorage.getItem('selectedClient'));

    /* if(localStorage.getItem('displayDCANotification')){
      localStorage.removeItem('displayDCANotification');
      const dialogRef = this.dialog.open(BasicQuestionComponent, {     
        data: { title: 'Notification!', 
        btnYesTitle: 'I Understand',
        question: "A previously entered desired claim age has been removed from this case profile because the month selected has since occurred.<br/>A new desired claim age may now be added and saved." }
      });
    } */

    //console.log('before bool convert', localStorage.getItem('dateOfBirthModified'));
    this.dateOfBirthModifiedOnPage = localStorage.getItem('dateOfBirthModified') == 'true' ? true : false;
    console.log('this.dateOfBirthModifiedOnPage', this.dateOfBirthModifiedOnPage);
    if(this.dateOfBirthModifiedOnPage){
      localStorage.setItem('dateOfBirthModified', 'false');
      //console.log('reset dateOfBirthModified', localStorage.getItem('dateOfBirthModified'));
      if(this.objAdjustedDesiredScenario){
        this.objAdjustedDesiredScenario.clientAgeYears = 0;
        this.objAdjustedDesiredScenario.clientAgeMonths = 0;
        this.objAdjustedDesiredScenario.spouseAgeYears = 0;
        this.objAdjustedDesiredScenario.spouseAgeMonths = 0;
        this.objAdjustedDesiredScenario.survivorSwitchAgeYears = 0;
        this.objAdjustedDesiredScenario.survivorSwitchAgeMonths = 0;

        //TODO: how doe we handle this vars for this particular scenario? Do we need to?
        //this.objAdjustedDesiredScenario.isClientAgeDisable = false;
        //this.objAdjustedDesiredScenario.isSpouseAgeDisable = false;
      }

      /* if(this.objAdjustedFRAScenario){
        this.objAdjustedFRAScenario.clientAgeYears = 0;
        this.objAdjustedFRAScenario.clientAgeMonths = 0;
        this.objAdjustedFRAScenario.spouseAgeYears = 0;
        this.objAdjustedFRAScenario.spouseAgeMonths = 0;
        this.objAdjustedFRAScenario.survivorSwitchAgeYears = 0;
        this.objAdjustedFRAScenario.survivorSwitchAgeMonths = 0;
      } */
    }

    this.hasClientSidebarBeenUpdated = true;
    // SMALLA: Already call from constructor - no need to call here otherwise it will crate the loading error ins some cases
    this.getClient(true);
  }

  objAdjustedCOLAs;
  objAdjustRates;// = '';
  hasCOLAsBeenAdjusted: boolean = false;
  hasRoRBeenAdjusted: boolean = false;
  reDirectModal(modalName): void {
    this.isPageReloadOtherThanFRACall = true;

    if (modalName == 'cola') {
      const dialogRef = this.dialog.open(COLAComponent, {
        //width: '1000px',
        //height: '700px',
        data: (this.objAdjustedCOLAs) ? this.objAdjustedCOLAs : 
          {inflationRate: '3.4',//2',//'3',
          colaYearOne: Number(this.socialSecurityForm.get('colaFirst').value.replace('%', '')), 
          colaYearTwo: Number(this.socialSecurityForm.get('colaSecond').value.replace('%', '')), 
          colaYearThree: Number(this.socialSecurityForm.get('colaThird').value.replace('%', '')), 
          colaYearFourPlus: Number(this.socialSecurityForm.get('colaFourth').value.replace('%', ''))}
      });

      dialogRef.afterClosed().subscribe(result =>{
        //recalc illustration page here with new ROR values
        //console.log('from close', result);
        if(result){
          this.hasCOLAsBeenAdjusted = true;
          this.objAdjustedCOLAs = result;
          //reset public colas
          //console.log('return from cola', result);          
          this.socialSecurityForm.controls['inflationRate'].setValue(result.inflationRate + "%");

          this.socialSecurityForm.controls['colaFirst'].setValue(result.colaYearOne + "%");
          this.socialSecurityForm.controls['colaSecond'].setValue(result.colaYearTwo + "%");
          this.socialSecurityForm.controls['colaThird'].setValue(result.colaYearThree + "%");
          this.socialSecurityForm.controls['colaFourth'].setValue(result.colaYearFourPlus + "%");

          const startYear = new Date().getFullYear();    
          this.colas = [
            { Cola: Number(this.socialSecurityForm.get('colaFirst').value.replace('%', '')), Year: startYear },
            { Cola: Number(this.socialSecurityForm.get('colaSecond').value.replace('%', '')), Year: startYear + 1 },
            { Cola: Number(this.socialSecurityForm.get('colaThird').value.replace('%', '')), Year: startYear + 2 },
            { Cola: Number(this.socialSecurityForm.get('colaFourth').value.replace('%', '')), Year: startYear + 3 },
          ];
          console.log('this.client', this.client);
          this.getSSData();
        }
      });
    }
    
    if (modalName == 'adjustRates') {
      const dialogRef = this.dialog.open(AdjustRatesComponent, {
       /*  width: '1000px',
        height: '700px', */
        data: {client: this.client, obj: this.objAdjustRates, modalName: modalName }
      });

      //on close
      dialogRef.afterClosed().subscribe(result =>{
        //recalc illustration page here with new ROR values
        console.log('from close', result);
        if(result){
          this.hasRoRBeenAdjusted = true;
          this.objAdjustRates = result;
          //this.isPageReloadOtherThanFRACall = false;
          console.log('returned rates to SS', this.objAdjustRates);
          //TODO: need to re-calc/set the Unfunded Costs
          //funding the cost between SS Desired total and Medicare Deductions
	          //- find how we fund the gap from HC/LTC (need to talk to Dustin)

            this.getSSData();
        }
      });
    }

  }

  public fundingSource: any [];
  returnedFundingSource(data){
    console.log('retured data to SS page', data);
    this.fundingSource = data;   
    this.contributionAmount = 0; 
    this.fundingItems = [];

    if(data.length > 0){
      for (var item in data){
        this.contributionAmount += data[item].totalContribution;
        this.handleNewFundingItem(data[item].fundingSource, data[item].annualContribution, 
          data[item].startYear, data[item].endYear, data[item].inflationRate/100);
      }
    } else{
      this.addFunds = false;
      this.getSSData();
    }
  }

  removeFundingItem(item) {
    this.fundingItems.splice(this.fundingItems.indexOf(item), 1);   
  }

  addFunds: boolean;
  public investmentOption: number = 1;
  currentYear = new Date().getFullYear();
  contributionAmount;
  handleNewFundingItem(fundingSource: string, annContribution: any, startAge: number, endAge: number, inflationRate: number) {

    this.addFunds = true;

    //check year here
    if (startAge < this.currentYear) {
      startAge = this.currentYear;
    }

    if (endAge < startAge || endAge > (this.client.clientProfile.LifeExpectancy - this.calculateAge(this.client.client.DOB)) + this.currentYear) {
      //need to check if client has a spouse, if has a spouse, we need to keep calculating after client passes if spouse is still alive
      if(this.client.clientProfile.Spouses[0].maritalStatus == 'Married'){ //this.includeSpouse || 
        if((this.client.clientProfile.Spouses[0].LifeExpectancy - this.calculateAge(this.client.clientProfile.Spouses[0].dob)) > (this.client.clientProfile.LifeExpectancy - this.calculateAge(this.client.client.DOB))){
          if(endAge > (this.client.clientProfile.Spouses[0].LifeExpectancy - this.calculateAge(this.client.clientProfile.Spouses[0].dob)) + this.currentYear){
            endAge = (this.client.clientProfile.Spouses[0].LifeExpectancy - this.calculateAge(this.client.clientProfile.Spouses[0].dob)) + this.currentYear;
          }
        } else {
          endAge = (this.client.clientProfile.LifeExpectancy - this.calculateAge(this.client.client.DOB)) + this.currentYear;
        }
      } else {
        endAge = (this.client.clientProfile.LifeExpectancy - this.calculateAge(this.client.client.DOB)) + this.currentYear;
      }
    }

    annContribution = Utils.formatToNumber(annContribution)
    var contributionAmount = this.getFutureContributionAmountV2(annContribution, endAge - startAge, inflationRate, startAge, null);

    this.totalRemainingGap = this.formatNumber((this.totalRemainingGap - Number(contributionAmount)));

    this.fundingItems.push({
      fundingSource,
      annContribution,
      startAge,
      endAge,
      inflationRate,
      contributionAmount: this.formatNumber(contributionAmount),
      remainingUnfunded: this.formatNumber(this.totalRemainingGap)
    });
    this.getSSData();
  }

  formatNumber(amount) {
    return Math.round(amount);
  }

  getFutureContributionAmountV2(startAmount, years, inflation, startAge, idx) {
    var result = 0;

    for (let i = 0; i < years + 1; i++) {
      result = result + (startAmount * Math.pow((1 + inflation / 100), i));
    }

    return result;
  }

  returnedAdjustStartInvestment(data){
        
    console.log('adj fund data', data);
    console.log('from funding year dropdown', data.selectedBalance);
    /* if(data.isWeekly){
      //this.weeklyCost = data.selectedBalance;
      this.bodyCardSelectedIndexWeekly = data.selectedDropDownIndex;
    } else {
      //this.yearlyCost = data.selectedBalance;
      this.bodyCardSelectedIndexAnnually = data.selectedDropDownIndex;
    } */
    // this.bodyCardSelectedIndex = data.selectedDropDownIndex;
    if(this.isFirstCall && this.hasAlternateScenario){
      
      let dOB = new Date(this.client.client.DOB);
      let timeDiff = Math.abs(Date.now() - dOB.getTime());
      let clientAge = Math.floor((timeDiff / (1000 * 3600 * 24))/365.25);
      let retirementAge = this.client.clientProfile.RetirementAge;  
            
      if (clientAge <= retirementAge) {
        var optAge = parseInt(this.ssDataAlt.cusStartBenLabel.split('/')[0].replace(' month', '').replace(' months', '').replace('ms', '').replace(' and', ''));
        this.annuallyWeeklyTtlYear = ((optAge - clientAge) > 1) ? optAge - clientAge : 1;
        this.orgAltAnnuallyWeeklyTtlYear = ((optAge - clientAge) > 1) ? optAge - clientAge : 1;
        this.dropDownSelectedIndexWeekly = this.dropDownSelectedIndexAnnually = this.annuallyWeeklyTtlYear;

        data.selectedDropDownIndex = this.annuallyWeeklyTtlYear;
      }
    }
    
    this.adjustFundingForSelectedScenario(data.selectedDropDownIndex, data.isWeekly);
    //this.loadingService.isLoading(false);
  }

  objAdjustedDesiredScenario = {} as any;// = {clientAgeYears: '65', clientAgeMonths: '12', spouseAgeYears: null, spouseAgeMonths: null};
  adjustModalWasUsed = false;
  returnedAdjustedDesiredScenario(data) {
    this.loadingService.isLoading(true);
    this.globalService.isAltComplete = false;
    console.log('retured data to SS page for DESIRED update', data);
    this.isPageReloadOtherThanFRACall = false;
    this.objAdjustedDesiredScenario = data;
    this.adjustModalWasUsed = true;
    console.log('adjustModalWasUsed', this.adjustModalWasUsed);
    //this.socialSecurityForm.controls['selfRetirementYears'].setValue(data.clientAgeYears);
    //this.socialSecurityForm.controls['selfRetirementMonths'].setValue(data.clientAgeMonths);

    this.socialSecurityForm.patchValue({'selfRetirementYears': data.clientAgeYears });
    this.socialSecurityForm.patchValue({'selfRetirementMonths': data.clientAgeMonths });
    
    this.ssObject.selfRetirementYears = data.clientAgeYears;
    this.ssObject.selfRetirementMonths = (data.clientAgeMonths) ? data.clientAgeMonths : 0;
    
    /* if (this.client.clientProfile.Spouses[0].maritalStatus == "Divorced") {
      //TODO: shouldnt this get assigned to the new desired claim age for Divorced?
      this.ssObject.spouseRetirementYears = (this.client.clientProfile.Spouses[0].expectedClaimAgeYears) ? this.client.clientProfile.Spouses[0].expectedClaimAgeYears || 0 : 62;
      this.ssObject.spouseRetirementMonths = (this.client.clientProfile.Spouses[0].expectedClaimAgeMonths) ? this.client.clientProfile.Spouses[0].expectedClaimAgeMonths || 0 : 0;
    } else if (this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed') {     
      this.ssObject.spouseRetirementYears = (this.client.clientProfile.Spouses[0].exSpouseClaimAgeYears) ? this.client.clientProfile.Spouses[0].exSpouseClaimAgeYears || 0 : 62;
      this.ssObject.spouseRetirementMonths = (this.client.clientProfile.Spouses[0].exSpouseClaimAgeMonths) ? this.client.clientProfile.Spouses[0].exSpouseClaimAgeMonths || 0 : 0;
 
    } */
    
    if(this.includeSpouse && this.client.clientProfile.Spouses[0].maritalStatus != 'Widowed'){
      this.socialSecurityForm.controls['spouseRetirementYears'].setValue(data.spouseAgeYears);
      this.socialSecurityForm.controls['spouseRetirementMonths'].setValue(data.spouseAgeMonths);
      this.ssObject.spouseRetirementYears = data.spouseAgeYears;
      this.ssObject.spouseRetirementMonths = data.spouseAgeMonths;
    }

    let showSurvivorSection = this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed' 
      || (this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' && !this.client.clientProfile.Spouses[0].alive && this.client.clientProfile.Spouses[0].tenyears) ? true : false;
    
      let isSpouseSurvivor = this.client.clientProfile.Spouses[0].maritalStatus == 'Married' && this.isSpouseSurvivor ? true : false
    showSurvivorSection = isSpouseSurvivor ? true : showSurvivorSection;
    
    if ((this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed' 
    || (this.client.clientProfile.Spouses[0].maritalStatus == 'Single' || this.client.clientProfile.Spouses[0].maritalStatus == 'Married') && this.includeSpouse) 
      && (data.survivorSwitchAgeYears || showSurvivorSection)){
      console.log('looking switch age', data.survivorSwitchAgeYears);
      // if (showSurvivorSection) {
        console.log('this.swappedClaim', this.swappedClaim);
        this.swappedClaim = data.swappedClaim == null ? false : data.swappedClaim;
        console.log('this.swappedClaim', this.swappedClaim);
        if(isSpouseSurvivor) {
          this.adjSurvivorBenefitAge = !data.swappedClaim ? data.survivorSwitchAgeYears : data.spouseAgeYears;
          this.adjSurvivorBenefitMonths = !data.swappedClaim ? data.survivorSwitchAgeMonths : data.spouseAgeMonths;
          this.adjRetirementBenefitAge = !data.swappedClaim ? data.spouseAgeYears : data.survivorSwitchAgeYears;
          this.adjRetirementBenefitMonths = !data.swappedClaim ? data.spouseAgeMonths : data.survivorSwitchAgeMonths;
          console.log('adjSurvivorBenefitAge', this.adjSurvivorBenefitAge);
          console.log('adjRetirementBenefitAge', this.adjRetirementBenefitAge);
          console.log('swappedClaim', this.swappedClaim);
          console.log('swappedClaim- spouse');
        } else {
          console.log('looking switch age 03')
          console.log('data.swappedClaim', data.swappedClaim)
          console.log('data', data);
          this.adjSurvivorBenefitAge = !data.swappedClaim ? data.survivorSwitchAgeYears : data.clientAgeYears;
          this.adjSurvivorBenefitMonths = !data.swappedClaim ? data.survivorSwitchAgeMonths : data.clientAgeMonths;
          this.adjRetirementBenefitAge = !data.swappedClaim ? data.clientAgeYears : data.survivorSwitchAgeYears;
          this.adjRetirementBenefitMonths = !data.swappedClaim ? data.clientAgeMonths : data.survivorSwitchAgeMonths;
        }
      // }
      // this.swappedClaim = !data.swappedClaim;
      this.adjSurvivorModal = true;
    } else if (this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed' 
    || (this.client.clientProfile.Spouses[0].maritalStatus == 'Single' || this.client.clientProfile.Spouses[0].maritalStatus == 'Married') && this.includeSpouse) {
      if(this.client.clientProfile.Spouses[0].maritalStatus == 'Married' && this.isSpouseSurvivor){
        console.log('inside retirement benefit age 01')
        this.adjRetirementBenefitAge = !data.swappedClaim ? data.spouseAgeYears : data.survivorSwitchAgeYears;
        this.adjRetirementBenefitMonths = !data.swappedClaim ? data.spouseAgeMonths : data.survivorSwitchAgeMonths;
      } else {
        console.log('inside retirement benefit age 02')
        this.adjRetirementBenefitAge = !data.swappedClaim ? data.clientAgeYears : data.survivorSwitchAgeYears;
        this.adjRetirementBenefitMonths = !data.swappedClaim ? data.clientAgeMonths : data.survivorSwitchAgeMonths;

        console.log('data.survivorSwitchAgeYears', data.survivorSwitchAgeYears);
        this.adjSurvivorBenefitAge = !data.swappedClaim ? data.survivorSwitchAgeYears : data.clientAgeYears;
        this.adjSurvivorBenefitMonths = !data.swappedClaim ? data.survivorSwitchAgeMonths : data.clientAgeMonths;
      }
      this.adjSurvivorModal = true;
    }

    console.log(this.adjSurvivorBenefitAge, this.adjSurvivorBenefitMonths, this.adjRetirementBenefitAge, this.adjRetirementBenefitMonths)

    //filing restricted client or spouse
    /* if(data.isClientFilingRestricted && data.fileRestrictedAgeYears){
      this.ssObject.SelfFilingRestrictedYear = data.clientAgeYears;//data.fileRestrictedAgeYears;
      this.ssObject.SelfFilingRestrictedMonth = (data.clientAgeMonths ? data.clientAgeMonths : 0);//data.fileRestrictedAgeMonths;

      this.ssObject.selfRetirementYears = data.fileRestrictedAgeYears;//data.clientAgeYears;
      this.ssObject.selfRetirementMonths = data.fileRestrictedAgeMonths;//(data.clientAgeMonths ? data.clientAgeMonths : 0);
    }

    if(data.isSpouseFilingRestricted && data.spouseFileRestrictedAgeYears){
      this.ssObject.SpouseFilingRestrictedYear = data.spouseAgeYears;//data.spouseFileRestrictedAgeYears;
      this.ssObject.SpouseFilingRestrictedMonth = (data.spouseAgeMonths) ? data.spouseAgeMonths : 0;//data.spouseFileRestrictedAgeMonths;

      this.ssObject.spouseRetirementYears = data.spouseFileRestrictedAgeYears;//data.spouseAgeYears;
      this.ssObject.spouseRetirementMonths = data.spouseFileRestrictedAgeMonths;//data.spouseAgeMonths;
    } */

    if(this.socialSecurityIllustrationCards.length > 3 && !this.hasAlternateScenario){
      this.socialSecurityIllustrationCards.pop();
    }

    //this.ssObject.isClientRetroFiling = data.isClientRetroFiling;
    //console.log('retro return', data.isClientRetroFiling);

    this.swappedClaim = data.swappedClaim == null ? false : data.swappedClaim;
    this.objAdjustedDesiredScenario.swappedClaim = data.swappedClaim;//this.swappedClaim;
    //this.ssObject.InvertSurvivorSwitch = data.swappedClaim;

    console.log('display updated ssObject', this.ssObject);

    if(data.saveDCA){
      console.log('saved modal data', data);
      //save the claim ages to the client and/or spouse profiles
      this.updateClientProfile(data);
    }

    //TODO: because of new logic with the Alt stuff....this should probably only call alt
    /* if((data.isClientFilingRestricted && data.fileRestrictedAgeYears) || (data.isSpouseFilingRestricted && data.spouseFileRestrictedAgeYears)){
      this.getSSData();
    } else {
      this.getSSDataAlt(this.storedFRAScenario, this.hasAlternateScenario, true);
    } */

    this.getSSDataAlt(this.storedFRAScenario, this.hasAlternateScenario, true, true, data);

    if(this.hasTBCBeenAdjustedAfterPageLoad){
      this.totalBenefitCalc();
    }
  }

  /**
 * Type guard to check if an unknown value is a valid stringified JSON object or array.
 */
 isStringifiedJSON(value: unknown): value is string {
  // 1. Must be a non-empty string
  if (typeof value !== 'string' || value.trim() === '') {
    return false;
  }

  try {
    const parsed = JSON.parse(value);

    // 2. Filter out primitive matches like numbers, booleans, or null
    // (JavaScript evaluates typeof null as 'object', so explicitly exclude it)
    return typeof parsed === 'object' && parsed !== null;
  } catch (error) {
    // 3. JSON.parse threw a SyntaxError, so it is not valid stringified JSON
    return false;
  }
}

  rejectOnPageLoad: boolean = false; //used to fix infinite loop issue for reject bool
  hasAdjustedFRAScenario: boolean = false;
  changedAlt2BackToFRA: boolean = false;
  objAdjustedFRAScenario;
  ssObjectFRA;
  returnedAdjustedFRAScenario(data){
    this.loadingService.isLoading(true);
    this.isPageReloadOtherThanFRACall = false;
    console.log('retured data to SS page for FRA update', data);

    if(!this.ssObjectFRA){
      this.ssObjectFRA = { ...this.ssObject };
    }
    
    // If none of the values have changed then don't set adjusted FRA bool
    if (this.ssObjectFRA && (
      Number(this.ssObjectFRA.selfRetirementYears) != Number(data.clientAgeYears)
      || Number(this.ssObjectFRA.selfRetirementMonths) != Number(data.clientAgeMonths)
      || Number(this.ssObjectFRA.spouseRetirementYears) != Number(data.spouseAgeYears)
      || Number(this.ssObjectFRA.spouseRetirementMonths) != Number(data.spouseAgeMonths)
      || Number(this.ssObjectFRA.SurvivorSwitchYears) != Number(data.survivorSwitchAgeYears)
      || Number(this.ssObjectFRA.SurvivorSwitchMonths) != Number(data.survivorSwitchAgeMonths)
    )
    ) {
      console.log('adjusted FRA = true');
      this.hasAdjustedFRAScenario = true;
    }
    this.illustrationsTypes[1] = "First Alternate";
    this.objAdjustedFRAScenario = data;

    //this.ssObjectFRA = this.ssObject;
    //this.ssObjectFRA = structuredClone(this.ssObject);
    this.ssObjectFRA.IsAltRequest = true;
    this.ssObjectFRA.IsFRAAltRequest = true;
    this.ssObject.IsFRAAltRequest = true;

    //NOTE: per ticket PO2-73, forcing this bool to true on editing FRA, even if same as FRA, fixes UI/PDF issue
    this.hasAdjustedFRAScenario = true;
    console.log('this.ssObjectFRA set on return', this.ssObjectFRA);
    
    //this.socialSecurityForm.patchValue({'selfRetirementYears': data.clientAgeYears });
    //this.socialSecurityForm.patchValue({'selfRetirementMonths': data.clientAgeMonths });
    this.ssObjectFRA.isPresentValue = this.isPresentValue;
    this.ssObjectFRA.selfRetirementYears = data.clientAgeYears || 0;// || data.survivorSwitchAgeYears;
    this.ssObjectFRA.selfRetirementMonths = data.clientAgeMonths || 0;// || data.survivorSwitchAgeMonths;

    if (this.client.clientProfile.Spouses[0].maritalStatus == "Divorced") {
      //TODO: shouldnt this get assigned to the new desired claim age for Divorced?
      this.ssObjectFRA.spouseRetirementYears = (this.client.clientProfile.Spouses[0].expectedClaimAgeYears) ? this.client.clientProfile.Spouses[0].expectedClaimAgeYears || 0 : 62;
      this.ssObjectFRA.spouseRetirementMonths = (this.client.clientProfile.Spouses[0].expectedClaimAgeMonths) ? this.client.clientProfile.Spouses[0].expectedClaimAgeMonths || 0 : 0;
    } else if (this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed') {     
      this.ssObjectFRA.spouseRetirementYears = (this.client.clientProfile.Spouses[0].exSpouseClaimAgeYears) ? this.client.clientProfile.Spouses[0].exSpouseClaimAgeYears || 0 : 62;
      this.ssObjectFRA.spouseRetirementMonths = (this.client.clientProfile.Spouses[0].exSpouseClaimAgeMonths) ? this.client.clientProfile.Spouses[0].exSpouseClaimAgeMonths || 0 : 0;
 
    }

    if(this.includeSpouse && this.client.clientProfile.Spouses[0].maritalStatus != 'Widowed'){
      //this.socialSecurityForm.controls['spouseRetirementYears'].setValue(data.spouseAgeYears);
      //this.socialSecurityForm.controls['spouseRetirementMonths'].setValue(data.spouseAgeMonths);
      //this.ssObjectFRA.spouseRetirementYears = data.spouseAgeYears ? data.spouseAgeYears : this.spouseRetirementYears;
      //this.ssObjectFRA.spouseRetirementMonths = data.spouseAgeYears ? data.spouseAgeMonths >= 0 ? data.spouseAgeMonths : 0 : this.spouseRetirementMonths;
      //console.log('we in obj FRA');
    }

    let showSurvivorSection = this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed' 
      || (this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' && !this.client.clientProfile.Spouses[0].alive && this.client.clientProfile.Spouses[0].tenyears) ? true : false;
    
    let isSpouseSurvivor = this.client.clientProfile.Spouses[0].maritalStatus == 'Married' && (this.isSpouseSurvivor || ((this.objAdjustedFRAScenario.isSurvivorShown && !this.objAdjustedFRAScenario.isSurvivorForClient) ? true : false)) ? true : false;
    this.isSpouseSurvivor = isSpouseSurvivor;
    showSurvivorSection = isSpouseSurvivor ? true : showSurvivorSection;

    if ((this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed' 
    || (this.client.clientProfile.Spouses[0].maritalStatus == 'Single' || this.client.clientProfile.Spouses[0].maritalStatus == 'Married') && this.includeSpouse) 
    && (data.survivorSwitchAgeYears || showSurvivorSection)){

      //Survivor Benefit
      if(isSpouseSurvivor) {
        console.log('Spouse is Survivor 000');
        this.ssObjectFRA.clientSurvivorSwitchYears = !data.swappedClaim ? data.survivorSwitchAgeYears || 0 : data.spouseAgeYears || 0;
        this.ssObjectFRA.clientSurvivorSwitchMonths = !data.swappedClaim ? (data.survivorSwitchAgeMonths > 0) ? data.survivorSwitchAgeMonths || 0 : 0 : data.spouseAgeMonths || 0;
        this.ssObjectFRA.SurvivorSwitchYears = !data.swappedClaim ? data.survivorSwitchAgeYears || 0 : data.spouseAgeYears || 0;
        this.ssObjectFRA.SurvivorSwitchMonths = !data.swappedClaim ? (data.survivorSwitchAgeMonths > 0) ? data.survivorSwitchAgeMonths || 0 : 0 : data.spouseAgeMonths || 0;

        this.ssObjectFRA.spouseRetirementYears = data.swappedClaim ? data.survivorSwitchAgeYears || 0 : data.spouseAgeYears || 0;
        this.ssObjectFRA.spouseRetirementMonths = data.swappedClaim ? (data.survivorSwitchAgeMonths > 0) ? data.survivorSwitchAgeMonths || 0 : 0 : data.spouseAgeMonths || 0;

        this.ssObjectFRA.SpouseFRAAge = this.ssObjectFRA.spouseRetirementYears;
        this.ssObjectFRA.SpouseFRAMonth = this.ssObjectFRA.spouseRetirementMonths;
      } else {
        console.log('Client is Survivor 000');
        this.ssObjectFRA.clientSurvivorSwitchYears = !data.swappedClaim ? data.survivorSwitchAgeYears || 0 : data.clientAgeYears || 0;
        this.ssObjectFRA.clientSurvivorSwitchMonths = !data.swappedClaim ? (data.survivorSwitchAgeMonths > 0) ? data.survivorSwitchAgeMonths || 0 : 0 : data.clientAgeMonths || 0;
        
        this.ssObjectFRA.SurvivorSwitchYears = !data.swappedClaim ? data.survivorSwitchAgeYears : data.clientAgeYears;
        this.ssObjectFRA.SurvivorSwitchMonths = !data.swappedClaim ? (data.survivorSwitchAgeMonths > 0) ? data.survivorSwitchAgeMonths || 0 : 0 : data.clientAgeMonths || 0;

        this.ssObjectFRA.selfRetirementYears = data.swappedClaim ? data.survivorSwitchAgeYears || 0 : data.clientAgeYears || 0;
        this.ssObjectFRA.selfRetirementMonths = data.swappedClaim ? (data.survivorSwitchAgeYears > 0) ? data.survivorSwitchAgeMonths || 0 : 0 : data.clientAgeMonths || 0;
        // this.ssObjectFRA.selfRetirementYears = !data.swappedClaim ? data.survivorSwitchAgeYears || 0 : data.clientAgeYears || 0;
        // this.ssObjectFRA.selfRetirementMonths = !data.swappedClaim ? (data.survivorSwitchAgeYears > 0) ? data.survivorSwitchAgeMonths || 0 : 0 : data.clientAgeMonths || 0;

        // SMALLA : if client only have retirement benefit but not survivor benefit then it is passing 0 value as selfRetirementYears. As a result it will show 0 age in card and also benefit value not matching with PDF (Polly Valdemire).
        //this.ssObjectFRA.selfRetirementYears = data.swappedClaim ? data.survivorSwitchAgeYears || 0 : data.clientAgeYears ? data.clientAgeYears : data.survivorSwitchAgeYears;
        //this.ssObjectFRA.selfRetirementMonths = data.swappedClaim ? (data.survivorSwitchAgeYears > 0) ? data.survivorSwitchAgeMonths || 0 : 0 : data.clientAgeYears ? data.clientAgeMonths || 0: data.survivorSwitchAgeMonths;
        
        //this.ssObjectFRA.SurvivorSwitchYears = data.swappedClaim ? data.survivorSwitchAgeYears : data.clientAgeYears;
        //this.ssObjectFRA.SurvivorSwitchMonths = data.swappedClaim ? (data.survivorSwitchAgeMonths > 0) ? data.survivorSwitchAgeMonths || 0 : 0 : data.clientAgeMonths || 0;
 
        //this.ssObjectFRA.selfRetirementYears = !data.swappedClaim ? data.survivorSwitchAgeYears || 0 : data.clientAgeYears || 0;
        //this.ssObjectFRA.selfRetirementMonths = !data.swappedClaim ? (data.survivorSwitchAgeYears > 0) ? data.survivorSwitchAgeMonths || 0 : 0 : data.clientAgeMonths || 0;

        this.ssObjectFRA.SelfFRAAge = this.ssObjectFRA.selfRetirementYears;
        this.ssObjectFRA.SelfFRAMonth = this.ssObjectFRA.selfRetirementMonths;
        console.log('in client 899');
        console.log('this.ssObjectFRA.selfRetirementYears 01', this.ssObjectFRA.selfRetirementYears)
        console.log('data.swappedClaim ', data.swappedClaim )
      }
      
      /* this.adjSurvivorModalFRA = true
      // this.isSurvAndFirstLoadSwapped = true
      this.ssObjectFRA.invertSurvivorSwitch = !data.swappedClaim ? 0 : 1;
      this.swappedClaimFRA = data.swappedClaim; */

    } else {

     /*  this.ssObjectFRA.clientSurvivorSwitchYears = data.swappedClaim ? data.survivorSwitchAgeYears || 0 : data.clientAgeYears || 0;
      this.ssObjectFRA.clientSurvivorSwitchMonths = data.swappedClaim ? (data.survivorSwitchAgeMonths > 0) ? data.survivorSwitchAgeMonths || 0 : 0 : data.clientAgeMonths || 0;
      this.ssObjectFRA.SurvivorSwitchYears = data.swappedClaim ? data.survivorSwitchAgeYears || 0 : data.clientAgeYears || 0;
      this.ssObjectFRA.SurvivorSwitchMonths = data.swappedClaim ? (data.survivorSwitchAgeMonths > 0) ? data.survivorSwitchAgeMonths || 0 : 0 : data.clientAgeMonths || 0; */
      //data.swappedClaim = true;

      this.ssObjectFRA.clientSurvivorSwitchYears = data.swappedClaim ? data.survivorSwitchAgeYears || 0 : data.clientAgeYears || 0;
        this.ssObjectFRA.clientSurvivorSwitchMonths = data.swappedClaim ? (data.survivorSwitchAgeMonths > 0) ? data.survivorSwitchAgeMonths || 0 : 0 : data.clientAgeMonths || 0;
        this.ssObjectFRA.SurvivorSwitchYears = data.swappedClaim ? data.survivorSwitchAgeYears || 0 : data.clientAgeYears || 0;
        this.ssObjectFRA.SurvivorSwitchMonths = data.swappedClaim ? (data.survivorSwitchAgeMonths > 0) ? data.survivorSwitchAgeMonths || 0 : 0 : data.clientAgeMonths || 0;


      this.ssObjectFRA.selfRetirementYears = (data.clientAgeYears) ? data.clientAgeYears : data.survivorSwitchAgeYears;//!data.swappedClaim ? data.survivorSwitchAgeYears || 0 : data.clientAgeYears  || 0;
      this.ssObjectFRA.selfRetirementMonths = (data.clientAgeYears) ? (data.clientAgeMonths) ? data.clientAgeMonths : 0 : data.survivorSwitchAgeMonths;//!data.swappedClaim ? (data.survivorSwitchAgeMonths > 0) ? data.survivorSwitchAgeMonths || 0 : 0 : data.clientAgeMonths || 0;
      //this.ssObjectFRA.selfRetirementYears = !data.swappedClaim ? data.survivorSwitchAgeYears || 0 : data.clientAgeYears || 0;
      //this.ssObjectFRA.selfRetirementMonths = !data.swappedClaim ? (data.survivorSwitchAgeYears > 0) ? data.survivorSwitchAgeMonths || 0 : 0 : data.clientAgeMonths || 0;
        
      this.ssObjectFRA.spouseRetirementYears = data.spouseAgeYears || 0;//data.swappedClaim ? data.survivorSwitchAgeYears || 0 : data.spouseAgeYears || 0;
      this.ssObjectFRA.spouseRetirementMonths = data.spouseAgeMonths || 0;//data.swappedClaim ? (data.survivorSwitchAgeMonths > 0) ? data.survivorSwitchAgeMonths || 0 : 0 : data.spouseAgeMonths || 0;

      

      /* this.ssObjectFRA.clientSurvivorSwitchYears = !data.swappedClaim ? data.survivorSwitchAgeYears || 0 : data.clientAgeYears || 0;
      this.ssObjectFRA.clientSurvivorSwitchMonths = !data.swappedClaim ? (data.survivorSwitchAgeMonths > 0) ? data.survivorSwitchAgeMonths || 0 : 0 : data.clientAgeMonths || 0;
        
      this.ssObjectFRA.SurvivorSwitchYears = !data.swappedClaim ? data.survivorSwitchAgeYears : data.clientAgeYears;
      this.ssObjectFRA.SurvivorSwitchMonths = !data.swappedClaim ? (data.survivorSwitchAgeMonths > 0) ? data.survivorSwitchAgeMonths || 0 : 0 : data.clientAgeMonths || 0;

      this.ssObjectFRA.selfRetirementYears = data.swappedClaim ? data.survivorSwitchAgeYears || 0 : data.clientAgeYears || 0;
      this.ssObjectFRA.selfRetirementMonths = data.swappedClaim ? (data.survivorSwitchAgeYears > 0) ? data.survivorSwitchAgeMonths || 0 : 0 : data.clientAgeMonths || 0; */
      console.log('I think here 88');

      /* this.adjSurvivorModalFRA = true
      // this.isSurvAndFirstLoadSwapped = true
      this.ssObjectFRA.invertSurvivorSwitch = !data.swappedClaim ? 0 : 1;
      this.swappedClaimFRA = data.swappedClaim; */
    }

    this.adjSurvivorModalFRA = true;
    // this.isSurvAndFirstLoadSwapped = true
    this.ssObjectFRA.invertSurvivorSwitch = !data.swappedClaim ? 0 : 1;
    this.ssObjectFRA.InvertSurvivorSwitchFRA = !data.swappedClaim ? 0 : 1;
    this.swappedClaimFRA = data.swappedClaim == null ? false : data.swappedClaim;

    // if(this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed' && data.survivorSwitchAgeYears){
    //   //Survivor Benefit
    //   this.swappedClaimFRA = data.swappedClaim;
    //   this.adjSurvivorBenefitAgeFRA = data.swappedClaim ? data.survivorSwitchAgeYears : data.clientAgeYears;
    //   this.adjSurvivorBenefitMonthsFRA = data.swappedClaim ? data.survivorSwitchAgeMonths : data.clientAgeMonths;
    //   this.adjRetirementBenefitAgeFRA = data.swappedClaim ? data.clientAgeYears : data.survivorSwitchAgeYears;
    //   this.adjRetirementBenefitMonthsFRA = data.swappedClaim ? data.clientAgeMonths : data.survivorSwitchAgeMonths;
    //   this.adjSurvivorModalFRA = true;
    // }

    //filing restricted client or spouse
    /* if(data.isClientFilingRestricted && data.fileRestrictedAgeYears){
      this.ssObjectFRA.SelfFilingRestrictedYear = data.clientAgeYears;//data.fileRestrictedAgeYears;
      this.ssObjectFRA.SelfFilingRestrictedMonth = (data.clientAgeMonths ? data.clientAgeMonths : 0);//data.fileRestrictedAgeMonths;

      this.ssObjectFRA.selfRetirementYears = data.fileRestrictedAgeYears;//data.clientAgeYears;
      this.ssObjectFRA.selfRetirementMonths = data.fileRestrictedAgeMonths;//(data.clientAgeMonths ? data.clientAgeMonths : 0);
    }

    if(data.isSpouseFilingRestricted && data.spouseFileRestrictedAgeYears){
      this.ssObjectFRA.SpouseFilingRestrictedYear = data.spouseAgeYears;//data.spouseFileRestrictedAgeYears;
      this.ssObjectFRA.SpouseFilingRestrictedMonth = data.spouseAgeMonths;//data.spouseFileRestrictedAgeMonths;

      this.ssObjectFRA.spouseRetirementYears = data.spouseFileRestrictedAgeYears;//data.spouseAgeYears;
      this.ssObjectFRA.spouseRetirementMonths = data.spouseFileRestrictedAgeMonths;//data.spouseAgeMonths;
    }
 */
    /* this.ssObjectFRA.spouseRetirementYears = 69;
    this.ssObjectFRA.spouseRetirementMonths = 9;

    this.ssObjectFRA.SpouseFRAAge = 69;
    this.ssObjectFRA.SpouseFRAMonth = 9; */

    this.objAdjustedFRAScenario.swappedClaim = this.swappedClaimFRA;
    
    console.log('before FRA calls getSSData', this.ssObjectFRA);
    // console.log('before FRA calls getSSData', this.ssObjectFRA.SelfRetirementYears);
    console.log('this.ssObjectFRA.selfRetirementYears 02', this.ssObjectFRA.selfRetirementYears)

    //this.getSSData();
    //ZSS 120423: added to help with issues on display when updating FRA to First Alt
    //and toggling between PV and FV after First Alt adjustments
    this.getSSDataFRAAlt();

    if(this.hasTBCBeenAdjustedAfterPageLoad){
      this.totalBenefitCalc();
    }
  }

  returnedRemoveDesiredScenario(data){
    //remove the Desired/Alternate scenario from page/illustration
    this.hasAlternateScenario = false;
    this.isAltCardRemoved = true;

    this.adjRetirementBenefitAge = 0;
    this.adjRetirementBenefitMonths = 0;
    this.adjSurvivorBenefitAge = 0;
    this.adjSurvivorBenefitMonths = 0;
    this.objAdjustedDesiredScenario.clientAgeYears = 0
    this.objAdjustedDesiredScenario.clientAgeMonths = 0
    this.objAdjustedDesiredScenario.survivorSwitchAgeYears = 0
    this.objAdjustedDesiredScenario.survivorSwitchAgeMonths = 0
    this.swappedClaim = false;

    this.colorScheme.domain.pop();
    this.illustrationsTypes.pop();
    this.illustrationComparisons.pop();
    this.lineGraphData = null;
    this.comparisonGraph = this.createComparisonGraphData(this.ssData.costsByCareAndRegionBody);
    /* this.socialSecurityIllustrationCards.pop();    
    this.socialSecurityIllustrationCards.push(
      { scenario: 'AddAlternate', color: '#0a4e8d', clientName: this.client.client.FirstName }
      ); */

    this.socialSecurityBenefitCards.pop();

    // this.setSelectedLifeExpectancyPoint();
  }

  returnedRemoveFRAScenario(data){
    this.loadingService.isLoading(true);
    console.log('retured removed data from SS page for FRA update', data);
    
    this.illustrationsTypes[1] = "FRA";
    this.hasAdjustedFRAScenario = false;
    this.changedAlt2BackToFRA = true;
    /* this.socialSecurityBenefitCards[1].scenario = "FRA";
    if(this.hasAlternateScenario){
      this.socialSecurityBenefitCards[3].scenario = "Alternate";
    } */
    this.objAdjustedFRAScenario = null;
    this.ssObjectFRA = null;
    this.ssObject.IsFRAAltRequest = false;

    this.getSSData();
  }

  getClient(isClient) {
    this.isClient = isClient;
    this.globalService.getClientData(Number(localStorage.getItem("selectedClient")), 4)
      .subscribe(
        clientResult => {
          // smalla 11/25/22 - implement the logic to handle the non legal married case - to run each as a single
          this.client = cloneDeep(clientResult);
          this.backUpClient = cloneDeep(clientResult);
          this.client.clientProfile.Spouses = JSON.parse(this.client.clientProfile.Spouses);
          this.backUpClient.clientProfile.Spouses = JSON.parse(this.backUpClient.clientProfile.Spouses);
          this.clientFullName = this.backUpClient.client.FirstName + " " + this.backUpClient.client.LastName;

          const fullDOB = new Date(this.client.client.DOB.toString());

          if (this.backUpClient.clientProfile.Spouses[0].maritalStatus == 'Married') {
            const spouseFullDOB = new Date(this.client.clientProfile.Spouses[0].dob.toString());
            // ZSS need to review: uncomment !this.backUpClient.clientProfile.SSDesiredAgeYears && this.backUpClient.clientProfile.Spouses[0].sSDesiredAgeYears
            // PR: https://hvsfin.visualstudio.com/HVSPortal-v2/_git/HVSPortal-v2/pullrequest/1357?_a=files&path=/src/app/social-security/social-security.component.ts
            if (this.backUpClient.clientProfile.SelfAlreadyCollecting && this.backUpClient.clientProfile.DateOfClaimYear && this.backUpClient.clientProfile.DateOfClaimMonth && !this.backUpClient.clientProfile.SSDesiredAgeYears && this.backUpClient.clientProfile.Spouses[0].sSDesiredAgeYears) {
              let clientAgeMonths = (new Date().getMonth() + 1) - this.getBirthdayMonth(this.client.client.DOB);
              clientAgeMonths = clientAgeMonths < 0 ? 12 + clientAgeMonths : clientAgeMonths;
              let getClaimAge = this.getAgeYearAtClaimYear(fullDOB, this.client.clientProfile.DateOfClaimYear, this.client.clientProfile.DateOfClaimMonth);
              this.client.clientProfile.SSDesiredAgeYears = getClaimAge > this.calculateAge(this.backUpClient.client.DOB) ? getClaimAge : this.calculateAge(this.backUpClient.client.DOB);
              this.client.clientProfile.SSDesiredAgeMonths = getClaimAge > this.calculateAge(this.backUpClient.client.DOB) ? this.getAgeMonthAtClaimMonth(fullDOB, this.client.clientProfile.DateOfClaimMonth) : clientAgeMonths;
              this.backUpClient.clientProfile.SSDesiredAgeYears = this.client.clientProfile.SSDesiredAgeYears;
              this.backUpClient.clientProfile.SSDesiredAgeMonths = this.client.clientProfile.SSDesiredAgeMonths;
            }
            // ZSS need to review: uncomment !this.backUpClient.clientProfile.Spouses[0].sSDesiredAgeYears && this.backUpClient.clientProfile.SSDesiredAgeYears
            if (this.backUpClient.clientProfile.SpouseAlreadyCollecting && this.backUpClient.clientProfile.Spouses[0].dateOfClaimYear && this.backUpClient.clientProfile.Spouses[0].dateOfClaimMonth && spouseFullDOB && !this.backUpClient.clientProfile.Spouses[0].sSDesiredAgeYears && this.backUpClient.clientProfile.SSDesiredAgeYears) {
              let spouseAgeMonths = (new Date().getMonth() + 1) - this.getBirthdayMonth(this.client.clientProfile.Spouses[0].dob);
              spouseAgeMonths = spouseAgeMonths < 0 ? 12 + spouseAgeMonths : spouseAgeMonths;
              let getSpouseClaimAge = this.getAgeYearAtClaimYear(spouseFullDOB, this.client.clientProfile.Spouses[0].dateOfClaimYear, this.client.clientProfile.Spouses[0].dateOfClaimMonth);
              this.client.clientProfile.Spouses[0].sSDesiredAgeYears = getSpouseClaimAge > this.calculateAge(this.client.clientProfile.Spouses[0].dob) ? getSpouseClaimAge: this.calculateAge(this.client.clientProfile.Spouses[0].dob);
              this.client.clientProfile.Spouses[0].sSDesiredAgeMonths = getSpouseClaimAge > this.calculateAge(this.client.clientProfile.Spouses[0].dob) ? this.getAgeMonthAtClaimMonth(spouseFullDOB, this.client.clientProfile.Spouses[0].dateOfClaimMonth): spouseAgeMonths;
              this.backUpClient.clientProfile.Spouses[0].sSDesiredAgeYears = this.client.clientProfile.Spouses[0].sSDesiredAgeYears;
              this.backUpClient.clientProfile.Spouses[0].sSDesiredAgeMonths = this.client.clientProfile.Spouses[0].sSDesiredAgeMonths;
            }
          }

          console.log('this.backUpClient 02', this.backUpClient);
          const age = this.calculateAge(new Date(this.backUpClient.client.DOB));
          const nowDate = new Date();
          this.currentAgeOffset = (nowDate.getMonth() < new Date(this.backUpClient.client.DOB).getMonth()) ? 1 : 0;
          this.clientSurvivorSwitchYears = this.backUpClient.clientProfile.SurvivorSwitchYears || 0;
          this.clientSurvivorSwitchMonths =  this.backUpClient.clientProfile.SurvivorSwitchMonths || 0;
          // if (this.backUpClient.clientProfile.Spouses[0] && this.backUpClient.clientProfile.Spouses[0].maritalStatus != 'Married') {
          if (this.backUpClient.clientProfile.Spouses[0] && this.backUpClient.clientProfile.Spouses[0].maritalStatus == 'Single') {
            if(this.backUpClient.clientProfile.Spouses[1] && this.backUpClient.clientProfile.Spouses[1].maritalStatus != 'Widowed'){
              if(this.backUpClient.clientProfile.Spouses[1].alive && this.backUpClient.clientProfile.Spouses[1].tenyears){
                //console.log('spouse IS alive | HAS BEEN together 10rys')
                this.includeSpouse = true;
              } else {
                //console.log('spouse IS NOT alive | NOT together 10rys')
                if(!this.backUpClient.clientProfile.Spouses[1].alive && this.backUpClient.clientProfile.Spouses[1].tenyears){
                  //(041623) this is for Divorced to Widowed cases
                  this.includeSpouse = true;
                } else {
                  this.includeSpouse = false;
                }
              }
            } else {
              this.includeSpouse = false;
            }
          } else {
            //ZSS added cause of the Survivor Switch Widow issues we were seeing
            /* if (this.backUpClient.clientProfile.Spouses[0] && this.backUpClient.clientProfile.Spouses[0].maritalStatus != 'Widowed') {
              this.includeSpouse = true;
            } else {
              this.includeSpouse = false;
            } */
            console.log('says im not single in here');
            this.includeSpouse = true;
          }
          
          // if (this.backUpClient.clientProfile.Spouses[0] && this.backUpClient.clientProfile.Spouses[0].maritalStatus == 'Widowed') {
          //   this.includeSpouse = false;
          // }

          //this.includeSpouse = true;
          console.log('this.includeSpouse zss', this.includeSpouse);
          
          if (this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].isLegalSpouse == 0) {
            // console.log('insidethis.nonLegalMarried')
            this.isNonLegalMarried = this.backUpClient.clientProfile.Spouses[0] && (this.backUpClient.clientProfile.Spouses[0].maritalStatus == "Married" && this.backUpClient.clientProfile.Spouses[0].isLegalSpouse == 0 ? true : false) || false;
            this.spouseFullName = this.backUpClient.clientProfile.Spouses[0] && (this.backUpClient.clientProfile.Spouses[0].maritalStatus == "Married" ? this.backUpClient.clientProfile.Spouses[0].firstName + " "+ this.backUpClient.clientProfile.Spouses[0].lastName : "") || "";
            this.nonLegalMarried(isClient);
          }
          // console.log('outside this.nonLegalMarried', this.client)
          //QUESTION ZSS: does this need to be refigured since we removed the 'Single' status in the Spouses array? Or is this on purpose since its just looking for the second spouse?
          console.log('here not single 01', this.client.clientProfile.Spouses.length);
          let spouses = [];
          spouses[0] = { PIAYears: {} };
          spouses[0].maritalStatus = 'Single';//this.clientModelV2.maritalStatus.maritalStatus;
          spouses[0].pia = '';
          spouses[0].pension = '';
          if (this.client.clientProfile.Spouses.length > 0 && this.backUpClient.clientProfile.Spouses[0].maritalStatus != "Married") {
            //if (this.client.clientProfile.Spouses[0].maritalStatus != 'Single' || this.client.clientProfile.Spouses[1].maritalStatus == 'Divorced' || this.client.clientProfile.Spouses[1].maritalStatus == 'Widowed') {
              console.log('here not single');
              this.client.clientProfile.Spouses = Utils.calculateMostProfitableSpouse(this.client, this.client.clientProfile.Spouses);
              this.client.clientProfile.Spouses = this.client.clientProfile.Spouses ? this.client.clientProfile.Spouses: spouses;
              if (this.client.clientProfile.Spouses) {
                console.log('here check')
              }
              console.log('this.client.clientProfile.Spouses', this.client.clientProfile.Spouses);

              // if (!this.client.clientProfile.Spouses[0]) {
              //   this.client.clientProfile.Spouses = spouses;
              // }

            //}
            // console.log('this.client.clientProfile.Spouses 01', this.client.clientProfile.Spouses);
          }
          let spouseDOB = (this.client.clientProfile.Spouses[0].dobStr && Date.parse(this.client.clientProfile.Spouses[0].dobStr) ? this.client.clientProfile.Spouses[0].dobStr : Date.parse(this.client.clientProfile.Spouses[0].dob) ? this.client.clientProfile.Spouses[0].dob : null) ;
          console.log('reset spouse array', this.client.clientProfile.Spouses);

          if (this.client.clientProfile.Spouses[0]) {
            if (this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced') {
              if (!this.client.clientProfile.Spouses[0].tenyears) {
                this.client.clientProfile.Spouses = spouses;
              } else {
                if (!this.client.clientProfile.Spouses[0].alive) {
                  this.client.clientProfile.Spouses[0].maritalStatus = 'Widowed';
                }
              }

            }
            // if (this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' && !this.client.clientProfile.Spouses[0].alive) {
            //   this.client.clientProfile.Spouses[0].maritalStatus = 'Widowed';
            //   this.client.clientProfile.Spouses = Utils.calculateMostProfitableSpouse(this.client, this.client.clientProfile.Spouses);
            // } else if (this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' && this.client.clientProfile.Spouses[0].alive && !this.client.clientProfile.Spouses[0].tenyears) {
            //   let isSpouseSingle = false;
            //   for (let spouses of this.client.clientProfile.Spouses) {
            //     if (spouses.maritalStatus == 'Divorced' && spouses.alive && !spouses.tenyears) {
            //       isSpouseSingle = true;
            //     } else {
            //       isSpouseSingle = false;
            //       break;
            //     }
            //   }
            //   if (isSpouseSingle) {
            //     let spouses = [];
            //     spouses[0] = { PIAYears: {} };
            //     spouses[0].maritalStatus = 'Single';//this.clientModelV2.maritalStatus.maritalStatus;
            //     spouses[0].pia = '';
            //     spouses[0].pension = '';
            //     this.client.clientProfile.Spouses = spouses;
            //   }
            //   // this.client.clientProfile.Spouses = [];

            // }
            if (this.client.clientProfile.Spouses[0].maritalStatus != 'Single' || this.client.clientProfile.Spouses[0].retirementAge) {
              this.client.clientProfile.Spouses[0].retirementAge = parseInt(this.client.clientProfile.Spouses[0].retirementAge);
            }

            //TODO: figure out how to convert spouses from existing Prodcution clients to Redesign (this needs to be done since the user wont know to go to Client Hub to update once in the new tool)
            if (this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' && this.client.clientProfile.Spouses[0].alive && this.client.clientProfile.Spouses[0].tenyears
              && !(this.client.clientProfile.Spouses[0].expectedClaimAgeYears)) {
              //need to calc LE because it was never set in Prod
              //this looks like it already exists in Prod - commenting out for now to test
              //this.backUpClient.clientProfile.Spouses[0].LifeExpectancy = 0;
              //this.client.clientProfile.Spouses[0].LifeExpectancy = 0;

              //need to set date of birth too
              this.client.clientProfile.Spouses[0].dob = new Date(spouseDOB);
              this.client.clientProfile.Spouses[0].dobStr = this.client.clientProfile.Spouses[0].dob.toString();

              //need to calc this spouses FRA
              //this was never set for a spouse in Prod
              var exSpouseFRA = this.getFRAv2(spouseDOB);
              this.client.clientProfile.Spouses[0].expectedClaimAgeYears = exSpouseFRA.age;
              this.client.clientProfile.Spouses[0].expectedClaimAgeMonths = exSpouseFRA.month;

            } else if (this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed' 
              && this.client.clientProfile.Spouses[0].yearOfStatement == null){
              //need to set year of statement for Widow
              this.client.clientProfile.Spouses[0].yearOfStatement = this.currentYear;
              this.client.clientProfile.Spouses[0].spouseCollectAtTimeOfPassing = false;
            }
          }

          console.log('this.client.clientProfile.Spouses[0]', this.client.clientProfile.Spouses[0]);
          if (this.client.clientProfile.Spouses.length) {
            this.spousePIA = typeof this.client.clientProfile.Spouses[0].pia === 'string' 
              ? this.client.clientProfile.Spouses[0].pia.replace(/,/g,"").replace("$","") 
              : (this.client.clientProfile.Spouses[0].pia) 
              ? this.client.clientProfile.Spouses[0].pia : 0;
          }
          this.client.clientProfile.Children = JSON.parse(this.client.clientProfile.Children);
          
          //TODO: set TBC limits
          this.minClientTBCLifeExp = this.client.clientProfile.RetirementAge;
          //var pre60Widow = false;
          if(this.includeSpouse){
            this.minSpouseTBCLifeExp = this.client.clientProfile.Spouses[0].retirementAge;

            if(this.client.clientProfile.Spouses[0].LifeExpectancy >= 60 && this.client.clientProfile.LifeExpectancy >= 60){
              if(this.client.clientProfile.Spouses[0].maritalStatus == 'Married'){
                if((70 - this.minClientTBCLifeExp) > (70 - this.minSpouseTBCLifeExp)){
                  //client younger
                  this.minClientTBCLifeExp = (70 - this.minSpouseTBCLifeExp) + this.minClientTBCLifeExp;
                } else {
                  //spouse younger
                  this.minSpouseTBCLifeExp = (70 - this.minClientTBCLifeExp) + this.minSpouseTBCLifeExp;
                }

                //need to readjust if reset past LX
                if(this.minSpouseTBCLifeExp > this.client.clientProfile.Spouses[0].retirementAge){
                  this.minSpouseTBCLifeExp = this.client.clientProfile.Spouses[0].retirementAge;
                }
              }
            } else {
              //pre-60 widow
              if(this.client.clientProfile.Spouses[0].LifeExpectancy - this.calculateAge(spouseDOB) > this.client.clientProfile.LifeExpectancy - this.calculateAge(this.client.client.DOB)){
                //spouse outlives client
                this.maxClientTBCLifeExp = this.client.clientProfile.LifeExpectancy;
                this.maxSpouseTBCLifeExp = (59 - (this.client.clientProfile.LifeExpectancy - this.client.clientProfile.RetirementAge)) + this.client.clientProfile.Spouses[0].retirementAge;
              } else {
                //client outlives spouse
                this.maxSpouseTBCLifeExp = this.client.clientProfile.Spouses[0].LifeExpectancy;
                this.maxSpouseTBCLifeExp = (59 - (this.client.clientProfile.Spouses[0].LifeExpectancy - this.client.clientProfile.Spouses[0].retirementAge)) + this.client.clientProfile.RetirementAge;
              }              
            }
          }


          // console.log('spouses', this.client.clientProfile.Spouses);

          this.clientPIA = (this.client.clientProfile.PIA) ? this.client.clientProfile.PIA : 0;
          // console.log('this.client.client.DOB', this.client.client.DOB);
          let FRA = this.getFRAv2(this.client.client.DOB);
          console.log('FRA from SS', FRA);

          this.clientRetirementYears = FRA.age;
          this.clientRetirementMonths = FRA.month;
          console.log('this.clientRetirementYears 01', this.clientRetirementYears );
          console.log('this.clientRetirementMonths 01', this.clientRetirementMonths);

          this.clientClaimStatus = this.calculateAge(this.client.client.DOB) >= 70 ? "True" : "False";

          this.clientClaimStatusDisabled = this.calculateAge(this.client.client.DOB) < 62 && !this.client.clientProfile.Spouses ||
                                           this.calculateAge(this.client.client.DOB) < 62 && this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].maritalStatus !== 'Widowed' || 
                                           this.calculateAge(this.client.client.DOB) < 60 && this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].maritalStatus === 'Widowed' ||
                                           this.calculateAge(this.client.client.DOB) >= 70;

          var clientMonths = 0;
          var spouseMonths = 0;

          // Past FRA, past retirement
          // already collected
          let isSelfAlreadyCollected = this.client.clientProfile.SelfAlreadyCollecting == 1 ? true : false;
          clientMonths = (new Date().getMonth() + 1) - this.getBirthdayMonth(this.client.client.DOB);
          // console.log('this.getBirthdayMonth(this.client.client.DOB)',this.getBirthdayMonth(this.client.client.DOB));
          // console.log('new Date().getMonth() + 1', new Date().getMonth());
          if (clientMonths > 0) {
            this.clientAgeMonth = clientMonths;
          } else if (clientMonths < 0) {
            this.clientAgeMonth = 12 + clientMonths;
          } else {
            this.clientAgeMonth = 0;
          }
          const birthDate = new Date(this.client.client.DOB);
          const startYear = new Date();
          let currentExactAge = this.calculateAge(birthDate);
          console.log('currentExactAge', currentExactAge);
          console.log('isSelfAlreadyCollected', isSelfAlreadyCollected);
          console.log('this.clientRetirementYears', this.clientRetirementYears);
          if (this.clientRetirementYears < currentExactAge || (this.clientRetirementYears == currentExactAge && this.clientRetirementMonths < this.clientAgeMonth)  || isSelfAlreadyCollected) {
            this.clientRetirementYears = currentExactAge;
            if(this.clientRetirementYears >= 70){
              if (age >= 70) {
                this.clientRetirementMonths = this.clientAgeMonth;
              } else {
                this.clientRetirementMonths = 0;
              }
            } else {
              this.clientRetirementMonths = this.clientAgeMonth;
            }
          }


          console.log('this.clientRetirementYears 03', this.clientRetirementYears );
          console.log('this.clientRetirementMonths 03', this.clientRetirementMonths);
          console.log('this.clientRetirementMonths 03', this.clientAgeMonth);
          
          this.dependentChildCount = this.client.clientProfile.Children && this.client.clientProfile.Children.length || 0;


          let previousSpouseWidowSpouse;
          
          for (let spousesSpouse in this.client.clientProfile.Spouses) {
            for (let previousSpouse in this.client.clientProfile.Spouses[spousesSpouse].spousesSpouse) {
              if (this.client.clientProfile.Spouses[spousesSpouse].spousesSpouse[previousSpouse].maritalStatus == 'Widowed')
                previousSpouseWidowSpouse = this.client.clientProfile.Spouses[spousesSpouse].spousesSpouse[previousSpouse];
            }
          }

          this.previousSpouse = previousSpouseWidowSpouse || { pia: "$0"};
          
        /* Internal notes:
        in client make married couple divorced
        change spouse primary insurance amount to be 1500 (make sure this number is twice as mucch then the below)
        change client primary insurance to be 500
        client has to outlive spouse by a few years
        need to be able to set spouse life expectancy
        -run ss report and set all COLA to be 0 for ease of looking

        when the ex-spouse is alive the client gets half; when the ex-spouse is dead, the client gets it all 
        (focus on Alernate cases)
        */
          if (this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus != 'Married') {
            if (this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced'){
              //this.spouseRetirementYears = this.calculateAge(this.client.clientProfile.Spouses[0].dob) > 67 ? Number(this.calculateAge(this.client.clientProfile.Spouses[0].dob)) : 67;
              this.spouseRetirementYears = this.calculateAge(spouseDOB) >= 67 ? Number(this.calculateAge(spouseDOB) + 1) : 67;              
              this.spouseRetirementMonths = 1;
            } else {
              if(this.includeSpouse){
                //console.log('this is setting the spouseRetirementYears');
                //this.spouseRetirementYears = this.calculateAge(this.client.clientProfile.Spouses[0].dob) > 67 ? Number(this.calculateAge(this.client.clientProfile.Spouses[0].dob)) : 67;
                this.spouseRetirementYears = this.calculateAge(spouseDOB) >= 67 ? Number(this.calculateAge(spouseDOB) + 1) : 67;                
                this.spouseRetirementMonths = 1;
              }
            }
            //console.log('zss in here 08', this.client.clientProfile.Spouses);
            if (this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' && !this.client.clientProfile.Spouses[0].alive) {
              //console.log('zss in here 09', this.client.clientProfile.Spouses[0].alive);
              this.client.clientProfile.Spouses[0].maritalStatus = 'Widowed';              
              this.spouseRetirementMonths = 1;
            } 
            
           /*  else if((this.client.clientProfile.Spouses.length > 1 && this.client.clientProfile.Spouses[0].maritalStatus == 'Single')){
              console.log('zss in here 09', this.client.clientProfile.Spouses[0].alive);
              if(this.client.clientProfile.Spouses[1].maritalStatus == 'Divorced' && !this.client.clientProfile.Spouses[1].alive){
                this.client.clientProfile.Spouses[1].maritalStatus = 'Widowed'
              }
            } */

          }

          if (this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Married' || this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced') {
            this.spouseClaimStatus = this.calculateAge(spouseDOB) >= 70 ? "True" : "False";
            this.spouseClaimStatusDisabled = this.calculateAge(spouseDOB) < 62 || this.calculateAge(spouseDOB) >= 70;

            let FRA = this.getFRAv2(spouseDOB);
             console.log('FRA for Spouse', FRA);
            this.spouseRetirementYears = FRA.age;
            this.spouseRetirementMonths = FRA.month;
            // Past FRA, past retirement
            // already collected
            spouseMonths = (new Date().getMonth() + 1) - this.getBirthdayMonth(spouseDOB);
            if (spouseMonths > 0) {
              this.spouseAgeMonth = spouseMonths;
            } else if (spouseMonths < 0) {
              this.spouseAgeMonth = 12 + spouseMonths;
            } else {
              this.spouseAgeMonth = 0;
            }
            let isSpouseAlreadyCollected = this.client.clientProfile.SpouseAlreadyCollecting == 1 ? true : false;
            let spouseAge = this.calculateAge(spouseDOB);
            if (this.spouseRetirementYears < spouseAge  
              || (this.spouseRetirementYears == spouseAge && this.spouseRetirementMonths < this.spouseAgeMonth ) 
              || isSpouseAlreadyCollected) {
              //console.log('set spouse in this if statment');
              this.spouseRetirementYears = spouseAge ;
              // this.spouseRetirementMonths = this.getBirthdayMonth(spouseDOB);

              // this.spouseRetirementMonths = spouseAgeMonth;

              if(this.spouseRetirementYears >= 70){
                if (spouseAge >= 70) {
                  this.spouseRetirementMonths = this.spouseAgeMonth;
                } else {
                  this.spouseRetirementMonths = 0;
                }
              } else {
                this.spouseRetirementMonths = this.spouseAgeMonth;
              }

            }
            

            // this.spouseRetirementYears = this.calculateAge(spouseDOB) >= 67 ? Number(this.calculateAge(spouseDOB) + 1) : 67;
            this.spouseMonthlyBenefitAmount = (this.client.clientProfile.Spouses[0].pia) ? this.client.clientProfile.Spouses[0].pia : 0;

            this.spouseStartPIA = (70/100) * this.spouseMonthlyBenefitAmount;
            this.spouseEndPIA = (132/100) * this.spouseMonthlyBenefitAmount;

          }

          this.clientMonthlyBenefitAmount = (this.client.clientProfile.PIA) ? this.client.clientProfile.PIA : 0;

          this.startPIA = (70/100) * this.clientMonthlyBenefitAmount;
          this.endPIA = (132/100) * this.clientMonthlyBenefitAmount;
          if (this.backUpClient.clientProfile.Spouses[0] && this.backUpClient.clientProfile.Spouses[0].isLegalSpouse == 0 && !isClient) {
            this.socialSecurityForm.patchValue({'selfLifeExpectancy' : (this.backUpClient.clientProfile.Spouses[0] && this.backUpClient.clientProfile.Spouses[0].LifeExpectancy) || 0 });
          } else {
            this.socialSecurityForm.patchValue({'selfLifeExpectancy' : this.client.clientProfile.LifeExpectancy });
            this.socialSecurityForm.patchValue({'spouseLifeExpectancy' : (this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].LifeExpectancy) || 0 });
          }


          //TODO: need to figure this out more with 'non-legally married' cases
          if (this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed') {
            this.spouseMonthlyBenefitAmount = this.client.clientProfile.Spouses[0].monthlyBenefitAtPassing;
            if(this.client.clientProfile.Spouses[0].monthlyBenefitAtPassing){
              this.spouseClaimStatus = "True";
            }
          }

          // if ((this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed' || this.client.clientProfile.Spouses[0].maritalStatus == 'Single' && this.includeSpouse) && !this.adjSurvivorModal && this.client.clientProfile.SurvivorSwitchYears > 0) {
          //   console.log('this.client01', this.swappedClaim);
          //   if (this.client.clientProfile.SurvivorSwitchYears > (this.client.clientProfile.SSDesiredAgeYears || this.client.clientProfile.SelfRetirementYears)) {
          //     this.swappedClaim = true
          //   } else if (this.client.clientProfile.SurvivorSwitchYears < (this.client.clientProfile.SSDesiredAgeYears || this.client.clientProfile.SelfRetirementYears)) {
          //     this.swappedClaim = false
          //   } else {
          //     if (this.client.clientProfile.SurvivorSwitchMonths > (this.client.clientProfile.SSDesiredAgeMonths || this.client.clientProfile.SelfRetirementMonths)) {
          //       this.swappedClaim = true
          //     } else if (this.client.clientProfile.SurvivorSwitchMonths < (this.client.clientProfile.SSDesiredAgeMonths || this.client.clientProfile.SelfRetirementMonths)) {
          //       this.swappedClaim = false
          //     } else {
          //       this.swappedClaim = false
          //     }
          //   }

          //   if (this.client.clientProfile.SurvivorSwitchYears) {
          //     this.adjSurvivorBenefitAge = !this.swappedClaim ? (this.client.clientProfile.SSDesiredAgeYears) : this.client.clientProfile.SurvivorSwitchYears || this.client.clientProfile.SSDesiredAgeYears
          //     this.adjSurvivorBenefitMonths = !this.swappedClaim ? this.client.clientProfile.SSDesiredAgeMonths : this.client.clientProfile.SurvivorSwitchMonths || this.client.clientProfile.SSDesiredAgeMonths
          //     this.adjRetirementBenefitAge = this.swappedClaim ? this.client.clientProfile.SSDesiredAgeYears : this.client.clientProfile.SurvivorSwitchYears || this.client.clientProfile.SSDesiredAgeYears
          //     this.adjRetirementBenefitMonths = this.swappedClaim ? this.client.clientProfile.SSDesiredAgeMonths : this.client.clientProfile.SurvivorSwitchMonths || this.client.clientProfile.SSDesiredAgeMonths
          //   } else {
          //     this.adjRetirementBenefitAge = this.client.clientProfile.SSDesiredAgeYears
          //     this.adjRetirementBenefitMonths = this.client.clientProfile.SSDesiredAgeMonths
          //     this.adjSurvivorBenefitAge = 0
          //     this.adjSurvivorBenefitMonths = 0
          //   }

          //   this.isSurvAndFirstLoadSwapped = true;
          //   // this.swappedClaim = false
          // } else if ((this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed' || this.client.clientProfile.Spouses[0].maritalStatus == 'Single' && this.includeSpouse) && !this.adjSurvivorModal) {
          //   this.swappedClaim = true
          // }

          this.isSpouseSurvivor = ((this.client.clientProfile.LifeExpectancy - this.calculateAge(this.client.client.DOB)) + this.calculateAge(spouseDOB) <= 60
            || (this.client.clientProfile.LifeExpectancy - this.calculateAge(this.client.client.DOB)) + this.calculateAge(spouseDOB) <= 69);

            if ((this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed' 
            || (this.client.clientProfile.Spouses[0].maritalStatus == 'Single' || this.client.clientProfile.Spouses[0].maritalStatus == 'Married') 
            && this.includeSpouse && !this.isSpouseSurvivor) 
            && !this.adjSurvivorModal && this.client.clientProfile.SurvivorSwitchYears > 0) {

              console.log('this.client01', this.swappedClaim);
              if (this.client.clientProfile.SurvivorSwitchYears < (this.client.clientProfile.SSDesiredAgeYears || this.client.clientProfile.SelfRetirementYears)) {
                this.swappedClaim = true;
                console.log('switch is true here 01', this.swappedClaim);
              } else if (this.client.clientProfile.SurvivorSwitchYears < (this.client.clientProfile.SSDesiredAgeYears || this.client.clientProfile.SelfRetirementYears)) {
                console.log('swap set to false here');
                this.swappedClaim = false;
              } else {
                if (this.client.clientProfile.SurvivorSwitchMonths < (this.client.clientProfile.SSDesiredAgeMonths || this.client.clientProfile.SelfRetirementMonths)) {
                  this.swappedClaim = true;
                  console.log('switch is true here 02', this.swappedClaim);
                } else if (this.client.clientProfile.SurvivorSwitchMonths < (this.client.clientProfile.SSDesiredAgeMonths || this.client.clientProfile.SelfRetirementMonths)) {
                  this.swappedClaim = true;
                } else {
                  this.swappedClaim = true;
                }
              }
  
              /* if(this.client.clientProfile.InvertSurvivorSwitch != null){
                this.swappedClaim = this.client.clientProfile.InvertSurvivorSwitch;
              } */
  
              //this.client.clientProfile.InvertSurvivorSwitch = this.swappedClaim;
              console.log('asd1', this.swappedClaim);
  
              this.adjSurvivorBenefitAge = !this.swappedClaim ? this.client.clientProfile.SSDesiredAgeYears : this.client.clientProfile.SurvivorSwitchYears
              this.adjSurvivorBenefitMonths = !this.swappedClaim ? this.client.clientProfile.SSDesiredAgeMonths : this.client.clientProfile.SurvivorSwitchMonths
              this.adjRetirementBenefitAge = this.swappedClaim ? this.client.clientProfile.SSDesiredAgeYears : this.client.clientProfile.SurvivorSwitchYears;
              this.adjRetirementBenefitMonths = this.swappedClaim ? this.client.clientProfile.SSDesiredAgeMonths : this.client.clientProfile.SurvivorSwitchMonths
              
              this.objAdjustedDesiredScenario.spouseSurvivorSwitchAgeYears = this.swappedClaim ? this.client.clientProfile.Spouses[0].sSDesiredAgeYears : this.client.clientProfile.SurvivorSwitchYears;
              this.objAdjustedDesiredScenario.spouseSurvivorSwitchAgeMonths = this.swappedClaim ? this.client.clientProfile.Spouses[0].sSDesiredAgeMonths : this.client.clientProfile.SurvivorSwitchMonths

              this.isSurvAndFirstLoadSwapped = true;
  
            } else if ((this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed' 
              || (this.client.clientProfile.Spouses[0].maritalStatus == 'Single' || this.client.clientProfile.Spouses[0].maritalStatus == 'Married') && this.includeSpouse) 
              && (!this.adjSurvivorModal || this.isSpouseSurvivor)) {
              //this.swappedClaim = true
  
              if (this.client.clientProfile.SurvivorSwitchYears > ((this.client.clientProfile.Spouses[0].sSDesiredAgeYears) ? this.client.clientProfile.Spouses[0].sSDesiredAgeYears : 0)) {
                this.swappedClaim = true;
                console.log('switch is true here 03', this.swappedClaim);
              } else if (this.client.clientProfile.SurvivorSwitchYears < ((this.client.clientProfile.Spouses[0].sSDesiredAgeYears) ? this.client.clientProfile.Spouses[0].sSDesiredAgeYears : 0)) {
                this.swappedClaim = false;
              } else {
                if (this.client.clientProfile.SurvivorSwitchMonths > ((this.client.clientProfile.Spouses[0].sSDesiredAgeMonths) ? this.client.clientProfile.Spouses[0].sSDesiredAgeMonths : 0)) {
                  this.swappedClaim = true;
                  console.log('switch is true here 04', this.swappedClaim);
                } else if (this.client.clientProfile.SurvivorSwitchMonths < ((this.client.clientProfile.Spouses[0].sSDesiredAgeMonths) ? this.client.clientProfile.Spouses[0].sSDesiredAgeMonths : 0)) {
                  this.swappedClaim = false;
                } else {
                  this.swappedClaim = false;
                }
              }
  
              //this.client.clientProfile.InvertSurvivorSwitch = this.swappedClaim;
              // if(this.client.clientProfile.InvertSurvivorSwitch != null){
              //   this.swappedClaim = this.client.clientProfile.InvertSurvivorSwitch;
              // }
  
              console.log('asd2', this.swappedClaim);
              /* if(this.client.clientProfile.Spouses[0].maritalStatus == 'Married' && this.isSpouseSurvivor && this.client.clientProfile.Spouses[0].sSDesiredAgeYears){
                this.adjRetirementBenefitAge = this.client.clientProfile.Spouses[0].sSDesiredAgeYears;
                this.adjRetirementBenefitMonths = this.client.clientProfile.Spouses[0].sSDesiredAgeMonths;
              } else {
                this.adjRetirementBenefitAge = this.client.clientProfile.Spouses[0].sSDesiredAgeYears
                this.adjRetirementBenefitMonths = this.client.clientProfile.Spouses[0].sSDesiredAgeMonths
              }          
  
              this.adjSurvivorBenefitAge = 0
              this.adjSurvivorBenefitMonths = 0 */
  
              if(this.isSpouseSurvivor){
                //ZSS added over rides here for spousal surv
                if(!this.client.clientProfile.Spouses[0].sSDesiredAgeYears && this.client.clientProfile.SSDesiredAgeYears){
                  let fra = this.getFRAv2(spouseDOB);
                  let dob = this.calculateAge(spouseDOB);
                  this.client.clientProfile.Spouses[0].sSDesiredAgeYears = (dob > fra.age) ? dob : fra.age;
                  this.client.clientProfile.Spouses[0].sSDesiredAgeMonths = (dob > fra.age) ? 0 : fra.month;
                }
                this.adjSurvivorBenefitAge = this.swappedClaim ? this.client.clientProfile.Spouses[0].sSDesiredAgeYears : this.client.clientProfile.SurvivorSwitchYears
                this.adjSurvivorBenefitMonths = this.swappedClaim ? this.client.clientProfile.Spouses[0].sSDesiredAgeMonths : this.client.clientProfile.SurvivorSwitchMonths
                this.adjRetirementBenefitAge = !this.swappedClaim ? this.client.clientProfile.Spouses[0].sSDesiredAgeYears : this.client.clientProfile.SurvivorSwitchYears;
                this.adjRetirementBenefitMonths = !this.swappedClaim ? this.client.clientProfile.Spouses[0].sSDesiredAgeMonths : this.client.clientProfile.SurvivorSwitchMonths
              } else {
                //this.adjRetirementBenefitAge = this.client.clientProfile.Spouses[0].sSDesiredAgeYears
                //this.adjRetirementBenefitMonths = this.client.clientProfile.Spouses[0].sSDesiredAgeMonths
                this.adjRetirementBenefitAge = this.client.clientProfile.SSDesiredAgeYears
                this.adjRetirementBenefitMonths = this.client.clientProfile.SSDesiredAgeMonths
                if(!this.adjSurvivorModal){
                  this.swappedClaim = true;
                }
              }
  
              this.isSurvAndFirstLoadSwapped = true; 
              console.log('am I here with spouse?', this.swappedClaim);  
              //console.log('asd2', this.swappedClaim);         
            }
            
            //this.swappedClaimFRA = false;//this.swappedClaim;
            // console.log('heyyo', this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed', this.client.clientProfile.Spouses[0].maritalStatus)
            // console.log('heyyo', this.adjSurvivorModal)
            this.getSSData();
          },
          error => { console.log(error) });
  }

  nonLegalMarried(isClient) {
    // console.log('this.backUpClient.clientProfile.Spouses', this.backUpClient.clientProfile.Spouses[0])
    this.includeSpouse = false;
    let spouses = [];
    spouses[0] = { PIAYears: {} };
    spouses[0].maritalStatus = 'Single';//this.clientModelV2.maritalStatus.maritalStatus;
    spouses[0].pia = '';
    spouses[0].pension = '';
    if (!isClient) {
      // switch client info
      // previously married
      if (this.backUpClient.clientProfile.Spouses[0].spousesSpouse.length > 0) {
        spouses[0].previouslyMarried  = {
          previousSpouseCount: this.backUpClient.clientProfile.Spouses[0].spousesSpouse.length,
          previouslyMarried: true,
          spousePreviouslyMarried: false,
        }
        for (var i = 1; i <= this.backUpClient.clientProfile.Spouses[0].spousesSpouse.length; i++) {
          // console.log('i', i);
          // console.log('this.backUpClient.clientProfile.Spouses[0].spousesSpouse[i-1]', this.backUpClient.clientProfile.Spouses[0].spousesSpouse[0].maritalStatus);
          spouses[i] = { maritalStatus: this.backUpClient.clientProfile.Spouses[0].spousesSpouse[i-1].maritalStatus };
          // spouses[i].maritalStatus = this.backUpClient.clientProfile.Spouses[0].spousesSpouse[i-1].maritalStatus;
          spouses[i].firstName = this.backUpClient.clientProfile.Spouses[0].spousesSpouse[i-1].firstName;
          spouses[i].lastName = this.backUpClient.clientProfile.Spouses[0].spousesSpouse[i-1].lastName;
          spouses[i].gender = this.backUpClient.clientProfile.Spouses[0].spousesSpouse[i-1].gender;
          spouses[i].dobStr = this.backUpClient.clientProfile.Spouses[0].spousesSpouse[i-1].dobStr;
          spouses[i].dob = this.backUpClient.clientProfile.Spouses[0].spousesSpouse[i-1].dob;
          spouses[i].pia = this.backUpClient.clientProfile.Spouses[0].spousesSpouse[i-1].pia;
          spouses[i].alive = this.backUpClient.clientProfile.Spouses[0].spousesSpouse[i-1].alive;
          spouses[i].tenyears = this.backUpClient.clientProfile.Spouses[0].spousesSpouse[i-1].tenyears;
        }
      }
      this.client.clientProfile.Spouses = spouses;
      this.client.clientProfile.Children = JSON.stringify(this.backUpClient.clientProfile.Spouses[0].children);
      let spouseDOB = (this.backUpClient.clientProfile.Spouses[0].dobStr && Date.parse(this.backUpClient.clientProfile.Spouses[0].dobStr) ? this.backUpClient.clientProfile.Spouses[0].dobStr : Date.parse(this.backUpClient.clientProfile.Spouses[0].dob) ? this.backUpClient.clientProfile.Spouses[0].dob : null) ;
      this.client.client.DOB = spouseDOB;
      this.client.client.FirstName = this.backUpClient.clientProfile.Spouses[0].firstName;
      this.client.client.GenderID = this.backUpClient.clientProfile.Spouses[0].gender;
      this.client.client.LastName = this.backUpClient.clientProfile.Spouses[0].lastName;
      this.client.clientProfile.ClientMetroArea = this.backUpClient.clientProfile.SpouseMetroArea;
      this.client.clientProfile.CurrentIncome = this.backUpClient.clientProfile.Spouses[0].currentIncome;
      this.client.clientProfile.HCC = this.backUpClient.clientProfile.Spouses[0].HCC || 0;
      this.client.clientProfile.HCCD = this.backUpClient.clientProfile.Spouses[0].HCCD || 0;
      this.client.clientProfile.HCDCW = this.backUpClient.clientProfile.Spouses[0].HCDCW || 0;
      this.client.clientProfile.HCFHDC = this.backUpClient.clientProfile.Spouses[0].HCFHDC || 0;
      this.client.clientProfile.HCHBP = this.backUpClient.clientProfile.Spouses[0].HCHBP || 0;
      this.client.clientProfile.HCHC = this.backUpClient.clientProfile.Spouses[0].HCHC || 0;
      this.client.clientProfile.HCMS = this.backUpClient.clientProfile.Spouses[0].HCMS || 0;
      this.client.clientProfile.HCT = this.backUpClient.clientProfile.Spouses[0].HCT || 0;
      this.client.clientProfile.HCT1D = this.backUpClient.clientProfile.Spouses[0].HCT1D || 0;
      this.client.clientProfile.HCT2D = this.backUpClient.clientProfile.Spouses[0].HCT2D || 0;
      this.client.clientProfile.HouseholdYearOneIncome = this.backUpClient.clientProfile.Spouses[0].currentIncome;
      this.client.clientProfile.PIA = this.backUpClient.clientProfile.Spouses[0].pia;
      this.client.clientProfile.PIAYears = this.backUpClient.clientProfile.Spouses[0].PIAYears;
      this.client.clientProfile.RetirementAge = this.backUpClient.clientProfile.Spouses[0].retirementAge;
      this.client.clientProfile.RetirementState = this.backUpClient.clientProfile.Spouses[0].state;
      this.client.clientProfile.Premiums = this.backUpClient.clientProfile.SpousePremiums;
      this.client.clientProfile.OOPCosts = this.backUpClient.clientProfile.SpouseOOPCosts;
      // social security claim age
      this.client.clientProfile.SSDesiredAgeYears = this.backUpClient.clientProfile.Spouses[0].sSDesiredAgeYears || 0;
      this.client.clientProfile.SSDesiredAgeMonths = this.backUpClient.clientProfile.Spouses[0].sSDesiredAgeMonths || 0;
      // this.client.clientProfile.Spouses = JSON.parse(this.client.clientProfile.Spouses);
      // work in retirement
      this.client.clientProfile.InRetFirstYearIncome = this.backUpClient.clientProfile.Spouses[0].inRetFirstYearIncome ? this.backUpClient.clientProfile.Spouses[0].inRetFirstYearIncome : null;
      this.client.clientProfile.InRetStopWorkAge = this.backUpClient.clientProfile.Spouses[0].inRetStopWork ? this.backUpClient.clientProfile.Spouses[0].inRetStopWork : null;
      // Pension
      this.client.clientProfile.Pension = this.backUpClient.clientProfile.Spouses[0].pension ? this.backUpClient.clientProfile.Spouses[0].pension: null;
      this.client.clientProfile.PensionMonths = this.backUpClient.clientProfile.Spouses[0].pensionStartMonth ? this.backUpClient.clientProfile.Spouses[0].pensionStartMonth : null;
      this.client.clientProfile.PensionYears = this.backUpClient.clientProfile.Spouses[0].pensionStartYear ? this.backUpClient.clientProfile.Spouses[0].pensionStartYear : null;
      this.client.clientProfile.SubstantialEarningYears = this.backUpClient.clientProfile.Spouses[0].substantialEarningYear ? this.backUpClient.clientProfile.Spouses[0].substantialEarningYear: null;
      this.client.clientProfile.IncludePension = Number(this.backUpClient.clientProfile.Spouses[0].pension) ? (this.backUpClient.clientProfile.Spouses[0].pension > 0 ? 1 : 0): 0;

    } else {
      this.client.clientProfile.Spouses[0] = spouses[0];
      for (i=1; i<this.backUpClient.clientProfile.Spouses.length; i++) {
        this.client.clientProfile.Spouses[i] = this.backUpClient.clientProfile.Spouses[i]
      }
      // this.client.clientProfile.Spouses = spouses;
      this.client.clientProfile.HouseholdYearOneIncome = this.backUpClient.clientProfile.CurrentIncome;
    }
    // console.log('this.client.clientProfile.Spouses', this.client.clientProfile.Spouses);
    this.client.clientProfile.IsHSApplySpouse = false;
    this.client.clientProfile.IsRunReportWithSpouse = false;
    this.client.clientProfile.IsSpousePrivHealthIns = null;
    this.client.clientProfile.MaritalStatus = 0;
    this.client.clientProfile.SpousePremiums = null;
    this.client.clientProfile.SpouseOOPCosts = null;
    this.client.clientProfile.SpouseMetroArea = null;
  }

  calcBenefits() {
    this.getSSData();
  }

  hasAlternateScenario: boolean = false;
  
  ssObject;
  ssObjectAlt;
  storedFRAScenario;
  
  storedOriginalSSObject;
  storedOriginalSSObjectAlt;
  
  storedOriginalOptimalTotals;
  storedOriginalOptimalTable;
  storedOriginalOptimalClaimAges;

  storedOriginalEarliestTotals;
  storedOriginalEarliestTable;
  storedOriginalEarliestClaimAges;
  
  getSSData() {
    const socialSecurityForm = this.socialSecurityForm;
    const userForm = this.userForm;
    //const socialSecurityObject = this.getSocialSecurityObject();
    //console.log('FRA Scenario', this.objAdjustedFRAScenario);
    //console.log('for API', socialSecurityObject);

    var tempChildren = [];
    var tempChild = {};

    
    if (this.client.clientProfile.Children && this.client.clientProfile.Children.length) {
      for (var k in this.client.clientProfile.Children) {
        tempChild = {};
        tempChild["CurrentAge"] = Number(this.client.clientProfile.Children[k].DependentChildAge);
        tempChild['isDisabled'] = !!this.client.clientProfile.Children[k].isDisabled;
        tempChild['dacAnticipateEnd'] = !!this.client.clientProfile.Children[k].dacAnticipateEnd;
        tempChild['StopBenefitsAge'] = this.client.clientProfile.Children[k].dacEndAge || null;
        tempChild['IsStudentAt19'] = false;
        tempChildren.push(tempChild);
      }
    }

    var investmentItems = [];

    for (var item in this.fundingItems) {

      var contribution = {
        Description: this.fundingItems[item].fundingSource,
        Begins: this.fundingItems[item].startAge,
        Ends: this.fundingItems[item].endAge,
        StartAmount: this.fundingItems[item].annContribution,
        Cola: this.fundingItems[item].inflationRate,
      }

      investmentItems.push(contribution);
    }
    console.log('this.includeSpouse', this.includeSpouse);
    let spousePIA = this.includeSpouse ? (((this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' || this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed') && this.client.clientProfile.Spouses[0].tenyears)?this.client.clientProfile.Spouses[0].pia: this.spousePIA.toString().replace(/,/g,"").replace("$","")) : 0;
    let spouseLifeExpectancy = this.includeSpouse? ((this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' || this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed')? (this.client.clientProfile.Spouses[0].exSpouseLifeExpectancy || 0):this.client.clientProfile.Spouses[0].LifeExpectancy) : 0;
    console.log('spouseLifeExpectancy 001', spouseLifeExpectancy);
    let spouseAlreadyCollecting = this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed' ? (this.client.clientProfile.Spouses[0].spouseCollectAtTimeOfPassing ? true : false) : this.client.clientProfile.SpouseAlreadyCollecting ? this.client.clientProfile.SpouseAlreadyCollecting: false;
    //console.log('asdff', this.client.clientProfile.Spouses[0].pia);
    console.log('this.client.clientProfile.PIAYears', this.client.clientProfile.PIAYears);
    console.log('hasAdjustedFRAScenario', this.hasAdjustedFRAScenario);

    let spouseGovtPension = Number(this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse && this.client.clientProfile.Spouses[0].pension ? this.client.clientProfile.Spouses[0].pension.toString().replace(/,/g,"").replace("$","") || 0 : 0);

    let spouseDOB = (this.client.clientProfile.Spouses[0].dobStr && Date.parse(this.client.clientProfile.Spouses[0].dobStr) ? new Date(this.client.clientProfile.Spouses[0].dobStr).toLocaleDateString("en-US") : new Date(this.client.clientProfile.Spouses[0].dob).toLocaleDateString("en-US") ? new Date(this.client.clientProfile.Spouses[0].dob).toLocaleDateString("en-US") : "1/1/1960");
    if (!this.hasAdjustedFRAScenario) {
      //if(!this.isPageReloadOtherThanFRACall){
        console.log('here i am');
        this.ssObject = {
          InvestmentItems: investmentItems,//JSON.stringify({ investmentItems }),
          InvestmentYears: this.annualEl ? Number(this.annualEl.nativeElement.value) : 0,
          InvestmentOption: this.investmentOption,

          FrmPhase1Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorOne)) : 6,
          FrmPhase1Periods: this.objAdjustRates ? Number(this.objAdjustRates.throughYearOne) : Math.max(65 - Number(this.calculateAge(this.client.client.DOB))),
          FrmPhase2Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorTwo)) : 6,
          FrmPhase2Periods: this.objAdjustRates ? (Number(this.objAdjustRates.throughYearTwo)) : 10,
          FrmPhase3Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorThree)) : 6,

          FrmName0: this.client.client.FirstName + " " + this.client.client.LastName,
          SelfCurrentMonthlyBenefit: (this.client.clientProfile.MonthlyBenefitAmount || 0) > 0 ? this.client.clientProfile.MonthlyBenefitAmount : this.clientMonthlyBenefitAmount,
          SpouseAlreadyCollecting: spouseAlreadyCollecting, //(this.client.clientProfile.Spouses) ? (this.client.clientProfile.Spouses[0].spouseCollectAtTimeOfPassing) ? this.client.clientProfile.Spouses[0].spouseCollectAtTimeOfPassing : "False" : "False",
          //this.client.clientProfile.SpouseAlreadyCollecting == 1 ? 'True': 'False', //'False',//this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.spouseClaimStatus : "False",
          SelfGovPensionAmount: this.client.clientProfile.Pension,// "", // --> Needs to be updated, but how is this calculated?
          Children: this.client.clientProfile.Children && this.client.clientProfile.Children.length > 0 ? tempChildren : [],
          //Children: [],
          SelfAlreadyCollecting: this.client.clientProfile.SelfAlreadyCollecting == 1 ? 'True' : 'False', //'False',//this.clientClaimStatus,
          // SpouseLifeExpectancy: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? 89 : 0, // make this part of ssData output
          selfConditions: JSON.stringify({
            HCHBP: this.client.clientProfile.HCHBP || 0,
            HCHC: this.client.clientProfile.HCHC || 0,
            HCT1D: this.client.clientProfile.HCT1D || 0,
            HCT2D: this.client.clientProfile.HCT2D || 0,
            HCCD: this.client.clientProfile.HCCD || 0,
            HCC: this.client.clientProfile.HCC || 0,
            HCT: this.client.clientProfile.HCT || 0,
            HCMS: this.client.clientProfile.HCMS || 0,
            HCDCW: this.client.clientProfile.HCDCW || 0,
            HCFHDC: this.client.clientProfile.HCFHDC || 0,

            HCALZ: this.client.clientProfile.HCALZ || 0,
            HCPARK: this.client.clientProfile.HCPARK || 0,
            HCAMP: this.client.clientProfile.HCAMP || 0,
            HCPTSD: this.client.clientProfile.HCPTSD || 0,
            HCOBS: this.client.clientProfile.HCOBS || 0,
          }),
          spouseConditions: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? JSON.stringify({
            HCHBP: this.client.clientProfile.Spouses[0].HCHBP || 0,
            HCHC: this.client.clientProfile.Spouses[0].HCHC || 0,
            HCT1D: this.client.clientProfile.Spouses[0].HCT1D || 0,
            HCT2D: this.client.clientProfile.Spouses[0].HCT2D || 0,
            HCCD: this.client.clientProfile.Spouses[0].HCCD || 0,
            HCC: this.client.clientProfile.Spouses[0].HCC || 0,
            HCT: this.client.clientProfile.Spouses[0].HCT || 0,
            HCMS: this.client.clientProfile.Spouses[0].HCMS || 0,
            HCDCW: this.client.clientProfile.Spouses[0].HCDCW || 0,
            HCFHDC: this.client.clientProfile.Spouses[0].HCFHDC || 0,

            HCALZ: this.client.clientProfile.Spouses[0].HCALZ || 0,
            HCPARK: this.client.clientProfile.Spouses[0].HCPARK || 0,
            HCAMP: this.client.clientProfile.Spouses[0].HCAMP || 0,
            HCPTSD: this.client.clientProfile.Spouses[0].HCPTSD || 0,
            HCOBS: this.client.clientProfile.Spouses[0].HCOBS || 0,
          }) : "",

          includeSpouse: this.includeSpouse,

          selfGender: this.client.client.GenderID,
          spouseGender: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.client.clientProfile.Spouses[0].gender || 1 : 1,
          // Finish validating fields below this --------

          BendPointInflation: 2, // make this part of ssData ?
          SelfCurrentAge: this.calculateAge(this.client.client.DOB),
          SpouseCurrentAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.calculateAge(spouseDOB) || 30 : 30,
          IsPresentValue: this.presentValue,// == "True" ? true : false,
          SpouseCurrentMonthlyBenefit: (this.client.clientProfile.Spouses[0].monthlyBenefits) ? Utils.formatToNumber(this.client.clientProfile.Spouses[0].monthlyBenefits) : this.spouseClaimStatus == "True" ? this.spouseMonthlyBenefitAmount.toString().replace(/,/g, "").replace("$", "") || 0 : 0,//this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? 0 : 0,
          FrmIncome: "Ind1", // make this part of ssData output
          SelfPensionStartMonth: this.client.clientProfile.PensionMonths, // ??
          isSelfSuspendable: "False", // ??
          SpouseBenefitAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.spouseRetirementYears : 0,
          selfCanRestrict: "False", // ??
          SpousePIA: spousePIA || 0,
          /* SelfLifeExpectancy: this.client.clientProfile.LifeExpectancy || 0, //87, // make this part of ssData output
          SpouseLifeExpectancy: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.client.clientProfile.Spouses[0].LifeExpectancy || 0 : 0, */
          SelfLifeExpectancy: this.client.clientProfile.LifeExpectancy,//this.socialSecurityForm.get('selfLifeExpectancy').value,
          SpouseLifeExpectancy: spouseLifeExpectancy || 0,

          StrategyDropDown: "AutoSelect",
          SelfPensionFrequency: "Monthly",
          SelfPensionStartYear: this.client.clientProfile.PensionYears, // ??
          SelfPensionInfl: (this.client.clientProfile.PensionInfl == null) ? 3.00 : this.client.clientProfile.PensionInfl, //default is null
          SelfPIA: this.clientPIA,
          COLA: this.colas,
          FrmColaXml: this.colas,
          SpousePensionStartMonth: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.client.clientProfile.Spouses[0].pensionMonth : 3,
          SpouseGovPensionAmount: spouseGovtPension,//this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse && this.client.clientProfile.Spouses[0].pension ? this.client.clientProfile.Spouses[0].pension.toString().replace(/,/g, "").replace("$", "") || 0 : 0,
          SpouseGovPension: spouseGovtPension > 0 ? true : false,//this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? (this.client.clientProfile.Spouses[0].IncludePension == 1) ? "True" : "False" : "False",
          SpousePensionInfl: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? (this.client.clientProfile.Spouses[0].PensionInfl == null) ? 3 : this.client.clientProfile.Spouses[0].PensionInfl : 3,
          PIAIncomeYears1: 0, // ??
          SelfAlreadyClaimedAge: 0, // ??
          spouseCanRestrict: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? "False" : "",
          SelfSubstantialEarningsYears: (this.client.clientProfile.SubstantialEarningYears) ? this.client.clientProfile.SubstantialEarningYears : 0,//this.client.clientProfile.SubstantialEarningYears || 30, // ??
          SelfBenefitAge: this.clientRetirementYears,// 67,
          FrmName1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.client.clientProfile.Spouses[0].firstName + " " + this.client.clientProfile.Spouses[0].lastName : "",
          SpouseAlreadyClaimedAge: 0, // ??

          // MaritalState: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.client.clientProfile.Spouses[0].maritalStatus : (this.client.clientProfile.Spouses.length > 1) ? this.client.clientProfile.Spouses[1].maritalStatus : "Single",
          MaritalState: this.client.clientProfile.Spouses[0].maritalStatus,

          SpousePensionStartYear: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.client.clientProfile.Spouses[0].pensionYear : "",
          SpousePensionFrequency: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? "Monthly" : "",
          RetirementStrategy: "FileForBenefits", // get in ssData ??
          PIAIncomeYears2: 0, // ??
          SpouseSubstantialEarningsYears: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse && this.client.clientProfile.Spouses[0].IncludePension ? (this.client.clientProfile.Spouses[0].substantialEarningYears) ? this.client.clientProfile.Spouses[0].substantialEarningYears : 0 : 0,
          SelfGovPension: this.client.clientProfile.IncludePension == 1 ? true : false,//"False",
          isSpouseSuspendable: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? "False" : "",

          //TODO: If between sessions, a user ages past their entered “Alternate 2” claim age (even if it’s just one of two spouses), then it reverts back to FRA automatically (unless already older than FRA).
          selfRetirementYears: (this.objAdjustedFRAScenario) ? (this.objAdjustedFRAScenario.clientAgeYears) ? this.objAdjustedFRAScenario.clientAgeYears : this.objAdjustedFRAScenario.survivorSwitchAgeYears : this.clientRetirementYears,
          selfRetirementMonths: (this.objAdjustedFRAScenario) ? (this.objAdjustedFRAScenario.clientAgeYears) ? this.objAdjustedFRAScenario.clientAgeMonths : this.objAdjustedFRAScenario.survivorSwitchAgeMonths : this.clientRetirementMonths,
          spouseRetirementYears: (this.objAdjustedFRAScenario && this.includeSpouse) ? (this.objAdjustedFRAScenario.spouseAgeYears) ? this.objAdjustedFRAScenario.spouseAgeYears : this.objAdjustedFRAScenario.survivorSwitchAgeYears : this.spouseRetirementYears,
          spouseRetirementMonths: (this.objAdjustedFRAScenario && this.includeSpouse) ? (this.objAdjustedFRAScenario.spouseAgeYears) ? this.objAdjustedFRAScenario.spouseAgeMonths || 0 : this.objAdjustedFRAScenario.survivorSwitchAgeMonths : this.spouseRetirementMonths || 0,

          SelfFilingRestrictedYear: (this.ssObject) ? (this.ssObject.SelfFilingRestrictedYear) ? this.ssObject.SelfFilingRestrictedYear : 0 : 0,
          SelfFilingRestrictedMonth: (this.ssObject) ? (this.ssObject.SelfFilingRestrictedMonth) ? this.ssObject.SelfFilingRestrictedMonth : 0 : 0,
          SpouseFilingRestrictedYear: (this.ssObject) ? (this.ssObject.SpouseFilingRestrictedYear) ? this.ssObject.SpouseFilingRestrictedYear : 0 : 0,
          SpouseFilingRestrictedMonth: (this.ssObject) ? (this.ssObject.SpouseFilingRestrictedMonth) ? this.ssObject.SpouseFilingRestrictedMonth : 0 : 0,

          /* selfRetirementYears: this.socialSecurityForm.get('selfRetirementYears').value,
          selfRetirementMonths: this.socialSecurityForm.get('selfRetirementMonths').value,
          spouseRetirementYears: this.socialSecurityForm.get('spouseRetirementYears').value,
          spouseRetirementMonths: this.socialSecurityForm.get('spouseRetirementMonths').value, */

          clientSurvivorSwitchYears: this.clientSurvivorSwitchYears,
          clientSurvivorSwitchMonths: this.clientSurvivorSwitchMonths,
          SurvivorSwitchYears: this.clientSurvivorSwitchYears,
          SurvivorSwitchMonths: this.clientSurvivorSwitchMonths,

          SelfDOB: this.client.client.DOB,
          SpouseDOB: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? isNaN(new Date(spouseDOB).getTime()) ? new Date('1/1/1960') : new Date(spouseDOB) : '1/1/1960',
          SpouseHasDOB: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? (this.client.clientProfile.Spouses[0].dobStr && Date.parse(this.client.clientProfile.Spouses[0].dobStr) ? true : Date.parse(this.client.clientProfile.Spouses[0].dob) ? true : false) : false,
          SelfCurrentIncome: this.client.clientProfile.CurrentIncome || 0,
          SpouseCurrentIncome: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].currentIncome : 0,
          SelfIRR: (this.client.clientProfile.IRR) ? this.client.clientProfile.IRR : (this.client.clientProfile.HouseholdYearOneIncome / (this.client.clientProfile.CurrentIncome + (this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? (this.client.clientProfile.Spouses[0].currentIncome) ? this.client.clientProfile.Spouses[0].currentIncome : 0 : 0))),

          //FrmDiscountRate: parseFloat((this.discountRate / 100).toString()),      
          FrmDiscountRate: this.socialSecurityForm.get('inflationRate').value.replace('%', '') / 100,
          SelfRetirementAge: this.client.clientProfile.RetirementAge,
          // SpouseRetirementAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].maritalStatus != "Widowed" ? (this.client.clientProfile.Spouses[0].retirementAge) ? this.client.clientProfile.Spouses[0].retirementAge : 0 : 0 : 0,
          SpouseRetirementAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? (this.client.clientProfile.Spouses[0].maritalStatus == 'Single') ? 0 : (this.client.clientProfile.Spouses[0].retirementAge ? this.client.clientProfile.Spouses[0].retirementAge : 0)  : 0,
          SpousePreviousSpouses: JSON.stringify(this.previousSpouse),
          FrmState: this.client.clientProfile.RetirementState == 'NA' ? '  ' : this.client.clientProfile.RetirementState,
          FrmState1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].state : '',
          SelfWorkingInRetirement: this.client.clientProfile.InRetStopWorkAge > 0 && this.client.clientProfile.InRetFirstYearIncome != null ? this.client.clientProfile.InRetStopWorkAge : 0,
          SpouseWorkingInRetirement: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.client.clientProfile.Spouses[0].inRetStopWork > 0 && this.client.clientProfile.Spouses[0].inRetFirstYearIncome != null ? this.client.clientProfile.Spouses[0].inRetStopWork : 0,
          SelfWorkingInRetirementIncome: this.client.clientProfile.InRetFirstYearIncome > 0 ? this.client.clientProfile.InRetFirstYearIncome : 0,
          SpouseWorkingInRetirementIncome: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.client.clientProfile.Spouses[0].inRetStopWork > 0 && this.client.clientProfile.Spouses[0].inRetFirstYearIncome != null ? this.client.clientProfile.Spouses[0].inRetFirstYearIncome : 0,
          InRetirementInflationRate: (this.client.clientProfile.InRetirementInflationRate == null) ? 2.40 : this.client.clientProfile.InRetirementInflationRate, //default if null
          MAGI: (this.client.clientProfile.MAGIPercentIncome == null) ? 100 : this.client.clientProfile.MAGIPercentIncome, //default if null

          //TODO: not sure I need these...leave for now
          SelfKnownBenefitClaiming: (this.client.clientProfile.SelfKnownBenefitClaiming) ? this.client.clientProfile.SelfKnownBenefitClaiming : 0,
          SpouseKnownBenefitClaiming: (this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0) ? (this.client.clientProfile.Spouses[0].SpouseKnownBenefitClaiming) ? this.client.clientProfile.Spouses[0].SpouseKnownBenefitClaiming : 0 : 0,

          //earnsInRetStartAge: this.client.clientProfile.RetirementAge,
          //earnsInRetEndAge: this.client.clientProfile.InRetStopWorkAge

          SelfYearOfStatement: this.client.clientProfile.YearOfStatement || this.currentYear,
          SpouseYearOfStatement: this.client.clientProfile.Spouses.length > 0 ? (this.client.clientProfile.Spouses[0].yearOfStatement) ? this.client.clientProfile.Spouses[0].yearOfStatement : this.currentYear : this.currentYear,
          SelfSpouses: this.client.clientProfile.Spouses,

          SelfDateOfClaimMonth: (this.client.clientProfile.SelfAlreadyCollecting > 0) ? this.client.clientProfile.DateOfClaimMonth || 0 : 0,
          SelfDateOfClaimYear: (this.client.clientProfile.SelfAlreadyCollecting > 0) ? this.client.clientProfile.DateOfClaimYear || 0 : 0,
          SpouseDateOfClaimMonth: (this.client.clientProfile.Spouses[0].maritalStatus == "Married" && this.client.clientProfile.SpouseAlreadyCollecting > 0) ? this.client.clientProfile.Spouses[0].dateOfClaimMonth : 0,
          SpouseDateOfClaimYear: (this.client.clientProfile.Spouses[0].maritalStatus == "Married" && this.client.clientProfile.SpouseAlreadyCollecting > 0) ? this.client.clientProfile.Spouses[0].dateOfClaimYear : 0,
          HouseholdYearOneIncome: this.client.clientProfile.HouseholdYearOneIncome || 0,
          PreRetirementInflationRate: (this.client.clientProfile.InflationRate == null) ? 3.00 : this.client.clientProfile.InflationRate, //default if null
          MidRetAdjYear: this.client.midRetirementAdj ? this.client.midRetirementAdj.Year || 0 : 0,
          MidRetRedDollar: this.client.midRetirementAdj ? this.client.midRetirementAdj.ReductionDollar : 0,
          MidRetRedPer: this.client.midRetirementAdj ? this.client.midRetirementAdj.ReductionPerc : 0,
          MidRetIncomeInflationRate: this.client.midRetirementAdj ? this.client.midRetirementAdj.IncomeInflationRate || null : null,
          SelfSubEarningYears: this.client.clientProfile.SubstantialEarningYearsDetails ? this.client.clientProfile.SubstantialEarningYearsDetails : null,
          SpouseSubEarningYears: this.client.clientProfile.Spouses.length > 0 && this.client.clientProfile.Spouses[0].SubstantialEarningYearsDetails ? JSON.stringify(this.client.clientProfile.Spouses[0].PIAYears) : null,
          invertSurvivorSwitch: !this.swappedClaim ? 0 : 1, //this.swappedClaim && this.adjSurvivorModal ? 0 : 1,
          SelfWidowYearOfStatement: this.client.clientProfile.Spouses[0].maritalStatus == "Widowed" ? (this.client.clientProfile.Spouses[0].yearOfStatement) ? this.client.clientProfile.Spouses[0].yearOfStatement : 0 : 0,
          SelfWidowYearTimeOfPassing: this.client.clientProfile.Spouses[0].maritalStatus == "Widowed" ? (this.client.clientProfile.Spouses[0].yearAtTimeOfPassing) ? this.client.clientProfile.Spouses[0].yearAtTimeOfPassing : 0 : 0,
          
          //TODO: issues with setting/calculating PIA in Alt when no PIA is set
          SelfFRAAge: this.clientRetirementYears,
          SelfFRAMonth: this.clientRetirementMonths,
          SpouseFRAAge: this.spouseRetirementYears,
          SpouseFRAMonth: this.spouseRetirementMonths,

          //TODO: the below is needed for Spouses of Spouses....or we could just use the SpousePreviousSpouses field
          //SpouseWidowYearOfStatement: this.client.clientProfile.Spouses[0].maritalStatus == "Widowed" ? (this.client.clientProfile.Spouses[0].yearOfStatement) ? this.client.clientProfile.Spouses[0].yearOfStatement : 0 : 0,
          //SpouseWidowYearTimeOfPassing: this.client.clientProfile.Spouses[0].maritalStatus == "Widowed" ? (this.client.clientProfile.Spouses[0].yearOfStatement) ? this.client.clientProfile.Spouses[0].yearOfStatement : 0 : 0
        //}
      }
    } else {
      this.ssObjectFRA.isPresentValue = this.isPresentValue;
    }

    // console.log('set up for p1', this.clientRetirementYears + ' ' + this.clientRetirementMonths);

    if (!this.hasAdjustedFRAScenario && this.changedAlt2BackToFRA) {
      this.ssObject.invertSurvivorSwitch = 0;
      this.changedAlt2BackToFRA = false;
    }


    //TODO ZSS: talk to Dustin about the updates below (04/01)
    if (this.ssObject.MaritalState == 'Divorced') { 
      this.ssObject.SpouseBenefitAge = 62;
      //this.ssObject.spouseRetirementYears = 62;
      //this.ssObject.spouseRetirementMonths = 0;
      this.ssObject.spouseRetirementYears = (this.client.clientProfile.Spouses[0].expectedClaimAgeYears) ? this.client.clientProfile.Spouses[0].expectedClaimAgeYears : 62;
      this.ssObject.spouseRetirementMonths = (this.client.clientProfile.Spouses[0].expectedClaimAgeMonths) ? this.client.clientProfile.Spouses[0].expectedClaimAgeMonths : 0;
      if (this.hasAdjustedFRAScenario && this.ssObjectFRA) {
        this.ssObjectFRA.spouseRetirementYears = (this.client.clientProfile.Spouses[0].expectedClaimAgeYears) ? this.client.clientProfile.Spouses[0].expectedClaimAgeYears : 62;
        this.ssObjectFRA.spouseRetirementMonths = (this.client.clientProfile.Spouses[0].expectedClaimAgeMonths) ? this.client.clientProfile.Spouses[0].expectedClaimAgeMonths : 0;
      }
    } else if (this.ssObject.MaritalState == 'Widowed') {      
      this.ssObject.spouseRetirementYears = (this.client.clientProfile.Spouses[0].exSpouseClaimAgeYears) ? this.client.clientProfile.Spouses[0].exSpouseClaimAgeYears : 62;
      this.ssObject.spouseRetirementMonths = (this.client.clientProfile.Spouses[0].exSpouseClaimAgeMonths) ? this.client.clientProfile.Spouses[0].exSpouseClaimAgeMonths : 0;
      if (this.hasAdjustedFRAScenario && this.ssObjectFRA) {
        this.ssObjectFRA.spouseRetirementYears = (this.client.clientProfile.Spouses[0].exSpouseClaimAgeYears) ? this.client.clientProfile.Spouses[0].exSpouseClaimAgeYears : 62;
        this.ssObjectFRA.spouseRetirementMonths = (this.client.clientProfile.Spouses[0].exSpouseClaimAgeMonths) ? this.client.clientProfile.Spouses[0].exSpouseClaimAgeMonths : 0;
      }
    } else {
      //optimize FRA on page load
      if(this.ssObject.SpouseRetirementAge < this.ssObject.spouseRetirementYears
        && this.ssObject.SpouseLifeExpectancy < this.ssObject.spouseRetirementYears
      ){
        this.ssObject.spouseRetirementYears = (this.ssObject.SpouseRetirementAge < 62) ? 62 : this.ssObject.SpouseRetirementAge;
        this.spouseRetirementYears = this.ssObject.spouseRetirementYears;
        if (this.hasAdjustedFRAScenario && this.ssObjectFRA) {
          this.ssObjectFRA.spouseRetirementYears = this.ssObject.spouseRetirementYears;
          this.ssObjectFRA.SpouseFRAAge = this.ssObject.spouseRetirementYears;
          //this.spouseRetirementYears = this.ssObject.spouseRetirementYears;
        }
      }
    } 

    var user = {
      UserID: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorID') : localStorage.getItem('userId'),
      CompanyCode: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorOrgID') : localStorage.getItem('orgID'),
      ClientID: localStorage.getItem('selectedClient')
    }

    // if (this.client.clientProfile.Spouses[0].maritalStatus == "Widowed" || this.client.clientProfile.Spouses[0].maritalStatus == 'Single' && this.includeSpouse) {
    //   this.ssObject.SurvivorSwitchYears = this.adjSurvivorBenefitAge || 0
    //   this.ssObject.SurvivorSwitchMonths = this.adjSurvivorBenefitMonths || 0
    //   this.ssObject.clientSurvivorSwitchYears = this.adjSurvivorBenefitAge || 0
    //   this.ssObject.clientSurvivorSwitchMonths = this.adjSurvivorBenefitMonths || 0
    //   this.ssObject.invertSurvivorSwitch = this.swappedClaim ? 0 : 1
    // } else {
    //   this.ssObject.invertSurvivorSwitch = 0
    // }

    // if (this.isSurvAndFirstLoadSwapped)
    //   this.ssObject.invertSurvivorSwitch = 1

    
    this.ssObject.spouseRetirementMonths = this.ssObject.spouseRetirementMonths || 0;

   /*  this.switchSurvivorMessage = this.switchSurvivorMessage.replace(" record. At age " + this.previousSurvivorYears.toString(), " record. At age " + this.clientSurvivorSwitchYears.toString());
    if (this.clientRetirementMonths == 0) {
      this.switchSurvivorMessage = this.switchSurvivorMessage.replace("At Age " + this.previousClaimYea rs.toString() + ", you will begin collecting", "At Age " + this.clientRetirementYears.toString() + ", you will begin collecting");
    } else {
      this.switchSurvivorMessage = this.switchSurvivorMessage.replace("At Age " + this.previousClaimYears.toString() + " and " + this.clientRetirementMonths.toString() + ", you will begin collecting", "At Age " + this.clientRetirementYears.toString() + " and " + this.clientRetirementMonths.toString() + ", you will begin collecting");
    } */

    this.ssObject.IsAltRequest = false;
    //this.ssObject.IsAltRequest = (this.hasAlternateScenario) ? true : false;

    // if (this.client.clientProfile.Spouses.length > 0 && this.client.clientProfile.Spouses[0].maritalStatus == "Widowed" && this.objAdjustedFRAScenario && this.adjSurvivorModalFRA) {
    //   this.ssObjectFRA.selfRetirementYears = this.adjRetirementBenefitAgeFRA
    //   this.ssObjectFRA.selfRetirementMonths = this.adjRetirementBenefitMonthsFRA
    //   this.ssObjectFRA.clientSurvivorSwitchYears = this.adjSurvivorBenefitAgeFRA
    //   this.ssObjectFRA.clientSurvivorSwitchMonths = this.adjSurvivorBenefitMonthsFRA
    //   this.ssObjectFRA.SurvivorSwitchYears = this.adjSurvivorBenefitAgeFRA
    //   this.ssObjectFRA.SurvivorSwitchMonths = this.adjSurvivorBenefitMonthsFRA
    //   this.ssObjectFRA.invertSurvivorSwitch = this.swappedClaimFRA ? 1 : 0
    // }

    if(this.hasAdjustedFRAScenario){
      this.ssObjectFRA.IsAltRequest = true;
      this.ssObjectFRA.IsFRAAltRequest = true;
    } else {
      if(this.ssObjectFRA){
        this.ssObjectFRA.IsAltRequest = false;
        this.ssObjectFRA.IsFRAAltRequest = false;
      }
    }

    if (this.isSurvAndFirstLoadSwapped) {
      this.ssObject.invertSurvivorSwitch = 0
      // this.ssObjectFRA.invertSurvivorSwitch = 0
    }

    if(this.hasClientSidebarBeenUpdated){
      if(this.hasAdjustedFRAScenario && this.ssObjectFRA){
        this.ssObjectFRA.selfConditions = JSON.stringify({
          HCHBP: this.client.clientProfile.HCHBP || 0,
          HCHC: this.client.clientProfile.HCHC || 0,
          HCT1D: this.client.clientProfile.HCT1D || 0,
          HCT2D: this.client.clientProfile.HCT2D || 0,
          HCCD: this.client.clientProfile.HCCD || 0,
          HCC: this.client.clientProfile.HCC || 0,
          HCT: this.client.clientProfile.HCT || 0,
          HCMS: this.client.clientProfile.HCMS || 0,
          HCDCW: this.client.clientProfile.HCDCW || 0,
          HCFHDC: this.client.clientProfile.HCFHDC || 0,

          HCALZ: this.client.clientProfile.HCALZ || 0,
            HCPARK: this.client.clientProfile.HCPARK || 0,
            HCAMP: this.client.clientProfile.HCAMP || 0,
            HCPTSD: this.client.clientProfile.HCPTSD || 0,
            HCOBS: this.client.clientProfile.HCOBS || 0,
        });
        this.ssObjectFRA.spouseConditions = this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? JSON.stringify({
          HCHBP: this.client.clientProfile.Spouses[0].HCHBP || 0,
          HCHC: this.client.clientProfile.Spouses[0].HCHC || 0,
          HCT1D: this.client.clientProfile.Spouses[0].HCT1D || 0,
          HCT2D: this.client.clientProfile.Spouses[0].HCT2D || 0,
          HCCD: this.client.clientProfile.Spouses[0].HCCD || 0,
          HCC: this.client.clientProfile.Spouses[0].HCC || 0,
          HCT: this.client.clientProfile.Spouses[0].HCT || 0,
          HCMS: this.client.clientProfile.Spouses[0].HCMS || 0,
          HCDCW: this.client.clientProfile.Spouses[0].HCDCW || 0,
          HCFHDC: this.client.clientProfile.Spouses[0].HCFHDC || 0,

          HCALZ: this.client.clientProfile.Spouses[0].HCALZ || 0,
            HCPARK: this.client.clientProfile.Spouses[0].HCPARK || 0,
            HCAMP: this.client.clientProfile.Spouses[0].HCAMP || 0,
            HCPTSD: this.client.clientProfile.Spouses[0].HCPTSD || 0,
            HCOBS: this.client.clientProfile.Spouses[0].HCOBS || 0,
        }) : "";

        this.ssObjectFRA.SelfLifeExpectancy = this.client.clientProfile.LifeExpectancy;
        this.ssObjectFRA.SpouseLifeExpectancy = spouseLifeExpectancy || 0;
      } else {
        //this.ssObject.SelfLifeExpectancy = this.client.clientProfile.LifeExpectancy;
        //this.ssObject.SpouseLifeExpectancy = spouseLifeExpectancy || 0;
      }
    }

    console.log('ss object', this.ssObject);    
    console.log('ss objectFRA', this.ssObjectFRA);

    if(!this.isPageReloadOtherThanFRACall){
      this.storedOriginalSSObject = { ...this.ssObject };
      //this.storedOriginalSSObject = (this.hasAdjustedFRAScenario) ? { ...this.ssObjectFRA } : { ...this.ssObject };
      console.log('ss storedOriginalSSObject', this.storedOriginalSSObject);
    } else {
      this.ssObject = { ...this.storedOriginalSSObject };
      console.log('ss object after adj 01', this.ssObject);  
      if(this.hasDurationBeenToggled){
        this.ssObject.isPresentValue = this.isPresentValue;
      }

      //adjust RoR, if adjusted
      if(this.objAdjustRates && this.hasRoRBeenAdjusted){
        this.ssObject.FrmPhase1Rate = Number(this.objAdjustRates.rorOne);
        this.ssObject.FrmPhase1Periods = Number(this.objAdjustRates.throughYearTwo) - Number(this.objAdjustRates.throughYearOne);
        this.ssObject.FrmPhase2Rate = Number(this.objAdjustRates.rorTwo);
        this.ssObject.FrmPhase2Periods = Number(this.objAdjustRates.throughYearThree) - Number(this.objAdjustRates.throughYearTwo);
        this.ssObject.FrmPhase3Rate = Number(this.objAdjustRates.rorThree);
      }

      if(this.hasClientSidebarBeenUpdated){
        console.log('side bar has been updated');  
        this.ssObject.SelfLifeExpectancy = this.client.clientProfile.LifeExpectancy;
        this.ssObject.SelfRetirementAge = this.client.clientProfile.RetirementAge;
        this.ssObject.selfGender = this.client.client.GenderID;
        this.ssObject.SelfCurrentAge = this.calculateAge(this.client.client.DOB);
        this.ssObject.SelfDOB = this.client.client.DOB

        if (this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.client.clientProfile.Spouses[0].maritalStatus != "Widowed" &&  this.includeSpouse) {
          this.ssObject.SpouseLifeExpectancy = spouseLifeExpectancy || 0;
          console.log('spouseLifeExpectancy 003', spouseLifeExpectancy);
          if(this.client.clientProfile.Spouses[0].LifeExpectancy){
            this.ssObject.SpouseLifeExpectancy = this.client.clientProfile.Spouses[0].LifeExpectancy || 0;
          }
          console.log('spouseLifeExpectancy 004', this.client.clientProfile.Spouses[0].LifeExpectancy);
          this.ssObject.SpouseCurrentAge = this.calculateAge(spouseDOB) || 30;
          this.ssObject.SpouseDOB = spouseDOB;
          
          if (this.ssObject.spouseGender)
            this.ssObject.spouseGender = this.client.clientProfile.Spouses[0].gender || 1;
        }
      }

      if(this.hasCOLAsBeenAdjusted){
        this.ssObject.COLA = this.colas;
        this.ssObject.FrmColaXml = this.colas;
      }

      /* if(this.hasAdjustedFRAScenario){
        this.ssObjectFRA = { ...this.ssObject };
      } */
    }

    this.ssObject.FrmDiscountRate = this.socialSecurityForm.get('inflationRate').value.replace('%', '') / 100;

    if (this.ssObjectFRA)
      this.ssObjectFRA.FrmDiscountRate = this.socialSecurityForm.get('inflationRate').value.replace('%', '') / 100;

    console.log('ss object 01', this.ssObject);    
    console.log('ss objectFRA 01', this.ssObjectFRA);
    if(!this.previousSSObject){
      //  console.log('setting previous obj');
      this.previousSSObject = { ...this.ssObject };
    }
    this.loadingService.isLoading(true);
    //this.globalService.getSSData(((this.hasAdjustedFRAScenario) ? this.ssObjectFRA : this.ssObject), this.userForm.value)
    this.globalService.getSSData(this.ssObject, this.userForm.value)
      .subscribe(
        data => {
          console.log('SS DATA', data);
          if(!this.origSSData){
            this.origSSData = data;
          }
          this.ssData = data;
          this.ssData.gridData = JSON.parse(this.ssData.gridData);
          this.ssData.gridData = this.formatGridData(this.ssData.gridData);

          this.displayEarningsTestMessage = this.ssData.displayEarningsTestText;
          this.displayRetroTestMessage = (this.ssData.earlRetoFiling || this.ssData.cusRetoFiling || this.ssData.optRetoFiling);

          let dOB = new Date(this.client.client.DOB);
          let timeDiff = Math.abs(Date.now() - dOB.getTime());
          let clientAge = Math.floor((timeDiff / (1000 * 3600 * 24))/365.25);
          this.annuallyWeeklyTtlYear = this.client.clientProfile.RetirementAge - clientAge;
          let retirementAge = this.client.clientProfile.RetirementAge;
          if (clientAge > retirementAge) {
            let dropDownSelectedIndex = 3;
            let clientLifeExpectance = this.client.clientProfile.LifeExpectancy;
            if (this.client.clientProfile.Spouses[0].maritalStatus == 'Married')  {
              let spouseLifeExpectancy = this.client.clientProfile.Spouses[0].LifeExpectancy;
              let spouseAge = Number(this.globalService.calculateAge(this.client.clientProfile.Spouses[0].dob));
              let spouseLifeRemainingYr = spouseLifeExpectancy - spouseAge;
              let clientLifeRemainingYr = clientLifeExpectance - clientAge;
              if (spouseLifeRemainingYr < clientLifeRemainingYr) {
                this.annuallyWeeklyTtlYear = spouseLifeExpectancy - (spouseAge + 5);
                  if (this.annuallyWeeklyTtlYear < 0) {
                    this.annuallyWeeklyTtlYear = spouseLifeExpectancy - spouseAge;
                  }
              } else {
                this.annuallyWeeklyTtlYear = clientLifeExpectance - (clientAge + 5);
                if (this.annuallyWeeklyTtlYear < 0) {
                  this.annuallyWeeklyTtlYear = clientLifeExpectance - clientAge;
                }
              }

            } else {
              this.annuallyWeeklyTtlYear = clientLifeExpectance - (clientAge + 5);
              if (this.annuallyWeeklyTtlYear < 0) {
                this.annuallyWeeklyTtlYear = clientLifeExpectance - clientAge;
              }
            }
            if (this.annuallyWeeklyTtlYear == 0) {
              dropDownSelectedIndex = 0;
            } else if (this.annuallyWeeklyTtlYear < 3) {
              dropDownSelectedIndex = 1;
            }
            this.dropDownSelectedIndexWeekly = this.dropDownSelectedIndexAnnually = dropDownSelectedIndex;
          } else {
            this.annuallyWeeklyTtlYear = ((parseInt(retirementAge) - clientAge) > 1) ? parseInt(retirementAge) - clientAge : 1;

            //TODO: check if Alt or Optimal is set for page load > or just set Optimal and have getSSDataAlt handle Alt

          }

          console.log('this.annuallyWeeklyTtlYear 001', this.annuallyWeeklyTtlYear);

          //this.setSelectedLifeExpectancyPoint();
          this.lineGraphData = null;
          // console.log('data.costsByCareAndRegionBody', data.costsByCareAndRegionBody);
          this.comparisonGraph = this.createComparisonGraphData(data.costsByCareAndRegionBody);

          var eIllTotal = {
            clientAmountTotal: 0,
            dependentChildrenAmount: 0,
            netOfMedicareAmount: 0,
            spouseAmount: 0,
            totalAnnualAmount: 0,
          };

          var aIllTotal = {
            clientAmountTotal: 0,
            dependentChildrenAmount: 0,
            netOfMedicareAmount: 0,
            spouseAmount: 0,
            totalAnnualAmount: 0,
          };

          var opIllTotal = {
            clientAmountTotal: 0,
            dependentChildrenAmount: 0,
            netOfMedicareAmount: 0,
            spouseAmount: 0,
            totalAnnualAmount: 0,
          };
          
          for (var key in data.earliestIllustrationTable) {
            eIllTotal.clientAmountTotal = eIllTotal.clientAmountTotal + data.earliestIllustrationTable[key].clientAmount;
            eIllTotal.dependentChildrenAmount = eIllTotal.dependentChildrenAmount + data.earliestIllustrationTable[key].dependentChildrenAmount;
            if (this.ssData.earlPartB.includes("(") && this.ssData.earlPartB.includes(")")) {
              eIllTotal.netOfMedicareAmount = Number(this.ssData.earlTotalBenefit.replace(/,/g, "").replace("$", "")) + Number(this.ssData.earlPartB.replace(/,/g, "").replace("(","").replace(")","").replace("$", ""));
            } else {
              eIllTotal.netOfMedicareAmount = Number(this.ssData.earlTotalBenefit.replace(/,/g, "").replace("$", "")) - Number(this.ssData.earlPartB.replace(/,/g, "").replace("$", "")); //eIllTotal.netOfMedicareAmount + data.earliestIllustrationTable[key].netOfMedicareAmount;
            }
            
            eIllTotal.spouseAmount = eIllTotal.spouseAmount + data.earliestIllustrationTable[key].spouseAmount;
            eIllTotal.totalAnnualAmount = eIllTotal.totalAnnualAmount + data.earliestIllustrationTable[key].totalAnnualAmount;
            for (var keyy in data.earliestIllustrationTable[key]) {
              if (typeof data.earliestIllustrationTable[key][keyy] === 'number') {
                data.earliestIllustrationTable[key][keyy] = Utils.formatToCurrency(data.earliestIllustrationTable[key][keyy].toFixed(0));
              }
            }
          }

          data.earliestIllustrationTable.totals = eIllTotal;

          for (var key in data.alternateIllustrationTable) {
            aIllTotal.clientAmountTotal = aIllTotal.clientAmountTotal + data.alternateIllustrationTable[key].clientAmount;
            aIllTotal.dependentChildrenAmount = aIllTotal.dependentChildrenAmount + data.alternateIllustrationTable[key].dependentChildrenAmount;
            aIllTotal.netOfMedicareAmount = Number(this.ssData.cusTotalBenefit.replace(/,/g, "").replace("$", "")) - Number(this.ssData.cusPartB.replace(/,/g, "").replace("$", "")); //aIllTotal.netOfMedicareAmount + data.alternateIllustrationTable[key].netOfMedicareAmount;
            aIllTotal.spouseAmount = aIllTotal.spouseAmount + data.alternateIllustrationTable[key].spouseAmount;
            aIllTotal.totalAnnualAmount = aIllTotal.totalAnnualAmount + data.alternateIllustrationTable[key].totalAnnualAmount;
            for (var keyy in data.alternateIllustrationTable[key]) {
              if (typeof data.alternateIllustrationTable[key][keyy] === 'number') {
                data.alternateIllustrationTable[key][keyy] = Utils.formatToCurrency(data.alternateIllustrationTable[key][keyy].toFixed(0));
              }
            }
          }

          data.alternateIllustrationTable.totals = aIllTotal;

          for (var key in data.optimalIllustrationTable) {
            opIllTotal.clientAmountTotal = opIllTotal.clientAmountTotal + data.optimalIllustrationTable[key].clientAmount;
            opIllTotal.dependentChildrenAmount = opIllTotal.dependentChildrenAmount + data.optimalIllustrationTable[key].dependentChildrenAmount;
            opIllTotal.netOfMedicareAmount = Number(this.ssData.opTotalBenefit.replace(/,/g, "").replace("$", "")) - Number(this.ssData.optPartB.replace(/,/g, "").replace("$", ""));//opIllTotal.netOfMedicareAmount + data.optimalIllustrationTable[key].netOfMedicareAmount;
            opIllTotal.spouseAmount = opIllTotal.spouseAmount + data.optimalIllustrationTable[key].spouseAmount;
            opIllTotal.totalAnnualAmount = opIllTotal.totalAnnualAmount + data.optimalIllustrationTable[key].totalAnnualAmount;
            for (var keyy in data.optimalIllustrationTable[key]) {
              if (typeof data.optimalIllustrationTable[key][keyy] === 'number') {
                data.optimalIllustrationTable[key][keyy] = Utils.formatToCurrency(data.optimalIllustrationTable[key][keyy].toFixed(0));
              }
            }
          }

          data.optimalIllustrationTable.totals = opIllTotal;

          for (var key in data.earliestIllustrationTable.totals) {
            data.earliestIllustrationTable.totals[key] = Utils.formatToCurrency(data.earliestIllustrationTable.totals[key].toFixed(0));
          }

          for (var key in data.alternateIllustrationTable.totals) {
            data.alternateIllustrationTable.totals[key] = Utils.formatToCurrency(data.alternateIllustrationTable.totals[key].toFixed(0));
          }

          for (var key in data.optimalIllustrationTable.totals) {
            data.optimalIllustrationTable.totals[key] = Utils.formatToCurrency(data.optimalIllustrationTable.totals[key].toFixed(0));
          }

          //const age = this.calculateAge(dOB);
          const age = this.calculateAge(dOB);
          // console.log('client age', age)
          // console.log('client age2', clientAge)
          //this.ssObject.MaritalState == 'Single'

          var earliest = data.earliestIllustrationTable;
          var optimal = (age >= 70 && this.ssObject.MaritalState == 'Single') ? earliest : data.optimalIllustrationTable;
          //HACK: ZSS added to get FRA/First Alt to work with Optimal when changed
          /* if(this.storedOriginalOptimalTable && this.hasAdjustedFRAScenario){
            optimal = this.storedOriginalOptimalTable;
            earliest = this.storedOriginalEarliestTable;
          } else {
            this.storedOriginalOptimalTable = optimal;
            this.storedOriginalEarliestTable = earliest;
          } */
          var alternate = data.alternateIllustrationTable;

          this.illustrationComparisons = [
            //defaulted the breakEven to 999 since we dont know how to handle right now; once we figure it out, change back to 0
            { name: 'Earliest vs Alternate', data: [earliest, alternate], breakEven: 999 }, //breakEven: 0
            { name: 'Earliest vs Optimal', data: [earliest, optimal], breakEven: 999 }, //breakEven: 0
            { name: 'Alternate vs Optimal', data: [alternate, optimal], breakEven: 999 } //breakEven: 0
          ]
          
          //this.illustrationComparisons[0].breakEven = this.calculateBreakEven(this.illustrationComparisons[0].data[0], this.illustrationComparisons[0].data[1]);
          //this.illustrationComparisons[1].breakEven = this.calculateBreakEven(this.illustrationComparisons[1].data[0], this.illustrationComparisons[1].data[1]);
          //this.illustrationComparisons[2].breakEven = this.calculateBreakEven(this.illustrationComparisons[2].data[0], this.illustrationComparisons[2].data[1]);

          // console.log('testing', this.ssData.earlStartBenLabel);
          // console.log('testing', this.ssData.cusStartBenLabel);

          this.selectedIllustrationIdx = 0;
          // const nowDate = new Date();
          console.log('age', age);
          this.selectedIllustration = this.illustrationComparisons[this.selectedIllustrationIdx];
          var earliestAges = { client: this.ssData.earlStartBenLabel.split('/')[0].replace(' month', 'm').replace(' months', 'm').replace('ms', 'm').replace(' and', 'y'), partner: this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].maritalStatus != "Widowed" ? (this.ssData.earlStartBenLabel.split('/')[1] ? this.ssData.earlStartBenLabel.split('/')[1].replace(' month', 'm').replace(' months', 'm').replace('ms', 'm').replace(' and', 'y') : '') : '' : ''};
          //const chosenAges = { client: this.ssData.cusStartBenLabel.substring(0, this.ssData.cusStartBenLabel.indexOf(' and')), partner: this.client.clientProfile.Spouses.length > 1 ? this.ssData.cusStartBenLabel.split('/')[1].substring(0, this.ssData.cusStartBenLabel.split('/')[1].indexOf(' and')) : ''};
          const chosenAges = { client: this.ssData.cusStartBenLabel.split('/')[0].replace(' month', 'm').replace(' months', 'm').replace('ms', 'm').replace(' and', 'y'), partner: this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].maritalStatus != "Widowed" ? (this.ssData.cusStartBenLabel.split('/')[1] ? this.ssData.cusStartBenLabel.split('/')[1].replace(' month', 'm').replace(' months', 'm').replace('ms', 'm').replace(' and', 'y') : '') : '' : ''};
          var optimalAges = { client: this.ssData.opStartBenLabel.split('/')[0].replace(' month', 'm').replace(' months', 'm').replace('ms', 'm').replace(' and', 'y'), partner: this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].maritalStatus != "Widowed" ? (this.ssData.opStartBenLabel.split('/')[1] ? this.ssData.opStartBenLabel.split('/')[1].replace(' month', 'm').replace(' months', 'm').replace('ms', 'm').replace(' and', 'y') : '') : '' : ''};

          if (clientAge <= retirementAge) {
            console.log('setting annuallyWeeklyTtlYear', this.annuallyWeeklyTtlYear);
            var optAge = parseInt(this.ssData.opStartBenLabel.split('/')[0].replace(' month', '').replace(' months', '').replace('ms', '').replace(' and', ''));
            this.annuallyWeeklyTtlYear = ((optAge - clientAge) > 1) ? optAge - clientAge : 1;
            this.orgOptAnnuallyWeeklyTtlYear = ((optAge - clientAge) > 1) ? optAge - clientAge : 1;
            this.dropDownSelectedIndexWeekly = this.dropDownSelectedIndexAnnually = this.annuallyWeeklyTtlYear;

            var earlAge = parseInt(this.ssData.earlStartBenLabel.split('/')[0].replace(' month', '').replace(' months', '').replace('ms', '').replace(' and', ''));
            this.orgEarlyAnnuallyWeeklyTtlYear = ((earlAge - clientAge) > 1) ? earlAge - clientAge : 1;
				
		        var fraAge = parseInt(this.ssData.cusStartBenLabel.split('/')[0].replace(' month', '').replace(' months', '').replace('ms', '').replace(' and', ''));
            this.orgFRAAnnuallyWeeklyTtlYear = ((fraAge - clientAge) > 1) ? fraAge - clientAge : 1;
          }

          // const optimalAges = { client: this.ssData.opStartBenLabel.split('/')[0].replace(' month', 'm').replace(' months', 'm').replace('ms', 'm').replace(' and', 'y'), partner: this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].maritalStatus != "Widowed" ? (this.ssData.opStartBenLabel.split('/')[1] ? this.ssData.opStartBenLabel.split('/')[1].replace(' month', 'm').replace(' months', 'm').replace('ms', 'm').replace(' and', 'y') : '') : '' : ''};
          /* if(this.storedOriginalOptimalClaimAges && this.hasAdjustedFRAScenario){
            optimalAges = this.storedOriginalOptimalClaimAges;
            earliestAges = this.storedOriginalEarliestClaimAges
          } else {
            this.storedOriginalOptimalClaimAges = optimalAges;
            this.storedOriginalEarliestClaimAges = earliestAges;
          } */
          console.log('chosenAges', chosenAges);
          // SM (01/03/23): FE we are showing year and age so for the below case while we are showing to FE we need to substract by currentAgeOffset Otherwise it will show wrong year (cause govt already declared the benefit for that specific year) - verified by Dustin
          // let spouseAge = 0;
          // let isSelfAlreadyCollected = this.client.clientProfile.SelfAlreadyCollecting == 1 ? true : false;
          /*
          if (age > 62 || isSelfAlreadyCollected) {
            let currentAgeOffset = (nowDate.getMonth() < dOB.getMonth()) ? 1 : 0;
            // update earliest one
            let earliestYear = earliestAges.client.split('y')[0];
            earliestYear = earliestYear.replace('y', '');
            let earliestNewYear = Number(earliestYear) - currentAgeOffset;
            
            //earliestAges.client = earliestNewYear + 'y' + earliestAges.client.split('y')[1];
            
            //if(this.getFRAv2(this.client.client.DOB).age < age){
            //}

            if ((age - currentAgeOffset) >= 70) {
              earliestAges.client = earliestNewYear + 'y 0m';
            }
          }

          if (this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
            let spouseDOB = new Date(this.client.clientProfile.Spouses[0].dob);
            let currentSpouseAgeOffset = (nowDate.getMonth() < spouseDOB.getMonth()) ? 1 : 0;
            spouseAge = this.calculateAge(spouseDOB);
            let isSpouseAlreadyCollected = this.client.clientProfile.SpouseAlreadyCollecting == 1 ? true : false;;
            if (spouseAge > 62 || isSpouseAlreadyCollected) {
              let spouseCurrentAgeOffset = (nowDate.getMonth() < spouseDOB.getMonth()) ? 1 : 0;
              // update earliest one
              let spouseEarliestYear = earliestAges.partner.split('y')[0];
              spouseEarliestYear = spouseEarliestYear.replace('y', '');
              let newSpouseEarliestYear = Number(spouseEarliestYear) - spouseCurrentAgeOffset;
              earliestAges.partner = newSpouseEarliestYear + 'y' + earliestAges.partner.split('y')[1];


              if ((spouseAge - spouseCurrentAgeOffset) >= 70) {
                earliestAges.partner = newSpouseEarliestYear + 'y 0m';
              }
            }
          }
          */

          console.log('Earliest FRA', this.getFRAv2(this.client.client.DOB));
          /* console.log('Earliest FRA', this.getFRAv2(this.client.client.DOB));
          console.log('Earliest FRA', (parseInt(earliestAges.client.replaceAll(' ', '').split('y')[0]) * 12));
          console.log('Earliest FRA', parseInt(earliestAges.client.replaceAll(' ', '').split('y')[1].split('m')[0]));
          console.log('Earliest FRA', (this.getFRAv2(this.client.client.DOB).age * 12)); */
          var earliestTotals = { client: this.ssData.earlSelfBenefit, partner: this.ssData.earlSpouseBenefit, netOfMedicare: this.ssData.earlNetOfB, netOfMedicarePercent: this.ssData.earlPartBPercent, netOfMedicareDollar: this.ssData.earlPartB }
          const chosenTotals = { client: this.ssData.cusSelfBenefit, partner: this.ssData.cusSpouseBenefit, netOfMedicare: this.ssData.cusNetOfB, netOfMedicarePercent: this.ssData.cusPartBPercent, netOfMedicareDollar: this.ssData.cusPartB }
          var optimalTotals = { client: this.ssData.opSelfBenefit, partner: this.ssData.opSpouseBenefit, netOfMedicare: this.ssData.optNetOfB, netOfMedicarePercent: this.ssData.optPartBPercent, netOfMedicareDollar: this.ssData.optPartB }
          //HACK: ZSS added to get FRA/First Alt to work with Optimal when changed
          /* if(this.storedOriginalOptimalTotals && this.hasAdjustedFRAScenario){
            optimalTotals = this.storedOriginalOptimalTotals;
            earliestTotals = this.storedOriginalEarliestTotals;
          } else {
            this.storedOriginalOptimalTotals = optimalTotals;
            this.storedOriginalEarliestTotals = earliestTotals;
          } */

          let earliestMedicareDeductions = earliestTotals.netOfMedicareDollar + " " + earliestTotals.netOfMedicarePercent ;
          let fraMedicalDeductions = chosenTotals.netOfMedicareDollar + " " + chosenTotals.netOfMedicarePercent;
          let optimalMedicalDeductions = optimalTotals.netOfMedicareDollar + " " + optimalTotals.netOfMedicarePercent;

          //HACK: remove once PO2-177 is marked as Done
          /* if(this.addFunds){
            var sum = 0;
            for (let i = 0; i < this.fundingSource.length; i++) {
              sum += this.fundingSource[i].totalContribution;
            } 
            
            this.currentRemainingTotal = this.ssData.remainingUnfundedOptimal = Utils.formatToNumber(data.cusPartB) - sum;     
            
            this.ssData.remainingUnfundedOptimal = Utils.formatToNumber(optimalTotals.netOfMedicareDollar) - sum;
            this.ssData.remainingUnfundedEarliest = Utils.formatToNumber(earliestTotals.netOfMedicareDollar) - sum;
            this.ssData.remainingUnfunded = Utils.formatToNumber(chosenTotals.netOfMedicareDollar) - sum;
          } */

          this.socialSecurityIllustrationCards = [
            { scenario: (this.ssData.earlRetoFiling) ? 'Earliest (Retroactive File)' : 'Earliest', color: '#5d80c0', clientName: this.client.client.FirstName, 
              clientFRA: (this.ssData.earlSelfRetoFiling) ? this.getFRAv2(this.client.client.DOB) : '',
              partnerFRA: (this.ssData.earlSpouseRetoFiling && this.client.clientProfile.Spouses[0].maritalStatus == "Married") ? this.getFRAv2(spouseDOB) : '',
              clientAge: earliestAges.client, clientTotal: earliestTotals.client , partnerName: (this.client.clientProfile.Spouses.length > 0) ? (this.client.clientProfile.Spouses[0].maritalStatus != "Widowed" && this.client.clientProfile.Spouses[0].maritalStatus != "Divorced") ? this.client.clientProfile.Spouses[0].firstName : '' : '',               
              partnerAge: earliestAges.partner, partnerTotal: earliestTotals.partner, medicareDeductions: earliestMedicareDeductions, netOfMedicare: earliestTotals.netOfMedicare,
            dependentChildrenSumTotal: this.ssData.depChildrenSumTotalEarliest
            },
              

              { scenario: (this.hasAdjustedFRAScenario) ? 'First Alternate' + ((this.ssData.cusSelfRetoFiling || this.ssData.cusSpouseRetoFiling) ? " (Retroactive File)" : "") : 'FRA', color: '#73bcb8', 
              clientFRA: (this.hasAdjustedFRAScenario && this.ssData.cusSelfRetoFiling) ? this.getFRAv2(this.client.client.DOB) : '',
              partnerFRA: (this.hasAdjustedFRAScenario && this.ssData.cusSpouseRetoFiling && this.client.clientProfile.Spouses[0].maritalStatus == "Married") ? this.getFRAv2(spouseDOB) : '',                
              clientName: this.client.client.FirstName, clientAge: chosenAges.client, clientCurrentAge: chosenAges.client.replaceAll(' ', '').split('y')[0], clientTotal: chosenTotals.client,
              partnerName: (this.client.clientProfile.Spouses.length > 0) ? (this.client.clientProfile.Spouses[0].maritalStatus != "Widowed" && this.client.clientProfile.Spouses[0].maritalStatus != "Divorced") ? this.client.clientProfile.Spouses[0].firstName : '' : '',
              clientRetroNumMonths: (this.hasAdjustedFRAScenario && this.ssData.cusSelfRetoFiling) ? this.ssData.cusSelfRetoNumMonths : '',
              partnerRetroNumMonths: (this.hasAdjustedFRAScenario && this.ssData.cusSpouseRetoFiling) ? this.ssData.cusSpouseRetoNumMonths : '', 
              partnerAge: chosenAges.partner, partnerCurrentAge: (chosenAges.partner) ? chosenAges.partner.replaceAll(' ', '').split('y')[0] : 0, 
              partnerTotal: chosenTotals.partner, medicareDeductions: fraMedicalDeductions, netOfMedicare: chosenTotals.netOfMedicare,
            dependentChildrenSumTotal: this.ssData.depChildrenSumTotal
            },         
                
            (age  >= 70 && this.ssObject.MaritalState == 'Single') ?
            { scenario: (this.ssData.optRetoFiling) ? 'Optimal (Retroactive File)' : 'Optimal', color: '#8d68dd', clientName: this.client.client.FirstName, 
              clientFRA: (this.ssData.optSelfRetoFiling) ? this.getFRAv2(this.client.client.DOB) : '',
              partnerFRA: (this.ssData.optSpouseRetoFiling && this.client.clientProfile.Spouses[0].maritalStatus == "Married") ? this.getFRAv2(spouseDOB) : '',
              clientAge: earliestAges.client, clientTotal: earliestTotals.client , partnerName: (this.client.clientProfile.Spouses.length > 0) ? (this.client.clientProfile.Spouses[0].maritalStatus != "Widowed" && this.client.clientProfile.Spouses[0].maritalStatus != "Divorced") ? this.client.clientProfile.Spouses[0].firstName : '' : '', 
              partnerAge: earliestAges.partner, partnerTotal: earliestTotals.partner, medicareDeductions: earliestMedicareDeductions, 
              netOfMedicare: earliestTotals.netOfMedicare,
              dependentChildrenSumTotal: this.ssData.depChildrenSumTotalOptimal
            } 
            : { scenario: (this.ssData.optRetoFiling) ? 'Optimal (Retroactive File)' : 'Optimal', color: '#8d68dd', clientName: this.client.client.FirstName, 
              clientFRA: (this.ssData.optSelfRetoFiling) ? this.getFRAv2(this.client.client.DOB) : '',
              partnerFRA: (this.ssData.optSpouseRetoFiling && this.client.clientProfile.Spouses[0].maritalStatus == "Married") ? this.getFRAv2(spouseDOB) : '',
              clientAge: optimalAges.client, clientTotal: optimalTotals.client , partnerName: (this.client.clientProfile.Spouses.length > 0) ? (this.client.clientProfile.Spouses[0].maritalStatus != "Widowed" && this.client.clientProfile.Spouses[0].maritalStatus != "Divorced") ? this.client.clientProfile.Spouses[0].firstName : '' : '', 
              partnerAge: optimalAges.partner, partnerTotal: optimalTotals.partner, medicareDeductions: optimalMedicalDeductions, netOfMedicare: optimalTotals.netOfMedicare,
            dependentChildrenSumTotal: this.ssData.depChildrenSumTotalOptimal
            },
              
            //{ scenario: 'Alternate', color: '#73bcb8', clientName: this.client.client.FirstName, clientAge: chosenAges.client, clientTotal: chosenTotals.client , partnerName: (this.client.clientProfile.Spouses.length > 0) ? this.client.clientProfile.Spouses[0].firstName : '', partnerAge: chosenAges.partner, partnerTotal: chosenTotals.partner, medicareDeductions: chosenTotals.netOfMedicarePercent, netOfMedicare: chosenTotals.netOfMedicare }
          ]

          console.log('this.socialSecurityIllustrationCards', this.socialSecurityIllustrationCards);
        
          let  earliestClaimAges = this.ssData.earlStartBenLabel.split('/');
          let clientEarliestClaim = [], spouseEarliestClaim = [];

          if (!earliestClaimAges.length)
            earliestClaimAges = [this.ssData.earlStartBenLabel];

          clientEarliestClaim = earliestClaimAges[0].split(" and ");
          clientEarliestClaim[1] = clientEarliestClaim[1].replace(" months", "").replace(" month", "");

          if (this.ssData.earlStartBenLabel.split('/').length > 1) {
            spouseEarliestClaim = earliestClaimAges[1].split(" and ");
            spouseEarliestClaim[1] = spouseEarliestClaim[1].replace(" months", "").replace(" month", "");
          }

          let  alternateClaimAges = this.ssData.cusStartBenLabel.split('/');
          let clientAlternateClaim = [], spouseAlternateClaim = [];

          if (!alternateClaimAges.length)
            alternateClaimAges = [this.ssData.cusStartBenLabel];

          clientAlternateClaim = alternateClaimAges[0].split(" and ");
          clientAlternateClaim[1] = clientAlternateClaim[1].replace(" months", "").replace(" month", "");

          if (this.ssData.cusStartBenLabel.split('/').length > 1) {
            spouseAlternateClaim = alternateClaimAges[1].split(" and ");
            spouseAlternateClaim[1] = spouseAlternateClaim[1].replace(" months", "").replace(" month", "");
          }

          let  optimalClaimAges = this.ssData.opStartBenLabel.split('/');
          let clientClaim = [], spouseClaim = [];

          if (!optimalClaimAges.length)
            optimalClaimAges = [this.ssData.opStartBenLabel];

          clientClaim = optimalClaimAges[0].split(" and ");
          clientClaim[1] = clientClaim[1].replace(" months", "").replace(" month", "");

          if (this.ssData.opStartBenLabel.split('/').length > 1) {
            spouseClaim = optimalClaimAges[1].split(" and ");
            spouseClaim[1] = spouseClaim[1].replace(" months", "").replace(" month", "");
          }
          
          console.log('this.storedOriginalOptimalTotals', this.storedOriginalOptimalTotals);
          this.socialSecurityBenefitCards = [
            //{ scenario: 'Earliest', color: '#5d80c0', amount: Utils.formatToCurrency(Utils.formatToNumber(earliestTotals.client) + Utils.formatToNumber(earliestTotals.partner)), includeCheck: false },
            { scenario: (this.ssData.earlRetoFiling) ? 'Earliest (Retroactive File)' : 'Earliest', color: '#5d80c0', 
            amount: (this.storedOriginalEarliestTotals && this.hasAdjustedFRAScenario) 
              ? Utils.formatToCurrency(Utils.formatToNumber(this.storedOriginalEarliestTotals.client) + Utils.formatToNumber((this.storedOriginalEarliestTotals.partner) ? this.storedOriginalEarliestTotals.partner : 0)) 
              : this.ssData.earlTotalBenefit, includeCheck: false, ages: { clientAge: clientEarliestClaim[0], clientMonths: clientEarliestClaim[1], spouseAge: spouseEarliestClaim[0], spouseMonths: spouseEarliestClaim[1]}},
            //{ scenario: 'FRA', color: '#73bcb8', amount: Utils.formatToCurrency(Utils.formatToNumber(chosenTotals.client) + Utils.formatToNumber(chosenTotals.partner)), includeCheck: false },
            { scenario: (this.hasAdjustedFRAScenario) ? 'First Alternate' + ((this.ssData.cusSelfRetoFiling || this.ssData.cusSpouseRetoFiling) ? " (Retroactive File)" : "") : 'FRA', color: '#73bcb8', amount: this.ssData.cusTotalBenefit, includeCheck: false,  ages: { clientAge: clientAlternateClaim[0], clientMonths: clientAlternateClaim[1], spouseAge: spouseAlternateClaim[0], spouseMonths: spouseAlternateClaim[1]}},
            //TODO: need to figure out is the 'check' just always supposed to be on the Optimal? Or whats best for the client (i.e. if someone changes LE and its better than the Optimal)
            //{ scenario: 'Optimal', color: '#8d68dd', amount: Utils.formatToCurrency(Utils.formatToNumber(optimalTotals.client) + Utils.formatToNumber(optimalTotals.partner)), includeCheck: false },
            (age >= 70 && this.ssObject.MaritalState == 'Single') ?
            { scenario: (this.ssData.optRetoFiling) ? 'Optimal (Retroactive File)' : 'Optimal', color: '#8d68dd', amount: this.ssData.earlTotalBenefit, includeCheck: false, ages: { clientAge: clientClaim[0], clientMonths: clientClaim[1], spouseAge: spouseClaim[0], spouseMonths: spouseClaim[1]}}
            : { scenario: (this.ssData.optRetoFiling) ? 'Optimal (Retroactive File)' : 'Optimal', color: '#8d68dd', 
              amount: (this.storedOriginalOptimalTotals && this.hasAdjustedFRAScenario) 
                ? Utils.formatToCurrency(Utils.formatToNumber(this.storedOriginalOptimalTotals.client) + Utils.formatToNumber((this.storedOriginalOptimalTotals.partner) ? this.storedOriginalOptimalTotals.partner : 0)) 
                : this.ssData.opTotalBenefit, 
              includeCheck: false, ages: { clientAge: clientClaim[0], clientMonths: clientClaim[1], spouseAge: spouseClaim[0], spouseMonths: spouseClaim[1]}},
            //{ scenario: 'Alternate', color: '#73bcb8', amount: Utils.formatToCurrency(Utils.formatToNumber(chosenTotals.client) + Utils.formatToNumber(chosenTotals.partner)), includeCheck: false },
          ];

          if (earliestAges.partner) {
            this.scenarioDropDown.scenarios = [`${earliestAges.client} / ${earliestAges.partner}`, `${chosenAges.client} / ${chosenAges.partner}`, `${optimalAges.client} / ${optimalAges.partner}`]
          } else {
              this.scenarioDropDown.scenarios = [earliestAges.client, chosenAges.client, optimalAges.client]
          }

          if (this.scenarioDropDown.length === 4 && !this.hasAlternateScenario) {
            this.scenarioDropDown.pop();
          }

          if (!this.hasAlternateScenario)
            this.scenarioDropDown.selected = 2;

          //090522 ZSS
          this.startingLumpsum = (this.hasAlternateScenario) ? data.startBalanceAlt : data.startBalanceOpt;
          this.beginningBalance = data.lumpsumCostOptimal;//data.lumpsumCost;
          this.totalRemainingGap = this.beginningBalance;

          this.currentRemainingTotal = data.remainingUnfundedOptimal;
          console.log('currentRemainingTotal', this.currentRemainingTotal);          

          this.yearlyCost = data.yearlyCostOptimal;//data.yearlyCost;
          this.weeklyCost = data.weeklyCostOptimal;//data.weeklyCost;

          if(!this.hasAlternateScenario){
            this.setScenario = this.socialSecurityIllustrationCards[2];
          }
          //this.futureYearlyCost = Number(this.yearlyCost) * (this.annuallyWeeklyTtlYear >= 10 ? 10: this.annuallyWeeklyTtlYear);
          //this.objAdjustRates.rorOne isnt set here I guess? hardcode to 6 for page load values
          /* console.log('this.annuallyWeeklyTtlYear', this.annuallyWeeklyTtlYear);
          var pay = Math.ceil(Math.abs(this.startingLumpsum * (6.00 / 1) / (Math.pow(1 + (6.00 / 1), (this.annuallyWeeklyTtlYear * 1 + 1))) - (1 + 6.00 / 1)));
          var payFutureAnnual = (pay + Number(this.yearlyCost)) * this.annuallyWeeklyTtlYear;
          this.futureYearlyCost = payFutureAnnual;

          this.weeklyCost = data.weeklyCost;
          //this.futureWeeklyCost  = Number(this.weeklyCost) * 52 * ((this.annuallyWeeklyTtlYear >= 10 ? 10: this.annuallyWeeklyTtlYear));
          var pay = Math.ceil(Math.abs(this.startingLumpsum * (6.00 / 52) / (Math.pow(1 + (6.00 / 52), (this.annuallyWeeklyTtlYear * 52 + 1))) - (1 + 6.00 / 52)));
          var payFutureWeek = (pay + Number(this.weeklyCost)) * (this.annuallyWeeklyTtlYear * 52);
          this.futureWeeklyCost = payFutureWeek; */


          var phaseOnePercent = (this.objAdjustRates ? (Number(this.objAdjustRates.rorOne)) : 6) / 100;
    
          //var pay = Math.ceil(Math.abs(this.startingLumpsum * (6.00 / 1) / (Math.pow(1 + (6.00 / 1), (this.annuallyWeeklyTtlYear * 1 + 1))) - (1 + 6.00 / 1)));
          //var payFutureAnnual = (pay + Number(this.yearlyCost)) * this.annuallyWeeklyTtlYear;
          var pay = Math.ceil(Math.abs(this.startingLumpsum * phaseOnePercent / (Math.pow((1 + phaseOnePercent), this.annuallyWeeklyTtlYear) - 1)));
          var payFutureAnnual = pay * this.annuallyWeeklyTtlYear;
          this.futureYearlyCost = this.yearlyCost;//payFutureAnnual;

          //var pay = Math.ceil(Math.abs(this.startingLumpsum * (6.00 / 52) / (Math.pow(1 + (6.00 / 52), (this.annuallyWeeklyTtlYear * 52 + 1))) - (1 + 6.00 / 52)));
          //var payFutureWeek = (pay + Number(this.weeklyCost)) * (this.annuallyWeeklyTtlYear * 52);
          var pay = Math.ceil(Math.abs(this.startingLumpsum * (phaseOnePercent / 52) / (Math.pow(1 + phaseOnePercent / 52, (this.annuallyWeeklyTtlYear * 52)) - 1)));
          var payFutureWeek = pay * (this.annuallyWeeklyTtlYear * 52);
          this.futureWeeklyCost = this.weeklyCost;//payFutureWeek;

          //this.lumpsum = dataAlt.lumpsum;

          this.yearlyCostFRA = data.yearlyCost;
          this.futureYearlyCostFRA = payFutureAnnual;
          //Number(this.yearlyCostFRA) * (this.annuallyWeeklyTtlYear >= 10 ? 10: this.annuallyWeeklyTtlYear);

          this.weeklyCostFRA = data.weeklyCost;
          this.futureWeeklyCostFRA = payFutureWeek;
          //Number(this.weeklyCostFRA) * 52 * ((this.annuallyWeeklyTtlYear >= 10 ? 10: this.annuallyWeeklyTtlYear));
          this.lumpsum = data.lumpsumCostOptimal;//data.lumpsumCost;
          this.lumpsumFRA = data.lumpsumCost;

          this.yearlyCostOptimal = data.yearlyCostOptimal;
          this.futureYearlyCostOptimal = Number(this.yearlyCostOptimal) * this.annuallyWeeklyTtlYear;

          this.weeklyCostOptimal = data.weeklyCostOptimal;
          this.futureWeeklyCostOptimal  = Number(this.weeklyCostOptimal) * 52 * this.annuallyWeeklyTtlYear;
          this.lumpsumOptimal = data.lumpsumCostOptimal;

          this.yearlyCostEarliest = data.yearlyCostEarliest;
          this.futureYearlyCostEarliest = Number(this.yearlyCostEarliest) * this.annuallyWeeklyTtlYear;

          this.weeklyCostEarliest = data.weeklyCostEarliest;
          this.futureWeeklyCostEarliest  = Number(this.weeklyCostEarliest) * 52 * this.annuallyWeeklyTtlYear;
          this.lumpsumEarliest = data.lumpsumCostEarliest;

          //this.futureTotalCost = Utils.formatToNumber(chosenTotals.netOfMedicare);
          //netOfMedicareDollar: this.ssData.cusPartB 
          if(!this.isPageReloadOtherThanFRACall){
            console.log('in here because of page reload');
            //TODO: this may just get reset everytime this is hit...mayb need to reconfigure
            this.totalRemainingGap = (this.beginningBalance > 0) ? this.beginningBalance : 0;
            //this.medicareDeductions = Utils.formatToNumber(chosenTotals.netOfMedicareDollar);
            this.medicareDeductions = Utils.formatToNumber(optimalTotals.netOfMedicareDollar);
            //this.currentRemainingTotal = this.medicareDeductions;
          } else if (this.hasRoRBeenAdjusted){
            this.totalRemainingGap = (this.beginningBalance > 0) ? this.beginningBalance : 0;
          }

          console.log('monster', this.totalRemainingGap, this.medicareDeductions)
          
          let clientAgeYears = this.socialSecurityForm.get('selfRetirementYears').value;
          let clientAgeMonth = this.socialSecurityForm.get('selfRetirementMonths').value;
          let isClientAgeDisable = false;

          let spouseAgeYears = this.socialSecurityForm.get('spouseRetirementYears').value;
          //console.log('spouseAgeYears', spouseAgeYears);
          let spouseAgeMonths = this.socialSecurityForm.get('spouseRetirementMonths').value;
          let isSpouseAgeDisable = false;
          console.log('calculateAge', this.calculateAge(this.client.client.DOB));
          console.log('getCurrentAgeByDOB', this.getCurrentAgeByDOB(this.client.client.DOB));
          console.log('clientAgeYears test', clientAgeYears);
          console.log('clientAgeMonth', clientAgeMonth);

          //ZSS: added to fix issues on client: LinwoodClone and Partner Clone
          clientAgeMonth = (clientAgeYears) ? clientAgeMonth : this.client.clientProfile.SSDesiredAgeMonths;
          clientAgeYears = (clientAgeYears) ? clientAgeYears : this.client.clientProfile.SSDesiredAgeYears;
          //console.log('clientAgeYears test', clientAgeYears);
          //console.log('clientAgeMonth', clientAgeMonth);

          if (this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
            /* console.log('spouseAgeYears', spouseAgeYears);
            spouseAgeMonths = (spouseAgeYears) ? spouseAgeMonths : this.client.clientProfile.Spouses[0].sSDesiredAgeMonths;
            spouseAgeYears = (spouseAgeYears) ? spouseAgeYears : this.client.clientProfile.Spouses[0].sSDesiredAgeYears;
            console.log('spouseAgeYears', spouseAgeYears); */

            //if (((this.client.clientProfile.MonthlyBenefitAmount || 0) > 0 && ( Utils.formatToNumber(this.client.clientProfile.Spouses[0].monthlyBenefits || 0)) == 0) 
            if (this.client.clientProfile.SelfAlreadyCollecting
            || this.calculateAge(this.client.client.DOB) >= 70) {
              clientAgeYears = this.calculateAge(this.client.client.DOB);
              clientAgeMonth = this.clientAgeMonth;
              isClientAgeDisable = true;
              //console.log('clientAgeYears test1', clientAgeYears);
              if(!this.client.clientProfile.Spouses[0].sSDesiredAgeYears){
                //spouseAgeMonths = (spouseAgeYears) ? spouseAgeMonths : this.client.clientProfile.Spouses[0].sSDesiredAgeMonths;
                spouseAgeYears = this.calculateAge(spouseDOB);
              }
            }
            //if (((this.client.clientProfile.MonthlyBenefitAmount || 0) == 0 && (Utils.formatToNumber(this.client.clientProfile.Spouses[0].monthlyBenefits || 0)) > 0) 
            if (this.client.clientProfile.SpouseAlreadyCollecting 
            || this.calculateAge(spouseDOB) >= 70)  {
              spouseAgeYears = this.calculateAge(spouseDOB);
              spouseAgeMonths = this.spouseAgeMonth;
              isSpouseAgeDisable = true;
              //console.log('clientAgeYears test2', clientAgeYears);
            }
            //console.log('I am here for clientAgeYears');
          } else {
            if (this.calculateAge(this.client.client.DOB) >= 70) {
              clientAgeYears = this.calculateAge(this.client.client.DOB);
              clientAgeMonth = this.clientAgeMonth;
              isClientAgeDisable = true;
              //console.log('clientAgeYears test3', clientAgeYears);
            }
          }

          if(!this.objAdjustedDesiredScenario 
            || (!Object.keys(this.objAdjustedDesiredScenario).length && (this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed' || this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced'))){
            var isSwappedClaim = (this.client.clientProfile.InvertSurvivorSwitch != null) ? this.client.clientProfile.InvertSurvivorSwitch : this.swappedClaim;
            //this.adjSurvivorBenefitAge = !isSwappedClaim ? this.clientSurvivorSwitchYears : ((this.isSpouseSurvivor) ? spouseAgeYears : clientAgeYears);
            //this.adjSurvivorBenefitMonths = !isSwappedClaim ? this.clientSurvivorSwitchMonths : ((this.isSpouseSurvivor) ? spouseAgeMonths : clientAgeMonth);
            //this.adjRetirementBenefitAge = !isSwappedClaim ? ((this.isSpouseSurvivor) ? spouseAgeYears : clientAgeYears) : this.clientSurvivorSwitchYears;
            //this.adjRetirementBenefitMonths = !isSwappedClaim ? ((this.isSpouseSurvivor) ? spouseAgeMonths : clientAgeMonth) : this.clientSurvivorSwitchMonths;
            console.log('setting swap', isSwappedClaim);

            this.objAdjustedDesiredScenario = {
              scenario: 'Alternate',
              clientAgeYears: clientAgeYears,//clientAgeYears, //(clientAgeYears ? clientAgeYears : this.clientSurvivorSwitchYears), //clientAgeYears
              clientAgeMonths: clientAgeMonth,//clientAgeMonth,// (clientAgeYears ? clientAgeMonth : this.clientSurvivorSwitchMonths), //clientAgeMonth
              spouseAgeYears: spouseAgeYears,// null, 
              spouseAgeMonths: spouseAgeMonths,
              isClientAgeDisable: isClientAgeDisable,
              isSpouseAgeDisable: isSpouseAgeDisable,
              survivorSwitchAgeYears: this.clientSurvivorSwitchYears,//(this.clientSurvivorSwitchYears),
              survivorSwitchAgeMonths: this.clientSurvivorSwitchMonths,//this.clientSurvivorSwitchMonths,
              
              isClientFilingRestricted: (this.calculateAge(this.client.client.DOB) == 69),
              isSpouseFilingRestricted: (this.calculateAge(spouseDOB) == 69),
              fileRestrictedAgeYears: (this.calculateAge(this.client.client.DOB) == 69) ? 0 : 0,
              fileRestrictedAgeMonths: (this.calculateAge(this.client.client.DOB) == 69) ? 0 : 0,
              clientFileRestrictedMinMonth: chosenAges.client.split(' ')[1].replace('m', ''),
              clientRetroDisplayAge: (this.ssData.earlSelfRetoFiling) ? earliestAges.client : '',
              spouseFileRestrictedAgeYears: (this.calculateAge(spouseDOB) == 69) ? 0 : 0,
              spouseFileRestrictedAgeMonths: (this.calculateAge(spouseDOB) == 69) ? 0 :0,
              spouseFileRestrictedMinMonth: (chosenAges.partner) ? chosenAges.partner.trim().split(' ')[1].replace('m', '') : 0,
              partnerRetroDisplayAge: (this.ssData.earlSpouseRetoFiling) ? earliestAges.partner : '',

              isClientRetroFiling: this.ssData.earlSelfRetoFiling,
              isSpouseRetroFiling: this.ssData.earlSpouseRetoFiling,

              clientDefaultAgeVal: earliestAges.client,
              partnerDefaultAgeVal: earliestAges.partner,

              swappedClaim: isSwappedClaim
              //(this.client.clientProfile.InvertSurvivorSwitch != null) ? this.client.clientProfile.InvertSurvivorSwitch : this.swappedClaim
            };                               
          } else {
            this.objAdjustedDesiredScenario = {
              clientDefaultAgeVal: earliestAges.client,
              partnerDefaultAgeVal: earliestAges.partner
            };
          }
          console.log('this.objAdjustedDesiredScenario 01', this.objAdjustedDesiredScenario);
          console.log('this.objAdjustedFRAScenario', this.objAdjustedFRAScenario)

          if(!this.objAdjustedFRAScenario) {
            this.objAdjustedFRAScenario = {
              scenario: 'FRA',
              //TODO: need to know if FRA has a (Retirement) and/or a (Survivor)
              clientAgeYears: (this.ssData.isFRAInvertedSwitch && !this.isSpouseSurvivor) ? 0 : chosenAges.client.replaceAll(' ', '').split('y')[0], 
              clientAgeMonths: (this.ssData.isFRAInvertedSwitch && !this.isSpouseSurvivor) ? 0 : chosenAges.client.replaceAll(' ', '').split('y')[1].replace('m', ''), 
              /* clientAgeYears: chosenAges.client.replaceAll(' ', '').split('y')[0], 
              clientAgeMonths: chosenAges.client.replaceAll(' ', '').split('y')[1].replace('m', ''),  */
              //this.isSpouseSurvivor
              spouseAgeYears: (chosenAges.partner) ? (this.ssData.isFRAInvertedSwitch || this.isSpouseSurvivor) ? 0 : chosenAges.partner.replaceAll(' ', '').split('y')[0] : '',
              spouseAgeMonths: (chosenAges.partner) ? (this.ssData.isFRAInvertedSwitch || this.isSpouseSurvivor) ? 0 : chosenAges.partner.replaceAll(' ', '').split('y')[1].replace('m', '') : '',
              isClientAgeDisable: isClientAgeDisable,
              isSpouseAgeDisable: isSpouseAgeDisable,
              survivorSwitchAgeYears: (this.isSpouseSurvivor) ? (!this.ssData.isFRAInvertedSwitch) ? 0 : ((this.ssData.spouseFRASurvivorAge) ? this.ssData.spouseFRASurvivorAge : 0) //(this.ssData.spouseBenefitAge) ? this.ssData.spouseBenefitAge : this.objAdjustedFRAScenario.spouseAgeYears) 
                : (!this.ssData.isFRAInvertedSwitch) ? 0 : (this.ssData.selfFRASurvivorAge) ? this.ssData.selfFRASurvivorAge : 0,
              survivorSwitchAgeMonths: (this.isSpouseSurvivor) ? (!this.ssData.isFRAInvertedSwitch) ? 0 : ((this.ssData.spouseFRASurvivorMonth) ? this.ssData.spouseFRASurvivorMonth : 0)
                : (!this.ssData.isFRAInvertedSwitch) ? 0 : (this.ssData.selfFRASurvivorMonth) ? this.ssData.selfFRASurvivorMonth : 0, 
              //survivorSwitchAgeYears: (this.isSpouseSurvivor) ? chosenAges.partner.replaceAll(' ', '').split('y')[0] : (!this.ssData.isFRAInvertedSwitch) ? chosenAges.client.replaceAll(' ', '').split('y')[0] : 0,
              //survivorSwitchAgeMonths: (this.isSpouseSurvivor) ? chosenAges.partner.replaceAll(' ', '').split('y')[1].replace('m', '') : (!this.ssData.isFRAInvertedSwitch) ? chosenAges.client.replaceAll(' ', '').split('y')[1].replace('m', '') : 0, 
              //survivorSwitchAgeYears: this.clientSurvivorSwitchYears,
              //survivorSwitchAgeMonths: this.clientSurvivorSwitchMonths,

              isClientFilingRestricted: (this.calculateAge(this.client.client.DOB) == 69),
              isSpouseFilingRestricted: (this.calculateAge(spouseDOB) == 69),
              fileRestrictedAgeYears: (this.calculateAge(this.client.client.DOB) == 69) ? 0 : 0,
              fileRestrictedAgeMonths: (this.calculateAge(this.client.client.DOB) == 69) ? 0 : 0,
              clientFileRestrictedMinMonth: chosenAges.client.split(' ')[1].replace('m', ''),
              clientRetroDisplayAge: (this.ssData.earlSelfRetoFiling) ? earliestAges.client : '',
              spouseFileRestrictedAgeYears: (this.calculateAge(spouseDOB) == 69) ? 0 : 0,
              spouseFileRestrictedAgeMonths: (this.calculateAge(spouseDOB) == 69) ? 0 :0,
              spouseFileRestrictedMinMonth: (chosenAges.partner) ? chosenAges.partner.trim().split(' ')[1].replace('m', '') : 0,
              partnerRetroDisplayAge: (this.ssData.earlSpouseRetoFiling) ? earliestAges.partner : '',

              //this should be setting eligability, not only if they are filing Retro
              isClientRetroFiling: (this.ssData.earlSelfRetoFiling),
              isSpouseRetroFiling: (this.ssData.earlSpouseRetoFiling),

              clientDefaultAgeVal: earliestAges.client,
              partnerDefaultAgeVal: earliestAges.partner,

              //swappedClaim: false
              swappedClaim: this.ssData.isFRAInvertedSwitch//false//(this.client.clientProfile.InvertSurvivorSwitch != null) ? this.client.clientProfile.InvertSurvivorSwitch : this.swappedClaim
            };
            console.log('setting on load this.isSpouseSurvivor', this.isSpouseSurvivor);
            console.log('setting on load this.objAdjustedFRAScenario', this.objAdjustedFRAScenario);
            //this.swappedClaimFRA = false;
            this.swappedClaimFRA = this.objAdjustedFRAScenario.swappedClaim;
            console.log('is FRA swapped', this.swappedClaimFRA);
            /* this.objAdjustedFRAScenario.swappedClaim = this.swappedClaimFRA = ((this.objAdjustedFRAScenario.spouseAgeYears || this.objAdjustedFRAScenario.clientAgeYears) && this.objAdjustedFRAScenario.survivorSwitchAgeYears)
            ? (this.client.clientProfile.InvertSurvivorSwitch) ? this.client.clientProfile.InvertSurvivorSwitch : false : ((this.objAdjustedFRAScenario.spouseAgeYears || this.objAdjustedFRAScenario.clientAgeYears) ? true : false);
            console.log('FRA obj first load', this.objAdjustedFRAScenario); */


            if(!this.isSpouseSurvivor){
              console.log('spouse is not the survivor');
              this.objAdjustedFRAScenario.clientAgeYears = this.swappedClaimFRA ? this.objAdjustedFRAScenario.survivorSwitchAgeYears : (this.ssData.selfBenefitAge) ? this.ssData.selfBenefitAge : this.objAdjustedFRAScenario.clientAgeYears;//''
              this.objAdjustedFRAScenario.clientAgeMonths = this.swappedClaimFRA ? this.objAdjustedFRAScenario.survivorSwitchAgeYears : (this.ssData.selfBenefitAge) ? this.ssData.selfBenefitMonth : this.objAdjustedFRAScenario.clientAgeMonths;//'';
              /* this.objAdjustedFRAScenario.survivorSwitchAgeYears = !this.swappedClaimFRA ? ((this.ssData.selfFRASurvivorAge) ? this.ssData.selfFRASurvivorAge : this.objAdjustedFRAScenario.clientAgeYears) : this.objAdjustedFRAScenario.survivorSwitchAgeYears;
              this.objAdjustedFRAScenario.survivorSwitchAgeMonths = !this.swappedClaimFRA ? ((this.ssData.selfFRASurvivorAge) ? this.ssData.selfFRASurvivorMonth : this.objAdjustedFRAScenario.clientAgeMonths) : this.objAdjustedFRAScenario.survivorSwitchAgeMonths;  */
              this.objAdjustedFRAScenario.survivorSwitchAgeYears = !this.swappedClaimFRA ? (this.objAdjustedFRAScenario.survivorSwitchAgeYears) ? this.objAdjustedFRAScenario.survivorSwitchAgeYears : this.ssData.selfFRASurvivorAge : this.objAdjustedFRAScenario.survivorSwitchAgeYears;
              this.objAdjustedFRAScenario.survivorSwitchAgeMonths = !this.swappedClaimFRA ? (this.objAdjustedFRAScenario.survivorSwitchAgeYears) ? this.objAdjustedFRAScenario.survivorSwitchAgeMonths : this.ssData.selfFRASurvivorMonth : this.objAdjustedFRAScenario.survivorSwitchAgeMonths; 
              if(this.includeSpouse){
                this.objAdjustedFRAScenario.spouseAgeYears = this.swappedClaimFRA ? this.objAdjustedFRAScenario.survivorSwitchAgeYears : (this.ssData.spouseFRASurvivorAge) ? this.ssData.spouseFRASurvivorAge : this.objAdjustedFRAScenario.spouseAgeYears;//''
                this.objAdjustedFRAScenario.spouseAgeMonths = this.swappedClaimFRA ? this.objAdjustedFRAScenario.survivorSwitchAgeMonths : (this.ssData.spouseFRASurvivorMonth) ? this.ssData.spouseFRASurvivorMonth : this.objAdjustedFRAScenario.spouseAgeMonths;//'';
              }
              //this.isPageReloadOtherThanFRACall = false;
            } else if(this.isSpouseSurvivor){
              /* this.objAdjustedFRAScenario.spouseAgeYears = this.swappedClaimFRA ? this.objAdjustedFRAScenario.survivorSwitchAgeYears : this.ssData.spouseFRASurvivorAge;//''
              this.objAdjustedFRAScenario.spouseAgeMonths = this.swappedClaimFRA ? this.objAdjustedFRAScenario.survivorSwitchAgeMonths : this.ssData.spouseFRASurvivorMonth;//'';
              this.objAdjustedFRAScenario.survivorSwitchAgeYears = this.swappedClaimFRA ? ((this.ssData.selfFRASurvivorAge) ? this.ssData.selfFRASurvivorAge : this.objAdjustedFRAScenario.spouseAgeYears): this.objAdjustedFRAScenario.survivorSwitchAgeYears;
              this.objAdjustedFRAScenario.survivorSwitchAgeMonths = this.swappedClaimFRA ? ((this.ssData.selfFRASurvivorMonth) ? this.ssData.selfFRASurvivorMonth : this.objAdjustedFRAScenario.spouseAgeMonths) : this.objAdjustedFRAScenario.survivorSwitchAgeMonths; */
              
              //this.objAdjustedFRAScenario.spouseAgeYears = this.swappedClaimFRA ? this.objAdjustedFRAScenario.survivorSwitchAgeYears : this.ssData.spouseFRASurvivorAge;//''
              //this.objAdjustedFRAScenario.spouseAgeMonths = this.swappedClaimFRA ? this.objAdjustedFRAScenario.survivorSwitchAgeMonths : this.ssData.spouseFRASurvivorMonth;//'';
              //this.objAdjustedFRAScenario.survivorSwitchAgeYears = this.swappedClaimFRA ? ((this.ssData.selfFRASurvivorAge) ? this.ssData.selfFRASurvivorAge : this.ssData.spouseBenefitAge): this.objAdjustedFRAScenario.survivorSwitchAgeYears;
              //this.objAdjustedFRAScenario.survivorSwitchAgeMonths = this.swappedClaimFRA ? ((this.ssData.selfFRASurvivorMonth) ? this.ssData.selfFRASurvivorMonth : this.ssData.spouseBenefitMonth) : this.objAdjustedFRAScenario.survivorSwitchAgeMonths;
              
              this.objAdjustedFRAScenario.spouseAgeYears = this.swappedClaimFRA ? this.objAdjustedFRAScenario.survivorSwitchAgeYears : (this.ssData.spouseBenefitAge) ? this.ssData.spouseBenefitAge : this.objAdjustedFRAScenario.spouseAgeYears;//''
              this.objAdjustedFRAScenario.spouseAgeMonths = this.swappedClaimFRA ? this.objAdjustedFRAScenario.survivorSwitchAgeMonths : (this.ssData.spouseBenefitAge) ? this.ssData.spouseBenefitMonth : this.objAdjustedFRAScenario.spouseAgeMonths;//'';
              this.objAdjustedFRAScenario.survivorSwitchAgeYears = !this.swappedClaimFRA ? ((this.objAdjustedFRAScenario.survivorSwitchAgeYears) ? this.objAdjustedFRAScenario.survivorSwitchAgeYears : this.ssData.spouseFRASurvivorAge): this.objAdjustedFRAScenario.survivorSwitchAgeYears;
              this.objAdjustedFRAScenario.survivorSwitchAgeMonths = !this.swappedClaimFRA ? ((this.objAdjustedFRAScenario.survivorSwitchAgeYears) ? this.objAdjustedFRAScenario.survivorSwitchAgeMonths : this.ssData.spouseFRASurvivorMonth) : this.objAdjustedFRAScenario.survivorSwitchAgeMonths;

              if(!this.objAdjustedFRAScenario.spouseAgeYears && !this.objAdjustedFRAScenario.survivorSwitchAgeYears){
                console.log('in here 8877');
                this.objAdjustedFRAScenario.survivorSwitchAgeYears = this.swappedClaimFRA ? (this.ssData.spouseBenefitAge) ? this.ssData.spouseBenefitAge : 0 : this.objAdjustedFRAScenario.spouseAgeYears;
                this.objAdjustedFRAScenario.spouseAgeYears = this.swappedClaimFRA ? (this.ssData.spouseFRASurvivorAge) ? this.ssData.spouseFRASurvivorAge : 0 : 0;
              }

            }
          } else {
            console.log('Else of FRA - spouse Early Retro', this.ssData.earlSpouseRetoFiling);
            //if(!this.isPageReloadOtherThanFRACall){
              this.objAdjustedFRAScenario = {
                scenario: 'FRA',

                clientAgeYears: (this.objAdjustedFRAScenario.clientAgeYears) ? this.objAdjustedFRAScenario.clientAgeYears : clientAgeYears, 
                clientAgeMonths: (this.objAdjustedFRAScenario.clientAgeYears) ? this.objAdjustedFRAScenario.clientAgeMonths || 0 : clientAgeMonth, 
                spouseAgeYears: (this.objAdjustedFRAScenario.spouseAgeYears) ? this.objAdjustedFRAScenario.spouseAgeYears : spouseAgeYears, 
                spouseAgeMonths: (this.objAdjustedFRAScenario.spouseAgeYears) ? this.objAdjustedFRAScenario.spouseAgeMonths || 0 : spouseAgeMonths,
                
                survivorSwitchAgeYears: (this.objAdjustedFRAScenario.survivorSwitchAgeYears) ? this.objAdjustedFRAScenario.survivorSwitchAgeYears : '',
                survivorSwitchAgeMonths: (this.objAdjustedFRAScenario.survivorSwitchAgeYears) ? this.objAdjustedFRAScenario.survivorSwitchAgeMonths : '',
                saveDCA: false,//(!this.objAdjustedFRAScenario.displayedDCAToggleOnMessage && !this.objAdjustedFRAScenario.displayedDCAToggleOffMessage) ? true : this.objAdjustedFRAScenario.saveDCA,
                displayedDCAToggleOnMessage: (this.objAdjustedFRAScenario.displayedDCAToggleOnMessage) ? this.objAdjustedFRAScenario.displayedDCAToggleOnMessage : false,
                displayedDCAToggleOffMessage: (this.objAdjustedFRAScenario.displayedDCAToggleOffMessage) ? this.objAdjustedFRAScenario.displayedDCAToggleOffMessage : false,
                isClientAgeDisable: isClientAgeDisable,
                isSpouseAgeDisable: isSpouseAgeDisable,
                
                isClientFilingRestricted: this.objAdjustedFRAScenario.isClientFilingRestricted,
                isSpouseFilingRestricted: this.objAdjustedFRAScenario.isSpouseFilingRestricted, 
                fileRestrictedAgeYears: (this.objAdjustedFRAScenario.isClientFilingRestricted) ? this.objAdjustedFRAScenario.fileRestrictedAgeYears : 0,
                fileRestrictedAgeMonths: (this.objAdjustedFRAScenario.isClientFilingRestricted) ? this.objAdjustedFRAScenario.fileRestrictedAgeMonths : 0,
                clientFileRestrictedMinMonth: (this.objAdjustedFRAScenario.clientFileRestrictedMinMonth) ? this.objAdjustedFRAScenario.clientFileRestrictedMinMonth : 0,
                spouseFileRestrictedAgeYears: (this.objAdjustedFRAScenario.isSpouseFilingRestricted) ? this.objAdjustedFRAScenario.spouseFileRestrictedAgeYears : 0,
                spouseFileRestrictedAgeMonths: (this.objAdjustedFRAScenario.isSpouseFilingRestricted) ? this.objAdjustedFRAScenario.spouseFileRestrictedAgeMonths : 0,
                spouseFileRestrictedMinMonth: (this.objAdjustedFRAScenario.spouseFileRestrictedMinMonth) ? this.objAdjustedFRAScenario.spouseFileRestrictedMinMonth : 0,

                clientRetroDisplayAge: (this.objAdjustedFRAScenario.clientRetroDisplayAge) ? this.objAdjustedFRAScenario.clientRetroDisplayAge : '',
                partnerRetroDisplayAge: (this.objAdjustedFRAScenario.partnerRetroDisplayAge) ? this.objAdjustedFRAScenario.partnerRetroDisplayAge : '',

                isClientRetroFiling: this.ssData.earlSelfRetoFiling,
                isSpouseRetroFiling: this.ssData.earlSpouseRetoFiling,

                clientDefaultAgeVal: this.objAdjustedFRAScenario.clientDefaultAgeVal,
                partnerDefaultAgeVal: this.objAdjustedFRAScenario.partnerDefaultAgeVal,

                swappedClaim: (this.objAdjustedFRAScenario.swappedClaim != null || this.objAdjustedFRAScenario.swappedClaim != undefined) 
                  ? this.objAdjustedFRAScenario.swappedClaim : this.swappedClaimFRA
              };
            //}

            console.log('Else of FRA -', this.objAdjustedFRAScenario);
            /* if(this.ssData.earlSpouseRetoFiling){
              this.objAdjustedFRAScenario.partnerRetroDisplayAge = earliestAges.partner
            } */

            //this.socialSecurityIllustrationCards[1].clientFRA = (this.ssDataAlt.earlSelfRetoFiling) ? this.getFRAv2(this.client.client.DOB) : '';
            //this.socialSecurityIllustrationCards[1].partnerFRA = (this.ssDataAlt.earlSpouseRetoFiling) ? this.getFRAv2(this.client.client.DOB) : '';
            this.socialSecurityIllustrationCards[1].clientRetroDisplayAge = (this.ssData.earlSelfRetoFiling) ? earliestAges.client : '';
            this.socialSecurityIllustrationCards[1].partnerRetroDisplayAge = (this.ssData.earlSpouseRetoFiling) ? earliestAges.partner : '';
          }
          console.log('this.objAdjustedFRAScenario FRA set', this.objAdjustedFRAScenario);
          //console.log('chosenAges.partner', chosenAges);
          //}
           //this.setSelectedLifeExpectancyPoint();
           //need to call again for the ALT scenario
           //TODO: need to do a check if we even need to run this > options should be if either a questions was answered yes
            //IF a user adds this on page, this will need to be called in a new funtion
          this.storedFRAScenario = alternate;
          // console.log('this.client.clientProfile.SSDesiredAgeYears', this.client.clientProfile.SSDesiredAgeYears);

          if(this.client.clientProfile.SSDesiredAgeYears || ((this.includeSpouse) ? this.client.clientProfile.Spouses[0].sSDesiredAgeYears : false)){
            console.log('here 01 - have DCA');

            //check if cleint and/or spouse has DCA
            if(!this.client.clientProfile.SSDesiredAgeYears){
              if(this.includeSpouse){
                console.log('here1');
                if(this.client.clientProfile.Spouses[0].sSDesiredAgeYears){
                  console.log('here2');
                  //set client DCA to FRA                  
                  this.client.clientProfile.SSDesiredAgeYears = this.clientRetirementYears;
                  this.client.clientProfile.SSDesiredAgeMonths = this.clientRetirementMonths;
                }
              }
            } else {
              if(this.includeSpouse){
                console.log('here11');
                if(!this.client.clientProfile.Spouses[0].sSDesiredAgeYears){
                  console.log('here22');
                  //set spouse DCA to FRA
                  this.client.clientProfile.Spouses[0].sSDesiredAgeYears = this.spouseRetirementYears;
                  this.client.clientProfile.Spouses[0].sSDesiredAgeMonths = this.spouseRetirementMonths;
                  //console.log('here22', this.client.clientProfile.Spouses[0].sSDesiredAgeYears);
                  //console.log('here22', this.client.clientProfile.Spouses[0].sSDesiredAgeMonths);

                  //TODO: reset the modal/adjust object here
                  //this.objAdjustedFRAScenario.spouseAgeYears = this.client.clientProfile.Spouses[0].sSDesiredAgeYears;
                  //this.objAdjustedFRAScenario.spouseAgeMonths = this.client.clientProfile.Spouses[0].sSDesiredAgeMonths;
                }
              }
            }
                 
            if(this.hasAlternateScenario){ // && !this.isPageReloadOtherThanFRACall
              //console.log('I have an alternate hasAlreadyRan', this.hasAlternateScenario);
              this.getSSDataAlt(alternate, true, true);
            } else {
              console.log('this.isAltCardRemoved', this.isAltCardRemoved)
              // if this is true then that means the alt card was removed
              // so we shouldn't run alt scenario again
              if (!this.isAltCardRemoved){
                //this.getSSDataAlt(alternate, false);
                this.getSSDataAlt(this.fraAlternate, false);

                /* if(this.isPageReloadOtherThanFRACall){
                  this.getSSDataAlt(alternate, (this.isFirstCall) ? false : true, (this.isFirstCall) ? false : true);
                  this.isFirstCall = false;
                } else {
                  this.getSSDataAlt(alternate, true);
                } */
              } else {
                this.socialSecurityIllustrationCards.push(
                  { scenario: 'AddAlternate', color: '#0a4e8d' }
                );
                
                //this.isAlreadyInitializeComponent = true;
                if(localStorage.getItem('displayDCANotification')){
                  localStorage.removeItem('displayDCANotification');
                  const dialogRef = this.dialog.open(BasicQuestionComponent, {     
                    data: { title: 'Notification!', 
                    btnYesTitle: 'I Understand',
                    question: "A previously entered desired claim age has been removed from this case profile because the month selected has since occurred.<br/>A new desired claim age may now be added and saved." }
                  });
                }
              }
            }
          } else {
            console.log('here 02');
            let showSurvivorSection = this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed' || (this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' && !this.client.clientProfile.Spouses[0].alive && this.client.clientProfile.Spouses[0].tenyears) ? true : false;
            let isSpouseSurvivor = this.client.clientProfile.Spouses[0].maritalStatus == 'Married' && this.isSpouseSurvivor ? true : false
            showSurvivorSection = isSpouseSurvivor ? true : showSurvivorSection;

            this.hasAlternateScenario = (showSurvivorSection && this.client.clientProfile.SurvivorSwitchYears > 0) ? true 
              : this.dateOfBirthModifiedOnPage ? false : this.hasAlternateScenario;

            if(this.hasAlternateScenario){
              this.getSSDataAlt(alternate, false);

            } else {
              console.log('here 03');
              // this.setSelectedLifeExpectancyPoint();
              let alternateMedicalDeductions = chosenTotals.netOfMedicareDollar + " " + chosenTotals.netOfMedicarePercent;
              // need to hide if single person, or both spouses, have already claimed
              let isShowAlternate = true;

              if (this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
                isShowAlternate = this.client.clientProfile.SpouseAlreadyCollecting && this.client.clientProfile.SelfAlreadyCollecting ? false : true;
                // if ((this.client.clientProfile.MonthlyBenefitAmount || 0) > 0 && ( Utils.formatToNumber(this.client.clientProfile.Spouses[0].monthlyBenefits || 0)) > 0) {
                //   isShowAlternate = false;
                // }
                // console.log('this.client.client.DOB', this.client.client.DOB);
                if ((this.calculateAge(spouseDOB) >= 70) && (this.calculateAge(this.client.client.DOB) >= 70))  {
                  isShowAlternate = false;
                }
              } else {
                if (this.client.clientProfile.SelfAlreadyCollecting || (this.calculateAge(this.client.client.DOB) >= 70)) {
                // if ((this.client.clientProfile.MonthlyBenefitAmount || 0) > 0 || (this.calculateAge(this.client.client.DOB) >= 70)) {
                  isShowAlternate = false;
                }
              }

              if (isShowAlternate) {
                this.socialSecurityIllustrationCards.push(
                  { scenario: 'AddAlternate', color: '#0a4e8d', clientName: this.client.client.FirstName, clientAge: chosenAges.client, clientTotal: chosenTotals.client , partnerName: (this.client.clientProfile.Spouses.length > 0) ? this.client.clientProfile.Spouses[0].firstName : '', 
                    partnerAge: chosenAges.partner, partnerTotal: chosenTotals.partner, medicareDeductions: alternateMedicalDeductions, netOfMedicare: chosenTotals.netOfMedicare }
                  );
              }    
              
              //this.isAlreadyInitializeComponent = true;
              if(localStorage.getItem('displayDCANotification')){
                localStorage.removeItem('displayDCANotification');
                const dialogRef = this.dialog.open(BasicQuestionComponent, {     
                  data: { title: 'Notification!', 
                  btnYesTitle: 'I Understand',
                  question: "A previously entered desired claim age has been removed from this case profile because the month selected has since occurred.<br/>A new desired claim age may now be added and saved." }
                });
              }
            }
          }

          if (!this.adjSurvivorModal && (this.client.clientProfile.Spouses[0].maritalStatus == "Widowed" || 
          (this.client.clientProfile.Spouses[0].maritalStatus == 'Single' || this.client.clientProfile.Spouses[0].maritalStatus == 'Married') && this.includeSpouse) 
          && this.client.clientProfile.SurvivorSwitchYears) {

            if(this.client.clientProfile.Spouses[0].maritalStatus == 'Married' && this.isSpouseSurvivor){
              console.log('ss object here?', this.ssObject.clientSurvivorSwitchYears);
              console.log('does it happen here', this.objAdjustedDesiredScenario.spouseAgeYears);
              this.objAdjustedDesiredScenario.spouseAgeYears = !this.swappedClaim ? this.adjSurvivorBenefitAge : this.adjRetirementBenefitAge
              console.log('does it happen here2', this.objAdjustedDesiredScenario.spouseAgeYears);
              this.objAdjustedDesiredScenario.spouseAgeMonths = !this.swappedClaim ? this.adjSurvivorBenefitMonths : this.adjRetirementBenefitMonths
              this.objAdjustedDesiredScenario.survivorSwitchAgeYears = !this.swappedClaim ? this.adjRetirementBenefitAge : this.adjSurvivorBenefitAge
              this.objAdjustedDesiredScenario.survivorSwitchAgeMonths = !this.swappedClaim ? this.adjRetirementBenefitMonths : this.adjSurvivorBenefitMonths
            } else {
              console.log('ss object here 0005', this.objAdjustedDesiredScenario);
              this.objAdjustedDesiredScenario.clientAgeYears = !this.swappedClaim ? this.adjSurvivorBenefitAge : this.adjRetirementBenefitAge;
              this.objAdjustedDesiredScenario.clientAgeMonths = !this.swappedClaim ? this.adjSurvivorBenefitMonths : this.adjRetirementBenefitMonths;
              this.objAdjustedDesiredScenario.survivorSwitchAgeYears = !this.swappedClaim ? this.adjRetirementBenefitAge : this.adjSurvivorBenefitAge;
              this.objAdjustedDesiredScenario.survivorSwitchAgeMonths = !this.swappedClaim ? this.adjRetirementBenefitMonths : this.adjSurvivorBenefitMonths;

              if(this.ssObjectFRA){
                if(!this.objAdjustedFRAScenario.swappedClaim){
                  //ZSS: this was added to fix the double display of Ret being mapped to Surv on second single value in Ret
                  //had to remove cause it was causing other issues
                 /*  this.ssObjectFRA.SurvivorSwitchYears = 0;
                  this.ssObjectFRA.SurvivorSwitchMonths = 0;
                  this.ssObjectFRA.selfRetirementYears = 0;
                  this.ssObjectFRA.selfRetirementMonths = 0;
                  this.ssObjectFRA.clientAgeYears = 0;
                  this.ssObjectFRA.clientAgeMonths = 0; */
                }

                console.log('ss ssObjectFRA here 0005', this.ssObjectFRA);
                this.objAdjustedFRAScenario.clientAgeYears = this.swappedClaimFRA ? this.ssObjectFRA.SurvivorSwitchYears : this.ssObjectFRA.selfRetirementYears;
                this.objAdjustedFRAScenario.clientAgeMonths = this.swappedClaimFRA ? this.ssObjectFRA.SurvivorSwitchMonths : this.ssObjectFRA.selfRetirementMonths;
                this.objAdjustedFRAScenario.survivorSwitchAgeYears = this.swappedClaimFRA ? this.ssObjectFRA.selfRetirementYears : this.ssObjectFRA.SurvivorSwitchYears;
                this.objAdjustedFRAScenario.survivorSwitchAgeMonths = this.swappedClaimFRA ? this.ssObjectFRA.selfRetirementMonths : this.ssObjectFRA.SurvivorSwitchMonths;
                console.log('ss object here 0005', this.objAdjustedFRAScenario);

                
              }
            }
                        
          }
                    
          if (this.isSurvAndFirstLoadSwapped) {
            this.isSurvAndFirstLoadSwapped = false
          }

          //check to see if we need to readjust the client profile if saved values
          if((this.ssData.selfRejectSwitchAgeInput || this.ssData.spouseRejectSwitchAgeInput) && this.ssObjectFRA){
            console.log('need to make adjustments - display modal FRA');

            const clientSurvivorSwitchAges = this.objAdjustedFRAScenario.swappedClaim ? `${this.objAdjustedFRAScenario.survivorSwitchAgeYears}y ${this.objAdjustedFRAScenario.survivorSwitchAgeMonths}m` : `${this.objAdjustedFRAScenario.clientAgeYears}y ${this.objAdjustedFRAScenario.clientAgeMonths}m`;
            const clientRetirementSwitchAges = !this.objAdjustedFRAScenario.swappedClaim ? `${this.objAdjustedFRAScenario.survivorSwitchAgeYears}y ${this.objAdjustedFRAScenario.survivorSwitchAgeMonths}m` : `${this.objAdjustedFRAScenario.clientAgeYears}y ${this.objAdjustedFRAScenario.clientAgeMonths}m`;

            const spouseSurvivorSwitchAges = this.objAdjustedFRAScenario.swappedClaim ? `${this.objAdjustedFRAScenario.survivorSwitchAgeYears}y ${this.objAdjustedFRAScenario.survivorSwitchAgeMonths}m` : `${this.objAdjustedFRAScenario.spouseAgeYears}y ${this.objAdjustedFRAScenario.spouseAgeMonths}m`;
            const spouseRetirementSwitchAges = !this.objAdjustedFRAScenario.swappedClaim ? `${this.objAdjustedFRAScenario.survivorSwitchAgeYears}y ${this.objAdjustedFRAScenario.survivorSwitchAgeMonths}m` : `${this.objAdjustedFRAScenario.spouseAgeYears}y ${this.objAdjustedFRAScenario.spouseAgeMonths}m`;

            const clientAges = Number(clientRetirementSwitchAges.split("y")[0]);
            const clientMonths = Number(clientRetirementSwitchAges.split("y")[1].replace("m",""));
            const clientSurvivorAges = Number(clientSurvivorSwitchAges.split("y")[0]);
            const clientSurvivorMonths = Number(clientSurvivorSwitchAges.split("y")[1].replace("m",""));

            const spouseAges = Number(spouseRetirementSwitchAges.split("y")[0]);
            const spouseMonths = Number(spouseRetirementSwitchAges.split("y")[1].replace("m",""));
            const spouseSurvivorAges = Number(spouseSurvivorSwitchAges.split("y")[0]);
            const spouseSurvivorMonths = Number(spouseSurvivorSwitchAges.split("y")[1].replace("m",""));

            let topAgeMonths = "";
            let bottomAgeMonths = "";
            let hasNullValue = false;

            if (this.ssData.selfRejectSwitchAgeInput) {
              let retirementFirst = clientAges > clientSurvivorAges || clientAges == clientSurvivorAges && clientMonths > clientSurvivorMonths
              topAgeMonths = retirementFirst ? clientRetirementSwitchAges : clientSurvivorSwitchAges;
              bottomAgeMonths = retirementFirst ? clientSurvivorSwitchAges : clientRetirementSwitchAges;
            }

            if (this.ssData.spouseRejectSwitchAgeInput) {
              let retirementFirst = spouseAges > spouseSurvivorAges || spouseAges == spouseSurvivorAges && spouseMonths > spouseSurvivorMonths
              topAgeMonths = retirementFirst ? spouseRetirementSwitchAges : spouseSurvivorSwitchAges;
              bottomAgeMonths = retirementFirst ? spouseSurvivorSwitchAges : spouseRetirementSwitchAges;
            }

            if (this.ssData.selfRejectSwitchAgeInput && (!clientAges || !clientSurvivorAges)) {
              hasNullValue = true;
            }

            if (this.ssData.spouseRejectSwitchAgeInput && (!spouseAges || !spouseSurvivorAges)) {
              hasNullValue = true;
            }

            //this.isFRABeingAdjusted = true;

            if(!hasNullValue) {
              //display the popup modal explaining
              const dialogRef = this.dialog.open(BasicQuestionComponent, {     
                data: { title: 'Notification!',
                btnYesTitle: 'I Understand',
                question: "The claiming strategy you entered (switching benefit types at " + topAgeMonths + ") would result in a "
                //+ "$X decrease in monthly benefits at age " 
                + "decrease in monthly benefits - and is therefore invalid."
                + "<br/>Social Security Administration rules state that a beneficiary can only switch a claiming option if the amount received is higher than the previous choice."
                + "<br/><br/>This protects the consumer from making a decision that would reduce benefits. (<a target='_BLANK' href='https://www.ssa.gov/benefits/survivors/ifyou.html'>https://www.ssa.gov/benefits/survivors/ifyou.html</a>)."
                //+ "<br/><br/>The desired claim for " + (dataAlt.selfRejectSwitchAgeInput ? this.clientFullName : this.spouseFullName) + " has been set to only "
                + "<br/><br/>The desired claim for " + (this.ssData.selfRejectSwitchAgeInput ? this.socialSecurityIllustrationCards[0].clientName : this.socialSecurityIllustrationCards[0].partnerName) + " has been set to only "
                //[survivor/retirement]
                + ((this.objAdjustedFRAScenario.swappedClaim) ? "retirement" : "survivor") + " benefits at age " + bottomAgeMonths + ". You can try other strategies by re-opening the "
                //[Alternate/Alt1]
                + "First Alternate box"
                + "<br/>again and changing the claim age(s)." }
              });
            }

            //need to reset the objAdjustedFRAScenario object
            if(this.objAdjustedFRAScenario.swappedClaim){
              if(this.ssData.selfRejectSwitchAgeInput){
                this.objAdjustedFRAScenario.clientAgeYears = 0;
                this.objAdjustedFRAScenario.clientAgeMonths = 0;

                this.ssObjectFRA.selfRetirementYears = 0;
                this.ssObjectFRA.selfRetirementMonths = 0;
              } else {
                this.objAdjustedFRAScenario.spouseAgeYears = 0;
                this.objAdjustedFRAScenario.spouseAgeMonths = 0;

                this.ssObjectFRA.spouseRetirementYears = 0;
                this.ssObjectFRA.spouseRetirementMonths = 0;
              }
            } else {
              this.objAdjustedFRAScenario.survivorSwitchAgeYears = 0;
              this.objAdjustedFRAScenario.survivorSwitchAgeMonths = 0;

              this.ssObjectFRA.SurvivorSwitchYears = 0;
              this.ssObjectFRA.SurvivorSwitchMonths = 0;
              this.ssObjectFRA.clientSurvivorSwitchYears = 0;
              this.ssObjectFRA.clientSurvivorSwitchMonths = 0;
            }

            //reset profile IF SAVED
            if(this.objAdjustedFRAScenario.saveDCA){
              console.log('save has clicked/checked');
              
              //need to call: updateClientProfile(this.objAdjustedFRAScenario);
                //need to save/set SSDesiredAgeYears/months to 0 depending on client or spouse
              //this.updateClientProfile(this.objAdjustedFRAScenario);                
            }

            this.isFRABeingAdjusted = true;
          }

          if(this.hasTBCBeenAdjustedAfterPageLoad){
            this.totalBenefitCalc();
          }
         
          if((this.hasAdjustedFRAScenario || (this.ssData.selfRejectSwitchAgeInput || this.ssData.spouseRejectSwitchAgeInput) && !this.rejectOnPageLoad)){
            //this.isPresentValue = false;
            //this.ssObject.invertSurvivorSwitch = this.objAdjustedFRAScenario.swappedClaim;
            //this.ssObjectFRA = this.ssObject;//.isPresentValue = false;
            this.rejectOnPageLoad = true;
            
            if(this.ssData.selfRejectSwitchAgeInput || this.ssData.spouseRejectSwitchAgeInput){
              console.log('need to reset the objAdjustedFRAScenario object');
              this.ssObjectFRA = { ...this.ssObject };
              //this.hasAdjustedFRAScenario = true;
              
              this.loadingService.isLoading(false);
            } else {            
              this.getSSDataFRAAlt();
            }
          } else {
            if(!this.hasAlternateScenario){
              this.loadingService.isLoading(false);
            }
          }
        },
        error => {
          this.error = <any>error
          this.loadingService.isLoading(true);
          console.log('we errored in SS', this.error);
        });
  }

  fraAlternate;
  ssDataFRA;
  getSSDataFRAAlt(){
    //this.loadingService.isLoading(true);
    
    this.ssObjectFRA.isPresentValue = this.isPresentValue;
    
    if(this.hasCOLAsBeenAdjusted){
      this.ssObjectFRA.COLA = this.colas;
      this.ssObjectFRA.FrmColaXml = this.colas;
    }
    //this.hasAdjustedFRAScenario = true;
    console.log('getSSDataFRAAlt obj before call', this.ssObjectFRA);
    if (this.ssObjectFRA)
      this.ssObjectFRA.FrmDiscountRate = this.socialSecurityForm.get('inflationRate').value.replace('%', '') / 100;

    this.globalService.getSSData(this.ssObjectFRA, this.userForm.value)
      .subscribe(
        data => {
          this.ssDataFRA = data;
          //this.yearlyCostFRA = data.yearlyCost;
          //this.futureYearlyCostFRA = Number(this.yearlyCostFRA) * this.annuallyWeeklyTtlYear;

          this.weeklyCostFRA = data.weeklyCost;
          this.futureWeeklyCostFRA  = Number(this.weeklyCostFRA) * 52 * this.annuallyWeeklyTtlYear;
          this.lumpsumFRA = data.lumpsumCost;

          var fraData = data;
          let spouseDOB = (this.client.clientProfile.Spouses[0].dobStr && Date.parse(this.client.clientProfile.Spouses[0].dobStr) ? new Date(this.client.clientProfile.Spouses[0].dobStr).toLocaleDateString("en-US") : new Date(this.client.clientProfile.Spouses[0].dob).toLocaleDateString("en-US") ? new Date(this.client.clientProfile.Spouses[0].dob).toLocaleDateString("en-US") : "1/1/1960");
          let spouseDOBDate = spouseDOB != null ? new Date(spouseDOB) : null;
          let isDisableAutoSurvivorBenefitMsg = this.client.clientProfile.Spouses[0].maritalStatus == 'Married' && spouseDOBDate != null? fraData.selfFRASurvivorAge == this.getSpouseMinSurvivorClaimAge() &&  fraData.selfFRASurvivorMonth == (13 - (spouseDOBDate.getMonth() + 1)) ? true : false: false;
          this.isAutoFRASurvivorBenefit = fraData && !isDisableAutoSurvivorBenefitMsg ? fraData.isAutoSurvivorBenefit: false;
          console.log('fraData Reponse', fraData);
          
          this.displayEarningsTestMessage = fraData.displayEarningsTestText;
          this.displayRetroTestMessage = (fraData.earlRetoFiling || fraData.cusRetoFiling || fraData.optRetoFiling);
          
          var aIllTotal = {
            clientAmountTotal: 0,
            dependentChildrenAmount: 0,
            netOfMedicareAmount: 0,
            spouseAmount: 0,
            totalAnnualAmount: 0,
          };          
          
          for (var key in data.alternateIllustrationTable) {
            aIllTotal.clientAmountTotal = aIllTotal.clientAmountTotal + data.alternateIllustrationTable[key].clientAmount;
            aIllTotal.dependentChildrenAmount = aIllTotal.dependentChildrenAmount + data.alternateIllustrationTable[key].dependentChildrenAmount;
            aIllTotal.netOfMedicareAmount = Number(fraData.cusTotalBenefit.replace(/,/g, "").replace("$", "")) - Number(fraData.cusPartB.replace(/,/g, "").replace("$", "")); //aIllTotal.netOfMedicareAmount + data.alternateIllustrationTable[key].netOfMedicareAmount;
            aIllTotal.spouseAmount = aIllTotal.spouseAmount + data.alternateIllustrationTable[key].spouseAmount;
            aIllTotal.totalAnnualAmount = aIllTotal.totalAnnualAmount + data.alternateIllustrationTable[key].totalAnnualAmount;
            for (var keyy in data.alternateIllustrationTable[key]) {
              if (typeof data.alternateIllustrationTable[key][keyy] === 'number') {
                data.alternateIllustrationTable[key][keyy] = Utils.formatToCurrency(data.alternateIllustrationTable[key][keyy].toFixed(0));
              }
            }
          }
    
          data.alternateIllustrationTable.totals = aIllTotal;
          console.log('data.alternateIllustrationTable.totals', data.alternateIllustrationTable.totals)
          
          for (var key in data.alternateIllustrationTable.totals) {
            data.alternateIllustrationTable.totals[key] = Utils.formatToCurrency(data.alternateIllustrationTable.totals[key].toFixed(0));
          }
          
          this.fraAlternate = data.alternateIllustrationTable;
          
          //TODO: fix/adjust these once code/new function is working
          //this.illustrationComparisons[0].data = []; //[earliest, alternate]
          //this.illustrationComparisons[2].data = []; //[alternate, optimal]
          var earliestAges = { client: fraData.earlStartBenLabel.split('/')[0].replace(' month', 'm').replace(' months', 'm').replace('ms', 'm').replace(' and', 'y'), partner: this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].maritalStatus != "Widowed" ? (fraData.earlStartBenLabel.split('/')[1] ? fraData.earlStartBenLabel.split('/')[1].replace(' month', 'm').replace(' months', 'm').replace('ms', 'm').replace(' and', 'y') : '') : '' : ''};
          const chosenAges = { client: fraData.cusStartBenLabel.split('/')[0].replace(' month', 'm').replace(' months', 'm').replace('ms', 'm').replace(' and', 'y'), partner: this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].maritalStatus != "Widowed" ? (fraData.cusStartBenLabel.split('/')[1] ? fraData.cusStartBenLabel.split('/')[1].replace(' month', 'm').replace(' months', 'm').replace('ms', 'm').replace(' and', 'y') : '') : '' : ''};
          
          const chosenTotals = { client: fraData.cusSelfBenefit, partner: fraData.cusSpouseBenefit, netOfMedicare: fraData.cusNetOfB, netOfMedicarePercent: fraData.cusPartBPercent, netOfMedicareDollar: fraData.cusPartB }
          
          let fraMedicalDeductions = chosenTotals.netOfMedicareDollar + " " + chosenTotals.netOfMedicarePercent;
          // let spouseDOB = (this.client.clientProfile.Spouses[0].dobStr && Date.parse(this.client.clientProfile.Spouses[0].dobStr) ? this.client.clientProfile.Spouses[0].dobStr : Date.parse(this.client.clientProfile.Spouses[0].dob) ? this.client.clientProfile.Spouses[0].dob : null);

          this.socialSecurityIllustrationCards[1] = { scenario: (this.hasAdjustedFRAScenario) ? 'First Alternate' + ((fraData.cusSelfRetoFiling || fraData.cusSpouseRetoFiling) ? " (Retroactive File)" : "") : 'FRA', color: '#73bcb8', 
            clientFRA: (this.hasAdjustedFRAScenario && fraData.cusSelfRetoFiling) ? this.getFRAv2(this.client.client.DOB) : '',
            partnerFRA: (this.hasAdjustedFRAScenario && fraData.cusSpouseRetoFiling && this.client.clientProfile.Spouses[0].maritalStatus == "Married") ? this.getFRAv2(spouseDOB) : '',                
            clientName: this.client.client.FirstName, clientAge: chosenAges.client, clientCurrentAge: chosenAges.client.replaceAll(' ', '').split('y')[0], clientTotal: chosenTotals.client,
            partnerName: (this.client.clientProfile.Spouses.length > 0) ? (this.client.clientProfile.Spouses[0].maritalStatus != "Widowed" && this.client.clientProfile.Spouses[0].maritalStatus != "Divorced") ? this.client.clientProfile.Spouses[0].firstName : '' : '',
            clientRetroNumMonths: (this.hasAdjustedFRAScenario && fraData.cusSelfRetoFiling) ? fraData.cusSelfRetoNumMonths : '',
            partnerRetroNumMonths: (this.hasAdjustedFRAScenario && fraData.cusSpouseRetoFiling) ? fraData.cusSpouseRetoNumMonths : '', 
            partnerAge: chosenAges.partner, partnerCurrentAge: (chosenAges.partner) ? chosenAges.partner.replaceAll(' ', '').split('y')[0] : 0, partnerTotal: chosenTotals.partner, medicareDeductions: fraMedicalDeductions, netOfMedicare: chosenTotals.netOfMedicare};

          this.socialSecurityIllustrationCards[1].clientRetroDisplayAge = (this.ssData.earlSelfRetoFiling) ? earliestAges.client : '';
          this.socialSecurityIllustrationCards[1].partnerRetroDisplayAge = (this.ssData.earlSpouseRetoFiling) ? earliestAges.partner : '';
          console.log('this.socialSecurityIllustrationCards[1]', this.socialSecurityIllustrationCards[1])
          
          let alternateClaimAges = fraData.cusStartBenLabel.split('/');
          let clientAlternateClaim = [], spouseAlternateClaim = [];
          
          if (!alternateClaimAges.length)
              alternateClaimAges = [fraData.cusStartBenLabel];
    
          clientAlternateClaim = alternateClaimAges[0].split(" and ");
          clientAlternateClaim[1] = clientAlternateClaim[1].replace(" months", "").replace(" month", "");
          
          if (fraData.cusStartBenLabel.split('/').length > 1) {
            spouseAlternateClaim = alternateClaimAges[1].split(" and ");
            spouseAlternateClaim[1] = spouseAlternateClaim[1].replace(" months", "").replace(" month", "");
          }
          
          const scenario = (this.hasAdjustedFRAScenario) ? 'First Alternate' + ((data.cusSelfRetoFiling || data.cusSpouseRetoFiling) ? " (Retroactive File)" : "") : "FRA";
          //(this.hasAdjustedFRAScenario) ? 'First Alternate' + ((data.cusSelfRetoFiling || data.cusSpouseRetoFiling) ? " (Retroactive File)" : "") : 'FRA';
          this.socialSecurityBenefitCards[1] = //(this.hasAdjustedFRAScenario && !this.hasTBCBeenAdjustedAfterPageLoad) ? this.socialSecurityBenefitCards[1] : 
          { scenario, color: '#73bcb8', amount: data.cusTotalBenefit, includeCheck: false, ages: { clientAge: clientAlternateClaim[0], clientMonths: clientAlternateClaim[1], spouseAge: spouseAlternateClaim[0], spouseMonths: spouseAlternateClaim[1] } };
          
          this.objAdjustedFRAScenario.scenario = scenario;

          console.log('this.socialSecurityBenefitCards.length', this.socialSecurityBenefitCards.length);
          if(this.socialSecurityBenefitCards.length > 3){
            //has Alt/Second Alt: scenario label adjust
            this.socialSecurityIllustrationCards[3].scenario = 'Second Alternate' + ((this.ssDataAlt.cusSelfRetoFiling || this.ssDataAlt.cusSpouseRetoFiling) ? " (Retroactive File)" : "");            
            this.socialSecurityBenefitCards[3].scenario = 'Second Alternate' + ((this.ssDataAlt.cusSelfRetoFiling || this.ssDataAlt.cusSpouseRetoFiling) ? " (Retroactive File)" : "");            
          }
          
          //DO I need to set this?
          //this.objAdjustedFRAScenario = {}

          //check to see if we need to readjust the client profile if saved values
          if((data.selfRejectSwitchAgeInput || data.spouseRejectSwitchAgeInput) && this.ssObjectFRA){
            console.log('need to make adjustments - display modal FRA', this.objAdjustedFRAScenario);

            const clientSurvivorSwitchAges = this.objAdjustedFRAScenario.swappedClaim ? `${this.objAdjustedFRAScenario.survivorSwitchAgeYears}y ${this.objAdjustedFRAScenario.survivorSwitchAgeMonths}m` : `${this.objAdjustedFRAScenario.clientAgeYears}y ${this.objAdjustedFRAScenario.clientAgeMonths}m`;
            const clientRetirementSwitchAges = !this.objAdjustedFRAScenario.swappedClaim ? `${this.objAdjustedFRAScenario.survivorSwitchAgeYears}y ${this.objAdjustedFRAScenario.survivorSwitchAgeMonths}m` : `${this.objAdjustedFRAScenario.clientAgeYears}y ${this.objAdjustedFRAScenario.clientAgeMonths}m`;

            const spouseSurvivorSwitchAges = this.objAdjustedFRAScenario.swappedClaim ? `${this.objAdjustedFRAScenario.survivorSwitchAgeYears}y ${this.objAdjustedFRAScenario.survivorSwitchAgeMonths}m` : `${this.objAdjustedFRAScenario.spouseAgeYears}y ${this.objAdjustedFRAScenario.spouseAgeMonths}m`;
            const spouseRetirementSwitchAges = !this.objAdjustedFRAScenario.swappedClaim ? `${this.objAdjustedFRAScenario.survivorSwitchAgeYears}y ${this.objAdjustedFRAScenario.survivorSwitchAgeMonths}m` : `${this.objAdjustedFRAScenario.spouseAgeYears}y ${this.objAdjustedFRAScenario.spouseAgeMonths}m`;

            const clientAges = Number(clientRetirementSwitchAges.split("y")[0]);
            const clientMonths = Number(clientRetirementSwitchAges.split("y")[1].replace("m",""));
            const clientSurvivorAges = Number(clientSurvivorSwitchAges.split("y")[0]);
            const clientSurvivorMonths = Number(clientSurvivorSwitchAges.split("y")[1].replace("m",""));

            const spouseAges = Number(spouseRetirementSwitchAges.split("y")[0]);
            const spouseMonths = Number(spouseRetirementSwitchAges.split("y")[1].replace("m",""));
            const spouseSurvivorAges = Number(spouseSurvivorSwitchAges.split("y")[0]);
            const spouseSurvivorMonths = Number(spouseSurvivorSwitchAges.split("y")[1].replace("m",""));

            let topAgeMonths = "";
            let bottomAgeMonths = "";
            let hasNullValue = false;

            if (data.selfRejectSwitchAgeInput) {
              let retirementFirst = clientAges > clientSurvivorAges || clientAges == clientSurvivorAges && clientMonths > clientSurvivorMonths
              topAgeMonths = retirementFirst ? clientRetirementSwitchAges : clientSurvivorSwitchAges;
              bottomAgeMonths = retirementFirst ? clientSurvivorSwitchAges : clientRetirementSwitchAges;
            }

            if (data.spouseRejectSwitchAgeInput) {
              let retirementFirst = spouseAges > spouseSurvivorAges || spouseAges == spouseSurvivorAges && spouseMonths > spouseSurvivorMonths
              topAgeMonths = retirementFirst ? spouseRetirementSwitchAges : spouseSurvivorSwitchAges;
              bottomAgeMonths = retirementFirst ? spouseSurvivorSwitchAges : spouseRetirementSwitchAges;
            }

            if (data.selfRejectSwitchAgeInput && (!clientAges || !clientSurvivorAges)) {
              hasNullValue = true;
            }

            if (data.spouseRejectSwitchAgeInput && (!spouseAges || !spouseSurvivorAges)) {
              console.log('check spouseAges', spouseAges);
              console.log('check spouseSurvivorAges', spouseSurvivorAges);
              hasNullValue = true;
            }

            //this.isFRABeingAdjusted = true;

            if(!hasNullValue) {
              //display the popup modal explaining
              const dialogRef = this.dialog.open(BasicQuestionComponent, {     
                data: { title: 'Notification!',
                btnYesTitle: 'I Understand',
                question: "The claiming strategy you entered (switching benefit types at " + topAgeMonths + ") would result in a "
                //+ "$X decrease in monthly benefits at age " 
                + "decrease in monthly benefits - and is therefore invalid."
                + "<br/>Social Security Administration rules state that a beneficiary can only switch a claiming option if the amount received is higher than the previous choice."
                + "<br/><br/>This protects the consumer from making a decision that would reduce benefits. (<a target='_BLANK' href='https://www.ssa.gov/benefits/survivors/ifyou.html'>https://www.ssa.gov/benefits/survivors/ifyou.html</a>)."
                //+ "<br/><br/>The desired claim for " + (dataAlt.selfRejectSwitchAgeInput ? this.clientFullName : this.spouseFullName) + " has been set to only "
                + "<br/><br/>The desired claim for " + (data.selfRejectSwitchAgeInput ? this.socialSecurityIllustrationCards[0].clientName : this.socialSecurityIllustrationCards[0].partnerName) + " has been set to only "
                //[survivor/retirement]
                + ((this.objAdjustedFRAScenario.swappedClaim) ? "retirement" : "survivor") + " benefits at age " + bottomAgeMonths + ". You can try other strategies by re-opening the "
                //[Alternate/Alt1]
                + "First Alternate box again and changing the claim age(s)." }
              });
              
              //ZSS 062524: remove the ssObjectFRA set 0s cause it was causing issues on adjustments and swaps in First Alt
              if(this.objAdjustedFRAScenario.swappedClaim){
                if(data.selfRejectSwitchAgeInput){
                  this.objAdjustedFRAScenario.clientAgeYears = 0;
                  this.objAdjustedFRAScenario.clientAgeMonths = 0;
  
                  //this.ssObjectFRA.selfRetirementYears = 0;
                  //this.ssObjectFRA.selfRetirementMonths = 0;
                } else {
                  this.objAdjustedFRAScenario.spouseAgeYears = 0;
                  this.objAdjustedFRAScenario.spouseAgeMonths = 0;
  
                  //this.ssObjectFRA.spouseRetirementYears = 0;
                  //this.ssObjectFRA.spouseRetirementMonths = 0;
                }
              } else {
                this.objAdjustedFRAScenario.survivorSwitchAgeYears = 0;
                this.objAdjustedFRAScenario.survivorSwitchAgeMonths = 0;
  
                //this.ssObjectFRA.SurvivorSwitchYears = 0;
                //this.ssObjectFRA.SurvivorSwitchMonths = 0;
                //this.ssObjectFRA.clientSurvivorSwitchYears = 0;
                //this.ssObjectFRA.clientSurvivorSwitchMonths = 0;
              }
            } else if(!this.isPageReloadOtherThanFRACall){
              //if fell in here, display message based on single input on top of the DCA Modal being rejected by Core logic
              //we dont really have logic for this - but, since self or spouse is rejected, we could assume that the optimal would be the best decision for that person
              //use the opStartBenLabel from the FRA response (after FRA turns into First Alt), and break it apart for the y and m for that person (self or spouse)

              const dialogRef = this.dialog.open(BasicQuestionComponent, {     
                data: { title: 'Notification!',
                btnYesTitle: 'I Understand',
                question: "The claiming strategy you entered (" + topAgeMonths + ") would result in "
                //+ "$X decrease in monthly benefits at age " 
                + "smaller monthly benefits than collecting " + ((this.objAdjustedFRAScenario.swappedClaim) ? "survivor" : "retirement") + " at that age."
                + " This protects the consumer from making a <br/>decision that would reduce benefits. (<a target='_BLANK' href='https://www.ssa.gov/benefits/survivors/ifyou.html'>https://www.ssa.gov/benefits/survivors/ifyou.html</a>)."
                //+ "<br/><br/>The desired claim for " + (dataAlt.selfRejectSwitchAgeInput ? this.clientFullName : this.spouseFullName) + " has been set to only "
                + "<br/><br/>The desired claiming strategy for " + (data.selfRejectSwitchAgeInput ? this.socialSecurityIllustrationCards[0].clientName : this.socialSecurityIllustrationCards[0].partnerName) + " has been set to "
                //[survivor/retirement]
                + ((this.objAdjustedFRAScenario.swappedClaim) ? "retirement" : "survivor") + " benefits at age " + ((data.selfRejectSwitchAgeInput) ? this.ssData.opStartBenLabel.split("/")[0] : this.ssData.opStartBenLabel.split("/")[1]) + ". You can try other strategies by re-opening the "
                //[Alternate/Alt1]
                + "First Alternate box <br/>again and changing the claim age." }
              });

              //need to reset the objAdjustedFRAScenario object
              if(!this.objAdjustedFRAScenario.swappedClaim){
                if(data.selfRejectSwitchAgeInput){
                  this.objAdjustedFRAScenario.clientAgeYears = this.ssData.opStartBenLabel.split("/")[0].split("and")[0].split(' ').join('');
                  this.objAdjustedFRAScenario.clientAgeMonths = this.ssData.opStartBenLabel.split("/")[0].split("and")[1].split("months")[0].split(' ').join('');
                } else {
                  this.objAdjustedFRAScenario.spouseAgeYears = this.ssData.opStartBenLabel.split("/")[1].split("and")[0].split(' ').join('');
                  this.objAdjustedFRAScenario.spouseAgeMonths = this.ssData.opStartBenLabel.split("/")[1].split("and")[1].split("months")[0].split(' ').join('');
                }

                this.objAdjustedFRAScenario.survivorSwitchAgeYears = 0;
                this.objAdjustedFRAScenario.survivorSwitchAgeMonths = 0;
              } else {
                this.objAdjustedFRAScenario.survivorSwitchAgeYears = (data.selfRejectSwitchAgeInput) ? this.ssData.opStartBenLabel.split("/")[0].split("and")[0].split(' ').join('') : this.ssData.opStartBenLabel.split("/")[1].split("and")[0].split(' ').join('');;
                this.objAdjustedFRAScenario.survivorSwitchAgeMonths = (data.selfRejectSwitchAgeInput) ? this.ssData.opStartBenLabel.split("/")[0].split("and")[1].split("months")[0].split(' ').join('') : this.ssData.opStartBenLabel.split("/")[1].split("and")[1].split("months")[0].split(' ').join('');

                if(data.selfRejectSwitchAgeInput){
                  this.objAdjustedFRAScenario.clientAgeYears = 0;
                  this.objAdjustedFRAScenario.clientAgeMonths = 0;
                } else {
                  this.objAdjustedFRAScenario.spouseAgeYears = 0;
                  this.objAdjustedFRAScenario.spouseAgeMonths = 0;
                }
              }

              //fix Summary card display
              this.socialSecurityIllustrationCards[1].partnerAge = this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].maritalStatus != "Widowed" ? (this.ssData.opStartBenLabel.split('/')[1] ? this.ssData.opStartBenLabel.split('/')[1].replace(' month', 'm').replace(' months', 'm').replace('ms', 'm').replace(' and', 'y') : '') : '' : '';

              //fix TBC display for FRA
              this.socialSecurityBenefitCards[1].ages.spouseAge = (this.objAdjustedFRAScenario.spouseAgeYears) ? this.objAdjustedFRAScenario.spouseAgeYears : this.objAdjustedFRAScenario.survivorSwitchAgeYears;
              this.socialSecurityBenefitCards[1].ages.spouseMonths = (this.objAdjustedFRAScenario.spouseAgeYears) ? this.objAdjustedFRAScenario.spouseAgeMonths : this.objAdjustedFRAScenario.survivorSwitchAgeMonths;

              //fix DCA display adjust
              this.objAdjustedFRAScenario.swappedClaim = this.ssData.OptSurvivorSwitchInverted;
            
            }

            //TODO: we currently do not save First Alt to client profile
            //reset profile IF SAVED
            if(this.objAdjustedFRAScenario.saveDCA){
              console.log('save has clicked/checked');
              
              //need to call: updateClientProfile(this.objAdjustedFRAScenario);
                //need to save/set SSDesiredAgeYears/months to 0 depending on client or spouse
              //this.updateClientProfile(this.objAdjustedFRAScenario);                
            }

            this.isFRABeingAdjusted = true;
          }
          
          this.isFRABeingAdjusted = true;

          var eIllTotal = {
            clientAmountTotal: 0,
            dependentChildrenAmount: 0,
            netOfMedicareAmount: 0,
            spouseAmount: 0,
            totalAnnualAmount: 0,
          };

          for (var key in data.earliestIllustrationTable) {
            eIllTotal.clientAmountTotal = eIllTotal.clientAmountTotal + data.earliestIllustrationTable[key].clientAmount;
            eIllTotal.dependentChildrenAmount = eIllTotal.dependentChildrenAmount + data.earliestIllustrationTable[key].dependentChildrenAmount;
            if (this.ssData.earlPartB.includes("(") && this.ssData.earlPartB.includes(")")) {
              eIllTotal.netOfMedicareAmount = Number(this.ssData.earlTotalBenefit.replace(/,/g, "").replace("$", "")) + Number(this.ssData.earlPartB.replace(/,/g, "").replace("(","").replace(")","").replace("$", ""));
            } else {
              eIllTotal.netOfMedicareAmount = Number(this.ssData.earlTotalBenefit.replace(/,/g, "").replace("$", "")) - Number(this.ssData.earlPartB.replace(/,/g, "").replace("$", "")); //eIllTotal.netOfMedicareAmount + data.earliestIllustrationTable[key].netOfMedicareAmount;
            }
            
            eIllTotal.spouseAmount = eIllTotal.spouseAmount + data.earliestIllustrationTable[key].spouseAmount;
            eIllTotal.totalAnnualAmount = eIllTotal.totalAnnualAmount + data.earliestIllustrationTable[key].totalAnnualAmount;
            for (var keyy in data.earliestIllustrationTable[key]) {
              if (typeof data.earliestIllustrationTable[key][keyy] === 'number') {
                data.earliestIllustrationTable[key][keyy] = Utils.formatToCurrency(data.earliestIllustrationTable[key][keyy].toFixed(0));
              }
            }
          }

          data.earliestIllustrationTable.totals = eIllTotal;

          console.log('data.alternateIllustrationTable.totals', data.alternateIllustrationTable.totals)
          for (var key in data.earliestIllustrationTable.totals) {
            data.earliestIllustrationTable.totals[key] = Utils.formatToCurrency(data.earliestIllustrationTable.totals[key].toFixed(0));
          }

          
          let placeHolderSelectedIllustration = [];
          var earliest = data.earliestIllustrationTable;
          var alternate = data.alternateIllustrationTable;
          placeHolderSelectedIllustration.push( { name: 'Earliest vs Alternate', data: [earliest, alternate], breakEven: 999 });
          this.illustrationComparisons[0] = placeHolderSelectedIllustration[0];

          // this.selectedIllustrationIdx = 0;
          this.selectedIllustration = this.illustrationComparisons[0];
          console.log('this.selectedIllustration 01', this.selectedIllustration);
          this.lineGraphData = null;
          if (this.ssDataAlt) {
            this.illustrationsTypes.pop();
          }
          console.log('this.illustrationsTypes', this.illustrationsTypes)
          this.comparisonGraph = this.createComparisonGraphData(data.costsByCareAndRegionBody);
          if (this.ssDataAlt) {
            this.illustrationsTypes[3] = "Second Alternate";
            this.comparisonGraph = this.createComparisonGraphData(this.ssDataAlt.costsByCareAndRegionBody);
          }

           // this.comparisonGraph = this.createComparisonGraphData(this.ssDataAlt.costsByCareAndRegionBody);
          // this.comparisonGraph = this.createComparisonGraphData(data.costsByCareAndRegionBody);

          //this.loadingService.isLoading(false);
          //this.getSSData();
          //this.getSSDataAlt(this.fraAlternate, true);

          var isSurvivorBenefit = false;
          if (this.isAutoFRASurvivorBenefit) {
            isSurvivorBenefit = ((this.objAdjustedFRAScenario.clientAgeYears || 0) > 0 && (this.objAdjustedFRAScenario.spouseAgeYears || 0)  > 0) ? true : false;
           }

           if (isSurvivorBenefit) {
            if(this.client.clientProfile.Spouses[0].maritalStatus != 'Widowed') {
              if (this.client.clientProfile.Spouses[0].maritalStatus == 'Single' || this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced') {
                for (let spouse of this.client.clientProfile.Spouses) {
                  if (spouse.maritalStatus == 'Divorced' && !spouse.alive && spouse.tenyears){ // && !this.isFRAAlt) {
                    this.isShowSurvivorSection = true;    
                    console.log('we divorced');             
                  }
                }
                if (this.client.clientProfile.Spouses[0].maritalStatus == 'Single' && !this.client.clientProfile.Spouses[1].alive && this.client.clientProfile.Spouses[1].tenyears) {
                  this.isShowSurvivorSection = true;
                }
              }
              if(this.client.clientProfile.Spouses && this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
                let clientAge = this.calculateAge(this.client.client.DOB);
                let spouseAge = this.calculateAge(this.client.clientProfile.Spouses[0].dob);
                if((this.client.clientProfile.LifeExpectancy - clientAge) + spouseAge <= 60
                || (this.client.clientProfile.LifeExpectancy - clientAge) + spouseAge <= 69
                || (this.client.clientProfile.Spouses[0].LifeExpectancy - spouseAge) + clientAge <= 69){
                  this.isShowSurvivorSection = true;
                }
              }
             } else {
              this.isShowSurvivorSection = true;
             }
           }

          if(this.isAutoFRASurvivorBenefit && isSurvivorBenefit && !this.isPageReloadOtherThanFRACall && this.isShowSurvivorSection)  {
            const dialogRef = this.dialog.open(BasicQuestionComponent, {     
              data: { title: 'Notification!', 
              btnYesTitle: 'I Understand',
              question: "The retirement benefit claim age entered will result in a spousal benefit being collected while both spouses are living. In this case, SSA will automatically switch the widow to a survivor benefit upon the spouse's death, therefore, the survivor claim age entered has been overridden to match the age at which widowhood begins." }
            });              
          }
                
          /* if(this.hasTBCBeenAdjustedAfterPageLoad){
            this.totalBenefitCalc();
          } */

          this.loadingService.isLoading(false);
        });
  }

  getSSDataAlt(fraIllustration, hasAlreadyRan, ajustClaim = false, adjustButtonClicked = false, data = null){
    console.log('hasAlreadyRan', hasAlreadyRan);
    this.hasAlternateScenario = true;
    this.isAltCardRemoved = false;

    const age = this.calculateAge(new Date(this.client.client.DOB));

    if(!hasAlreadyRan){ //on first time run set the Alt
      this.ssObject.selfRetirementYears = (this.objAdjustedDesiredScenario.fileRestrictedAgeYears) ? this.objAdjustedDesiredScenario.fileRestrictedAgeYears : (this.client.clientProfile.SSDesiredAgeYears) ? this.client.clientProfile.SSDesiredAgeYears : this.socialSecurityForm.get('selfRetirementYears').value;
      this.ssObject.selfRetirementMonths = (this.objAdjustedDesiredScenario.fileRestrictedAgeMonths) ? this.objAdjustedDesiredScenario.fileRestrictedAgeMonths : (this.client.clientProfile.SSDesiredAgeMonths) ? this.client.clientProfile.SSDesiredAgeMonths : (this.socialSecurityForm.get('selfRetirementMonths').value) ? this.socialSecurityForm.get('selfRetirementMonths').value : 0;
      //this.ssObject.selfRetirementYears = (this.client.clientProfile.SSDesiredAgeYears) ? this.client.clientProfile.SSDesiredAgeYears : this.socialSecurityForm.get('selfRetirementYears').value;
      //this.ssObject.selfRetirementMonths = (this.client.clientProfile.SSDesiredAgeMonths) ? this.client.clientProfile.SSDesiredAgeMonths : (this.socialSecurityForm.get('selfRetirementMonths').value) ? this.socialSecurityForm.get('selfRetirementMonths').value : 0;
      console.log('finding this value', this.ssObject.selfRetirementYears);
      console.log('finding this value', this.ssObject.SSDesiredAgeYears);

      console.log('finding this value', this.ssObject.selfRetirementMonths);
      console.log('finding this value', this.client.clientProfile.SSDesiredAgeMonths);
      console.log('finding this value', this.socialSecurityForm.get('selfRetirementMonths').value);
      if(age >= 70){
        // this.ssObject.selfRetirementYears = age - this.currentAgeOffset;//this.objAdjustedDesiredScenario.clientAgeYears;
        this.ssObject.selfRetirementYears = age;
        //this.ssObject.selfRetirementMonths = 0;//this.objAdjustedDesiredScenario.clientAgeMonths;
      }
      //console.log('this.includeSpouse', this.includeSpouse);
      if(this.includeSpouse && this.client.clientProfile.Spouses[0].maritalStatus != "Widowed"){
        //console.log('first time not Widowed');
        this.ssObject.spouseRetirementYears = this.client.clientProfile.Spouses[0].sSDesiredAgeYears ? this.client.clientProfile.Spouses[0].sSDesiredAgeYears || 0 : this.socialSecurityForm.get('spouseRetirementYears').value || 0;
        this.ssObject.spouseRetirementMonths = this.client.clientProfile.Spouses[0].sSDesiredAgeMonths ? this.client.clientProfile.Spouses[0].sSDesiredAgeMonths || 0 : this.socialSecurityForm.get('spouseRetirementMonths').value || 0;
      }
    } else {
      
      //this.ssObject.selfRetirementYears = (this.objAdjustedDesiredScenario.fileRestrictedAgeYears) ? this.objAdjustedDesiredScenario.fileRestrictedAgeYears : this.objAdjustedDesiredScenario.clientAgeYears;
      //this.ssObject.selfRetirementMonths = (this.objAdjustedDesiredScenario.fileRestrictedAgeMonths) ? this.objAdjustedDesiredScenario.fileRestrictedAgeMonths : (this.objAdjustedDesiredScenario.clientAgeMonths) ? this.objAdjustedDesiredScenario.clientAgeMonths : 0;   
      this.ssObject.selfRetirementYears = (this.objAdjustedDesiredScenario.clientAgeYears) ? this.objAdjustedDesiredScenario.clientAgeYears : (this.client.clientProfile.SSDesiredAgeYears) ? this.client.clientProfile.SSDesiredAgeYears : this.socialSecurityForm.get('selfRetirementYears').value;
      this.ssObject.selfRetirementMonths = (this.objAdjustedDesiredScenario.clientAgeMonths) ? this.objAdjustedDesiredScenario.clientAgeMonths : (this.client.clientProfile.SSDesiredAgeMonths) ? this.client.clientProfile.SSDesiredAgeMonths : (this.socialSecurityForm.get('selfRetirementMonths').value) ? this.socialSecurityForm.get('selfRetirementMonths').value : 0; 
      //console.log('finding this value', this.ssObject.selfRetirementMonths);
      //this.socialSecurityForm.patchValue({'selfRetirementYears': this.ssObject.selfRetirementYears });
      //this.socialSecurityForm.patchValue({'selfRetirementMonths': this.ssObject.selfRetirementMonths});
      if(this.includeSpouse && this.client.clientProfile.Spouses[0].maritalStatus != "Widowed"){
        //console.log('second time not Widowed');
        //this.ssObject.spouseRetirementYears = (this.objAdjustedDesiredScenario.spouseFileRestrictedAgeYears) ? this.objAdjustedDesiredScenario.spouseFileRestrictedAgeYears || 0 : this.objAdjustedDesiredScenario.spouseAgeYears || 0;
        //this.ssObject.spouseRetirementMonths = (this.objAdjustedDesiredScenario.spouseFileRestrictedAgeMonths) ? this.objAdjustedDesiredScenario.spouseFileRestrictedAgeMonths || 0 : this.objAdjustedDesiredScenario.spouseAgeMonths || 0;
        this.ssObject.spouseRetirementYears = (this.objAdjustedDesiredScenario.spouseAgeYears) ? this.objAdjustedDesiredScenario.spouseAgeYears : this.client.clientProfile.Spouses[0].sSDesiredAgeYears ? this.client.clientProfile.Spouses[0].sSDesiredAgeYears || 0 : this.socialSecurityForm.get('spouseRetirementYears').value || 0;
        this.ssObject.spouseRetirementMonths = (this.objAdjustedDesiredScenario.spouseAgeMonths) ? this.objAdjustedDesiredScenario.spouseAgeMonths : this.client.clientProfile.Spouses[0].sSDesiredAgeMonths ? this.client.clientProfile.Spouses[0].sSDesiredAgeMonths || 0 : this.socialSecurityForm.get('spouseRetirementMonths').value || 0;
      }
    }

    //TODO ZSS: talk to Dustin about the updates below (04/01)
    if (this.client.clientProfile.Spouses[0].maritalStatus == "Divorced") {
      //TODO: shouldnt this get assigned to the new desired claim age for Divorced?
      this.ssObject.spouseRetirementYears = (this.client.clientProfile.Spouses[0].expectedClaimAgeYears) ? this.client.clientProfile.Spouses[0].expectedClaimAgeYears || 0 : 62;
      this.ssObject.spouseRetirementMonths = (this.client.clientProfile.Spouses[0].expectedClaimAgeMonths) ? this.client.clientProfile.Spouses[0].expectedClaimAgeMonths || 0 : 0;
    } else if (this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed') {     
      this.ssObject.spouseRetirementYears = (this.client.clientProfile.Spouses[0].exSpouseClaimAgeYears) ? this.client.clientProfile.Spouses[0].exSpouseClaimAgeYears || 0 : 62;
      this.ssObject.spouseRetirementMonths = (this.client.clientProfile.Spouses[0].exSpouseClaimAgeMonths) ? this.client.clientProfile.Spouses[0].exSpouseClaimAgeMonths || 0 : 0;
 
    } else {
      //optimize FRA on page load
      if(this.ssObject.SpouseRetirementAge < this.ssObject.spouseRetirementYears
        && this.ssObject.SpouseLifeExpectancy < this.ssObject.spouseRetirementYears
      ){
        this.ssObject.spouseRetirementYears = (this.ssObject.SpouseRetirementAge < 62) ? 62 : this.ssObject.SpouseRetirementAge;
      }
    } 

    this.socialSecurityForm.patchValue({'selfRetirementYears': this.ssObject.selfRetirementYears });
    console.log('set this this.ssObject.selfRetirementYears', this.ssObject.selfRetirementYears)
    this.socialSecurityForm.patchValue({'selfRetirementMonths': this.ssObject.selfRetirementMonths});
    if(this.includeSpouse && this.client.clientProfile.Spouses[0].maritalStatus != "Widowed"){
      this.socialSecurityForm.patchValue({'spouseRetirementYears': this.ssObject.spouseRetirementYears });
      this.socialSecurityForm.patchValue({'spouseRetirementMonths': this.ssObject.spouseRetirementMonths});

      this.objAdjustedDesiredScenario.spouseAgeYears =this.ssObject.spouseRetirementYears;
      this.objAdjustedDesiredScenario.spouseAgeMonths = this.ssObject.spouseRetirementMonths;
    }

    this.ssObject.IsAltRequest = true;
    this.ssObject.IsPresentValue = this.presentValue;


    //console.log('Spouse', this.client.clientProfile.Spouses[0]);
    //console.log('objAdjustedDesiredScenario', this.objAdjustedDesiredScenario);

    let showSurvivorSection = this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed'
      || (this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' && !this.client.clientProfile.Spouses[0].alive && this.client.clientProfile.Spouses[0].tenyears)
      || (this.client.clientProfile.Spouses[0].maritalStatus == 'Married' && this.isSpouseSurvivor) ? true : false;

    if (this.client.clientProfile.Spouses.length > 0 && this.client.clientProfile.Spouses[0].maritalStatus == "Widowed"
      || (this.client.clientProfile.Spouses[0].maritalStatus == 'Single' || this.client.clientProfile.Spouses[0].maritalStatus == 'Married') && this.includeSpouse) {
      // this.ssObject.invertSurvivorSwitch = this.swappedClaim ? 0 : 1
      // if (!this.adjRetirementBenefitAge)
      console.log('this.isSpouseSurvivor', this.isSpouseSurvivor);
      if (this.client.clientProfile.Spouses[0].maritalStatus == 'Married' && this.isSpouseSurvivor) {
        //this.ssObject.spouseRetirementYears = (!this.swappedClaim) ? this.adjRetirementBenefitAge || 0 : this.adjSurvivorBenefitAge || 0;
        //this.ssObject.spouseRetirementMonths = (!this.swappedClaim) ? this.adjRetirementBenefitMonths || 0 : this.adjSurvivorBenefitMonths || 0;
        this.ssObject.spouseRetirementYears = this.adjRetirementBenefitAge || 0;
        this.ssObject.spouseRetirementMonths = this.adjRetirementBenefitMonths || 0;

        if (this.ssObject.spouseRetirementYears == 0){
          //console.log('in here first time?');
          this.ssObject.spouseRetirementYears = this.adjSurvivorBenefitAge || 0;
          this.ssObject.spouseRetirementMonths = this.adjSurvivorBenefitMonths || 0;

          //this.adjSurvivorBenefitAge = 0;
          //this.adjSurvivorBenefitMonths = 0;
          this.ssObject.clientSurvivorSwitchYears = 0;
          this.ssObject.clientSurvivorSwitchMonths = 0;
          this.ssObject.SurvivorSwitchYears = 0;
          this.ssObject.SurvivorSwitchMonths = 0;
        } else {
          //console.log('zss here 009');
          /* this.ssObject.clientSurvivorSwitchYears = (!this.swappedClaim) ? this.adjSurvivorBenefitAge || 0 : this.adjRetirementBenefitAge || 0;
          this.ssObject.clientSurvivorSwitchMonths = (!this.swappedClaim) ? this.adjSurvivorBenefitMonths || 0 : this.adjRetirementBenefitMonths || 0;
          this.ssObject.SurvivorSwitchYears = (!this.swappedClaim) ? this.adjSurvivorBenefitAge || 0 : this.adjRetirementBenefitAge || 0;
          this.ssObject.SurvivorSwitchMonths = (!this.swappedClaim) ? this.adjSurvivorBenefitMonths || 0 : this.adjRetirementBenefitMonths || 0;
  
          this.ssObject.spouseRetirementYears = (this.swappedClaim) ? this.adjSurvivorBenefitAge || 0 : this.adjRetirementBenefitAge || 0;
          this.ssObject.spouseRetirementMonths = (this.swappedClaim) ? this.adjSurvivorBenefitMonths || 0 : this.adjRetirementBenefitMonths || 0; */

          this.ssObject.clientSurvivorSwitchYears = this.adjSurvivorBenefitAge || 0;
          this.ssObject.clientSurvivorSwitchMonths = this.adjSurvivorBenefitMonths || 0;
          this.ssObject.SurvivorSwitchYears = this.adjSurvivorBenefitAge || 0;
          this.ssObject.SurvivorSwitchMonths = this.adjSurvivorBenefitMonths || 0;
          /* this.ssObject.clientSurvivorSwitchYears = (!this.swappedClaim) ? this.adjSurvivorBenefitAge || 0 : this.adjRetirementBenefitAge || 0;
          this.ssObject.clientSurvivorSwitchMonths = (!this.swappedClaim) ? this.adjSurvivorBenefitMonths || 0 : this.adjRetirementBenefitMonths || 0;
          this.ssObject.SurvivorSwitchYears = (!this.swappedClaim) ? this.adjSurvivorBenefitAge || 0 : this.adjRetirementBenefitAge || 0;
          this.ssObject.SurvivorSwitchMonths = (!this.swappedClaim) ? this.adjSurvivorBenefitMonths || 0 : this.adjRetirementBenefitMonths || 0;
           */
          //console.log('zss here 009', this.ssObject);

        }

      } else if (this.adjRetirementBenefitAge) {
        this.ssObject.selfRetirementYears = this.adjRetirementBenefitAge || 0;
        this.ssObject.selfRetirementMonths = this.adjRetirementBenefitMonths || 0;
        console.log('finding this value2', this.ssObject.selfRetirementMonths);

        this.ssObject.clientSurvivorSwitchYears = this.adjSurvivorBenefitAge || 0;
        this.ssObject.clientSurvivorSwitchMonths = this.adjSurvivorBenefitMonths || 0;
        this.ssObject.SurvivorSwitchYears = this.adjSurvivorBenefitAge || 0;
        this.ssObject.SurvivorSwitchMonths = this.adjSurvivorBenefitMonths || 0;
        
      }

      console.log('check swap before Alt call', this.swappedClaim);
      this.ssObject.invertSurvivorSwitch = !this.swappedClaim ? 0 : 1;

      console.log('checking Alt in switch', this.ssObject);
    } else {
      //console.log('checking 77');
      if(this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced'){
      /* this.ssObject.selfRetirementYears = this.adjSurvivorBenefitAge || 0;
        this.ssObject.selfRetirementMonths = this.adjRetirementBenefitMonths || 0;
        this.ssObject.clientSurvivorSwitchYears = this.adjSurvivorBenefitAge || 0;
        this.ssObject.clientSurvivorSwitchMonths = this.adjSurvivorBenefitMonths || 0;
        this.ssObject.SurvivorSwitchYears = this.adjSurvivorBenefitAge || 0;
        this.ssObject.SurvivorSwitchMonths = this.adjSurvivorBenefitMonths || 0; */
        /* console.log('zss this.adjSurvivorBenefitAge', this.adjSurvivorBenefitAge);
        console.log('zss this.adjSurvivorBenefitMonths', this.adjSurvivorBenefitMonths);
        console.log('zss this.adjRetirementBenefitAge', this.adjRetirementBenefitAge);
        console.log('zss this.adjRetirementBenefitMonths', this.adjRetirementBenefitMonths);
        console.log('zss this.objAdjustedDesiredScenario', this.objAdjustedDesiredScenario); */
        
        console.log('survivor?', showSurvivorSection);
        if(showSurvivorSection){

          if(!this.objAdjustedDesiredScenario.swappedClaim){
            if(this.objAdjustedDesiredScenario.clientAgeYears || this.objAdjustedDesiredScenario.survivorSwitchAgeYears){
              this.ssObject.selfRetirementYears = (this.objAdjustedDesiredScenario.clientAgeYears) ? this.objAdjustedDesiredScenario.clientAgeYears : 0;
              this.ssObject.selfRetirementMonths = (this.objAdjustedDesiredScenario.clientAgeMonths) ? this.objAdjustedDesiredScenario.clientAgeMonths : 0;
              console.log('zss this.ssObject.selfRetirementYears', this.ssObject.selfRetirementYears);

              this.ssObject.SurvivorSwitchYears = (this.objAdjustedDesiredScenario.survivorSwitchAgeYears) ? this.objAdjustedDesiredScenario.survivorSwitchAgeYears : 0;
              this.ssObject.SurvivorSwitchMonths = (this.objAdjustedDesiredScenario.survivorSwitchAgeMonths) ? this.objAdjustedDesiredScenario.survivorSwitchAgeMonths : 0;
              this.ssObject.clientSurvivorSwitchYears = (this.objAdjustedDesiredScenario.survivorSwitchAgeYears) ? this.objAdjustedDesiredScenario.survivorSwitchAgeYears : 0;
              this.ssObject.clientSurvivorSwitchMonths = (this.objAdjustedDesiredScenario.survivorSwitchAgeMonths) ? this.objAdjustedDesiredScenario.survivorSwitchAgeMonths : 0;
            }
          } else {
            this.ssObject.selfRetirementYears = (this.objAdjustedDesiredScenario.survivorSwitchAgeYears) ? this.objAdjustedDesiredScenario.survivorSwitchAgeYears : 0;
            this.ssObject.selfRetirementMonths = (this.objAdjustedDesiredScenario.survivorSwitchAgeMonths) ? this.objAdjustedDesiredScenario.survivorSwitchAgeMonths : 0;
            console.log('zss this.ssObject.selfRetirementYears', this.ssObject.selfRetirementYears);

            this.ssObject.SurvivorSwitchYears = (this.objAdjustedDesiredScenario.clientAgeYears) ? this.objAdjustedDesiredScenario.clientAgeYears : 0;
            this.ssObject.SurvivorSwitchMonths = (this.objAdjustedDesiredScenario.clientAgeMonths) ? this.objAdjustedDesiredScenario.clientAgeMonths : 0;
            this.ssObject.clientSurvivorSwitchYears = (this.objAdjustedDesiredScenario.clientAgeYears) ? this.objAdjustedDesiredScenario.clientAgeYears : 0;
            this.ssObject.clientSurvivorSwitchMonths = (this.objAdjustedDesiredScenario.clientAgeMonths) ? this.objAdjustedDesiredScenario.clientAgeMonths : 0;
          }
          //this.ssObject.invertSurvivorSwitch = 0
          this.ssObject.invertSurvivorSwitch = !this.objAdjustedDesiredScenario.swappedClaim ? 0 : 1;
          this.swappedClaim = this.objAdjustedDesiredScenario.swappedClaim;
          //this.objAdjustedDesiredScenario.swappedClaim = this.swappedClaim;
        } else {
          //this.ssObject.selfRetirementYears = this.objAdjustedDesiredScenario.clientAgeYears;//(this.objAdjustedDesiredScenario.survivorSwitchAgeYears) ? this.objAdjustedDesiredScenario.survivorSwitchAgeYears : 0;
          //this.ssObject.selfRetirementMonths = (this.objAdjustedDesiredScenario.survivorSwitchAgeMonths) ? this.objAdjustedDesiredScenario.survivorSwitchAgeMonths : 0;
          this.ssObject.invertSurvivorSwitch = 0;
          this.swappedClaim = false;
          this.objAdjustedDesiredScenario.swappedClaim = false;
        }

      } else {
        this.ssObject.invertSurvivorSwitch = 0;
      }
    }

    /* if (this.isSurvAndFirstLoadSwapped) {
      this.ssObject.invertSurvivorSwitch = 1;
      //console.log('yes in here');
    } */
    
    if(!this.isPageReloadOtherThanFRACall){
      console.log('checking this here 003');
      this.storedOriginalSSObjectAlt = { ...this.ssObject };
    } else {
      //console.log('checking this here 003');
      //this.isPageReloadOtherThanFRACall = false;
      this.ssObject = { ...this.storedOriginalSSObjectAlt };
      /* if(this.addFunds){
        var investmentItems = [];
    
        for (var item in this.fundingItems) {
    
          var contribution = {
            Description: this.fundingItems[item].fundingSource,
            Begins: this.fundingItems[item].startAge,
            Ends: this.fundingItems[item].endAge,
            StartAmount: this.fundingItems[item].annContribution,
            Cola: this.fundingItems[item].inflationRate,
          }
    
          investmentItems.push(contribution);
        }
        this.ssObject.InvestmentItems = JSON.stringify({ investmentItems });
      } */

      if(this.hasDurationBeenToggled){
        this.ssObject.isPresentValue = this.isPresentValue;
      }

      if(this.hasClientSidebarBeenUpdated){
        let spouseLifeExpectancy = this.includeSpouse? ((this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' || this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed')? (this.client.clientProfile.Spouses[0].exSpouseLifeExpectancy || 0):this.client.clientProfile.Spouses[0].LifeExpectancy) : 0;
        this.ssObject.SelfLifeExpectancy = this.client.clientProfile.LifeExpectancy;
        this.ssObject.SpouseLifeExpectancy = spouseLifeExpectancy || 0;
      }

      if(this.hasCOLAsBeenAdjusted){
        this.ssObject.COLA = this.colas;
        this.ssObject.FrmColaXml = this.colas;
      }
    }

    if (!this.ssObject.selfRetirementYears) {
      this.ssObject.selfRetirementYears = '0';
    }

    if(!this.ssObject.invertSurvivorSwitch && (this.ssObject.SurvivorSwitchYears * 12) + this.ssObject.SurvivorSwitchMonths < (this.ssObject.selfRetirementYears * 12) + this.ssObject.selfRetirementMonths
      && (this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced') && this.includeSpouse){
      //this.ssObject.invertSurvivorSwitch = true;
      //this.swappedClaim = true;
        if(showSurvivorSection){
          //NOTE: creates problems for non-survivor clients...
          var sYears = this.ssObject.SurvivorSwitchYears;
          var sMonths = this.ssObject.SurvivorSwitchMonths;
          var rYears = this.ssObject.selfRetirementYears;
          var rMonths = this.ssObject.selfRetirementMonths;

          this.ssObject.SurvivorSwitchYears = rYears;
          this.ssObject.clientSurvivorSwitchYears = rYears;
          this.ssObject.SurvivorSwitchMonths = rMonths;
          this.ssObject.clientSurvivorSwitchMonths = rMonths;

          this.ssObject.selfRetirementYears = sYears;
          this.ssObject.selfRetirementMonths = sMonths;
        }
    }
    
    if (this.ssObject)
      this.ssObject.FrmDiscountRate = this.socialSecurityForm.get('inflationRate').value.replace('%', '') / 100;

    this.previousSSObjectAlt = { ...this.ssObject};    
    console.log('SS object right before Alt Data call', this.ssObject);
    this.loadingService.isLoading(true);
    this.globalService.getSSData(this.ssObject, this.userForm.value)
      .subscribe(
        dataAlt => {
          console.log('SS DATA ALT', dataAlt);
          this.ssDataAlt = dataAlt;
          let spouseDOB = (this.client.clientProfile.Spouses[0].dobStr && Date.parse(this.client.clientProfile.Spouses[0].dobStr) ? new Date(this.client.clientProfile.Spouses[0].dobStr).toLocaleDateString("en-US") : new Date(this.client.clientProfile.Spouses[0].dob).toLocaleDateString("en-US") ? new Date(this.client.clientProfile.Spouses[0].dob).toLocaleDateString("en-US") : "1/1/1960");
          let spouseDOBDate = spouseDOB != null ? new Date(spouseDOB) : null;
          let isDisableAutoSurvivorBenefitMsg = this.client.clientProfile.Spouses[0].maritalStatus == 'Married' && spouseDOBDate != null? this.ssDataAlt.selfFRASurvivorAge == this.getSpouseMinSurvivorClaimAge() &&  this.ssDataAlt.selfFRASurvivorMonth == (13 - (spouseDOBDate.getMonth() + 1)) ? true : false: false;
          this.isAutoAlternateSurvivorBenefit = this.ssDataAlt && !isDisableAutoSurvivorBenefitMsg ? this.ssDataAlt.isAutoSurvivorBenefit: false;
          this.ssDataAlt.gridData = JSON.parse(this.ssDataAlt.gridData);
          this.ssDataAlt.gridData = this.formatGridData(this.ssDataAlt.gridData);

          this.scenarioDropDown.selected = 3;

          this.startingLumpsum = dataAlt.startBalanceAlt;
          this.beginningBalance = dataAlt.lumpsumCost;
          this.lumpsum = dataAlt.lumpsumCost;
          this.lumpsumAlt = dataAlt.lumpsumCost;

          //this.currentRemainingTotal = data.remainingUnfunded;

          /* this.yearlyCost = dataAlt.yearlyCost;
          this.futureYearlyCost = Number(this.yearlyCost) * (this.annuallyWeeklyTtlYear >= 10 ? 10: this.annuallyWeeklyTtlYear);

          this.weeklyCost = dataAlt.weeklyCost;
          this.futureWeeklyCost  = Number(this.weeklyCost) * 52 * ((this.annuallyWeeklyTtlYear >= 10 ? 10: this.annuallyWeeklyTtlYear)); */

          this.yearlyCost = dataAlt.yearlyCost;
          this.weeklyCost = dataAlt.weeklyCost;

          this.yearlyCostAlt = this.yearlyCost;
          this.weeklyCostAlt = this.weeklyCost;
          //this.futureYearlyCost = Number(this.yearlyCost) * (this.annuallyWeeklyTtlYear >= 10 ? 10: this.annuallyWeeklyTtlYear);
          //this.objAdjustRates.rorOne isnt set here I guess? hardcode to 6 for page load values
          /* console.log('this.annuallyWeeklyTtlYear', this.annuallyWeeklyTtlYear);
          var pay = Math.ceil(Math.abs(this.startingLumpsum * (6.00 / 1) / (Math.pow(1 + (6.00 / 1), (this.annuallyWeeklyTtlYear * 1 + 1))) - (1 + 6.00 / 1)));
          var payFutureAnnual = (pay + Number(this.yearlyCost)) * this.annuallyWeeklyTtlYear;
          this.futureYearlyCost = payFutureAnnual;

          this.weeklyCost = dataAlt.weeklyCost;
          //this.futureWeeklyCost  = Number(this.weeklyCost) * 52 * ((this.annuallyWeeklyTtlYear >= 10 ? 10: this.annuallyWeeklyTtlYear));
          var pay = Math.ceil(Math.abs(this.startingLumpsum * (6.00 / 52) / (Math.pow(1 + (6.00 / 52), (this.annuallyWeeklyTtlYear * 52 + 1))) - (1 + 6.00 / 52)));
          var payFutureWeek = (pay + Number(this.weeklyCost)) * (this.annuallyWeeklyTtlYear * 52);
          this.futureWeeklyCost = payFutureWeek; */
           
          /* console.log('dataAlt.cusStartBenLabel', dataAlt.cusStartBenLabel);
          this.returnedDesiredClaimAge('68y 0m / 68y 0m');
 */
          var phaseOnePercent = (this.objAdjustRates ? (Number(this.objAdjustRates.rorOne)) : 6) / 100;
    
          //var pay = Math.ceil(Math.abs(this.startingLumpsum * (6.00 / 1) / (Math.pow(1 + (6.00 / 1), (this.annuallyWeeklyTtlYear * 1 + 1))) - (1 + 6.00 / 1)));
          //var payFutureAnnual = (pay + Number(this.yearlyCost)) * this.annuallyWeeklyTtlYear;
          var pay = Math.ceil(Math.abs(this.startingLumpsum * phaseOnePercent / (Math.pow((1 + phaseOnePercent), this.annuallyWeeklyTtlYear) - 1)));
          var payFutureAnnual = pay * this.annuallyWeeklyTtlYear;
          this.futureYearlyCost = this.yearlyCost;//payFutureAnnual;

          //var pay = Math.ceil(Math.abs(this.startingLumpsum * (6.00 / 52) / (Math.pow(1 + (6.00 / 52), (this.annuallyWeeklyTtlYear * 52 + 1))) - (1 + 6.00 / 52)));
          //var payFutureWeek = (pay + Number(this.weeklyCost)) * (this.annuallyWeeklyTtlYear * 52);
          var pay = Math.ceil(Math.abs(this.startingLumpsum * (phaseOnePercent / 52) / (Math.pow(1 + phaseOnePercent / 52, (this.annuallyWeeklyTtlYear * 52)) - 1)));
          var payFutureWeek = pay * (this.annuallyWeeklyTtlYear * 52);
          this.futureWeeklyCost = this.weeklyCost;//payFutureWeek;

          this.totalRemainingGap = this.beginningBalance;
          this.medicareDeductions = Utils.formatToNumber(dataAlt.cusPartB);
          this.currentRemainingTotal = (this.addFunds) ? dataAlt.remainingUnfunded : this.medicareDeductions;

          //HACK: remove once PO2-177 is marked as Done
          /* if(this.addFunds){
            var sum = 0;
            for (let i = 0; i < this.fundingSource.length; i++) {
              sum += this.fundingSource[i].totalContribution;
            } 
            
            this.currentRemainingTotal = this.ssDataAlt.remainingUnfunded = Utils.formatToNumber(dataAlt.cusPartB) - sum;
          } */
          
          let dOB = new Date(this.client.client.DOB);
          let timeDiff = Math.abs(Date.now() - dOB.getTime());
          let clientAge = Math.floor((timeDiff / (1000 * 3600 * 24))/365.25);
          let retirementAge = this.client.clientProfile.RetirementAge;  
            
          if (clientAge <= retirementAge) {
            console.log('setting annuallyWeeklyTtlYear ALT', this.annuallyWeeklyTtlYear);
            let optAge = parseInt(dataAlt.cusStartBenLabel.split('/')[0].replace(' month', '').replace(' months', '').replace('ms', '').replace(' and', ''));
            //console.log('optAge', optAge);
            this.annuallyWeeklyTtlYear = ((optAge - clientAge) > 1) ? optAge - clientAge : 1;
            //console.log('optAge - clientAge', (optAge - clientAge));
            this.orgAltAnnuallyWeeklyTtlYear = ((optAge - clientAge) > 1) ? optAge - clientAge : 1;
            this.dropDownSelectedIndexWeekly = this.dropDownSelectedIndexAnnually = this.annuallyWeeklyTtlYear;
            //this.dropDownSelectedIndexWeekly = this.dropDownSelectedIndexAnnually = this.annuallyWeeklyTtlYear;
            //console.log('what is this', (optAge - clientAge));
          }

          var aIllTotal = {
            clientAmountTotal: 0,
            dependentChildrenAmount: 0,
            netOfMedicareAmount: 0,
            spouseAmount: 0,
            totalAnnualAmount: 0,
          };

          for (var key in dataAlt.alternateIllustrationTable) {
            aIllTotal.clientAmountTotal = aIllTotal.clientAmountTotal + dataAlt.alternateIllustrationTable[key].clientAmount;
            aIllTotal.dependentChildrenAmount = aIllTotal.dependentChildrenAmount + dataAlt.alternateIllustrationTable[key].dependentChildrenAmount;
            aIllTotal.netOfMedicareAmount = Number(this.ssDataAlt.cusTotalBenefit.replace(/,/g, "").replace("$", "")) - Number(this.ssDataAlt.cusPartB.replace(/,/g, "").replace("$", "")); //aIllTotal.netOfMedicareAmount + data.alternateIllustrationTable[key].netOfMedicareAmount;
            aIllTotal.spouseAmount = aIllTotal.spouseAmount + dataAlt.alternateIllustrationTable[key].spouseAmount;
            aIllTotal.totalAnnualAmount = aIllTotal.totalAnnualAmount + dataAlt.alternateIllustrationTable[key].totalAnnualAmount;
            for (var keyy in dataAlt.alternateIllustrationTable[key]) {
              if (typeof dataAlt.alternateIllustrationTable[key][keyy] === 'number') {
                dataAlt.alternateIllustrationTable[key][keyy] = Utils.formatToCurrency(dataAlt.alternateIllustrationTable[key][keyy].toFixed(0));
              }
            }
          }

          dataAlt.alternateIllustrationTable.totals = aIllTotal;

          for (var key in dataAlt.alternateIllustrationTable.totals) {
            dataAlt.alternateIllustrationTable.totals[key] = Utils.formatToCurrency(dataAlt.alternateIllustrationTable.totals[key].toFixed(0));
          }

          var alternate = dataAlt.alternateIllustrationTable;
          console.log('alternate', alternate);

          if (hasAlreadyRan && this.illustrationComparisons.length > 3) {
            //if this was already ran, we now need to pop the values that were added to various arrays
            //this.colorScheme.domain.pop();
            //this.illustrationsTypes.pop();
            this.illustrationComparisons.pop();
            //this.lineGraphData = null;
            //this.comparisonGraph = this.createComparisonGraphData(this.ssData.costsByCareAndRegionBody);

            this.socialSecurityIllustrationCards.pop();
            this.socialSecurityBenefitCards.pop();
          }
          if (this.client.clientProfile.SSDesiredAgeYears && !ajustClaim) {
            this.socialSecurityForm.patchValue({ 'selfRetirementYears': this.client.clientProfile.SSDesiredAgeYears });
            this.socialSecurityForm.patchValue({ 'selfRetirementMonths': this.client.clientProfile.SSDesiredAgeMonths });

            if (this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Married'
              || this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced') {
              if (this.client.clientProfile.Spouses[0].sSDesiredAgeYears) {
                this.socialSecurityForm.patchValue({ 'spouseRetirementYears': this.client.clientProfile.Spouses[0].sSDesiredAgeYears });
                this.socialSecurityForm.patchValue({ 'spouseRetirementMonths': this.client.clientProfile.Spouses[0].sSDesiredAgeMonths });

                //this.objAdjustedDesiredScenario.spouseAgeYears =this.ssObject.spouseRetirementYears;
                //this.objAdjustedDesiredScenario.spouseAgeMonths = this.ssObject.spouseRetirementMonths;
              }
            }

            //reset this
            /* this.objAdjustedDesiredScenario = {clientAgeYears: this.socialSecurityForm.get('selfRetirementYears').value, 
              clientAgeMonths: this.socialSecurityForm.get('selfRetirementMonths').value, 
              spouseAgeYears: this.socialSecurityForm.get('spouseRetirementYears').value, 
              spouseAgeMonths: this.socialSecurityForm.get('spouseRetirementMonths').value}; */
          }

          let clientAgeYears = this.socialSecurityForm.get('selfRetirementYears').value;
          console.log('clientAgeYears when here', clientAgeYears);
          let clientAgeMonth = this.socialSecurityForm.get('selfRetirementMonths').value;
          let isClientAgeDisable = false;

          let spouseAgeYears = this.socialSecurityForm.get('spouseRetirementYears').value;
          let spouseAgeMonths = this.socialSecurityForm.get('spouseRetirementMonths').value;
          let isSpouseAgeDisable = false;

          //this.yearlyCostFRA = dataAlt.yearlyCost;
          //this.futureYearlyCostFRA = Number(this.yearlyCostFRA) * this.annuallyWeeklyTtlYear;

          //this.weeklyCostFRA = dataAlt.weeklyCost;
          //this.futureWeeklyCostFRA  = Number(this.weeklyCostFRA) * 52 * this.annuallyWeeklyTtlYear;
          this.lumpsum = dataAlt.lumpsumCost;

          if (this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
            /* if(this.client.clientProfile.Spouses[0].sSDesiredAgeYears){
              this.socialSecurityForm.patchValue({'spouseRetirementYears': this.client.clientProfile.Spouses[0].sSDesiredAgeYears });
              this.socialSecurityForm.patchValue({'spouseRetirementMonths': this.client.clientProfile.Spouses[0].sSDesiredAgeMonths });

              spouseAgeYears = this.socialSecurityForm.get('spouseRetirementYears').value;
              spouseAgeMonths = this.socialSecurityForm.get('spouseRetirementMonths').value;
            } */

            //if (((this.client.clientProfile.MonthlyBenefitAmount || 0) > 0 && ( Utils.formatToNumber(this.client.clientProfile.Spouses[0].monthlyBenefits || 0)) == 0) || this.calculateAge(this.client.client.DOB) >= 70) {
            if (this.client.clientProfile.SelfAlreadyCollecting || this.calculateAge(this.client.client.DOB) >= 70) {
              clientAgeYears = this.calculateAge(this.client.client.DOB);
              clientAgeMonth = this.clientAgeMonth;
              isClientAgeDisable = true;

              if (!this.client.clientProfile.Spouses[0].sSDesiredAgeYears) {
                //spouseAgeMonths = (spouseAgeYears) ? spouseAgeMonths : this.client.clientProfile.Spouses[0].sSDesiredAgeMonths;
                spouseAgeYears = this.calculateAge(spouseDOB);
              }
            }
            //if (((this.client.clientProfile.MonthlyBenefitAmount || 0) == 0 && ( Utils.formatToNumber(this.client.clientProfile.Spouses[0].monthlyBenefits || 0)) > 0) || this.calculateAge(this.client.clientProfile.Spouses[0].dob) >= 70) {
            if (this.client.clientProfile.SpouseAlreadyCollecting || this.calculateAge(spouseDOB) >= 70) {
              spouseAgeYears = this.calculateAge(spouseDOB);
              spouseAgeMonths = this.spouseAgeMonth;
              isSpouseAgeDisable = true;
            }
          } else {
            if (this.calculateAge(this.client.client.DOB) >= 70) {
              clientAgeYears = this.calculateAge(this.client.client.DOB);
              clientAgeMonth = this.clientAgeMonth;
              isClientAgeDisable = true;
            }
          }

          //reset this
          // pass clientAge Disable or Partner age deisable bool value if already claimed
          // let survivorSwitchAgeYear = (this.objAdjustedDesiredScenario.survivorSwitchAgeYears) ? this.objAdjustedDesiredScenario.survivorSwitchAgeYears : this.client.clientProfile.
          console.log('before resetting this.objAdjustedDesiredScenario', this.objAdjustedDesiredScenario);
          console.log('this.objAdjustedDesiredScenario.isClientFilingRestricted', this.objAdjustedDesiredScenario.isClientFilingRestricted);
          console.log('this.objAdjustedDesiredScenario.clientAgeYears', this.objAdjustedDesiredScenario.clientAgeYears);
          console.log('clientAgeYears', clientAgeYears);
          var isSwappedClaim = (this.client.clientProfile.InvertSurvivorSwitch != null) ? this.client.clientProfile.InvertSurvivorSwitch : this.swappedClaim;
          //this.adjSurvivorBenefitAge = !isSwappedClaim ? this.clientSurvivorSwitchYears : ((this.isSpouseSurvivor) ? spouseAgeYears : clientAgeYears);
          //this.adjSurvivorBenefitMonths = !isSwappedClaim ? this.clientSurvivorSwitchMonths : ((this.isSpouseSurvivor) ? spouseAgeMonths : clientAgeMonth);
          //this.adjRetirementBenefitAge = !isSwappedClaim ? ((this.isSpouseSurvivor) ? spouseAgeYears : clientAgeYears) : this.clientSurvivorSwitchYears;
          //this.adjRetirementBenefitMonths = !isSwappedClaim ? ((this.isSpouseSurvivor) ? spouseAgeMonths : clientAgeMonth) : this.clientSurvivorSwitchMonths;

          this.objAdjustedDesiredScenario = {
            scenario: 'Alternate',
            clientAgeYears: (this.objAdjustedDesiredScenario.clientAgeYears) ? this.objAdjustedDesiredScenario.clientAgeYears : clientAgeYears,
            clientAgeMonths: (this.objAdjustedDesiredScenario.clientAgeYears) ? this.objAdjustedDesiredScenario.clientAgeMonths || 0 : clientAgeMonth,
            spouseAgeYears: (this.objAdjustedDesiredScenario.spouseAgeYears) ? this.objAdjustedDesiredScenario.spouseAgeYears : spouseAgeYears,
            spouseAgeMonths: (this.objAdjustedDesiredScenario.spouseAgeYears) ? this.objAdjustedDesiredScenario.spouseAgeMonths || 0 : spouseAgeMonths,

            survivorSwitchAgeYears: (this.objAdjustedDesiredScenario.survivorSwitchAgeYears) ? this.objAdjustedDesiredScenario.survivorSwitchAgeYears : '',
            survivorSwitchAgeMonths: (this.objAdjustedDesiredScenario.survivorSwitchAgeMonths) ? this.objAdjustedDesiredScenario.survivorSwitchAgeMonths : '',

            saveDCA: (this.objAdjustedDesiredScenario.displayedDCAToggleOnMessage != undefined && !this.objAdjustedDesiredScenario.displayedDCAToggleOnMessage && !this.objAdjustedDesiredScenario.displayedDCAToggleOffMessage && this.objAdjustedDesiredScenario.displayedDCAToggleOffMessage != undefined) ? true : this.objAdjustedDesiredScenario.saveDCA,
            displayedDCAToggleOnMessage: (this.objAdjustedDesiredScenario.displayedDCAToggleOnMessage) ? this.objAdjustedDesiredScenario.displayedDCAToggleOnMessage : false,
            displayedDCAToggleOffMessage: (this.objAdjustedDesiredScenario.displayedDCAToggleOffMessage) ? this.objAdjustedDesiredScenario.displayedDCAToggleOffMessage : false,
            isClientAgeDisable: isClientAgeDisable,
            isSpouseAgeDisable: isSpouseAgeDisable,

            isClientFilingRestricted: this.objAdjustedDesiredScenario.isClientFilingRestricted,
            isSpouseFilingRestricted: this.objAdjustedDesiredScenario.isSpouseFilingRestricted,
            fileRestrictedAgeYears: (this.objAdjustedDesiredScenario.isClientFilingRestricted) ? this.objAdjustedDesiredScenario.fileRestrictedAgeYears : 0,
            fileRestrictedAgeMonths: (this.objAdjustedDesiredScenario.isClientFilingRestricted) ? this.objAdjustedDesiredScenario.fileRestrictedAgeMonths : 0,
            clientFileRestrictedMinMonth: (this.objAdjustedDesiredScenario.clientFileRestrictedMinMonth) ? this.objAdjustedDesiredScenario.clientFileRestrictedMinMonth : 0,
            spouseFileRestrictedAgeYears: (this.objAdjustedDesiredScenario.isSpouseFilingRestricted) ? this.objAdjustedDesiredScenario.spouseFileRestrictedAgeYears : 0,
            spouseFileRestrictedAgeMonths: (this.objAdjustedDesiredScenario.isSpouseFilingRestricted) ? this.objAdjustedDesiredScenario.spouseFileRestrictedAgeMonths : 0,
            spouseFileRestrictedMinMonth: (this.objAdjustedDesiredScenario.spouseFileRestrictedMinMonth) ? this.objAdjustedDesiredScenario.spouseFileRestrictedMinMonth : 0,

            clientRetroDisplayAge: (this.objAdjustedDesiredScenario.clientRetroDisplayAge) ? this.objAdjustedDesiredScenario.clientRetroDisplayAge : '',
            partnerRetroDisplayAge: (this.objAdjustedDesiredScenario.partnerRetroDisplayAge) ? this.objAdjustedDesiredScenario.partnerRetroDisplayAge : '',

            //this should be setting eligability
            isClientRetroFiling: (this.objAdjustedDesiredScenario.isClientRetroFiling) ? this.objAdjustedDesiredScenario.isClientRetroFiling : false,
            isSpouseRetroFiling: (this.objAdjustedDesiredScenario.isSpouseRetroFiling) ? this.objAdjustedDesiredScenario.isSpouseRetroFiling : false,
            //isClientRetroFiling: this.ssData.earlSelfRetoFiling,
            //isSpouseRetroFiling: this.ssData.earlSpouseRetoFiling

            /* swappedClaim: (this.objAdjustedDesiredScenario.swappedClaim != null || this.objAdjustedDesiredScenario.swappedClaim != undefined) 
              ? this.objAdjustedDesiredScenario.swappedClaim : this.swappedClaim */

            clientDefaultAgeVal: this.objAdjustedDesiredScenario.clientDefaultAgeVal,
            partnerDefaultAgeVal: this.objAdjustedDesiredScenario.partnerDefaultAgeVal,

            swappedClaim: (this.objAdjustedDesiredScenario.swappedClaim != null || this.objAdjustedDesiredScenario.swappedClaim != undefined)
              ? this.objAdjustedDesiredScenario.swappedClaim : false
          };
          console.log('after Alt this.objAdjustedDesiredScenario', this.objAdjustedDesiredScenario);

          console.log('this.adjSurvivorBenefitAge', this.adjSurvivorBenefitAge);
          console.log('this.adjRetirementBenefitAge', this.adjRetirementBenefitAge);
          if ((this.client.clientProfile.Spouses[0].maritalStatus == "Widowed"
            || (this.client.clientProfile.Spouses[0].maritalStatus == 'Single' || this.client.clientProfile.Spouses[0].maritalStatus == 'Married') && this.includeSpouse)) {
            console.log(adjustButtonClicked)
            // save after adjustment has generate different this.adjSurvivorBenefitAge and other values
            if (adjustButtonClicked) {
              if (this.client.clientProfile.Spouses[0].maritalStatus == 'Married' && this.isSpouseSurvivor) {
                console.log('this.objAdjustedDesiredScenario.clientAgeYears', this.objAdjustedDesiredScenario.clientAgeYears)
                console.log('this.adjRetirementBenefitAge', this.adjRetirementBenefitAge);
                console.log('this.adjSurvivorBenefitAge', this.adjSurvivorBenefitAge);
                //if (this.swappedClaim) {
                if (!this.objAdjustedDesiredScenario.swappedClaim) {
                  this.objAdjustedDesiredScenario.spouseAgeYears = this.adjRetirementBenefitAge
                  this.objAdjustedDesiredScenario.spouseAgeMonths = this.adjRetirementBenefitMonths
                  this.objAdjustedDesiredScenario.survivorSwitchAgeYears = this.adjSurvivorBenefitAge
                  this.objAdjustedDesiredScenario.survivorSwitchAgeMonths = this.adjSurvivorBenefitMonths
                } else {
                  this.objAdjustedDesiredScenario.spouseAgeYears = this.adjSurvivorBenefitAge
                  this.objAdjustedDesiredScenario.spouseAgeMonths = this.adjSurvivorBenefitMonths
                  this.objAdjustedDesiredScenario.survivorSwitchAgeYears = this.adjRetirementBenefitAge
                  this.objAdjustedDesiredScenario.survivorSwitchAgeMonths = this.adjRetirementBenefitMonths
                }
              } else {
                //if (this.swappedClaim) {
                if (!this.objAdjustedDesiredScenario.swappedClaim) {
                  this.objAdjustedDesiredScenario.clientAgeYears = this.adjRetirementBenefitAge
                  this.objAdjustedDesiredScenario.clientAgeMonths = this.adjRetirementBenefitMonths
                  this.objAdjustedDesiredScenario.survivorSwitchAgeYears = this.adjSurvivorBenefitAge
                  this.objAdjustedDesiredScenario.survivorSwitchAgeMonths = this.adjSurvivorBenefitMonths
                } else {
                  this.objAdjustedDesiredScenario.clientAgeYears = this.adjSurvivorBenefitAge
                  this.objAdjustedDesiredScenario.clientAgeMonths = this.adjSurvivorBenefitMonths
                  this.objAdjustedDesiredScenario.survivorSwitchAgeYears = this.adjRetirementBenefitAge
                  this.objAdjustedDesiredScenario.survivorSwitchAgeMonths = this.adjRetirementBenefitMonths
                }
              }
            } else {
              if (this.client.clientProfile.Spouses[0].maritalStatus == 'Married' && this.isSpouseSurvivor) {
                console.log('this.adjSurvivorBenefitAge', this.adjSurvivorBenefitAge)
                console.log('this.adjRetirementBenefitAge', this.adjRetirementBenefitAge)
                console.log('this.swappedClaim 333', this.swappedClaim)
                // if (this.swappedClaim) {
                //   this.objAdjustedDesiredScenario.spouseAgeYears = this.adjSurvivorBenefitAge
                //   this.objAdjustedDesiredScenario.spouseAgeMonths = this.adjSurvivorBenefitMonths
                //   this.objAdjustedDesiredScenario.survivorSwitchAgeYears = this.adjRetirementBenefitAge
                //   this.objAdjustedDesiredScenario.survivorSwitchAgeMonths = this.adjRetirementBenefitMonths
                // } else {
                //   this.objAdjustedDesiredScenario.spouseAgeYears = this.adjRetirementBenefitAge
                //   this.objAdjustedDesiredScenario.spouseAgeMonths = this.adjRetirementBenefitMonths
                //   this.objAdjustedDesiredScenario.survivorSwitchAgeYears = this.adjSurvivorBenefitAge
                //   this.objAdjustedDesiredScenario.survivorSwitchAgeMonths = this.adjSurvivorBenefitMonths
                // }
                //if (this.swappedClaim) {
                if (!this.objAdjustedDesiredScenario.swappedClaim) {
                  this.objAdjustedDesiredScenario.spouseAgeYears = this.adjRetirementBenefitAge
                  this.objAdjustedDesiredScenario.spouseAgeMonths = this.adjRetirementBenefitMonths
                  this.objAdjustedDesiredScenario.survivorSwitchAgeYears = this.adjSurvivorBenefitAge
                  this.objAdjustedDesiredScenario.survivorSwitchAgeMonths = this.adjSurvivorBenefitMonths
                } else {
                  this.objAdjustedDesiredScenario.spouseAgeYears = this.adjSurvivorBenefitAge
                  this.objAdjustedDesiredScenario.spouseAgeMonths = this.adjSurvivorBenefitMonths
                  this.objAdjustedDesiredScenario.survivorSwitchAgeYears = this.adjRetirementBenefitAge
                  this.objAdjustedDesiredScenario.survivorSwitchAgeMonths = this.adjRetirementBenefitMonths
                }
              
                console.log('asd in here', this.adjSurvivorBenefitAge, this.adjRetirementBenefitAge, this.swappedClaim);

                /* this.objAdjustedDesiredScenario.clientAgeYears = this.swappedClaim ? this.adjSurvivorBenefitAge : this.adjRetirementBenefitAge;
                this.objAdjustedDesiredScenario.clientAgeMonths = this.swappedClaim ? this.adjSurvivorBenefitMonths : this.adjRetirementBenefitMonths;
                this.objAdjustedDesiredScenario.survivorSwitchAgeYears = this.swappedClaim ? this.adjRetirementBenefitAge : this.adjSurvivorBenefitAge;
                this.objAdjustedDesiredScenario.survivorSwitchAgeMonths = this.swappedClaim ? this.adjRetirementBenefitMonths : this.adjSurvivorBenefitMonths;

                this.adjSurvivorBenefitAge = this.swappedClaim ? this.adjSurvivorBenefitAge : this.adjRetirementBenefitAge;
                this.adjSurvivorBenefitMonths = this.swappedClaim ? this.adjSurvivorBenefitMonths : this.adjRetirementBenefitMonths;
                this.adjSurvivorBenefitAge = this.swappedClaim ? this.adjRetirementBenefitAge : this.adjSurvivorBenefitAge;
                this.adjSurvivorBenefitMonths = this.swappedClaim ? this.adjRetirementBenefitMonths : this.adjSurvivorBenefitMonths; */

                console.log('asd in here', this.objAdjustedDesiredScenario);

                //ZSS 062424: If spouse is the survivor, why are we adjusting the client info?
                //this.objAdjustedDesiredScenario.clientAgeYears = this.objAdjustedDesiredScenario.swappedClaim ? this.adjSurvivorBenefitAge : this.adjRetirementBenefitAge
                //this.objAdjustedDesiredScenario.clientAgeMonths = this.objAdjustedDesiredScenario.swappedClaim ? this.adjSurvivorBenefitMonths : this.adjRetirementBenefitMonths
                this.objAdjustedDesiredScenario.survivorSwitchAgeYears = this.objAdjustedDesiredScenario.swappedClaim ? this.adjRetirementBenefitAge : this.adjSurvivorBenefitAge
                this.objAdjustedDesiredScenario.survivorSwitchAgeMonths = this.objAdjustedDesiredScenario.swappedClaim ? this.adjRetirementBenefitMonths : this.adjSurvivorBenefitMonths

              }
            }


          } else if(this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' && this.includeSpouse){
            console.log('divorced switch', this.objAdjustedDesiredScenario);
            console.log('divorced switch', this.client.clientProfile);

            this.objAdjustedDesiredScenario.survivorSwitchAgeYears = (this.client.clientProfile.SurvivorSwitchYears) ? this.client.clientProfile.SurvivorSwitchYears : this.objAdjustedDesiredScenario.survivorSwitchAgeYears;
            this.objAdjustedDesiredScenario.survivorSwitchAgeMonths = (this.client.clientProfile.SurvivorSwitchMonths) ? this.client.clientProfile.SurvivorSwitchMonths : this.objAdjustedDesiredScenario.survivorSwitchAgeMonths;

            this.objAdjustedDesiredScenario.clientAgeYears = (this.client.clientProfile.SSDesiredAgeYears) ? this.client.clientProfile.SSDesiredAgeYears : this.objAdjustedDesiredScenario.clientAgeYears;
            this.objAdjustedDesiredScenario.clientAgeMonths = (this.client.clientProfile.SSDesiredAgeMonths) ? this.client.clientProfile.SSDesiredAgeMonths :  this.objAdjustedDesiredScenario.clientAgeMonths;

            //this.objAdjustedDesiredScenario.swappedClaim = true;//(this.client.clientProfile.InvertSurvivorSwitch != null) ? this.client.clientProfile.InvertSurvivorSwitch : this.swappedClaim;
            if(!this.objAdjustedDesiredScenario.swappedClaim && (this.objAdjustedDesiredScenario.survivorSwitchAgeYears * 12) + this.objAdjustedDesiredScenario.survivorSwitchAgeMonths < (this.objAdjustedDesiredScenario.clientAgeYears * 12) + this.objAdjustedDesiredScenario.clientAgeMonths){
              this.objAdjustedDesiredScenario.swappedClaim = true;
            }
          }



          //check to see if we need to readjust the client profile if saved values
          //check to see if we need to readjust the client profile if saved values
          console.log('asdddd', dataAlt.selfRejectSwitchAgeInput || dataAlt.spouseRejectSwitchAgeInput)
          if ((dataAlt.selfRejectSwitchAgeInput || dataAlt.spouseRejectSwitchAgeInput)) {
            console.log('need to make adjustments - display modal', this.isFRABeingAdjusted);

            const clientSurvivorSwitchAges = this.objAdjustedDesiredScenario.swappedClaim ? `${this.objAdjustedDesiredScenario.survivorSwitchAgeYears}y ${this.objAdjustedDesiredScenario.survivorSwitchAgeMonths}m` : `${this.objAdjustedDesiredScenario.clientAgeYears}y ${this.objAdjustedDesiredScenario.clientAgeMonths}m`;
            const clientRetirementSwitchAges = !this.objAdjustedDesiredScenario.swappedClaim ? `${this.objAdjustedDesiredScenario.survivorSwitchAgeYears}y ${this.objAdjustedDesiredScenario.survivorSwitchAgeMonths}m` : `${this.objAdjustedDesiredScenario.clientAgeYears}y ${this.objAdjustedDesiredScenario.clientAgeMonths}m`;

            const spouseSurvivorSwitchAges = this.objAdjustedDesiredScenario.swappedClaim ? `${this.objAdjustedDesiredScenario.survivorSwitchAgeYears}y ${this.objAdjustedDesiredScenario.survivorSwitchAgeMonths}m` : `${this.objAdjustedDesiredScenario.spouseAgeYears}y ${this.objAdjustedDesiredScenario.spouseAgeMonths}m`;
            const spouseRetirementSwitchAges = !this.objAdjustedDesiredScenario.swappedClaim ? `${this.objAdjustedDesiredScenario.survivorSwitchAgeYears}y ${this.objAdjustedDesiredScenario.survivorSwitchAgeMonths}m` : `${this.objAdjustedDesiredScenario.spouseAgeYears}y ${this.objAdjustedDesiredScenario.spouseAgeMonths}m`;

            let retirementIsMoreProfitable = false;

            const clientAges = Number(clientRetirementSwitchAges.split("y")[0]);
            const clientMonths = Number(clientRetirementSwitchAges.split("y")[1].replace("m",""));
            const clientSurvivorAges = Number(clientSurvivorSwitchAges.split("y")[0]);
            const clientSurvivorMonths = Number(clientSurvivorSwitchAges.split("y")[1].replace("m",""));

            const spouseAges = Number(spouseRetirementSwitchAges.split("y")[0]);
            const spouseMonths = Number(spouseRetirementSwitchAges.split("y")[1].replace("m",""));
            const spouseSurvivorAges = Number(spouseSurvivorSwitchAges.split("y")[0]);
            const spouseSurvivorMonths = Number(spouseSurvivorSwitchAges.split("y")[1].replace("m",""));

            let topAgeMonths = "";
            let bottomAgeMonths = "";
            let hasNullValue = false;

            if (dataAlt.selfRejectSwitchAgeInput) {
              let retirementFirst = clientAges > clientSurvivorAges || clientAges == clientSurvivorAges && clientMonths > clientSurvivorMonths
              topAgeMonths = retirementFirst ? clientRetirementSwitchAges : clientSurvivorSwitchAges;
              bottomAgeMonths = retirementFirst ? clientSurvivorSwitchAges : clientRetirementSwitchAges;
            }

            if (dataAlt.spouseRejectSwitchAgeInput) {
              let retirementFirst = spouseAges > spouseSurvivorAges || spouseAges == spouseSurvivorAges && spouseMonths > spouseSurvivorMonths
              topAgeMonths = retirementFirst ? spouseRetirementSwitchAges : spouseSurvivorSwitchAges;
              bottomAgeMonths = retirementFirst ? spouseSurvivorSwitchAges : spouseRetirementSwitchAges;
            }

            if (dataAlt.selfRejectSwitchAgeInput && (!clientAges || !clientSurvivorAges)) {
              hasNullValue = true;
            }

            if (dataAlt.spouseRejectSwitchAgeInput && (!spouseAges || !spouseSurvivorAges)) {
              hasNullValue = true;
            }

            //ZSS removed '&& hasAlreadyRan' was causing issues for profiles without an Alt saved to profile and adding an Alt for the first time
            if (!hasNullValue && this.isAlreadyInitializeComponent && !this.isFRABeingAdjusted) {
              //display the popup modal explaining
              const dialogRef = this.dialog.open(BasicQuestionComponent, {
                data: {
                  title: 'Notification!',
                  btnYesTitle: 'I Understand',
                  question: "The claiming strategy you entered (switching benefit types at " + topAgeMonths + ") would result in a "
                      //+ "$X decrease in monthly benefits at age " 
                      + "decrease in monthly benefits - and is therefore invalid."
                      + "<br/>Social Security Administration rules state that a beneficiary can only switch a claiming option if the amount received is higher than the previous choice."
                      + "<br/><br/>This protects the consumer from making a decision that would reduce benefits. (<a target='_BLANK' href='https://www.ssa.gov/benefits/survivors/ifyou.html'>https://www.ssa.gov/benefits/survivors/ifyou.html</a>)."
                      //+ "<br/><br/>The desired claim for " + (dataAlt.selfRejectSwitchAgeInput ? this.clientFullName : this.spouseFullName) + " has been set to only "
                      + "<br/><br/>The desired claim for " + (dataAlt.selfRejectSwitchAgeInput ? this.socialSecurityIllustrationCards[0].clientName : this.socialSecurityIllustrationCards[0].partnerName) + " has been set to only "
                      //[survivor/retirement]
                      + (this.objAdjustedDesiredScenario.swappedClaim ? "retirement" : "survivor") + " benefits at age " + bottomAgeMonths + ". You can try other strategies by re-opening the "
                        //[Alternate/Alt1]
                        + ((this.hasAdjustedFRAScenario) ? "Second Alternate" : "Alternate") + " box"
                        + "<br/>again and changing the claim age(s)."
                }

                // question: "The claiming strategy you entered (switching benefit types at " 
                //   + dataAlt.selfRejectSwitchAgeInput ? (this.objAdjustedDesiredScenario.swappedClaim) ? this.objAdjustedDesiredScenario.clientAgeYears : this.objAdjustedDesiredScenario.survivorSwitchAgeYears + "y " + (this.objAdjustedDesiredScenario.swappedClaim) ? this.objAdjustedDesiredScenario.clientAgeMonths : this.objAdjustedDesiredScenario.survivorSwitchMonths + ") would result in a "
                //   : (this.objAdjustedDesiredScenario.swappedClaim) ? this.objAdjustedDesiredScenario.spouseAgeYears : this.objAdjustedDesiredScenario.survivorSwitchAgeYears + "y " + (this.objAdjustedDesiredScenario.swappedClaim) ? this.objAdjustedDesiredScenario.spouseAgeMonths : this.objAdjustedDesiredScenario.survivorSwitchAgeMonths + "m" + ") would result in a "
                // //+ "$X decrease in monthly benefits at age " 
                // + "decrease in monthly benefits - and is therefore invalid."
                // + "<br/>Social Security Administration rules state that a beneficiary can only switch a claiming option if the amount received is higher than the previous choice."
                // + "<br/><br/>This protects the consumer from making a decision that would reduce benefits. (<a target='_BLANK' href='https://www.ssa.gov/benefits/survivors/ifyou.html'>https://www.ssa.gov/benefits/survivors/ifyou.html</a>)."
                // //+ "<br/><br/>The desired claim for " + (dataAlt.selfRejectSwitchAgeInput ? this.clientFullName : this.spouseFullName) + " has been set to only "
                // + "<br/><br/>The desired claim for " + (dataAlt.selfRejectSwitchAgeInput ? this.socialSecurityIllustrationCards[0].clientName : this.socialSecurityIllustrationCards[0].partnerName) + " has been set to only "
                // //[survivor/retirement]
                // + ((this.objAdjustedDesiredScenario.swappedClaim) ? "retirement" : "survivor") + " benefits at age " + dataAlt.selfRejectSwitchAgeInput ? (this.objAdjustedDesiredScenario.swappedClaim) ? this.objAdjustedDesiredScenario.survivorSwitchAgeYears : this.objAdjustedDesiredScenario.clientAgeYears + "y " + (this.objAdjustedDesiredScenario.swappedClaim) ? this.objAdjustedDesiredScenario.survivorSwitchAgeMonths : this.objAdjustedDesiredScenario.clientAgeMonths : (this.objAdjustedDesiredScenario.swappedClaim) ? this.objAdjustedDesiredScenario.spouseAgeYears : this.objAdjustedDesiredScenario.survivorSwitchAgeYears + "y " + (this.objAdjustedDesiredScenario.swappedClaim) ? this.objAdjustedDesiredScenario.spouseAgeMonths : this.objAdjustedDesiredScenario.survivorSwitchAgeMonths + "m" + ". You can try other strategies by re-opening the "
                // //[Alternate/Alt1]
                // + ((this.hasAdjustedFRAScenario) ? "Second Alternate" : "Alternate") + " box"
                // + "<br/>again and changing the claim age(s)." }

              });
            }

            //need to reset the objAdjustedDesiredScenario object
            if (this.objAdjustedDesiredScenario.swappedClaim) {
              if (dataAlt.selfRejectSwitchAgeInput) {
                this.objAdjustedDesiredScenario.clientAgeYears = 0;
                this.objAdjustedDesiredScenario.clientAgeMonths = 0;
              } else {
                this.objAdjustedDesiredScenario.spouseAgeYears = 0;
                this.objAdjustedDesiredScenario.spouseAgeMonths = 0;
              }
            } else {
              this.objAdjustedDesiredScenario.survivorSwitchAgeYears = 0;
              this.objAdjustedDesiredScenario.survivorSwitchAgeMonths = 0;
            }

            //reset profile IF SAVED
            if (this.objAdjustedDesiredScenario.saveDCA && hasAlreadyRan && this.isAlreadyInitializeComponent && !this.isFRABeingAdjusted) {
              console.log('save has clicked/checked');

              //need to call: updateClientProfile(this.objAdjustedDesiredScenario);
              //need to save/set SSDesiredAgeYears/months to 0 depending on client or spouse
              //this.updateClientProfile(this.objAdjustedDesiredScenario);                
            }

            if (this.isFRABeingAdjusted) {
              this.isFRABeingAdjusted = false;
            }
          } else {
            /* if(localStorage.getItem('displayDCANotification')){
              localStorage.removeItem('displayDCANotification');
              const dialogRef = this.dialog.open(BasicQuestionComponent, {     
                data: { title: 'Notification!', 
                btnYesTitle: 'I Understand',
                question: "A previously entered desired claim age has been removed from this case profile because the month selected has since occurred.<br/>A new desired claim age may now be added and saved." }
              });
            } */
          }

          console.log('this.objAdjustedDesiredScenario', this.objAdjustedDesiredScenario)
          if (this.illustrationsTypes.length > 3 || hasAlreadyRan) {
            this.colorScheme.domain.pop();
            this.illustrationsTypes.pop();

            this.lineGraphData = null;
            this.comparisonGraph = this.createComparisonGraphData(this.ssData.costsByCareAndRegionBody);

          }
          this.colorScheme.domain.push("#0a4e8d");
          //this.illustrationsTypes.push("Alternate");
          //this.illustrationsTypes.push((this.hasAdjustedFRAScenario) ? "Second Alternate" : "Alternate");
          this.illustrationsTypes.push((this.ssDataAlt.cusRetoFiling) ? (this.hasAdjustedFRAScenario) ? 'Second Alternate (Retroactive File)' : 'Alternate (Retroactive File)' : (this.hasAdjustedFRAScenario) ? 'Second Alternate' : 'Alternate');
          this.comparisonGraph = this.createComparisonGraphData(dataAlt.costsByCareAndRegionBody);

          this.illustrationComparisons.push({ name: 'Alternate vs FRA', data: [alternate, fraIllustration], breakEven: 999 }); //breakEven: 0
          //TODO: def not sure this breakeven is correct for Alternate
          //this.illustrationComparisons[3].breakEven = this.calculateBreakEven(this.illustrationComparisons[3].data[0], this.illustrationComparisons[3].data[1]);

          this.selectedIllustrationIdx = 0;
          this.selectedIllustration = this.illustrationComparisons[this.selectedIllustrationIdx];
          console.log('this.illustrationComparisons', this.illustrationComparisons)
          console.log('selectedIllustration', this.selectedIllustration);
          const chosenAges = {
            client: this.ssDataAlt.cusStartBenLabel.split('/')[0].replace(' month', 'm').replace(' months', 'm').replace('ms', 'm').replace(' and', 'y'),
            partner: this.client.clientProfile.Spouses.length > 0
              ? (this.client.clientProfile.Spouses[0].maritalStatus != "Widowed" && this.client.clientProfile.Spouses[0].maritalStatus != "Divorced")
                ? (this.ssDataAlt.cusStartBenLabel.split('/')[1]
                  ? this.ssDataAlt.cusStartBenLabel.split('/')[1].replace(' month', 'm').replace(' months', 'm').replace('ms', 'm').replace(' and', 'y')
                  : '')
                : ''
              : ''
          };
          

          console.log('am I here today?', chosenAges);

          if (age >= 70 && this.client.clientProfile.SelfAlreadyCollecting != 1) {

            // update alternate one
            // chosenAges.client = age + 'y ' + (this.currentAgeOffset > 0 ? this.clientRetirementMonths + 'm' : '0m');//chosenAges.client.split('y')[1];
            chosenAges.client = age + 'y ' + this.clientRetirementMonths + 'm';

            this.ssObject.selfRetirementYears = age;
            // this.ssObject.selfRetirementMonths = (this.currentAgeOffset > 0) ? this.clientRetirementMonths : 0; 
            this.ssObject.selfRetirementMonths = this.clientRetirementMonths;
            console.log('finding this value22', this.ssObject.selfRetirementMonths);
          }

          let chosenScenario = '';
          if (chosenAges.partner) {
            chosenScenario = `${chosenAges.client} / ${chosenAges.partner}`;
          } else {
            chosenScenario = `${chosenAges.client}`;
          }

          this.scenarioDropDown.scenarios[3] = chosenScenario;

          this.isShowAlternate = true;
          if (this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
            if (this.calculateAge(spouseDOB) >= 70 && this.client.clientProfile.SpouseAlreadyCollecting != 1) {
              chosenAges.partner = this.calculateAge(spouseDOB) + 'y ' + this.spouseRetirementMonths + 'm';// + chosenAges.partner.split('y')[1];
              this.ssObject.spouseRetirementYears = this.calculateAge(spouseDOB);
              // this.ssObject.spouseRetirementMonths = (this.spouseAgeOffSet > 0) ? this.spouseRetirementMonths : 0;
              this.ssObject.spouseRetirementMonths = this.spouseRetirementMonths;
            }
            // if ((this.client.clientProfile.MonthlyBenefitAmount || 0) > 0 && (Utils.formatToNumber(this.client.clientProfile.Spouses[0].monthlyBenefits || 0)) > 0) {
            //   isShowAlternate = false;
            //   //console.log('dont show Alt 02');
            // }
            // console.log('spouseDOB', spouseDOB);
            // console.log('this.client.client.DOB', this.client.client.DOB);
            // if ((this.calculateAge(spouseDOB) >= 70) && (this.calculateAge(this.client.client.DOB) >= 70))  {
            //   isShowAlternate = false;
            //   //console.log('dont show Alt 01');
            // }
            this.isShowAlternate = this.client.clientProfile.SpouseAlreadyCollecting && this.client.clientProfile.SelfAlreadyCollecting ? false : true;
            if ((this.calculateAge(spouseDOB) >= 70) && (this.calculateAge(this.client.client.DOB) >= 70)) {
              this.isShowAlternate = false;
            }
          } else {
            if (this.client.clientProfile.SelfAlreadyCollecting || (this.calculateAge(this.client.client.DOB) >= 70)) {
              // if (((this.client.clientProfile.MonthlyBenefitAmount || 0) > 0) || (this.calculateAge(this.client.client.DOB) >= 70))  {
              this.isShowAlternate = false;
            }
          }
          console.log('this.isShowAlternate', this.isShowAlternate);
          // console.log('chosenAges', chosenAges.client);
          const chosenTotals = { client: this.ssDataAlt.cusSelfBenefit, partner: this.ssDataAlt.cusSpouseBenefit, netOfMedicare: this.ssDataAlt.cusNetOfB, netOfMedicarePercent: this.ssDataAlt.cusPartBPercent, netOfMedicareDollar: this.ssDataAlt.cusPartB }
          let alternateMedicalDeductions = chosenTotals.netOfMedicareDollar + " " + chosenTotals.netOfMedicarePercent;
          // need to hide if single person, or both spouses, have already claimed
          // if client already claimed then clientAge as currentAge
          // if spouse already claimed then partnerAge as currentAge

          if (this.isShowAlternate) {
            var clientRetroDisplayAge = '';
            var partnerRetroDisplayAge = '';

            const earliestAges = { client: this.ssData.earlStartBenLabel.split('/')[0].replace(' month', 'm').replace(' months', 'm').replace('ms', 'm').replace(' and', 'y'), partner: this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].maritalStatus != "Widowed" ? (this.ssData.earlStartBenLabel.split('/')[1] ? this.ssData.earlStartBenLabel.split('/')[1].replace(' month', 'm').replace(' months', 'm').replace('ms', 'm').replace(' and', 'y') : '') : '' : '' };
            if (this.ssDataAlt.cusSelfRetoFiling) {
              clientRetroDisplayAge = earliestAges.client;
            }

            if (this.ssDataAlt.cusSpouseRetoFiling) {
              partnerRetroDisplayAge = earliestAges.partner;
            }

            this.socialSecurityIllustrationCards.push(
              {
                scenario: (this.ssDataAlt.cusRetoFiling) ? (this.hasAdjustedFRAScenario) ? 'Second Alternate (Retroactive File)' : 'Alternate (Retroactive File)' : (this.hasAdjustedFRAScenario) ? 'Second Alternate' : 'Alternate',
                color: '#0a4e8d', clientCurrentAge: this.ssObject.SelfCurrentAge, clientName: this.client.client.FirstName,
                clientFRA: (this.ssDataAlt.cusSelfRetoFiling) ? this.getFRAv2(this.client.client.DOB) : '',
                clientRetroNumMonths: (this.ssDataAlt.cusSelfRetoFiling) ? this.ssDataAlt.cusSelfRetoNumMonths : '',
                clientRetroDisplayAge: (this.ssDataAlt.cusSelfRetoFiling) ? clientRetroDisplayAge : '',
                partnerFRA: (this.ssDataAlt.cusSpouseRetoFiling && this.client.clientProfile.Spouses[0].maritalStatus == "Married") ? this.getFRAv2(spouseDOB) : '',
                partnerRetroNumMonths: (this.ssDataAlt.cusSpouseRetoFiling) ? this.ssDataAlt.cusSpouseRetoNumMonths : '',
                partnerRetroDisplayAge: (this.ssDataAlt.cusSpouseRetoFiling) ? partnerRetroDisplayAge : '',
                clientAge: chosenAges.client, clientTotal: chosenTotals.client, partnerName: (this.client.clientProfile.Spouses.length > 0) ? (this.client.clientProfile.Spouses[0].maritalStatus != "Widowed" && this.client.clientProfile.Spouses[0].maritalStatus != "Divorced") ? this.client.clientProfile.Spouses[0].firstName : '' : '',
                partnerAge: chosenAges.partner, partnerCurrentAge: this.ssObject.SpouseCurrentAge, partnerTotal: chosenTotals.partner, medicareDeductions: alternateMedicalDeductions, netOfMedicare: chosenTotals.netOfMedicare, displayRemoveAltIcon: !(this.client.clientProfile.SSDesiredAgeYears),
                dependentChildrenSumTotal: this.ssDataAlt.depChildrenSumTotal
              }
            );
            console.log('this.socialSecurityIllustrationCards', this.socialSecurityIllustrationCards);

            this.setScenario = this.socialSecurityIllustrationCards[3];

            let alternateClaimAges = this.ssDataAlt.cusStartBenLabel.split('/');
            let clientAlternateClaim = [], spouseAlternateClaim = [];

            if (!alternateClaimAges.length)
              alternateClaimAges = [this.ssDataAlt.cusStartBenLabel];

            clientAlternateClaim = alternateClaimAges[0].split(" and ");
            clientAlternateClaim[1] = clientAlternateClaim[1].replace(" months", "").replace(" month", "");

            if (this.ssDataAlt.cusStartBenLabel.split('/').length > 1) {
              spouseAlternateClaim = alternateClaimAges[1].split(" and ");
              spouseAlternateClaim[1] = spouseAlternateClaim[1].replace(" months", "").replace(" month", "");
            }

            this.socialSecurityBenefitCards.push(
              //{ scenario: 'Alternate', color: '#0a4e8d', amount: Utils.formatToCurrency(Utils.formatToNumber(chosenTotals.client) + Utils.formatToNumber(chosenTotals.partner)), includeCheck: false }
              { scenario: (this.ssDataAlt.cusRetoFiling) ? (this.hasAdjustedFRAScenario) ? 'Second Alternate (Retroactive File)' : 'Alternate (Retroactive File)' : (this.hasAdjustedFRAScenario) ? 'Second Alternate' : 'Alternate', color: '#0a4e8d', amount: this.ssDataAlt.cusTotalBenefit, includeCheck: false, ages: { clientAge: clientAlternateClaim[0], clientMonths: clientAlternateClaim[1], spouseAge: spouseAlternateClaim[0], spouseMonths: spouseAlternateClaim[1] } }
            );
          }


          // dataAlt.selfRejectSwitchAgeInput || dataAlt.spouseRejectSwitchAgeInput

          // this.setSelectedLifeExpectancyPoint();

          // //check if the TBC was adjusted, if so, recalc Alts for TBC
          // if(this.newSSObject){
          //   //need to recalc benefits if dropdown for LE changed with added Alt
          //   this.totalBenefitCalc(this.newSSObject);
          // }

          //this.isAlreadyInitializeComponent = true;
          //this.loadingService.isLoading(false);

          var isSurvivorBenefit = false;
          if (this.isAutoAlternateSurvivorBenefit) {
            isSurvivorBenefit = ((this.objAdjustedDesiredScenario.clientAgeYears || 0) > 0 && (this.objAdjustedDesiredScenario.spouseAgeYears || 0)  > 0) ? true : false;
           }

           if (isSurvivorBenefit) {
            if(this.client.clientProfile.Spouses[0].maritalStatus != 'Widowed') {
              if (this.client.clientProfile.Spouses[0].maritalStatus == 'Single' || this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced') {
                for (let spouse of this.client.clientProfile.Spouses) {
                  if (spouse.maritalStatus == 'Divorced' && !spouse.alive && spouse.tenyears){ // && !this.isFRAAlt) {
                    this.isShowSurvivorSection = true;    
                    console.log('we divorced');             
                  }
                }
                if (this.client.clientProfile.Spouses[0].maritalStatus == 'Single' && !this.client.clientProfile.Spouses[1].alive && this.client.clientProfile.Spouses[1].tenyears) {
                  this.isShowSurvivorSection = true;
                }
              }
              if(this.client.clientProfile.Spouses && this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
                let clientAge = this.calculateAge(this.client.client.DOB);
                let spouseAge = this.calculateAge(this.client.clientProfile.Spouses[0].dob);
                if((this.client.clientProfile.LifeExpectancy - clientAge) + spouseAge <= 60
                || (this.client.clientProfile.LifeExpectancy - clientAge) + spouseAge <= 69
                || (this.client.clientProfile.Spouses[0].LifeExpectancy - spouseAge) + clientAge <= 69){
                  this.isShowSurvivorSection = true;
                }
              }
             } else {
              this.isShowSurvivorSection = true;
             }
           }
           
          if(this.isAutoAlternateSurvivorBenefit && isSurvivorBenefit && !this.isPageReloadOtherThanFRACall && this.isShowSurvivorSection) {
            // isSpouseSurvivor
            if (!this.isSpouseSurvivor) {
              console.log('here i am 01');
              let survivorAgeYears = this.ssDataAlt.autoSurvivorAgeYear;
              let survivorAgeMonths = this.ssDataAlt.autoSurvivorAgeMonth;
              console.log('this.client.clientProfile', this.client.clientProfile);
              if (this.client.clientProfile.SSDesiredAgeYears == survivorAgeYears && this.client.clientProfile.SSDesiredAgeMonths == survivorAgeMonths) {
                this.isAutoAlternateSurvivorBenefit = false;
              }
              if (this.isAutoAlternateSurvivorBenefit) {
                // if (this.objAdjustedDesiredScenario.swappedClaim) {
                  console.log('here i am 02');
                  console.log('data', data);
                  this.objAdjustedDesiredScenario.clientAgeYears = survivorAgeYears;
                  this.objAdjustedDesiredScenario.clientAgeMonths = survivorAgeMonths;
                  let retirementMonths = (this.objAdjustedDesiredScenario.survivorSwitchAgeYears || 0) * 12 + (this.objAdjustedDesiredScenario.survivorSwitchAgeMonths || 0);
                  let survivorMonths = (this.objAdjustedDesiredScenario.clientAgeYears || 0) * 12 + (this.objAdjustedDesiredScenario.clientAgeMonths || 0);
                  console.log('retirementMonths', retirementMonths)
                  console.log('survivorMonths', survivorMonths)
                  if (retirementMonths > survivorMonths) {
                    console.log('here i am')
                    this.objAdjustedDesiredScenario.swappedClaim = false;
                  } else {
                    this.objAdjustedDesiredScenario.swappedClaim = true;
                  }
                  if (data) {
                    data.SSDesiredAgeYears = survivorAgeYears;
                    data.SSDesiredAgeMonths = survivorAgeMonths;
                    if (retirementMonths > survivorMonths) {
                      data.invertSurvivorSwitch = true;
                    } else {
                      data.invertSurvivorSwitch = false;
                    }
                    if(data.saveDCA){
                      console.log('saved modal data', data);
                      //save the claim ages to the client and/or spouse profiles
                      this.updateClientProfile(data);
                    }
                  }
                // }
              }

            } else {
              console.log('here i am 01');
              let survivorAgeYears = this.ssDataAlt.autoSurvivorAgeYear;
              let survivorAgeMonths = this.ssDataAlt.autoSurvivorAgeMonth;
              console.log('this.client.clientProfile', this.client.clientProfile);
              if (this.client.clientProfile.Spouses[0].sSDesiredAgeYears == survivorAgeYears && this.client.clientProfile.Spouses[0].sSDesiredAgeMonths == survivorAgeMonths) {
                this.isAutoAlternateSurvivorBenefit = false;
              }
              if (this.isAutoAlternateSurvivorBenefit) {
                // if (this.objAdjustedDesiredScenario.swappedClaim) {
                  console.log('here i am 02');
                  console.log('data', data);
                  console.log('this.objAdjustedDesiredScenario', this.objAdjustedDesiredScenario)
                  this.objAdjustedDesiredScenario.spouseAgeYears = survivorAgeYears;
                  this.objAdjustedDesiredScenario.spouseAgeMonths = survivorAgeMonths;
                  let retirementMonths = (this.objAdjustedDesiredScenario.survivorSwitchAgeYears || 0) * 12 + (this.objAdjustedDesiredScenario.survivorSwitchAgeMonths || 0);
                  let survivorMonths = (this.objAdjustedDesiredScenario.spouseAgeYears || 0) * 12 + (this.objAdjustedDesiredScenario.spouseAgeMonths || 0);
                  console.log('retirementMonths', retirementMonths)
                  console.log('survivorMonths', survivorMonths)
                  if (retirementMonths > survivorMonths) {
                    console.log('here i am')
                    this.objAdjustedDesiredScenario.swappedClaim = false;
                  } else {
                    this.objAdjustedDesiredScenario.swappedClaim = true;
                  }
                  if (data) {
                    data.Spouses[0].sSDesiredAgeYears = survivorAgeYears;
                    data.Spouses[0].sSDesiredAgeMonths = survivorAgeMonths;
                    if (retirementMonths > survivorMonths) {
                      data.invertSurvivorSwitch = true;
                    } else {
                      data.invertSurvivorSwitch = false;
                    }
                    if(data.saveDCA){
                      console.log('saved modal data', data);
                      //save the claim ages to the client and/or spouse profiles
                      this.updateClientProfile(data);
                    }
                  }
                // }
              }

            }

            console.log('this.objAdjustedDesiredScenario', this.objAdjustedDesiredScenario);
            if (this.isAutoAlternateSurvivorBenefit) {
              const dialogRef = this.dialog.open(BasicQuestionComponent, {    
                data: { title: 'Notification!', 
                btnYesTitle: 'I Understand',
                question: "The retirement benefit claim age entered will result in a spousal benefit being collected while both spouses are living. In this case, SSA will automatically switch the widow to a survivor benefit upon the spouse's death, therefore, the survivor claim age entered has been overridden to match the age at which widowhood begins." }
              }); 
            }
             
          } else if(this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' && this.includeSpouse){
            //if Single/Divorced
            
          } else if(this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed' && this.includeSpouse){
            //if Single/Divorced turned Widowed
            if(this.client.clientProfile.Spouses[0].tenyears && !this.client.clientProfile.Spouses[0].alive){
              if(this.objAdjustedDesiredScenario.swappedClaim && this.objAdjustedDesiredScenario.clientAgeYears && !this.objAdjustedDesiredScenario.survivorSwitchAgeYears){

                var sYears = this.objAdjustedDesiredScenario.survivorSwitchAgeYears;
                var sMonths = this.objAdjustedDesiredScenario.survivorSwitchAgeMonths;
                var rYears = this.objAdjustedDesiredScenario.clientAgeYears;
                var rMonths = this.objAdjustedDesiredScenario.clientAgeMonths;

                this.objAdjustedDesiredScenario.survivorSwitchAgeYears = rYears;
                this.objAdjustedDesiredScenario.survivorSwitchAgeMonths = rMonths;

                this.objAdjustedDesiredScenario.clientAgeYears = sYears;
                this.objAdjustedDesiredScenario.clientAgeMonths = sMonths;
              }
            }
          }

          this.loadingService.isLoading(false);
        },
        error => {
          this.error = <any>error
          //console.log('we errored in SS Alt', this.error);
          this.loadingService.isLoading(false);
        });
  }

  hasTBCBeenAdjustedAfterPageLoad: boolean = false;
  totalBenefitCalc() {
    this.loadingService.isLoading(true);
    this.previousSSObject.SelfLifeExpectancy = this.socialSecurityForm.value.selfLifeExpectancy;

    // let recalcTBC = this.socialSecurityForm.value.selfLifeExpectancy != this.client.clientProfile.LifeExpectancy;

    if (this.previousSSObjectAlt)
      this.previousSSObjectAlt.SelfLifeExpectancy = this.socialSecurityForm.value.selfLifeExpectancy;

    if (this.includeSpouse) {
      // recalcTBC = recalcTBC || this.socialSecurityForm.value.spouseLifeExpectancy != this.client.clientProfile.Spouses[0].LifeExpectancy;

      this.previousSSObject.SpouseLifeExpectancy = this.socialSecurityForm.value.spouseLifeExpectancy;
      if (this.previousSSObjectAlt)
        this.previousSSObjectAlt.SpouseLifeExpectancy = this.socialSecurityForm.value.spouseLifeExpectancy;
    }

    if (this.previousSSObject){
      this.previousSSObject.FrmDiscountRate = this.socialSecurityForm.get('inflationRate').value.replace('%', '') / 100;
      this.previousSSObject.IsPresentValue = this.isPresentValue ? 1 : 0;
    }

    console.log('TBC Request Object', this.previousSSObject);
    if (true) {
      this.globalService.getSSData(this.previousSSObject, this.userForm.value)
        .subscribe(
          data => { // Get Earliest & FRA (or alt 2)
            console.log('TBC Return Object', data);
            const scenario = (this.hasAdjustedFRAScenario) ? 'First Alternate' + ((data.cusSelfRetoFiling || data.cusSpouseRetoFiling) ? " (Retroactive File)" : "") : 'FRA';
            //!this.hasAdjustedFRAScenario ? 'FRA' : 'First Alternate';

            let earliestClaimAges = data.earlStartBenLabel.split('/');
            let clientEarliestClaim = [], spouseEarliestClaim = [];

            if (!earliestClaimAges.length)
              earliestClaimAges = [data.earlStartBenLabel];

            clientEarliestClaim = earliestClaimAges[0].split(" and ");
            clientEarliestClaim[1] = clientEarliestClaim[1].replace(" months", "").replace(" month", "");

            if (data.earlStartBenLabel.split('/').length > 1) {
              spouseEarliestClaim = earliestClaimAges[1].split(" and ");
              spouseEarliestClaim[1] = spouseEarliestClaim[1].replace(" months", "").replace(" month", "");
            }

            let alternateClaimAges = data.cusStartBenLabel.split('/');
            let clientAlternateClaim = [], spouseAlternateClaim = [];

            if (!alternateClaimAges.length)
              alternateClaimAges = [data.cusStartBenLabel];

            clientAlternateClaim = alternateClaimAges[0].split(" and ");
            clientAlternateClaim[1] = clientAlternateClaim[1].replace(" months", "").replace(" month", "");

            if (data.cusStartBenLabel.split('/').length > 1) {
              spouseAlternateClaim = alternateClaimAges[1].split(" and ");
              spouseAlternateClaim[1] = spouseAlternateClaim[1].replace(" months", "").replace(" month", "");
            }

            const previousSSOBjectModifiedForOptimal = JSON.parse(JSON.stringify(this.previousSSObject));

            let optimalClaimAges = this.origSSData.opStartBenLabel.split('/');
            let clientClaim = [], spouseClaim = [];

            if (!optimalClaimAges.length)
              optimalClaimAges = [this.origSSData.opStartBenLabel];

            clientClaim = optimalClaimAges[0].split(" and ");
            clientClaim[1] = clientClaim[1].replace(" months", "").replace(" month", "");

            if (this.origSSData.opStartBenLabel.split('/').length > 1) {
              spouseClaim = optimalClaimAges[1].split(" and ");
              spouseClaim[1] = spouseClaim[1].replace(" months", "").replace(" month", "");
            }

            previousSSOBjectModifiedForOptimal.selfRetirementYears = Number(clientClaim[0] || 0);
            previousSSOBjectModifiedForOptimal.selfRetirementMonths = Number(clientClaim[1] || 0);
            previousSSOBjectModifiedForOptimal.spouseRetirementYears = Number(spouseClaim[0] || 0);
            previousSSOBjectModifiedForOptimal.spouseRetirementMonths = Number(spouseClaim[1] || 0);

            //TODO: need to figure out if Optimal has a switch on first page load and update the previousSSOBjectModifiedForOptimal object
            //previousSSOBjectModifiedForOptimal.SurvivorSwitchYears = data.OptSurvivorSwitchYear;
            //previousSSOBjectModifiedForOptimal.SurvivorSwitchMonths = data.OptSurvivorSwitchMonth;
            previousSSOBjectModifiedForOptimal.invertSurvivorSwitch = (this.origSSData.OptSurvivorSwitchInverted) ? 1 : 0;
            if(this.origSSData.OptSurvivorSwitchInverted && this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed'){
              //var yearsS = previousSSOBjectModifiedForOptimal.SurvivorSwitchYears;
              //var monthsS = previousSSOBjectModifiedForOptimal.SurvivorSwitchMonths;
              var yearsR = previousSSOBjectModifiedForOptimal.selfRetirementYears;
              var monthsR = previousSSOBjectModifiedForOptimal.selfRetirementMonths;

              previousSSOBjectModifiedForOptimal.SurvivorSwitchYears = Number(clientClaim[0] || 0);//yearsR;//63
              previousSSOBjectModifiedForOptimal.SurvivorSwitchMonths = Number(clientClaim[1] || 0);//monthsR;//7
              previousSSOBjectModifiedForOptimal.selfRetirementYears = this.ssData.OptSurvivorSwitchYear;//66;//yearsS;
              previousSSOBjectModifiedForOptimal.selfRetirementMonths = this.ssData.OptSurvivorSwitchMonth;//0;//monthsS;
            }

            console.log('previousSSOBjectModifiedForOptimal', previousSSOBjectModifiedForOptimal);

            var optimalOnPageLoad = this.socialSecurityBenefitCards[2];
            
            if (previousSSOBjectModifiedForOptimal)
              previousSSOBjectModifiedForOptimal.FrmDiscountRate = this.socialSecurityForm.get('inflationRate').value.replace('%', '') / 100;

            console.log('optimalOnPageLoad', optimalOnPageLoad);
            this.globalService.getSSData(previousSSOBjectModifiedForOptimal, this.userForm.value)
              .subscribe(
                data2 => { // Get new Optimal (since we reuse original optimal claim year and month)
                  console.log('TBC new Optimal', data2);
                  if (!this.previousSSObjectAlt) {
                    //var benefit = Utils.removeCurrencyFormatting(data2.cusTotalBenefit) + Utils.removeCurrencyFormatting(data2.depChildrenSumTotal);
                    //data2.cusTotalBenefit = Utils.formatToCurrency(Math.round(benefit));

                    //HACK 122223: for ticket HPV-2314 - peronsal benefits issues in BuildIllustration for Optimal
                    if(this.includeSpouse && this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed'){
                      var benefit = Utils.removeCurrencyFormatting(data2.cusTotalBenefit) + Utils.removeCurrencyFormatting(data2.depChildrenSumTotal);
                      data2.cusTotalBenefit = Utils.formatToCurrency(Math.round(benefit) + Math.round(this.ssData.p1OptimalPersonalBen) + Math.round(this.ssData.p2OptimalPersonalBen));
                    }

                    console.log('TBC 1');
                    this.socialSecurityBenefitCards = [
                      { scenario: (data.earlRetoFiling) ? 'Earliest (Retroactive File)' : 'Earliest', color: '#5d80c0', amount: data.earlTotalBenefit, includeCheck: false, ages: { clientAge: clientEarliestClaim[0], clientMonths: clientEarliestClaim[1], spouseAge: spouseEarliestClaim[0], spouseMonths: spouseEarliestClaim[1] } },
                      (this.hasAdjustedFRAScenario && !this.hasTBCBeenAdjustedAfterPageLoad) ? this.socialSecurityBenefitCards[1] : 
                      { scenario, color: '#73bcb8', amount: data.cusTotalBenefit, includeCheck: false, ages: { clientAge: clientAlternateClaim[0], clientMonths: clientAlternateClaim[1], spouseAge: spouseAlternateClaim[0], spouseMonths: spouseAlternateClaim[1] } },
                      { scenario: (data.optRetoFiling) ? 'Optimal (Retroactive File)' : 'Optimal', color: '#8d68dd', 
                      //amount: (this.hasAdjustedFRAScenario && !this.hasTBCBeenAdjustedAfterPageLoad) ? data2.earlTotalBenefit : data.cusTotalBenefit,  
                      amount: ((this.hasAlternateScenario || this.hasAdjustedFRAScenario) && !this.hasTBCBeenAdjustedAfterPageLoad) 
                        ? optimalOnPageLoad.amount //data2.opTotalBenefit 
                        //two lines below are removed cause we are not supposed to optimze Optimal here
                        //: (Utils.removeCurrencyFormatting(data.earlTotalBenefit) > Utils.removeCurrencyFormatting(data2.cusTotalBenefit)) 
                          //? data.earlTotalBenefit 
                        : data2.cusTotalBenefit, 
                      //amount: (this.hasAlternateScenario && !this.hasTBCBeenAdjustedAfterPageLoad) ? optimalOnPageLoad.amount : data2.cusTotalBenefit, 
                        includeCheck: true, ages: { clientAge: previousSSOBjectModifiedForOptimal.selfRetirementYears, clientMonths: previousSSOBjectModifiedForOptimal.selfRetirementMonths, spouseAge: previousSSOBjectModifiedForOptimal.spouseRetirementYears, spouseMonths: previousSSOBjectModifiedForOptimal.spouseRetirementMonths } }
                    ];
                    this.loadingService.isLoading(false);
                  }

                  if (this.previousSSObjectAlt) {
                    console.log('TBC 2');
                    
                    this.ssObject.FrmDiscountRate = this.socialSecurityForm.get('inflationRate').value.replace('%', '') / 100;

                    this.globalService.getSSData(this.previousSSObjectAlt, this.userForm.value)
                      .subscribe(
                        data3 => { // Get alternate

                          //HACK 122223: for ticket HPV-2314 - peronsal benefits issues in BuildIllustration for Optimal
                          if(this.includeSpouse && this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed'){
                            var benefit = Utils.removeCurrencyFormatting(data2.cusTotalBenefit);
                            data2.cusTotalBenefit = Utils.formatToCurrency(Math.round(benefit) + Math.round(this.ssData.p1OptimalPersonalBen) + Math.round(this.ssData.p2OptimalPersonalBen));
                          }

                          this.socialSecurityBenefitCards = [
                            { scenario: (data.earlRetoFiling) ? 'Earliest (Retroactive File)' : 'Earliest', color: '#5d80c0', amount: data.earlTotalBenefit, includeCheck: false, ages: { clientAge: clientEarliestClaim[0], clientMonths: clientEarliestClaim[1], spouseAge: spouseEarliestClaim[0], spouseMonths: spouseEarliestClaim[1] } },
                            //HACK 110823: ZSS added because FRA, when adjusted, is using the originally stored object for this call, which displays the wrong values
                            //since we already set this in getSSData, and when adjusting the FRA to First Alt this object already gets set, just reuse the object
                            (this.hasAdjustedFRAScenario && !this.hasTBCBeenAdjustedAfterPageLoad) ? this.socialSecurityBenefitCards[1] : 
                            { scenario, color: '#73bcb8', amount: data.cusTotalBenefit, includeCheck: false, ages: { clientAge: clientAlternateClaim[0], clientMonths: clientAlternateClaim[1], spouseAge: spouseAlternateClaim[0], spouseMonths: spouseAlternateClaim[1] } },
                            { scenario: (data.optRetoFiling) ? 'Optimal (Retroactive File)' : 'Optimal', color: '#8d68dd', 
                              //HACK 110823: ZSS issue if you just update Alt on page load, it was also updating Optimal on screen in UI
                              //amount: data2.opTotalBenefit, 
                              //amount: (this.storedOriginalOptimalTotals && this.hasAlternateScenario && !this.hasTBCBeenAdjustedAfterPageLoad) 
                              //  ? Utils.formatToCurrency(Utils.formatToNumber(this.storedOriginalOptimalTotals.client) + Utils.formatToNumber((this.storedOriginalOptimalTotals.partner) ? this.storedOriginalOptimalTotals.partner : 0)) 
                              //  : data2.opTotalBenefit, 
                              amount: ((this.hasAlternateScenario || this.hasAdjustedFRAScenario) && !this.hasTBCBeenAdjustedAfterPageLoad) 
                                ? optimalOnPageLoad.amount //data2.opTotalBenefit 
                                //two lines below are removed cause we are not supposed to optimze Optimal here
                                //: (Utils.removeCurrencyFormatting(data.earlTotalBenefit) > Utils.removeCurrencyFormatting(data2.cusTotalBenefit) && this.hasAdjustedFRAScenario) 
                                //  ? data.earlTotalBenefit 
                                : data2.cusTotalBenefit, 
                              includeCheck: true, ages: { clientAge: previousSSOBjectModifiedForOptimal.selfRetirementYears, clientMonths: previousSSOBjectModifiedForOptimal.selfRetirementMonths, spouseAge: previousSSOBjectModifiedForOptimal.spouseRetirementYears, spouseMonths: previousSSOBjectModifiedForOptimal.spouseRetirementMonths } }
                          ];

                          if (this.hasAlternateScenario)
                            this.socialSecurityBenefitCards.push({ scenario: ((this.hasAdjustedFRAScenario) ? 'Second Alternate' : 'Alternate') + ((data3.cusSelfRetoFiling || data3.cusSpouseRetoFiling) ? " (Retroactive File)" : ""), 
                              color: '#0a4e8d', amount: data3.cusTotalBenefit, includeCheck: false, 
                              ages: { clientAge: this.previousSSObjectAlt.selfRetirementYears, clientMonths: this.previousSSObjectAlt.selfRetirementMonths, 
                                //HACK 110823: ZSS when adjusting the Alt of a widowed/divored and not alive spouse, we adjust the objects for use in other areas of code for spousal values to be passed to API
                                //this section then displays them when it shouldnt cause we dont display them in the DCA modal - so, set to zeros for display on Widows
                                spouseAge: (this.includeSpouse && this.client.clientProfile.Spouses[0].maritalStatus == 'Married') ? this.previousSSObjectAlt.spouseRetirementYears : 0, 
                                spouseMonths: (this.includeSpouse && this.client.clientProfile.Spouses[0].maritalStatus == 'Married') ? this.previousSSObjectAlt.spouseRetirementMonths : 0 } })
                          this.loadingService.isLoading(false);
                        }
                      )
                  }
                }
              )
          }
        )
    }
  }

  handleEditClientModal() {
    this.modalService.add('add-edit-client', { ID: 0 });
  }

  isPresentValue: boolean = false;
  hasDurationBeenToggled: boolean = false;
  isAutoAlternateSurvivorBenefit: boolean = false;
  isAutoFRASurvivorBenefit: boolean = false;
  toggleDuration() {
    this.loadingService.isLoading(true);
    this.isPageReloadOtherThanFRACall = true;
    this.presentValue = !this.presentValue;
    this.isPresentValue = !this.isPresentValue;
    this.hasDurationBeenToggled = true;
    //this.objAdjustedFRAScenario = null;

    var objAdjustedFRAScenarioClone;
    if(this.objAdjustedFRAScenario){
      objAdjustedFRAScenarioClone = { ...this.objAdjustedFRAScenario };
    }

    // this.objAdjustedFRAScenario = null;
    this.getSSData();

    if(objAdjustedFRAScenarioClone){
      this.objAdjustedFRAScenario = objAdjustedFRAScenarioClone;
    }
    console.log('PV toggle', this.objAdjustedFRAScenario);
    this.getSSDataFRAAlt();
  }

  toggleCashFlow(){
    this.displayYearByYearBreakdown = !this.displayYearByYearBreakdown;
  }

  calculateBreakEven(illA, illB) {
    var beIndex = 0;
    var cummulativeA = 0, cummulativeB = 0;

    for (var i = 0; i < illA.length; i++) {
      cummulativeA += Number(illA[i].totalAnnualAmount.replace(/,/g, "").replace("$", ""));
      cummulativeB += Number(illB[i].totalAnnualAmount.replace(/,/g, "").replace("$", ""));

      if (cummulativeA < cummulativeB && !beIndex) {
        beIndex = i;
      }
    }

    return beIndex;
  }

  calculateAge(birthday) {
    birthday = new Date(birthday);
    let currentDate = new Date();
    let currentAgeOffset = (currentDate.getMonth() < birthday.getMonth()) ? 1 : 0;
    // console.log('currentAgeOffset', currentAgeOffset);
    let currentAge = (currentDate.getFullYear() - birthday.getFullYear()) - currentAgeOffset;
    return currentAge;
    // console.log('birthday', birthday);
    // var ageDifMs = Date.now() - birthday;
    // // console.log('ageDifMs', ageDifMs);
    // var ageDate = new Date(ageDifMs);
    // return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  formatGridData(data) {
    var temparray = [], chunk = 31;
    var tempSpouseArray = [];

    if (data == null)
      return;

    if (this.includeSpouse && this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
      for (var i = 0, j = data.length; i < j; i += chunk) {
        temparray.push(data.slice(i, i + chunk));
      }
    } else {
      for (var i = 0; i < data.length; i++) {
        temparray.push(data[i]);
      }
    }

    if (this.includeSpouse && this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
      var tempRow;
      for (var i = 0; i < temparray.length; i++) {
        tempRow = [];

        for (var jj = 0; jj < temparray.length; jj++) {
          tempRow.push(temparray[jj][i]);
        }

        tempSpouseArray.push(tempRow);
      }
    }

    return !this.includeSpouse || (this.includeSpouse && this.client.clientProfile.Spouses[0].maritalStatus != 'Married') ? temparray : tempSpouseArray;
  }

  lineGraphData;
  createComparisonGraphData(data) {
    data = data.replace(/<tr>/g, '');
    data = data.replace(/<\/tr>/g, '%END%');
    data = data.split('%END%');

    if(this.lineGraphData){
      var result2 = this.lineGraphData, item;
      item = {
        name: this.illustrationsTypes[3],
        series: []
      }

      for (var t = 0; t < data.length; t++) {
        var dataItem = data[t].replace(/<th>/g, '');
        dataItem = dataItem.replace(/<\/th>/g, '%END%');
        dataItem = dataItem.replace('Ages', '').split('%END%');

        if (dataItem[1] && dataItem[0]) {
          
          var ages = dataItem[0];
          var illustrations = dataItem[1].replace(/<td>/g, '');
          illustrations = illustrations.replace(/<\/td>/g, '%END%');
          illustrations = illustrations.split('%END%');

          // console.log('ALT: in the 1-0 area', illustrations);

          item.series.push({
            name: ages,
            value: Number(illustrations[1]).toFixed(0) || 0
          })
        }

      }
      result2.push(item);
      Object.assign(this, { val: [...result2] });

    } else {

      //this.lineGraphData = data;
      var result = [], item;

      for (var i = 0; i < this.illustrationsTypes.length; i++) {
        item = {
          name: this.illustrationsTypes[i],
          series: []
        }

        // console.log('data.length', data.length);
        for (var j = 0; j < data.length; j++) {
          var dataItem = data[j].replace(/<th>/g, '');
          // console.log('dataItem', dataItem);
          dataItem = dataItem.replace(/<\/th>/g, '%END%');
          dataItem = dataItem.replace('Ages', '').split('%END%');

          if (dataItem[1] && dataItem[0]) {
            var ages = dataItem[0];
            var illustrations = dataItem[1].replace(/<td>/g, '');
            illustrations = illustrations.replace(/<\/td>/g, '%END%');
            illustrations = illustrations.split('%END%');

            // console.log('in the 1-0 area', illustrations);

            item.series.push({
              name: ages,
              value: Number(illustrations[i]).toFixed(0) || 0
            })
          }

        }
        result.push(item);
      }
      this.lineGraphData = result;
      // console.log('this.lineGraphData', this.lineGraphData);
      Object.assign(this, { val: result });
      
    }

    //Object.assign(this, { val: result });
    return {};
  }

  updateClientProfile(data){
    var UserModel = {
      ID: this.client.client ? this.client.client.ID : 0,
      FirstName: this.client.client.FirstName,
      LastName: this.client.client.LastName,
      AdvisorID: this.client.client.AdvisorID,
      OrganizationID: this.client.client.OrganizationID,
      Username: this.client.client.Username,
      GenderID: this.client.client.GenderID,
      DOB: this.client.client.DOB,
      Email: this.client.client.Email,
      Phone: this.client.client.Phone,
      Address: this.client.client.Address,
      City: this.client.client.City,
      State: this.client.client.State,
      Zip: this.client.client.Zip,
    }

    if(this.includeSpouse){
      this.client.clientProfile.Spouses[0].sSDesiredAgeYears = data.spouseAgeYears;
      this.client.clientProfile.Spouses[0].sSDesiredAgeMonths = data.spouseAgeMonths;

      this.backUpClient.clientProfile.Spouses[0].sSDesiredAgeYears = data.spouseAgeYears;
      this.backUpClient.clientProfile.Spouses[0].sSDesiredAgeMonths = data.spouseAgeMonths;
    }

    var ClientProfile = {
      ClientID: this.client.clientProfile.ClientID,
      MaritalStatus: this.client.clientProfile.MaritalStatus,
      CurrentIncome: this.client.clientProfile.CurrentIncome,
      IRR: this.client.clientProfile.IRR,
      SelfIRR: this.client.clientProfile.IRR,
      RetirementAge: this.client.clientProfile.RetirementAge,
      RetirementState: this.client.clientProfile.RetirementState,
      SpouseID: this.client.clientProfile.SpouseID,
      LifeExpectancy: this.client.clientProfile.LifeExpectancy,
      HCHBP: this.client.clientProfile.HCHBP ? 1 : 0,
      HCHC: this.client.clientProfile.HCHC ? 1 : 0,
      HCT2D: this.client.clientProfile.HCT2D ? 1 : 0,
      HCCD: this.client.clientProfile.HCCD ? 1 : 0,
      HCC: this.client.clientProfile.HCC ? 1 : 0,
      HCT: this.client.clientProfile.HCT ? 1 : 0,      
      HCT1D: this.client.clientProfile.HCT1D ? 1 : 0,
      HCMS: this.client.clientProfile.HCMS ? 1 : 0,
      HCDCW: this.client.clientProfile.HCDCW ? 1 : 0,
      HCFHDC: this.client.clientProfile.HCFHDC ? 1 : 0,
      
      HCALZ: this.client.clientProfile.HCALZ ? 1 : 0,
      HCPARK: this.client.clientProfile.HCPARK ? 1 : 0,
      HCAMP: this.client.clientProfile.HCAMP ? 1 : 0,
      HCPTSD: this.client.clientProfile.HCPTSD ? 1 : 0,
      HCOBS: this.client.clientProfile.HCOBS ? 1 : 0,

      HCCDYrsDiag: this.client.clientProfile.HCCDYrsDiag ? 1 : 0,
      HCCYrsDiag: this.client.clientProfile.HCCYrsDiag ? 1 : 0,      
      Children: this.client.clientProfile.Children && this.client.clientProfile.Children.length > 0 ? this.client.clientProfile.Children : null,//JSON.stringify(this.client.clientProfile.Children),
      IncludePension: this.client.clientProfile.IncludePension,      
      SelfPIA: (this.client.clientProfile.PIA) ? this.client.clientProfile.PIA : 0,
      PIA: this.client.clientProfile.PIA,
      PIAYears: this.client.clientProfile.PIAYears,
      SelfAlreadyCollecting: this.client.clientProfile.SelfAlreadyCollecting,
      SelfCurrentMonthlyBenefit: this.client.clientProfile.SelfCurrentMonthlyBenefit,//this is usually defaulted as an empty string is no value (not sure if thats an issue)
      MonthlyBenefitAmount: this.client.clientProfile.MonthlyBenefitAmount,//this is usually defaulted as an empty string is no value (not sure if thats an issue)
      SpouseAlreadyCollecting: this.client.clientProfile.SpouseAlreadyCollecting, 
	    SpouseCurrentMonthlyBenefit: this.client.clientProfile.SpouseCurrentMonthlyBenefit,//this is usually defaulted as 0 if no value (not sure if thats an issue)
      UseNationalAverage: this.client.clientProfile.UseNationalAverage,
      IsRunReportWithSpouse: this.client.clientProfile.IsRunReportWithSpouse,
      IsLegalSpouse: this.client.clientProfile.IsLegalSpouse,
      IsPrivHealthIns: this.client.clientProfile.IsPrivHealthIns,
      CoverageType: this.client.clientProfile.CoverageType,
      PremiumType: this.client.clientProfile.PremiumType,
      Premiums:  this.client.clientProfile.Premiums,
      IsHSApplySpouse: this.client.clientProfile.IsHSApplySpouse,
      IsSpousePrivHealthIns: this.client.clientProfile.IsSpousePrivHealthIns,
      SpouseCoverageType: this.client.clientProfile.SpouseCoverageType,
      SpousePremiumType: this.client.clientProfile.SpousePremiumType,
      SpousePremiums: this.client.clientProfile.SpousePremiums,
      Bracket: this.client.clientProfile.Bracket,
      InflationRate: this.client.clientProfile.InflationRate ,
      HouseholdYearOneIncome: this.client.clientProfile.HouseholdYearOneIncome,
      HouseholdYearOneIncomeChangeYear: this.client.clientProfile.HouseholdYearOneIncomeChangeYear,
      InRetirementInflationRate: this.client.clientProfile.InRetirementInflationRate,
      MAGIPercentIncome: this.client.clientProfile.MAGIPercentIncome,
      OOPCosts: this.client.clientProfile.OOPCosts,
      SpouseOOPCosts: this.client.clientProfile.SpouseOOPCosts,
      ClientMetroArea: this.client.clientProfile.ClientMetroArea,
      SpouseMetroArea: this.client.clientProfile.SpouseMetroArea,
      Pension: this.client.clientProfile.Pension,
      PensionMonths: this.client.clientProfile.PensionMonths,
      PensionYears: this.client.clientProfile.PensionYears,
      SubstantialEarningYears: this.client.clientProfile.SubstantialEarningYears,//this looks like it defaults to a string but is an int here???
      SubstantialEarningYearsDetails: this.client.clientProfile.SubstantialEarningYearsDetails,
      Spouses: JSON.stringify(this.backUpClient.clientProfile.Spouses),
      InRetFirstYearIncome: this.client.clientProfile.InRetFirstYearIncome,
      InRetStopWorkAge: this.client.clientProfile.InRetStopWorkAge, //this is usually defaulted as an empty string is no value (not sure if thats an issue)

      //THIS IS ALL THAT IS CHANGING IF SAVED
      SSDesiredAgeYears: data.clientAgeYears,// data.clientAgeYears,//this.client.clientProfile.SSDesiredAgeYears,
      SSDesiredAgeMonths: data.clientAgeMonths,//data.clientAgeMonths,//this.client.clientProfile.SSDesiredAgeMonths,

      SurvivorSwitchYears: data.survivorSwitchAgeYears,// data.survivorSwitchAgeYears,
      SurvivorSwitchMonths: data.survivorSwitchAgeMonths,

      SelfKnownBenefitClaiming: this.client.clientProfile.SelfKnownBenefitClaiming,
      SpouseKnownBenefitClaiming: (this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0) ? this.client.clientProfile.Spouses[0].SpouseKnownBenefitClaiming : 0,
      
      SelfFilingRestrictedYear: (data.isClientFilingRestricted && data.fileRestrictedAgeYears) ? data.fileRestrictedAgeYears : 0,
      SelfFilingRestrictedMonth: (data.isClientFilingRestricted && data.fileRestrictedAgeMonths) ? data.fileRestrictedAgeMonths : 0,
      SpouseFilingRestrictedYear: (data.isSpouseFilingRestricted && data.spouseFileRestrictedAgeYears) ? data.spouseFileRestrictedAgeYears : 0,
      SpouseFilingRestrictedMonth: (data.isSpouseFilingRestricted && data.spouseFileRestrictedAgeMonths) ? data.spouseFileRestrictedAgeMonths : 0,
      DateOfClaimMonth: this.client.clientProfile.DateOfClaimMonth,
      DateOfClaimYear: this.client.clientProfile.DateOfClaimYear,

      SelfWidowYearOfStatement: this.client.clientProfile.Spouses[0].maritalStatus == "Widowed" ? (this.client.clientProfile.Spouses[0].yearOfStatement) ? this.client.clientProfile.Spouses[0].yearOfStatement : 0 : 0,
      SelfWidowYearTimeOfPassing: this.client.clientProfile.Spouses[0].maritalStatus == "Widowed" ? (this.client.clientProfile.Spouses[0].yearAtTimeOfPassing) ? this.client.clientProfile.Spouses[0].yearAtTimeOfPassing : 0 : 0,
      YearOfStatement: this.client.clientProfile.YearOfStatement,
        
      // SpouseDateOfClaimMonth: (this.client.clientProfile.Spouses[0].maritalStatus == "Married" && this.client.clientProfile.SpouseAlreadyCollecting > 0) ? this.client.clientProfile.Spouses[0].dateOfClaimMonth : 0,
      // SpouseDateOfClaimYear: (this.client.clientProfile.Spouses[0].maritalStatus == "Married" && this.client.clientProfile.SpouseAlreadyCollecting > 0) ? this.client.clientProfile.Spouses[0].dateOfClaimYear : 0,
      //SpouseSSDesiredAgeYears: data.spouseAgeYears,//this.client.clientProfile.SpouseSSDesiredAgeYears,
      //SpouseSSDesiredAgeMonths: data.spouseAgeMonths,//this.client.clientProfile.SpouseSSDesiredAgeMonths,
      
      InvertSurvivorSwitch: data.swappedClaim,
      PensionInfl: this.client.clientProfile.PensionInfl,
     }

     if (!this.isStringifiedJSON(ClientProfile.Children)) {
       ClientProfile.Children = JSON.stringify(ClientProfile.Children);
     }

     console.log('ClientProfile.SurvivorSwitchYears ', ClientProfile.SurvivorSwitchYears);

     //HACK: added to save the same way it loads on page load. And the code-block after this already existed, so to prevent issues this was added before it
     let showSurvivorSection = this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed' 
      || (this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' && !this.client.clientProfile.Spouses[0].alive && this.client.clientProfile.Spouses[0].tenyears) ? true : false;
    
      let isSpouseSurvivor = this.client.clientProfile.Spouses[0].maritalStatus == 'Married' && this.isSpouseSurvivor ? true : false
    showSurvivorSection = isSpouseSurvivor ? true : showSurvivorSection;
    
    if ((this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed' 
    || (this.client.clientProfile.Spouses[0].maritalStatus == 'Single' || this.client.clientProfile.Spouses[0].maritalStatus == 'Married') && this.includeSpouse) 
      && (data.survivorSwitchAgeYear || showSurvivorSection)){
      console.log('looking switch age', data.survivorSwitchAgeYears);
      // if (showSurvivorSection) {
        this.swappedClaim = data.swappedClaim;
        if(isSpouseSurvivor) {
         /*  this.adjSurvivorBenefitAge = data.swappedClaim ? data.survivorSwitchAgeYears : data.spouseAgeYears;
          this.adjSurvivorBenefitMonths = data.swappedClaim ? data.survivorSwitchAgeMonths : data.spouseAgeMonths;
          this.adjRetirementBenefitAge = data.swappedClaim ? data.spouseAgeYears : data.survivorSwitchAgeYears;
          this.adjRetirementBenefitMonths = data.swappedClaim ? data.spouseAgeMonths : data.survivorSwitchAgeMonths;
          console.log('adjSurvivorBenefitAge', this.adjSurvivorBenefitAge);
          console.log('adjRetirementBenefitAge', this.adjRetirementBenefitAge);
          console.log('swappedClaim', this.swappedClaim);
          console.log('swappedClaim- spouse'); */
        } else {
          /* console.log('looking switch age 03')
          console.log('data.swappedClaim', data.swappedClaim )
          console.log('data', data); */
          /* this.adjSurvivorBenefitAge = data.swappedClaim ? data.survivorSwitchAgeYears : data.clientAgeYears;
          this.adjSurvivorBenefitMonths = data.swappedClaim ? data.survivorSwitchAgeMonths : data.clientAgeMonths;
          this.adjRetirementBenefitAge = data.swappedClaim ? data.clientAgeYears : data.survivorSwitchAgeYears;
          this.adjRetirementBenefitMonths = data.swappedClaim ? data.clientAgeMonths : data.survivorSwitchAgeMonths; */
        }
      // }
      // this.swappedClaim = !data.swappedClaim;
      this.adjSurvivorModal = true;
    } else if (this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed' 
    || (this.client.clientProfile.Spouses[0].maritalStatus == 'Single' || this.client.clientProfile.Spouses[0].maritalStatus == 'Married') && this.includeSpouse) {
      if(this.client.clientProfile.Spouses[0].maritalStatus == 'Married' && this.isSpouseSurvivor){
        console.log('inside retirement benefit age 01')
        this.adjRetirementBenefitAge = !data.swappedClaim ? data.spouseAgeYears : data.survivorSwitchAgeYears;
        this.adjRetirementBenefitMonths = !data.swappedClaim ? data.spouseAgeMonths : data.survivorSwitchAgeMonths;
      } else {
        console.log('inside retirement benefit age 02')
        this.adjRetirementBenefitAge = !data.swappedClaim ? data.clientAgeYears : data.survivorSwitchAgeYears;
        this.adjRetirementBenefitMonths = !data.swappedClaim ? data.clientAgeMonths : data.survivorSwitchAgeMonths;

        console.log('data.survivorSwitchAgeYears', data.survivorSwitchAgeYears);
        this.adjSurvivorBenefitAge = !data.swappedClaim ? data.survivorSwitchAgeYears : data.clientAgeYears;
        this.adjSurvivorBenefitMonths = !data.swappedClaim ? data.survivorSwitchAgeMonths : data.clientAgeMonths;
      }
      this.adjSurvivorModal = true;
    }


    //TODO: need to save for Surv Widowed Spouses (not just clients); also need to test basic save cases
    //TODO: check how things are saving to the profile since we are always updating the DCA in the client profile
      //looks like its saving whatever Survivor is to the profile in the DCA area of the questionnaire....need to look into this
      if ((this.client.clientProfile.Spouses[0].maritalStatus == "Widowed" || this.client.clientProfile.Spouses[0].maritalStatus == 'Single' && this.includeSpouse)) {
        this.swappedClaim = data.swappedClaim;
  
        if(isSpouseSurvivor) {
  
            if(this.swappedClaim){
  
              this.backUpClient.clientProfile.Spouses[0].sSDesiredAgeYears = this.adjRetirementBenefitAge;
              this.backUpClient.clientProfile.Spouses[0].sSDesiredAgeMonths = this.adjRetirementBenefitMonths;
              ClientProfile.SurvivorSwitchYears = this.adjSurvivorBenefitAge;
              ClientProfile.SurvivorSwitchMonths = this.adjSurvivorBenefitMonths;
            } else {
  
              this.backUpClient.clientProfile.Spouses[0].sSDesiredAgeYears = this.adjSurvivorBenefitAge;
              this.backUpClient.clientProfile.Spouses[0].sSDesiredAgeMonths = this.adjSurvivorBenefitMonths;
              ClientProfile.SurvivorSwitchYears = this.adjRetirementBenefitAge;
              ClientProfile.SurvivorSwitchMonths = this.adjRetirementBenefitMonths;
            }
            
            //reset spouses
            ClientProfile.Spouses = JSON.stringify(this.backUpClient.clientProfile.Spouses);
            console.log('reset spouse', ClientProfile.Spouses);
            console.log('after reset spouse', ClientProfile);
            //ClientProfile.InvertSurvivorSwitch = !this.swappedClaim;
        } else {
  
          // console.log('here i am 01');
          // ClientProfile.SSDesiredAgeYears = this.adjSurvivorBenefitAge;
          // ClientProfile.SSDesiredAgeMonths = this.adjSurvivorBenefitMonths;
          // ClientProfile.SurvivorSwitchYears = this.adjRetirementBenefitAge;
          // ClientProfile.SurvivorSwitchMonths = this.adjRetirementBenefitMonths;
  
          if (!this.swappedClaim && !this.adjRetirementBenefitAge) {
            console.log('here i am 02');
            this.adjRetirementBenefitAge = this.adjSurvivorBenefitAge;
            this.adjRetirementBenefitMonths = this.adjSurvivorBenefitMonths;
            this.adjSurvivorBenefitAge = 0;
            this.adjSurvivorBenefitMonths = 0;
          } 
  
          if (this.swappedClaim && !this.adjSurvivorBenefitAge) {
            console.log('here i am 05');
            // this.adjRetirementBenefitAge = this.adjSurvivorBenefitAge;
            // this.adjRetirementBenefitMonths = this.adjSurvivorBenefitMonths;
            // this.adjSurvivorBenefitAge = 0;
            // this.adjSurvivorBenefitMonths = 0;
            ClientProfile.SSDesiredAgeYears = this.adjRetirementBenefitAge || 0;
            ClientProfile.SSDesiredAgeMonths = this.adjRetirementBenefitMonths || 0;
            ClientProfile.SurvivorSwitchYears = this.adjSurvivorBenefitAge || 0;
            ClientProfile.SurvivorSwitchMonths = this.adjSurvivorBenefitMonths || 0;
          } 
          
          if (!this.swappedClaim && this.adjRetirementBenefitAge && this.adjSurvivorBenefitAge) {
            console.log('here i am 03');
            ClientProfile.SSDesiredAgeYears = this.adjSurvivorBenefitAge;
            ClientProfile.SSDesiredAgeMonths = this.adjSurvivorBenefitMonths;
            ClientProfile.SurvivorSwitchYears = this.adjRetirementBenefitAge;
            ClientProfile.SurvivorSwitchMonths = this.adjRetirementBenefitMonths;
          } else if (this.swappedClaim && this.adjRetirementBenefitAge && this.adjSurvivorBenefitAge) {
            console.log('here i am 04');
            ClientProfile.SSDesiredAgeYears = this.adjRetirementBenefitAge;
            ClientProfile.SSDesiredAgeMonths = this.adjRetirementBenefitMonths;
            ClientProfile.SurvivorSwitchYears = this.adjSurvivorBenefitAge;
            ClientProfile.SurvivorSwitchMonths = this.adjSurvivorBenefitMonths;
          }
        }
      }
  
      // if (overrideSpouseDCA) {
      //   ClientProfile.InvertSurvivorSwitch = this.swappedClaim;
      //   this.backUpClient.clientProfile.Spouses[0].sSDesiredAgeYears = this.adjSurvivorBenefitAge;
      //   this.backUpClient.clientProfile.Spouses[0].sSDesiredAgeMonths = this.adjSurvivorBenefitMonths;
      //   ClientProfile.SurvivorSwitchYears = this.adjRetirementBenefitAge;
      //   ClientProfile.SurvivorSwitchMonths = this.adjRetirementBenefitMonths;
      //   ClientProfile.Spouses = JSON.stringify(this.backUpClient.clientProfile.Spouses);
      // }

    // if (!this.client.clientProfile.Spouses.length || this.client.clientProfile.Spouses.length && (this.client.clientProfile.Spouses[0].maritalStatus == 'Single' || this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced')) {
    //   ClientProfile.InvertSurvivorSwitch = true;
    // }


     //TODO: do I need these??? Set to default null
    var MidRetirementAdj = null;
    let LstMAGIProj = null;
    var AdditionalQuestion = null;
    var RiskTolerance = null;
    console.log('Update Client from SS Page', ClientProfile);
    this.globalService.createClient(UserModel, ClientProfile , RiskTolerance, AdditionalQuestion, MidRetirementAdj, LstMAGIProj)
    .subscribe(
      resp => {
        this.globalService.isAltComplete = true;
      },
      error => {
        this.snackBarService.add('There was an issue creating new client, please try again later.', 1);
      });
  }
  
  spouseHasDOB: boolean = false;
  hasAlreadyDisplayedDurationToggleMsg: boolean = false;
  handleSavingSS(hasDurationBeenToggled, isHandleSavingsSS = false) {
    console.log('this.ssObject.clientSurvivorSwitchYears', this.ssObject.clientSurvivorSwitchYears);
    if(hasDurationBeenToggled && !this.hasAlreadyDisplayedDurationToggleMsg){
      const dialogRef = this.dialog.open(BasicQuestionComponent, {     
        data: { title: 'Notification!', 
        btnNoTitle: 'No',
        btnYesTitle: 'Yes',
        question: "You viewed this illustration in today's dollars during this session.<br/>Would you like to include a Today's Dollar's summary page in the PDF report?" }
      });
  
      dialogRef.afterClosed().subscribe(result => {
        //console.log('result from pdf download', result);  
        if(result != undefined){
          this.hasDurationBeenToggled = result;
          this.hasAlreadyDisplayedDurationToggleMsg = true;

          this.handleSavingSS(false);
        }
      }); 

    } else {
      
        var Report = {
          ClientID: this.client.client.ID,
          AdvisorID: this.client.client.AdvisorID,
          CompanyCode: this.client.client.OrganizationID,
          ReportTypeID: 2,
        }
    
        var tempChildren = [];
        var tempChild = {};
    
        if (this.client.clientProfile.Children && this.client.clientProfile.Children.length) {
          for (var k in this.client.clientProfile.Children) {
            if (this.client.clientProfile.Children[k].DependentChildAge) {
              tempChild = {};
              tempChild["CurrentAge"] = Number(this.client.clientProfile.Children[k].DependentChildAge);
              tempChild['isDisabled'] = !!this.client.clientProfile.Children[k].isDisabled;
              tempChild['dacAnticipateEnd'] = !!this.client.clientProfile.Children[k].dacAnticipateEnd;
              tempChild['StopBenefitsAge'] = this.client.clientProfile.Children[k].dacEndAge || null;
              tempChild['IsStudentAt19'] = false;
              tempChildren.push(tempChild);
            }
          }
        }
    
        var investmentItems = [];
    
        for (var item in this.fundingItems) {
    
          var contribution = {
            Description: this.fundingItems[item].fundingSource,
            Begins: this.fundingItems[item].startAge,
            Ends: this.fundingItems[item].endAge,
            StartAmount: this.fundingItems[item].annContribution,
            Cola: this.fundingItems[item].inflationRate,
          }
    
          investmentItems.push(contribution);
        }
        let spouseGovtPension = Number(this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse && this.client.clientProfile.Spouses[0].pension ? this.client.clientProfile.Spouses[0].pension.toString().replace(/,/g,"").replace("$","") || 0 : 0);
        let spousePIA = this.includeSpouse ? (((this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' || this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed') && this.client.clientProfile.Spouses[0].tenyears)?this.client.clientProfile.Spouses[0].pia: this.spousePIA.toString().replace(/,/g,"").replace("$","")) : 0;
        let spouseLifeExpectancy = this.includeSpouse? ((this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' || this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed')? (this.client.clientProfile.Spouses[0].exSpouseLifeExpectancy || 0):this.client.clientProfile.Spouses[0].LifeExpectancy) : 0;
        let spouseDOB = (this.includeSpouse || (this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' || this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed')) ? (this.client.clientProfile.Spouses[0].dobStr && Date.parse(this.client.clientProfile.Spouses[0].dobStr) ? new Date(this.client.clientProfile.Spouses[0].dobStr).toLocaleDateString("en-US") : new Date(this.client.clientProfile.Spouses[0].dob).toLocaleDateString("en-US") ? new Date(this.client.clientProfile.Spouses[0].dob).toLocaleDateString("en-US") : "1/1/1960") : '1/1/1960';
        // let spouseDOB = (this.client.clientProfile.Spouses[0].dobStr && Date.parse(this.client.clientProfile.Spouses[0].dobStr) ? new Date(this.client.clientProfile.Spouses[0].dobStr).toLocaleDateString("en-US") : new Date(this.client.clientProfile.Spouses[0].dob).toLocaleDateString("en-US") ? new Date(this.client.clientProfile.Spouses[0].dob).toLocaleDateString("en-US") : "1/1/1960");
        
        this.spouseHasDOB = (this.includeSpouse || (this.client.clientProfile.Spouses[0].maritalStatus == 'Divorced' || this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed')) ? (this.client.clientProfile.Spouses[0].dobStr && Date.parse(this.client.clientProfile.Spouses[0].dobStr) ? true : Date.parse(this.client.clientProfile.Spouses[0].dob) ? true : false) : false;
    
        let spouseAlreadyCollecting = this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed' ? (this.client.clientProfile.Spouses[0].spouseCollectAtTimeOfPassing ? true : false) : this.client.clientProfile.SpouseAlreadyCollecting ? this.client.clientProfile.SpouseAlreadyCollecting: false;
                    
        var ReportSS = {
          InvestmentItems: JSON.stringify({ investmentItems }),
          InvestmentYears: this.annualEl ? Number(this.annualEl.nativeElement.value): 0,
          InvestmentOption: this.investmentOption,
    
          FrmPhase1Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorOne)) : 6,
          FrmPhase1Periods: this.objAdjustRates ? Number(this.objAdjustRates.throughYearOne) : Math.max(65 - Number(this.calculateAge(this.client.client.DOB))),
          FrmPhase2Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorTwo)) : 6,
          FrmPhase2Periods: this.objAdjustRates ? (Number(this.objAdjustRates.throughYearTwo)) : 10,
          FrmPhase3Rate: this.objAdjustRates ? (Number(this.objAdjustRates.rorThree)) : 6,
    
          FrmName0: this.client.client.FirstName + "/" + this.client.client.LastName,
          // SelfCurrentMonthlyBenefit: this.clientMonthlyBenefitAmount,
          // SpouseAlreadyCollecting: this.client.clientProfile.SpouseAlreadyCollecting == 1 ? 'True': 'False', //'False',//this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.spouseClaimStatus : "False",
          SelfCurrentMonthlyBenefit: (this.client.clientProfile.MonthlyBenefitAmount || 0) > 0 ? this.client.clientProfile.MonthlyBenefitAmount : this.clientMonthlyBenefitAmount,
          SpouseAlreadyCollecting: spouseAlreadyCollecting,//(this.client.clientProfile.Spouses) ? (this.client.clientProfile.Spouses[0].spouseCollectAtTimeOfPassing) ? this.client.clientProfile.Spouses[0].spouseCollectAtTimeOfPassing : "False" : "False",
          SelfGovPensionAmount: this.client.clientProfile.Pension,// "", // --> Needs to be updated, but how is this calculated?
          Children: this.client.clientProfile.Children && this.client.clientProfile.Children.length > 0 ? JSON.stringify(tempChildren) : '[]',
          SelfAlreadyCollecting: this.client.clientProfile.SelfAlreadyCollecting == 1 ? 'True': 'False', //'False',//this.clientClaimStatus,
          // SpouseLifeExpectancy: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? 89 : 0, // make this part of ssData output
          FrmQDepChildren: this.client.clientProfile.Children && this.client.clientProfile.Children.length > 0 ? 1 : 0,
          FrmQFormerSpouses: 0,
          FrmSpouseQFormerSpouses: 0, // TODO: add value
          FrmSpouseQDepChildren: this.client.clientProfile.Children && this.client.clientProfile.Children.length > 0 ? 1 : 0,
    
          selfConditions: JSON.stringify({
            HCHBP: this.client.clientProfile.HCHBP || 0,
            HCHC: this.client.clientProfile.HCHC || 0,
            HCT1D: this.client.clientProfile.HCT1D || 0,
            HCT2D: this.client.clientProfile.HCT2D || 0,
            HCCD: this.client.clientProfile.HCCD || 0,
            HCC: this.client.clientProfile.HCC || 0,
            HCT: this.client.clientProfile.HCT || 0,
            HCMS: this.client.clientProfile.HCMS || 0,
            HCDCW: this.client.clientProfile.HCDCW || 0,
            HCFHDC: this.client.clientProfile.HCFHDC || 0,

            HCALZ: this.client.clientProfile.HCALZ || 0,
            HCPARK: this.client.clientProfile.HCPARK || 0,
            HCAMP: this.client.clientProfile.HCAMP || 0,
            HCPTSD: this.client.clientProfile.HCPTSD || 0,
            HCOBS: this.client.clientProfile.HCOBS || 0,
          }),
          spouseConditions: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? JSON.stringify({
            HCHBP: this.client.clientProfile.Spouses[0].HCHBP || 0,
            HCHC: this.client.clientProfile.Spouses[0].HCHC || 0,
            HCT1D: this.client.clientProfile.Spouses[0].HCT1D || 0,
            HCT2D: this.client.clientProfile.Spouses[0].HCT2D || 0,
            HCCD: this.client.clientProfile.Spouses[0].HCCD || 0,
            HCC: this.client.clientProfile.Spouses[0].HCC || 0,
            HCT: this.client.clientProfile.Spouses[0].HCT || 0,
            HCMS: this.client.clientProfile.Spouses[0].HCMS || 0,
            HCDCW: this.client.clientProfile.Spouses[0].HCDCW || 0,
            HCFHDC: this.client.clientProfile.Spouses[0].HCFHDC || 0,

            HCALZ: this.client.clientProfile.Spouses[0].HCALZ || 0,
            HCPARK: this.client.clientProfile.Spouses[0].HCPARK || 0,
            HCAMP: this.client.clientProfile.Spouses[0].HCAMP || 0,
            HCPTSD: this.client.clientProfile.Spouses[0].HCPTSD || 0,
            HCOBS: this.client.clientProfile.Spouses[0].HCOBS || 0,
          }) : "",
    
          includeSpouse: this.includeSpouse ? 1: 0,
    
          
    
          SelfGender: this.client.client.GenderID,
          SpouseGender: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.client.clientProfile.Spouses[0].gender || 1 : 1,
          // Finish validating fields below this --------
    
          BendPointInflation: 2, // make this part of ssData ?
          SelfCurrentAge: this.calculateAge(this.client.client.DOB),
          SpouseCurrentAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.calculateAge(this.client.clientProfile.Spouses[0].dob) || 30 : 30,
          IsPresentValue: this.hasDurationBeenToggled ? 1 : 0,// == "True" ? true : false,
          SpouseCurrentMonthlyBenefit: (this.client.clientProfile.Spouses[0].monthlyBenefits) ? Utils.formatToNumber(this.client.clientProfile.Spouses[0].monthlyBenefits) : this.spouseClaimStatus == "True" ? this.spouseMonthlyBenefitAmount.toString().replace(/,/g,"").replace("$","") || 0 : 0,//this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? 0 : 0,
          // SpouseCurrentMonthlyBenefit: this.spouseClaimStatus == "True" ? this.spouseMonthlyBenefitAmount.toString().replace(/,/g,"").replace("$","") || 0 : 0,//this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? 0 : 0,
          FrmIncome: "Ind1", // make this part of ssData output
          SelfPensionStartMonth: this.client.clientProfile.PensionMonths, // ??
          isSelfSuspendable: "False", // ??
          SpouseBenefitAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.spouseRetirementYears : 0,
          selfCanRestrict: "False", // ??
          SpousePIA: spousePIA,
          /* SelfLifeExpectancy: this.client.clientProfile.LifeExpectancy || 0, //87, // make this part of ssData output
          SpouseLifeExpectancy: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.client.clientProfile.Spouses[0].LifeExpectancy || 0 : 0, */
          SelfLifeExpectancy: this.client.clientProfile.LifeExpectancy,//this.socialSecurityForm.get('selfLifeExpectancy').value,
          SpouseLifeExpectancy: spouseLifeExpectancy || 0,
    
          StrategyDropDown: "AutoSelect",
          SelfPensionFrequency: "Monthly",
          SelfPensionStartYear: this.client.clientProfile.PensionYears, // ??
          SelfPensionInfl: (this.client.clientProfile.PensionInfl == null) ? 3.00 : this.client.clientProfile.PensionInfl, //default is null
          SelfPIA: this.clientPIA,
          COLA: JSON.stringify({ Colas: this.colas }),
          FrmColaXml:  JSON.stringify({ Colas: this.colas }),
          SpousePensionStartMonth: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.client.clientProfile.Spouses[0].pensionMonth : "01",
          SpouseGovPensionAmount: spouseGovtPension,
          SpouseGovPension: spouseGovtPension > 0 ? true : false,
          SpousePensionInfl: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? (this.client.clientProfile.Spouses[0].PensionInfl == null) ? 3 : this.client.clientProfile.Spouses[0].PensionInfl : 3,
          PIAIncomeYears1: 0, // ??
          SelfAlreadyClaimedAge: 0, // ??
          spouseCanRestrict: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? "False" : "",
          SelfSubstantialEarningsYears: this.client.clientProfile.SubstantialEarningYears ? this.client.clientProfile.SubstantialEarningYears : 0,
          SelfBenefitAge: this.clientRetirementYears,// 67,
          FrmName1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.client.clientProfile.Spouses[0].firstName + "/" + this.client.clientProfile.Spouses[0].lastName : "",
          SpouseAlreadyClaimedAge: 0, // ??
    
          // MaritalState: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.client.clientProfile.Spouses[0].maritalStatus : (this.client.clientProfile.Spouses.length > 1) ? this.client.clientProfile.Spouses[1].maritalStatus : "Single",
          MaritalState: this.client.clientProfile.Spouses[0].maritalStatus,
          SpousePensionStartYear: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? this.client.clientProfile.Spouses[0].pensionYear : "",
          SpousePensionFrequency: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? "Monthly" : "",
          RetirementStrategy: "FileForBenefits", // get in ssData ??
          PIAIncomeYears2: 0, // ??
          SpouseSubstantialEarningsYears: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse && (this.client.clientProfile.Spouses[0].IncludePension == 1) && this.client.clientProfile.Spouses[0].substantialEarningYears ? this.client.clientProfile.Spouses[0].substantialEarningYears : 0,
          SelfGovPension: (Number(this.client.clientProfile.Pension) || 0) > 0 ? true : false,//"False",
          isSpouseSuspendable: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? "False" : "",
    
          //TODO: this is an issue with saving for PDFs for clients that have not done an Alternate
          //these areas need to be saved for Optimal reports; right now they are empty
          /* selfRetirementYears: this.socialSecurityForm.get('selfRetirementYears').value,
          selfRetirementMonths: this.socialSecurityForm.get('selfRetirementMonths').value,
          spouseRetirementYears: this.socialSecurityForm.get('spouseRetirementYears').value,
          spouseRetirementMonths: this.socialSecurityForm.get('spouseRetirementMonths').value, */
    
          selfRetirementYears: (this.ssObject.selfRetirementYears) ? this.ssObject.selfRetirementYears : (this.socialSecurityForm.get('selfRetirementYears').value) ? Number(this.socialSecurityForm.get('selfRetirementYears').value) : this.clientRetirementYears,
          selfRetirementMonths: (this.ssObject.selfRetirementMonths >= 0) ? this.ssObject.selfRetirementMonths : (this.socialSecurityForm.get('selfRetirementMonths').value) ? Number(this.socialSecurityForm.get('selfRetirementMonths').value) : (this.clientRetirementMonths) ? this.clientRetirementMonths : 0,
          spouseRetirementYears: (this.ssObject.spouseRetirementYears) ? this.ssObject.spouseRetirementYears : (this.socialSecurityForm.get('spouseRetirementYears').value) ? Number(this.socialSecurityForm.get('spouseRetirementYears').value) : this.spouseRetirementYears,
          spouseRetirementMonths: (this.ssObject.spouseRetirementMonths >= 0) ? this.ssObject.spouseRetirementMonths : (this.socialSecurityForm.get('spouseRetirementMonths').value) ? Number(this.socialSecurityForm.get('spouseRetirementMonths').value) || 0 : this.spouseRetirementMonths || 0,
    
          clientSurvivorSwitchYears: (this.ssObject.clientSurvivorSwitchYears >= 0) ? this.ssObject.clientSurvivorSwitchYears : this.clientSurvivorSwitchYears,
          clientSurvivorSwitchMonths: (this.ssObject.clientSurvivorSwitchMonths >= 0) ? this.ssObject.clientSurvivorSwitchMonths : this.clientSurvivorSwitchMonths,
          SurvivorSwitchYears: (this.ssObject.clientSurvivorSwitchYears >= 0) ? this.ssObject.clientSurvivorSwitchYears : this.clientSurvivorSwitchYears,
          SurvivorSwitchMonths: (this.ssObject.clientSurvivorSwitchMonths >= 0) ? this.ssObject.clientSurvivorSwitchMonths : this.clientSurvivorSwitchMonths,
    
          SelfFilingRestrictedYear: (this.ssObject.SelfFilingRestrictedYear) ? this.ssObject.SelfFilingRestrictedYear : (this.client.clientProfile.SelfFilingRestrictedYear) ? this.client.clientProfile.SelfFilingRestrictedYear : 0,
          SelfFilingRestrictedMonth: (this.ssObject.SelfFilingRestrictedMonth) ? this.ssObject.SelfFilingRestrictedMonth : (this.client.clientProfile.SelfFilingRestrictedMonth) ? this.client.clientProfile.SelfFilingRestrictedMonth : 0,
          SpouseFilingRestrictedYear: (this.ssObject.SpouseFilingRestrictedYear) ? this.ssObject.SpouseFilingRestrictedYear : (this.client.clientProfile.Spouses[0].SpouseFilingRestrictedYear) ? this.client.clientProfile.Spouses[0].SpouseFilingRestrictedYear : 0,
          SpouseFilingRestrictedMonth: (this.ssObject.SpouseFilingRestrictedMonth) ? this.ssObject.SpouseFilingRestrictedMonth : (this.client.clientProfile.Spouses[0].SpouseFilingRestrictedMonth) ? this.client.clientProfile.Spouses[0].SpouseFilingRestrictedMonth : 0,
        
    
          /* selfRetirementYears: this.clientRetirementYears,
          selfRetirementMonths: this.clientRetirementMonths,
          spouseRetirementYears: this.spouseRetirementYears,
          spouseRetirementMonths: this.spouseRetirementMonths,
    
          clientSurvivorSwitchYears: this.clientSurvivorSwitchYears,
          clientSurvivorSwitchMonths: this.clientSurvivorSwitchMonths,
          SurvivorSwitchYears: this.clientSurvivorSwitchYears,
          SurvivorSwitchMonths: this.clientSurvivorSwitchMonths, */
    
          SelfDOB: this.client.client.DOB,
          SpouseDOB: isNaN(new Date(spouseDOB).getTime()) ? new Date('1/1/1960') : new Date(spouseDOB),
          SpouseHasDOB: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? (this.client.clientProfile.Spouses[0].dobStr && Date.parse(this.client.clientProfile.Spouses[0].dobStr) ? true : Date.parse(this.client.clientProfile.Spouses[0].dob) ? true : false) : false,
          SelfCurrentIncome: this.client.clientProfile.CurrentIncome || 0,
          SpouseCurrentIncome: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].currentIncome : 0,
          SelfIRR: this.client.clientProfile.IRR || this.defaultIRR,
              
          FrmDiscountRate: this.socialSecurityForm.get('inflationRate').value.replace('%', '') / 100,
          SelfRetirementAge: this.client.clientProfile.RetirementAge,
          SpouseRetirementAge: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? (this.client.clientProfile.Spouses[0].maritalStatus == 'Single') ? 0 : this.client.clientProfile.Spouses[0].retirementAge : 0,
          SpousePreviousSpouses: JSON.stringify(this.previousSpouse),
          HouseholdYearOneIncome: this.client.clientProfile.HouseholdYearOneIncome,
          
          /* SelfFRA: (this.objAdjustedFRAScenario) ? this.objAdjustedFRAScenario.clientAgeYears : this.getFRAv2(this.client.client.DOB).age,
          SelfFRAMonth: (this.objAdjustedFRAScenario) ? this.objAdjustedFRAScenario.clientAgeMonths : this.getFRAv2(this.client.client.DOB).month,
          SpouseFRA: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? (this.objAdjustedFRAScenario) ? (this.objAdjustedFRAScenario.spouseAgeYears) ? this.objAdjustedFRAScenario.spouseAgeYears : this.getFRAv2(this.client.clientProfile.Spouses[0].dob).age : 0 : 0,
          SpouseFRAMonth: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse ? (this.objAdjustedFRAScenario) ? (this.objAdjustedFRAScenario.spouseAgeMonths) ? this.objAdjustedFRAScenario.spouseAgeMonths : this.getFRAv2(this.client.clientProfile.Spouses[0].dob).month : 0 : 0, */
          SelfFRA: (this.ssObjectFRA && (this.hasAdjustedFRAScenario || !this.rejectOnPageLoad)) ? this.ssObjectFRA.selfRetirementYears : this.getFRAv2(this.client.client.DOB).age,
          SelfFRAMonth: (this.ssObjectFRA && (this.hasAdjustedFRAScenario || !this.rejectOnPageLoad)) ? this.ssObjectFRA.selfRetirementMonths : this.getFRAv2(this.client.client.DOB).month,
          SpouseFRA: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse 
          ? (this.ssObjectFRA && (this.hasAdjustedFRAScenario || !this.rejectOnPageLoad)) ? (this.ssObjectFRA.spouseRetirementYears) ? this.ssObjectFRA.spouseRetirementYears : this.getFRAv2(spouseDOB).age : this.spouseRetirementYears : 0,
          SpouseFRAMonth: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.includeSpouse 
          ? (this.ssObjectFRA && (this.hasAdjustedFRAScenario || !this.rejectOnPageLoad)) ? (this.ssObjectFRA.spouseRetirementMonths >= 0) ? this.ssObjectFRA.spouseRetirementMonths : this.getFRAv2(spouseDOB).month : this.spouseRetirementMonths : 0,
          
          //ZSS 051024: removed reject bool check on the HasAlternateFRA - was causing issues in PDFs causing UI/PDF mismatch
          //Note: the issue above was because of widow maker (only tested where Spouse was widowed) => but thats what causes the issue
          HasAlternateFRA: (this.hasAdjustedFRAScenario),// || this.rejectOnPageLoad),//((this.rejectOnPageLoad) ? true : false)),
          HasAlternateScenario: (this.hasAlternateScenario),
    
          FrmState: this.client.clientProfile.RetirementState == 'NA' ? '  ': this.client.clientProfile.RetirementState,
          FrmState1: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 ? this.client.clientProfile.Spouses[0].state : '',
          SelfWorkingInRetirement: this.client.clientProfile.InRetStopWorkAge > 0 && this.client.clientProfile.InRetFirstYearIncome != null ? this.client.clientProfile.InRetStopWorkAge : 0,
          SpouseWorkingInRetirement: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.client.clientProfile.Spouses[0].inRetStopWork > 0 && this.client.clientProfile.Spouses[0].inRetFirstYearIncome != null ? this.client.clientProfile.Spouses[0].inRetStopWork : 0,
          SelfWorkingInRetirementIncome: this.client.clientProfile.InRetFirstYearIncome > 0 ? this.client.clientProfile.InRetFirstYearIncome : 0,
          SpouseWorkingInRetirementIncome: this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0 && this.client.clientProfile.Spouses[0].inRetStopWork > 0 && this.client.clientProfile.Spouses[0].inRetFirstYearIncome != null ? this.client.clientProfile.Spouses[0].inRetFirstYearIncome : 0,
          InRetirementInflationRate: (this.client.clientProfile.InRetirementInflationRate == null) ? 2.40 : this.client.clientProfile.InRetirementInflationRate, //default if null
          MidRetAdjYear: this.client.midRetirementAdj ? this.client.midRetirementAdj.Year || 0 : 0,
          MidRetRedDollar: this.client.midRetirementAdj ? this.client.midRetirementAdj.ReductionDollar : 0,
          MidRetRedPer: this.client.midRetirementAdj ? this.client.midRetirementAdj.ReductionPerc: 0,
          MidRetIncomeInflationRate: this.client.midRetirementAdj ? this.client.midRetirementAdj.IncomeInflationRate: null,
          MAGI: (this.client.clientProfile.MAGIPercentIncome == null) ? 100 : this.client.clientProfile.MAGIPercentIncome, //default if null
          PreRetirementInflationRate: (this.client.clientProfile.InflationRate == null) ? 3.00 : this.client.clientProfile.InflationRate, //default if null
    
          SelfKnownBenefitClaiming: (this.client.clientProfile.SelfKnownBenefitClaiming) ? this.client.clientProfile.SelfKnownBenefitClaiming : 0,
          SpouseKnownBenefitClaiming: (this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length > 0) ? (this.client.clientProfile.Spouses[0].SpouseKnownBenefitClaiming) ? this.client.clientProfile.Spouses[0].SpouseKnownBenefitClaiming : 0 : 0,
    
          SelfYearOfStatement: this.client.clientProfile.YearOfStatement || this.currentYear,
          SpouseYearOfStatement: this.client.clientProfile.Spouses.length > 0 ? (this.client.clientProfile.Spouses[0].yearOfStatement) ? this.client.clientProfile.Spouses[0].yearOfStatement : this.currentYear : this.currentYear,
    
          SelfDateOfClaimMonth: (this.client.clientProfile.SelfAlreadyCollecting > 0) ? this.client.clientProfile.DateOfClaimMonth || 0 : 0,
          SelfDateOfClaimYear: (this.client.clientProfile.SelfAlreadyCollecting > 0) ? this.client.clientProfile.DateOfClaimYear || 0 : 0,
          SpouseDateOfClaimMonth: (this.client.clientProfile.Spouses[0].maritalStatus == "Married" && this.client.clientProfile.SpouseAlreadyCollecting > 0) ? this.client.clientProfile.Spouses[0].dateOfClaimMonth : 0,
          SpouseDateOfClaimYear: (this.client.clientProfile.Spouses[0].maritalStatus == "Married" && this.client.clientProfile.SpouseAlreadyCollecting > 0) ? this.client.clientProfile.Spouses[0].dateOfClaimYear : 0,
          SelfSubEarningYears: this.client.clientProfile.SubstantialEarningYearsDetails ? this.client.clientProfile.SubstantialEarningYearsDetails : null,
          SpouseSubEarningYears: this.client.clientProfile.Spouses.length > 0 && this.client.clientProfile.Spouses[0].SubstantialEarningYearsDetails ? JSON.stringify(this.client.clientProfile.Spouses[0].PIAYears) : null,
          InvertSurvivorSwitch: (this.hasAlternateScenario) ? this.swappedClaim ? 1 : 0 : 0,
          
          SelfWidowYearOfStatement: this.client.clientProfile.Spouses[0].maritalStatus == "Widowed" ? (this.client.clientProfile.Spouses[0].yearOfStatement) ? this.client.clientProfile.Spouses[0].yearOfStatement : 0 : 0,
          SelfWidowYearTimeOfPassing: this.client.clientProfile.Spouses[0].maritalStatus == "Widowed" ? (this.client.clientProfile.Spouses[0].yearAtTimeOfPassing) ? this.client.clientProfile.Spouses[0].yearAtTimeOfPassing : 0 : 0,
          SelfFRASurvivorSwitchYears: this.ssObjectFRA ? this.ssObjectFRA.SurvivorSwitchYears : 0,
          SelfFRASurvivorSwitchMonths: this.ssObjectFRA ? this.ssObjectFRA.SurvivorSwitchMonths : 0,
          InvertSurvivorSwitchFRA: this.hasAdjustedFRAScenario ? this.swappedClaimFRA ? 1 : 0 : 0,
          //InvertSurvivorSwitchFRA: this.hasAdjustedFRAScenario ? this.ssObjectFRA.invertSurvivorSwitch : 0,

          //retro save
          hasRetro: this.displayRetroTestMessage,
          clientRetroMonthsEarliest: 0,//((this.ssData.earlRetoFiling) ? this.ssData.cusSelfRetoNumMonths : 0),
          spouseRetroMonthsEarliest : 0,//((this.ssData.earlRetoFiling) ? this.ssData.cusSpouseRetoNumMonths : 0),
          
          clientRetroMonthsOptimal : 0,//((this.ssData.optRetoFiling) ? this.ssData.cusSelfRetoNumMonths : 0),
          spouseRetroMonthsOptimal : 0,//((this.ssData.optRetoFiling) ? this.ssData.cusSpouseRetoNumMonths : 0),
          
          clientRetroMonthsAlternate : ((this.ssDataAlt) ? (this.ssDataAlt.cusRetoFiling) ? this.ssDataAlt.cusSelfRetoNumMonths : 0 : 0),
          spouseRetroMonthsAlternate : ((this.ssDataAlt) ? (this.ssDataAlt.cusRetoFiling) ? this.ssDataAlt.cusSpouseRetoNumMonths : 0 : 0),
          
        }

        //retro save
        if(ReportSS.hasRetro){
          if(this.ssData.earlRetoFiling){
            var retroMonthsPast = (((parseInt(this.socialSecurityIllustrationCards[0].clientAge.replaceAll(' ', '').split('y')[0]) * 12) + parseInt(this.socialSecurityIllustrationCards[0].clientAge.replaceAll(' ', '').split('y')[1].split('m')[0])) - ((this.socialSecurityIllustrationCards[0].clientFRA.age * 12) + this.socialSecurityIllustrationCards[0].clientFRA.month));
            ReportSS.clientRetroMonthsEarliest = ((retroMonthsPast > 0) ? retroMonthsPast >= 6 ? 6 : retroMonthsPast : 0);

            if(this.includeSpouse && this.socialSecurityIllustrationCards[0].partnerAge){
              console.log('partner SS card age', this.socialSecurityIllustrationCards[0].partnerAge);
              var retroMonthsPastPartner = (((parseInt(this.socialSecurityIllustrationCards[0].partnerAge.replaceAll(' ', '').split('y')[0]) * 12) + parseInt(this.socialSecurityIllustrationCards[0].partnerAge.replaceAll(' ', '').split('y')[1].split('m')[0])) - ((this.socialSecurityIllustrationCards[0].partnerFRA.age * 12) + this.socialSecurityIllustrationCards[0].partnerFRA.month));
              ReportSS.spouseRetroMonthsEarliest = ((retroMonthsPastPartner > 0) ? retroMonthsPastPartner >= 6 ? 6 : retroMonthsPastPartner : 0);
            }
          }

          if(this.ssData.optRetoFiling){
            var retroMonthsPast = (((parseInt(this.socialSecurityIllustrationCards[2].clientAge.replaceAll(' ', '').split('y')[0]) * 12) + parseInt(this.socialSecurityIllustrationCards[2].clientAge.replaceAll(' ', '').split('y')[1].split('m')[0])) - ((this.socialSecurityIllustrationCards[2].clientFRA.age * 12) + this.socialSecurityIllustrationCards[2].clientFRA.month));
            ReportSS.clientRetroMonthsOptimal = ((retroMonthsPast > 0) ? retroMonthsPast >= 6 ? 6 : retroMonthsPast : 0);

            if(this.includeSpouse && this.socialSecurityIllustrationCards[2].partnerAge){
              var retroMonthsPastPartner = (((parseInt(this.socialSecurityIllustrationCards[2].partnerAge.replaceAll(' ', '').split('y')[0]) * 12) + parseInt(this.socialSecurityIllustrationCards[2].partnerAge.replaceAll(' ', '').split('y')[1].split('m')[0])) - ((this.socialSecurityIllustrationCards[2].partnerFRA.age * 12) + this.socialSecurityIllustrationCards[2].partnerFRA.month));
              ReportSS.spouseRetroMonthsOptimal = ((retroMonthsPastPartner > 0) ? retroMonthsPastPartner >= 6 ? 6 : retroMonthsPastPartner : 0);
            }
          }
        }

        if (this.backUpClient.clientProfile.Spouses && this.backUpClient.clientProfile.Spouses.length > 0) {
          if (this.backUpClient.clientProfile.Spouses.length > 1)
            ReportSS.FrmQFormerSpouses = 1;
          else if (this.backUpClient.clientProfile.Spouses[0].maritalStatus == 'Widowed')
            ReportSS.FrmQFormerSpouses = 1;
          else if (this.backUpClient.clientProfile.Spouses[0].maritalStatus == 'Divorced' && this.backUpClient.clientProfile.Spouses[0].tenyears)
            ReportSS.FrmQFormerSpouses = 1;
          else 
            ReportSS.FrmQFormerSpouses = 0;
        } else {
          ReportSS.FrmQFormerSpouses = 0;
        }
        if (this.backUpClient.clientProfile.Spouses[0].spousesSpouse) {
          if (this.backUpClient.clientProfile.Spouses[0].spousesSpouse.length > 0) {
            ReportSS.FrmSpouseQFormerSpouses = 1;
          } else {
            ReportSS.FrmSpouseQFormerSpouses = 0;
          }
        }
    
        if((this.ssData.selfRejectSwitchAgeInput || this.ssData.spouseRejectSwitchAgeInput) && this.ssObjectFRA){
          ReportSS.SelfFRASurvivorSwitchYears = 0;
          ReportSS.SelfFRASurvivorSwitchMonths = 0;    
    
          /* ReportSS.SurvivorSwitchMonths = 0;
          ReportSS.SurvivorSwitchYears = 0;  
    
          ReportSS.clientSurvivorSwitchMonths = 0;
          ReportSS.clientSurvivorSwitchYears = 0;    */       
          console.log('fell in here for reject');
        }
        
        
        if (this.client.clientProfile.Spouses.length > 0 && (this.client.clientProfile.Spouses[0].maritalStatus == "Widowed" 
          || this.client.clientProfile.Spouses[0].maritalStatus == 'Single' && this.includeSpouse)) {
            ReportSS.SurvivorSwitchYears = this.adjSurvivorBenefitAge;
            ReportSS.SurvivorSwitchMonths = this.adjSurvivorBenefitMonths;
          //ReportSS.InvertSurvivorSwitch  = this.swappedClaim ? 0 : !this.adjSurvivorModal ? 0 : 1
    
          if (this.hasAdjustedFRAScenario) {
            if(this.isSpouseSurvivor){
              ReportSS.SelfFRASurvivorSwitchYears = !this.swappedClaimFRA ? this.ssObjectFRA.SurvivorSwitchYears : this.ssObjectFRA.spouseRetirementYears;
              ReportSS.SelfFRASurvivorSwitchMonths = !this.swappedClaimFRA ? this.ssObjectFRA.SurvivorSwitchMonths : this.ssObjectFRA.spouseRetirementMonths;
              ReportSS.SpouseFRA = this.swappedClaimFRA ? this.ssObjectFRA.SurvivorSwitchYears : this.ssObjectFRA.spouseRetirementYears;
              ReportSS.SpouseFRAMonth = this.swappedClaimFRA ? this.ssObjectFRA.SurvivorSwitchMonths : this.ssObjectFRA.spouseRetirementMonths;
            } else {
              /* ReportSS.SelfFRASurvivorSwitchYears = this.ssObjectFRA.SurvivorSwitchYears;
              ReportSS.SelfFRASurvivorSwitchMonths = this.ssObjectFRA.SurvivorSwitchMonths;
              ReportSS.SelfFRA = this.ssObjectFRA.selfRetirementYears;
              ReportSS.SelfFRAMonth = this.ssObjectFRA.selfRetirementMonths; */
              ReportSS.SelfFRASurvivorSwitchYears = !this.swappedClaimFRA ? this.ssObjectFRA.SurvivorSwitchYears : this.ssObjectFRA.selfRetirementYears;
              ReportSS.SelfFRASurvivorSwitchMonths = !this.swappedClaimFRA ? this.ssObjectFRA.SurvivorSwitchMonths : this.ssObjectFRA.selfRetirementMonths;
              ReportSS.SelfFRA = !this.swappedClaimFRA ? this.ssObjectFRA.selfRetirementYears : this.ssObjectFRA.SurvivorSwitchYears;
              ReportSS.SelfFRAMonth = !this.swappedClaimFRA ? this.ssObjectFRA.selfRetirementMonths : this.ssObjectFRA.SurvivorSwitchMonths;
              console.log('I am in here FRA swap this.ssObjectFRA', this.ssObjectFRA);
              console.log('I am in here FRA swap ReportSS', ReportSS);
              if(!ReportSS.SelfFRA){
                ReportSS.SelfFRA = this.ssObjectFRA.selfRetirementYears;
                ReportSS.SelfFRAMonth = this.ssObjectFRA.selfRetirementMonths;
                ReportSS.SelfFRASurvivorSwitchYears = 0;
                ReportSS.SelfFRASurvivorSwitchMonths = 0;
              }
            }
            // ReportSS.SpouseBenefitAge = !this.swappedClaimFRA ? this.ssObjectFRA.SurvivorSwitchMonths : this.ssObjectFRA.selfRetirementMonths
            ReportSS.InvertSurvivorSwitchFRA = this.swappedClaimFRA ? 1 : 0;
          }
    
        } else {
          //ReportSS.InvertSurvivorSwitch = 0;
          if (this.hasAdjustedFRAScenario) {
            if(this.isSpouseSurvivor){
              ReportSS.SelfFRASurvivorSwitchYears = this.swappedClaimFRA ? this.ssObjectFRA.SurvivorSwitchYears : this.ssObjectFRA.spouseRetirementYears;
              ReportSS.SelfFRASurvivorSwitchMonths = this.swappedClaimFRA ? this.ssObjectFRA.SurvivorSwitchMonths : this.ssObjectFRA.spouseRetirementMonths;
              ReportSS.SpouseFRA = !this.swappedClaimFRA ? this.ssObjectFRA.SurvivorSwitchYears : this.ssObjectFRA.spouseRetirementYears;
              ReportSS.SpouseFRAMonth = !this.swappedClaimFRA ? this.ssObjectFRA.SurvivorSwitchMonths : this.ssObjectFRA.spouseRetirementMonths;
            } else {
              ReportSS.SelfFRASurvivorSwitchYears = this.swappedClaimFRA ? this.ssObjectFRA.SurvivorSwitchYears : this.ssObjectFRA.selfRetirementYears;
              ReportSS.SelfFRASurvivorSwitchMonths = this.swappedClaimFRA ? this.ssObjectFRA.SurvivorSwitchMonths : this.ssObjectFRA.selfRetirementMonths;
              ReportSS.SelfFRA = this.swappedClaimFRA ? this.ssObjectFRA.selfRetirementYears : this.ssObjectFRA.SurvivorSwitchYears;
              ReportSS.SelfFRAMonth = this.swappedClaimFRA ? this.ssObjectFRA.selfRetirementMonths : this.ssObjectFRA.SurvivorSwitchMonths;
              //console.log('I am in here FRA swap', this.ssObjectFRA);
              //console.log('I am in here FRA swap', ReportSS.SelfFRA);
            }

            console.log('I am in here FRA swap', this.ssObjectFRA);
            console.log('I am in here FRA swap', ReportSS.SpouseFRA);
          }
        }
    
        // console.log('this.client.clientProfile.Spouses', this.client.clientProfile.Spouses);
        if (ReportSS.MaritalState == 'Divorced') {
          ReportSS.SpouseBenefitAge = 62;
          //ReportSS.spouseRetirementYears = 62;
          //ReportSS.spouseRetirementMonths = 0;
    
          //ReportSS.spouseRetirementYears = (this.client.clientProfile.Spouses[0].exSpouseClaimAgeYears) ? this.client.clientProfile.Spouses[0].exSpouseClaimAgeYears : 62;
          //ReportSS.spouseRetirementMonths = (this.client.clientProfile.Spouses[0].exSpouseClaimAgeMonths) ? this.client.clientProfile.Spouses[0].exSpouseClaimAgeMonths : 0;
     
          ReportSS.spouseRetirementYears = (this.client.clientProfile.Spouses[0].expectedClaimAgeYears) ? this.client.clientProfile.Spouses[0].expectedClaimAgeYears : 62;
          ReportSS.spouseRetirementMonths = (this.client.clientProfile.Spouses[0].expectedClaimAgeMonths) ? this.client.clientProfile.Spouses[0].expectedClaimAgeMonths || 0 : 0;
        } 
    
        //TODO:  if has retro we should reset the peron(s) retirement year and month back to their current age so the API can handle it
        //TODO: fix static values to be the client/spouse current age
          //this will fix the PDF issue....need to make sure UI is working correctly
        console.log('viewed cards', this.socialSecurityIllustrationCards);
        if(this.socialSecurityIllustrationCards.length > 2){
          //FRA / First Alt
          /* if(this.socialSecurityIllustrationCards[1].scenario.includes('Retro')){
            if(this.ssData.earlSelfRetoFiling){
              ReportSS.SelfFRA = this.socialSecurityIllustrationCards[1].clientAge.replaceAll(' ', '').split('y')[0];
              ReportSS.SelfFRAMonth = this.socialSecurityIllustrationCards[1].clientAge.replaceAll(' ', '').split('y')[1].split('m')[0];
            }
    
            if(this.includeSpouse && this.ssData.earlSpouseRetoFiling){
              ReportSS.SpouseFRA = this.socialSecurityIllustrationCards[1].partnerAge.replaceAll(' ', '').split('y')[0];
              ReportSS.SpouseFRAMonth =  this.socialSecurityIllustrationCards[1].partnerAge.replaceAll(' ', '').split('y')[1].split('m')[0];
            }
          } */
          
          //Alt / Second Alt
          /* if(this.socialSecurityIllustrationCards[3].scenario.includes('Retro')){
            if(this.ssDataAlt.cusSelfRetoFiling){
              ReportSS.selfRetirementYears = this.socialSecurityIllustrationCards[1].clientAge.replaceAll(' ', '').split('y')[0];
              ReportSS.selfRetirementMonths = this.socialSecurityIllustrationCards[1].clientAge.replaceAll(' ', '').split('y')[1].split('m')[0];
            }
    
            if(this.includeSpouse && this.ssDataAlt.cusSpouseRetoFiling){
              ReportSS.spouseRetirementYears = this.socialSecurityIllustrationCards[1].partnerAge.replaceAll(' ', '').split('y')[0];
              ReportSS.spouseRetirementMonths = this.socialSecurityIllustrationCards[1].partnerAge.replaceAll(' ', '').split('y')[1].split('m')[0];
            }
          } */
          
        } else {
          //FRA / First Alt
          /* if(this.socialSecurityIllustrationCards[1].scenario.includes('Retro')){
            if(this.ssData.earlSelfRetoFiling){
              ReportSS.SelfFRA = this.socialSecurityIllustrationCards[1].clientAge.replaceAll(' ', '').split('y')[0];
              ReportSS.SelfFRAMonth = this.socialSecurityIllustrationCards[1].clientAge.replaceAll(' ', '').split('y')[1].split('m')[0];
            }
    
            if(this.includeSpouse && this.ssData.earlSpouseRetoFiling){
              ReportSS.SpouseFRA = this.socialSecurityIllustrationCards[1].partnerAge.replaceAll(' ', '').split('y')[0];
              ReportSS.SpouseFRAMonth = this.socialSecurityIllustrationCards[1].partnerAge.replaceAll(' ', '').split('y')[1].split('m')[0];
            }
          } */
        }

        console.log('saving for PDF', ReportSS);
        console.log('this.clientRetirementMonths', this.clientRetirementMonths);
        // console.log('this.client.midRetirementAdj.Year', this.client.midRetirementAdj.Year)
        this.globalService.createReportSS(Report, ReportSS)
        .subscribe(
            resp => {
              if (resp) {
                this.snackBarService.add("Please wait while your social security report is being generated.", 0);
                //this.router.navigateByUrl('/reports/create?d=t');
                this.downloadReport(resp.ReportID, resp.AdvisorID, resp.ClientID, resp.CompanyCode, resp.ReportTypeID);
              }
            },
            error => this.error = <any>error);

      //}

    
    }
  }

  getSpouseMinSurvivorClaimAge() {
    let clientAge = this.calculateAge(this.client.client.DOB);
    let spouseAge = this.calculateAge(this.client.clientProfile.Spouses[0].dob);
    let clientDOBMonth =  new Date(this.client.client.DOB).getMonth() + 1;
    //let clientMonthIndex = clientDOBMonth <= new Date().getMonth() + 1 ? 0 : 1;
    //let clientMonthIndex = clientDOBMonth <= new Date().getMonth() + 1 ? 0 : 1;
    //console.log('clientMonthIndex', clientMonthIndex);
    //let clientRemainingYear = this.data.clientProfile.LifeExpectancy - (clientAge + clientMonthIndex);
    let clientRemainingYear = this.client.clientProfile.LifeExpectancy - (clientAge);    
    let spouseRemainingYear = this.client.clientProfile.Spouses[0].LifeExpectancy - spouseAge;
    if(clientDOBMonth > new Date().getMonth() + 1){
      // clientRemainingYear += 1;
    } else {
      let spouseMonth =  new Date(this.client.clientProfile.Spouses[0].dob);
      let spouseAgeIndex = spouseMonth.getMonth() + 1 == 1 ? 1:0;
      if(spouseRemainingYear > clientRemainingYear && spouseAgeIndex == 1) {
        clientRemainingYear += 1;
      }
    }
    console.log('spouseRemainingYear', spouseRemainingYear);
    let spouseMinSurvivorClaimAge = spouseRemainingYear > clientRemainingYear ? spouseAge + clientRemainingYear  : 0;
    console.log('spouseMinClaimAge 22', spouseMinSurvivorClaimAge);
    return spouseMinSurvivorClaimAge;
  }

  downloadReport(reportID, advisorID, clientID, orgID, reportTypeID) {
    this.loadingService.isLoading(true);

    var ReportFields = { reportID, advisorID, clientID, orgID, ReportTypeID: reportTypeID, token: localStorage.getItem("bearer") };
    console.log('this.hasAlternateScenario', this.hasAlternateScenario)
    let isAlternateScenario = !this.isShowAlternate ? false: this.hasAlternateScenario;
    // console.log('Report object', this.hasAlternateScenario);
    this.globalService.generateReport(ReportFields, this.client.client, ReportFields, isAlternateScenario)
      .subscribe(
      resp => {
        this.loadingService.isLoading(false);
      },
      error => {
        this.error = <any>error;
        this.loadingService.isLoading(false);
      });
  }

  // getFRAv2(bday){
  //   const startYear = new Date().getFullYear(); 
  //   var yearOfBirth = startYear - this.calculateAge(bday);
  //   var fraMonths = 0;
  //   if(yearOfBirth <= 1954){
  //     fraMonths = 780;
  //   } else if(yearOfBirth <= 1959){
  //     fraMonths = (Math.min(12, (yearOfBirth - 1937) * 2)) + 780;
  //   } else {
  //     fraMonths = (Math.min(12, (yearOfBirth - 1954) * 2)) + 792;
  //   }

  //   var fra = fraMonths / 12;

  //   let FRA = {
  //     age: 0,
  //     month: 0,
  //   }
  //   FRA.age = Math.round(fra);
  //   //console.log('log FRA', fra%12)
  //   //this.getBirthdayMonth(bday)
  //   FRA.month = (yearOfBirth >= 1960) ? 0 : Math.round(fra%12) + 1;

  //   console.log('returned FRA', FRA);
  //   return FRA
  // }

  getBirthdayFullYear(dob: Date){
    //const birthDate = new Date(dob);
    const startYear = new Date().getFullYear();

    var _monthOffset = 0;
    // If the person's DOB falls on the first day of the month, Soc.Sec. pretends they are an extra month older (as if born in the PREVIOUS month)
    if (dob.getDate() == 1)
    {
      _monthOffset = 1;
    }
    //return _monthOffset;
    // console.log('month day', dob.getDate());
    // console.log('month day offset', _monthOffset);


    var _yearOffset = 0;
    // If the person's DOB falls on New Year's Day, Soc.Sec. references factors and age thresholds according to the PREVIOUS year
    if ((dob.getMonth() == 0) && (_monthOffset == 1))
    {
      //(dbarksdale3) Updated behavior of this value
      //_yearOffset = -1;
      _yearOffset = 1;
    }
    //return _yearOffset;
    // console.log('month', dob.getMonth());
    // console.log('year offset', _yearOffset);


    return (startYear - this.getCurrentAgeByDOB(dob) - _yearOffset);
  }

  getCurrentAgeByDOB(birthday){
    var dob = new Date(birthday);
    const startYear = new Date();
    var CurrentAgeOffset = ((startYear.getMonth() + 1) < (dob.getMonth() + 1)) ? 1 : 0;
    console.log('getCurrentAgeByDOB', ((((startYear.getFullYear() - dob.getFullYear()) * 12) + (startYear.getMonth() + 1) - (dob.getMonth() + 1)) / 12 + CurrentAgeOffset));
    return Math.floor(((((startYear.getFullYear() - dob.getFullYear()) * 12) + (startYear.getMonth() + 1) - (dob.getMonth() + 1)) / 12 + CurrentAgeOffset));
  }
   
  getFRAv2(bday){
    // const startYear = new Date().getFullYear();
    const birthDate = new Date(bday);
    //var yearOfBirth = birthDate.getFullYear();
    var yearOfBirth = this.getBirthdayFullYear(birthDate);

    // var yearOfBirth = startYear - birthYear;
    // console.log('yearOfBirth',yearOfBirth);
    var fraMonths = 0;
    if(yearOfBirth <= 1954){
      if (yearOfBirth <= 1937) {
        fraMonths = 780;
      } else {
        if (yearOfBirth <=1942) {
          switch (yearOfBirth)
          {
            case 1938:
              fraMonths = 780+2;
              break;
            case 1939:
              fraMonths = 780 + 4;
              break;
            case 1940:
              fraMonths = 780 + 6;
              break;
            case 1941:
              fraMonths = 780 + 8;
              break;
            case 1942:
              fraMonths = 780 + 10;
              break;

          }
        } else {
          fraMonths = 792;
        }

      }
    } else if (yearOfBirth <=1961 && this.client.clientProfile.Spouses[0].maritalStatus === 'Widowed') {
      switch (yearOfBirth)
      {
        case 1955:
          fraMonths = 792 + 0;
          break;
        case 1956:
          fraMonths = 792 + 0;
          break;
        case 1957:
          fraMonths = 792 + 2;
          break;
        case 1958:
          fraMonths = 792 + 4;
          break;
        case 1959:
          fraMonths = 792 + 6;
          break;
        case 1960:
          fraMonths = 792 + 8;
          break;
        case 1961:
          fraMonths = 792 + 10;
          break;
      }
    } else if(yearOfBirth <= 1959){
      switch (yearOfBirth)
      {
        case 1955:
          fraMonths = 792 + 2;
          break;
        case 1956:
          fraMonths = 792 + 4;
          break;
        case 1957:
          fraMonths = 792 + 6;
          break;
        case 1958:
          fraMonths = 792 + 8;
          break;
        case 1959:
          fraMonths = 792 + 10;
          break;
      }
    } else {
      fraMonths = 804;
    }

    // console.log('fraMonths', fraMonths);
    var fra = fraMonths / 12;
    // console.log('fra', fra);
    // console.log('framonthtest', )

    let FRA = {
      age: 0,
      month: 0,
    }
    FRA.age = Math.floor(fra);
    //console.log('log FRA', fra%12)
    //this.getBirthdayMonth(bday)
    FRA.month = fraMonths % 12;

    // console.log('returned FRA', FRA);
    return FRA
  }



  getFRA(bday) {
    bday = typeof bday === 'string' ? bday : bday.formatted;
    let yearOfBirth = Number(bday.substring(bday.length - 4, bday.length));
    let FRA = {
      age: 0,
      month: 0,
    }

    if (yearOfBirth <= 1937) {
      FRA.age = 65;
      FRA.month = 0;
    } else if (yearOfBirth === 1938) {
      FRA.age = 65;
      FRA.month = 2;
    } else if (yearOfBirth === 1939) {
      FRA.age = 65;
      FRA.month = 4;
    } else if (yearOfBirth === 1940) {
      FRA.age = 65;
      FRA.month = 6;
    } else if (yearOfBirth === 1941) {
      FRA.age = 65;
      FRA.month = 8;
    } else if (yearOfBirth === 1942) {
      FRA.age = 65;
      FRA.month = 10;
    } else if (yearOfBirth >= 1943 && yearOfBirth <= 1954) {
      FRA.age = 66;
      FRA.month = 0;
    } else if (yearOfBirth === 1955) {
      FRA.age = 66;
      FRA.month = 2;
    } else if (yearOfBirth === 1956) {
      FRA.age = 66;
      FRA.month = 4;
    } else if (yearOfBirth === 1957) {
      FRA.age = 66;
      FRA.month = 6;
    } else if (yearOfBirth === 1958) {
      FRA.age = 66;
      FRA.month = 8;
    } else if (yearOfBirth === 1959) {
      FRA.age = 66;
      FRA.month = 10;
    } else if (yearOfBirth >= 1960) {
      FRA.age = 67;
      FRA.month = 0;
    }

    return FRA;
  }

  getBirthdayMonth(date = null) {
    var d = new Date(date);
    return (d.getMonth() + 1);
  }

  getClassColor(isComparison) {
    var className = ""
    // console.log('this.selectedIllustration', this.selectedIllustration);
    if (this.selectedIllustration.name === 'Earliest vs Alternate') {
      className = isComparison ? 'earliest' : 'alternate';
    } else if (this.selectedIllustration.name === 'Earliest vs Optimal') {
      className = isComparison ? 'earliest' : 'optimal';
    } else if (this.selectedIllustration.name === 'Alternate vs Optimal') {
      className = isComparison ? 'alternate' : 'optimal';
    }

    return className
  }

  formatComparison(str) {
    return str.replace('Alternate', 'Chosen')
  }

  formatName() {
    if (this.client) {
      return this.client.clientProfile && this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].firstName ?
        this.client.client.FirstName + ' and ' + this.client.clientProfile.Spouses[0].firstName + ' ' + this.client.client.LastName
        : this.client.client.FirstName + ' ' + this.client.client.LastName
    }
  }

  formatMoney(val) {
    return Utils.formatToCurrency(val);
  }

  formatDataLabel(value)
  {
    if(Number.isInteger(value)){
      return Utils.formatToCurrency(value);
    } else {
      return  Utils.formatToCurrency(Math.round((value) * 100) / 100);
    }

    //return Utils.formatToCurrency(value);
    //return "$" + value
  }

  clientHubRedirect(){
    this.router.navigate(['/clients/edit']);
  }

  newSSObject;
  onLifeExpChange(value, isClient){
    // //console.log('le passed', value);
    // //this.newSSObject = this.ssObject;
    // const newSSObject = { ...this.ssObject };
    // if(this.hasAlternateScenario){
    //   if(isClient){
    //     newSSObject.SelfLifeExpectancy = value;
    //   } else {
    //     newSSObject.SpouseLifeExpectancy = value;
    //   }
    //   //this.getSSDataAlt(this.storedFRAScenario, true);
    // } else {
    //   //this.getSSData();
    //   newSSObject.SelfLifeExpectancy = value;
    // }

    // //this.getSSData();
    // //this.setSelectedLifeExpectancyPoint();

    // this.newSSObject = newSSObject;
    this.hasTBCBeenAdjustedAfterPageLoad = true;
    this.totalBenefitCalc();
  }

  setScenario;
  returnedDesiredClaimAge(desiredAge) {
    console.log('what is desiredAge', desiredAge);
    let scenario;
    //console.log('here setting option')
    if (this.includeSpouse && desiredAge.includes('/')) {
      scenario = this.socialSecurityIllustrationCards.find(card => card.clientAge.trim() == desiredAge.split(' / ')[0].trim() && card.partnerAge.trim() == desiredAge.split(' / ')[1].trim());
    } else {
      scenario = this.socialSecurityIllustrationCards.find(card => card.clientAge.trim() == desiredAge.trim())
    }
    console.log('what is scenario', scenario);
    this.setScenario = scenario;

    let dOB = new Date(this.client.client.DOB);
    let timeDiff = Math.abs(Date.now() - dOB.getTime());
    let clientAge = Math.floor((timeDiff / (1000 * 3600 * 24))/365.25);

    switch (scenario.scenario.toLowerCase()) {
      case 'optimal':
        //console.log('in optimal');
        this.yearlyCost = this.yearlyCostOptimal;
        this.weeklyCost = this.weeklyCostOptimal;
        this.lumpsum = this.lumpsumOptimal;
        this.startingLumpsum = this.ssData.startBalanceOpt;
        //this.currentRemainingTotal = (this.ssDataAlt) ? this.ssDataAlt.remainingUnfundedOptimal : this.ssData.remainingUnfundedOptimal;
        this.currentRemainingTotal = this.ssData.remainingUnfundedOptimal;

        var optAge = parseInt(this.ssData.opStartBenLabel.split('/')[0].replace(' month', '').replace(' months', '').replace('ms', '').replace(' and', ''));
        this.annuallyWeeklyTtlYear = ((optAge - clientAge) > 1) ? optAge - clientAge : 1;
        break;
      case 'earliest':
        //console.log('in earliest');
        this.yearlyCost = this.yearlyCostEarliest;
        this.weeklyCost = this.weeklyCostEarliest;
        this.lumpsum = this.lumpsumEarliest;
        this.startingLumpsum = this.ssData.startBalanceEarly;
        //this.currentRemainingTotal = (this.ssDataAlt) ? this.ssDataAlt.remainingUnfundedEarliest : this.ssData.remainingUnfundedEarliest;
        this.currentRemainingTotal = this.ssData.remainingUnfundedEarliest;

        var optAge = parseInt(this.ssData.earlStartBenLabel.split('/')[0].replace(' month', '').replace(' months', '').replace('ms', '').replace(' and', ''));
        this.annuallyWeeklyTtlYear = ((optAge - clientAge) > 1) ? optAge - clientAge : 1;
        break;
      case 'fra':
        //console.log('in fra');
        this.yearlyCost = this.yearlyCostFRA;
        this.weeklyCost = this.weeklyCostFRA;
        this.lumpsum = this.lumpsumFRA;
        this.startingLumpsum = (this.hasAdjustedFRAScenario && this.ssDataFRA) ? this.ssDataFRA.startBalanceFRA : this.ssData.startBalanceFRA;
        //this.currentRemainingTotal = (this.ssDataAlt) ? this.ssDataAlt.remainingUnfunded : this.ssData.remainingUnfunded;
        this.currentRemainingTotal = (this.hasAdjustedFRAScenario && this.ssDataFRA) ? this.ssDataFRA.remainingUnfunded : this.ssData.remainingUnfunded;

        var optAge = parseInt(this.ssData.cusStartBenLabel.split('/')[0].replace(' month', '').replace(' months', '').replace('ms', '').replace(' and', ''));
        this.annuallyWeeklyTtlYear = ((optAge - clientAge) > 1) ? optAge - clientAge : 1;
        break;
      case 'alternate':
        //console.log('in alternate');
        this.yearlyCost = this.yearlyCostAlt;
        this.weeklyCost = this.weeklyCostAlt;
        this.lumpsum = this.lumpsumAlt;        
        this.startingLumpsum = (this.hasAdjustedFRAScenario && this.ssDataAlt) ? this.ssDataAlt.startBalanceAlt : this.ssData.startBalanceAlt;
        this.currentRemainingTotal = (this.ssDataAlt) ? this.ssDataAlt.remainingUnfunded : this.ssData.remainingUnfunded;

        var optAge = parseInt(this.ssDataAlt.cusStartBenLabel.split('/')[0].replace(' month', '').replace(' months', '').replace('ms', '').replace(' and', ''));
        this.annuallyWeeklyTtlYear = ((optAge - clientAge) > 1) ? optAge - clientAge : 1;
        break;
      default:
        //console.log('in default');
        break;
    }
    
    this.dropDownSelectedIndexWeekly = this.dropDownSelectedIndexAnnually = this.annuallyWeeklyTtlYear;

    //console.log('test lumpsum', this.lumpsumEarliest);
    //this.startingLumpsum = data.startBalanceAlt;    
    var phaseOnePercent = (this.objAdjustRates ? (Number(this.objAdjustRates.rorOne)) : 6) / 100;
    console.log('phaseOnePercent', phaseOnePercent);

    //var pay = Math.ceil(Math.abs(this.startingLumpsum * (6.00 / 1) / (Math.pow(1 + (6.00 / 1), (this.annuallyWeeklyTtlYear * 1 + 1))) - (1 + 6.00 / 1)));
    //var payFutureAnnual = (pay + Number(this.yearlyCost)) * this.annuallyWeeklyTtlYear;
    //var pay = Math.ceil(Math.abs(this.startingLumpsum * phaseOnePercent / (Math.pow((1 + phaseOnePercent), this.annuallyWeeklyTtlYear) - 1)));
    //var payFutureAnnual = pay * this.annuallyWeeklyTtlYear;
    //this.futureYearlyCost = payFutureAnnual;
    var pay = Math.ceil(Math.abs(this.startingLumpsum * (phaseOnePercent / 1) / 
      ((Math.pow(1 + (phaseOnePercent / 1), (this.annuallyWeeklyTtlYear * 1 + 1))) - (1 + phaseOnePercent / 1))));
    var payFutureAnnual = pay * this.annuallyWeeklyTtlYear;
    this.futureYearlyCost = payFutureAnnual;

    //var pay = Math.ceil(Math.abs(this.startingLumpsum * (6.00 / 52) / (Math.pow(1 + (6.00 / 52), (this.annuallyWeeklyTtlYear * 52 + 1))) - (1 + 6.00 / 52)));
    //var payFutureWeek = (pay + Number(this.weeklyCost)) * (this.annuallyWeeklyTtlYear * 52);
    //var pay = Math.ceil(Math.abs(this.startingLumpsum * (phaseOnePercent / 52) / (Math.pow(1 + phaseOnePercent / 52, (this.annuallyWeeklyTtlYear * 52)) - 1)));
    //var payFutureWeek = pay * (this.annuallyWeeklyTtlYear * 52);
    //this.futureWeeklyCost = payFutureWeek;
    var pay = Math.ceil(Math.abs(this.startingLumpsum * (phaseOnePercent / 52) / 
      ((Math.pow(1 + (phaseOnePercent / 52), (this.annuallyWeeklyTtlYear * 52 + 1))) - (1 + phaseOnePercent / 52))));
    var payFutureWeek = pay * (this.annuallyWeeklyTtlYear * 52);
    this.futureWeeklyCost = payFutureWeek;    
          

    this.beginningBalance = this.lumpsum;
    this.totalRemainingGap = Number(this.lumpsum);
    this.medicareDeductions = Utils.formatToNumber(scenario.medicareDeductions.split(' ')[0]);
    
  }
  
  adjustFundingForSelectedScenario(selectedDropDownIndex, isWeekly){
    //call this when the dropdowns in the Funding options for Annual and Monthly is toggled
    console.log('in adjust funding', selectedDropDownIndex);
    if(this.setScenario) {
      //clone the ssData or the ssDataAlt, depending on situation
      //console.log('selected scenario', this.setScenario);
      var setScenarioTitle = this.setScenario.scenario.toLowerCase();
      console.log('set scenario', setScenarioTitle);
      //var newObj = (setScenarioTitle == "alternate") ? { ...this.ssObjectAlt } : { ...this.ssObject };
      var newObj = { ...this.ssObject };
      newObj.IsAltRequest = true; //not sure if need to set/reset - just set
      newObj.isFundingBeingAdjusted = true;
      newObj.adjustedFundingScenario = setScenarioTitle;
      newObj.adjustedFundingScenarioSelectedIndex = selectedDropDownIndex;

      //adjust the DCA to get the year/age difference to match expected values?
      /* newObj.selfRetirementYears = ((setScenarioTitle == "alternate") ? parseInt(this.ssDataAlt.cusStartBenLabel.split('/')[0].replace(' month', '').replace(' months', '').replace('ms', '').replace(' and', '')) 
        : (setScenarioTitle == "fra") ? parseInt(this.ssData.cusStartBenLabel.split('/')[0].replace(' month', '').replace(' months', '').replace('ms', '').replace(' and', '')) 
        : (setScenarioTitle == "earliest") ? parseInt(this.ssData.earlStartBenLabel.split('/')[0].replace(' month', '').replace(' months', '').replace('ms', '').replace(' and', ''))
        : parseInt(this.ssData.opStartBenLabel.split('/')[0].replace(' month', '').replace(' months', '').replace('ms', '').replace(' and', '')));
 */
      if(newObj.selfRetirementYears){
        //console.log('new retirement22', newObj.selfRetirementYears);
        newObj.selfRetirementYears = newObj.selfRetirementYears 
          + (((setScenarioTitle == "alternate") ? parseInt(this.orgAltAnnuallyWeeklyTtlYear || 0)
          : (setScenarioTitle == "fra") ? parseInt(this.orgFRAAnnuallyWeeklyTtlYear || 0)
          : (setScenarioTitle == "earliest") ? parseInt(this.orgEarlyAnnuallyWeeklyTtlYear || 0) 
          : parseInt(this.orgOptAnnuallyWeeklyTtlYear || 0)) - parseInt(selectedDropDownIndex));// + 1;//this.annuallyWeeklyTtlYear);
      }

      console.log('new retirement', newObj.selfRetirementYears);
      //newObj.selfRetirementYears = 70;
      newObj.selfRetirementMonths = 0;
      //newObj.SelfRetirementAge = newObj.selfRetirementYears;

      if(this.includeSpouse){
        //TODO: do we need this?
      }

      //call the SS endpoint
      this.loadingService.isLoading(true);
      console.log('new obj', newObj);
      
      this.globalService.getSSData(newObj, this.userForm.value)
        .subscribe(
          data => {
            //need to readjust all values set in the function/method: returnedDesiredClaimAge (above)
            //TODO: first goal is to set/reset: this.startingLumpsum
            console.log('new ss resp for funding', data);

            this.lumpsum = data.lumpsumCost;
            this.startingLumpsum = data.startBalanceAlt;
            console.log('what I need', data.startBalanceAlt);
            var phaseOnePercent = (this.objAdjustRates ? (Number(this.objAdjustRates.rorOne)) : 6) / 100;

            if(!isWeekly){              
              this.yearlyCost = data.yearlyCost;
              
              //var pay = Math.ceil(Math.abs(data.startBalanceAlt * phaseOnePercent / (Math.pow((1 + phaseOnePercent), selectedDropDownIndex) - 1)));
              var pay = Math.ceil(Math.abs(data.startBalanceAlt * (phaseOnePercent / 1) / 
                ((Math.pow(1 + (phaseOnePercent / 1), (selectedDropDownIndex * 1 + 1))) - (1 + phaseOnePercent / 1))));

              var payFutureAnnual = pay * selectedDropDownIndex;
              this.futureYearlyCost = payFutureAnnual;

              this.dropDownSelectedIndexAnnually = this.bodyCardSelectedIndexAnnually = selectedDropDownIndex;// - 1;
            } else {              
              this.weeklyCost = data.weeklyCost;

              //var pay = Math.ceil(Math.abs(data.startBalanceAlt * (phaseOnePercent / 52) / (Math.pow(1 + phaseOnePercent / 52, (selectedDropDownIndex * 52)) - 1)));
              var pay = Math.ceil(Math.abs(data.startBalanceAlt * (phaseOnePercent / 52) / 
                ((Math.pow(1 + (phaseOnePercent / 52), (selectedDropDownIndex * 52 + 1))) - (1 + phaseOnePercent / 52))));
        
              var payFutureWeek = pay * (selectedDropDownIndex * 52);
              this.futureWeeklyCost = payFutureWeek;         
              
              this.dropDownSelectedIndexWeekly = this.bodyCardSelectedIndexWeekly = selectedDropDownIndex;// - 1;
            }

            //this.returnedDesiredClaimAge('68y 0m / 68y 0m');

            //this.annuallyWeeklyTtlYear = selectedDropDownIndex;
            //this.beginningBalance = data.lumpsumCost;//this.lumpsum;
            //this.totalRemainingGap = Number(data.lumpsumCost);//this.lumpsum);
            //this.medicareDeductions = Utils.formatToNumber(this.setScenario.medicareDeductions.split(' ')[0]);

            this.loadingService.isLoading(false);
          }
        );
      }
  }

  onSelectNonLegalInd() {
    if (this.socialSecurityForm.value.nonLegalMarriedInd == 'Spouse') {
      this.hasAlternateScenario = false;
      this.getClient(false);
      
    } else {
      this.hasAlternateScenario = false;
      this.getClient(true);
    }
  }

  getAgeYearAtClaimYear(birthday, claimYear, claimMonth) {
    console.log('birthday', birthday);
    console.log('claimYear', claimYear);
    var dob = new Date(birthday);
    // const startYear = new Date(claimYear);
    // var CurrentAgeOffset = ((startYear.getMonth() + 1) < (dob.getMonth() + 1)) ? 1 : 0;
    console.log('startYear.getFullYear()', claimYear)
    console.log('dob.getFullYear()', dob.getFullYear())
    var ageDiffs = claimYear - dob.getFullYear();
    console.log('ageDiffs', ageDiffs);
    ageDiffs = dob.getMonth() + 1 > claimMonth ? ageDiffs - 1: ageDiffs;
    return ageDiffs;
    // console.log('age',Math.floor(((((startYear.getFullYear() - dob.getFullYear()) * 12) + (claimMonth + 1) - (dob.getMonth() + 1)) / 12 + CurrentAgeOffset)));
    // return Math.floor(((((startYear.getFullYear() - dob.getFullYear()) * 12) + (claimMonth + 1) - (dob.getMonth() + 1)) / 12 + CurrentAgeOffset));
  }

  getAgeMonthAtClaimMonth(birthday,claimMonth) {
    var dob = new Date(birthday);
    console.log('dobFull', dob);
    var dobMonth = dob.getMonth() + 1;
    console.log('dobMonth', dobMonth)
    console.log('claimMonth', claimMonth)
    console.log('claimMonth - dobMonth', claimMonth - dobMonth)
    var months = dobMonth > claimMonth ? (12 - dobMonth) + Number(claimMonth) : (claimMonth - dobMonth);
    console.log('months', months)
    return months
  }

  // getPartnerDOB() {
  //   let partnerDOB = this.client.clientProfile.Spouses[0].maritalStatus === 'Married' ? this.client.clientProfile.Spouses[0].dob: ''
  //   return partnerDOB;
  // }
}
